// فرانتِ بازیکن — UI لابی، میز، حباب‌های چت محو‌شونده، آواتار، پروفایل، دوستان.
// ⚠ `LocalTable` (بازیِ تمرینیِ آفلاین) کلِ موتورِ مشترک را می‌کشد:
// engine + bot(۴۲KB) + rules + deck + bidding + scoring ≈ ۲۵KB گزیپ که کاربرِ آنلاین
// هرگز اجرا نمی‌کند. حالا فقط در لحظهٔ شروعِ بازیِ تمرینی import می‌شود.
// SUIT_GLYPH/suitFa دو ثابتِ کوچک‌اند که کلِ UI به آن‌ها نیاز دارد، پس همین‌جا هستند.
import { API, WS } from './config.js?v=20261028_428';
import { NetworkTable } from './net/NetworkTable.js?v=20261028_428';
import { sounds, isMuted, setMuted, toggleMute as _toggleMuteAudio, seatPan, _seatPan } from './game/audio.js?v=20261028_428';
import { renderChaharBargCenter, renderChaharBargScorePanel, getCardMatchHints } from './game/chaharbargUi.js?v=20261028_428';
import {
  renderBluffCenter,
  renderBluffScoreBar,
  renderBluffControls,
  renderBluffInterrogationModal,
} from './game/bluffUi.js?v=20261028_428';
import { BluffAudio } from './game/bluffAudio.js?v=20261028_428';
import { shopModal, initShopModal } from './ui/shopModal.js?v=20261028_428';
import {
  dmPanel,
  dmUnread,
  myProfilePanel,
  friendsPanel,
  occupantsUI,
  formatRelativeTime,
  initSocialPanels,
} from './ui/socialPanels.js?v=20261028_428';
import { renderLogin, authOtpFlow, renderProfileOnboarding, initAuthModal, showUpgradeGuestModal } from './ui/authModal.js?v=20261028_428';
import {
  chatRailUI,
  composerUI,
  initChatVoice,
  presetsPopup,
  playVoice,
  stopCurrentVoice,
  voiceBubbleEl,
  getCurrentVoicePlayback,
  setCustomPresets,
  applyServerQuick,
  quickFavItems,
} from './ui/chatVoice.js?v=20261028_428';
import { showHelpModal } from './ui/helpModal.js';
import { t, fmtNum, getLang, setLang, onLangChange, LANGUAGES, suitName, isRTL, formatLocalizedDate } from './i18n.js?v=20261028_428';

const $ = (s) => document.querySelector(s);
const el = (tag, props = {}, ...kids) => {
  const n = Object.assign(document.createElement(tag), props);
  for (const k of kids) if (k != null) n.append(k);
  return n;
};
const faNum = (s) => fmtNum(s);
const _reducedMotion = () => !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

// ─── پل هپتیک و Safe Area بومی اندروید ───────────────────────────────────────
if (window.AndroidBridge) {
  const _origVibrate = navigator.vibrate ? navigator.vibrate.bind(navigator) : null;
  navigator.vibrate = function(pattern) {
    try {
      if (Array.isArray(pattern)) {
        if (pattern.length > 3) window.AndroidBridge.hapticSuccess?.();
        else window.AndroidBridge.hapticMedium?.();
      } else if (typeof pattern === 'number') {
        if (pattern >= 20) window.AndroidBridge.hapticMedium?.();
        else window.AndroidBridge.hapticTick?.();
      }
    } catch {}
    if (_origVibrate) try { _origVibrate(pattern); } catch {}
    return true;
  };

  try {
    if (typeof window.AndroidBridge.getSafeAreaTop === 'function') {
      const sat = window.AndroidBridge.getSafeAreaTop();
      const sab = window.AndroidBridge.getSafeAreaBottom();
      const sal = window.AndroidBridge.getSafeAreaLeft();
      const sar = window.AndroidBridge.getSafeAreaRight();
      if (sat > 0) document.documentElement.style.setProperty('--sat', `${sat}px`);
      if (sab > 0) document.documentElement.style.setProperty('--sab', `${sab}px`);
      if (sal > 0) document.documentElement.style.setProperty('--sal', `${sal}px`);
      if (sar > 0) document.documentElement.style.setProperty('--sar', `${sar}px`);
    }
  } catch {}
}

window.addEventListener('safeinsetschange', (e) => {
  if (!e.detail) return;
  const { top, bottom, left, right } = e.detail;
  if (top != null) document.documentElement.style.setProperty('--sat', `${top}px`);
  if (bottom != null) document.documentElement.style.setProperty('--sab', `${bottom}px`);
  if (left != null) document.documentElement.style.setProperty('--sal', `${left}px`);
  if (right != null) document.documentElement.style.setProperty('--sar', `${right}px`);
});
// «انتخابِ دومرحله‌ایِ» برگه باید روی هر دستگاهِ لمسی فعال باشد، نه فقط زیرِ ۵۶۰px.
// قبلاً شرط `innerWidth <= 560 && maxTouchPoints > 0` بود، یعنی تبلت و گوشیِ افقی
// کلیکِ تک‌مرحله‌ای می‌گرفتند و یک لمسِ اتفاقی = یک کارتِ سوخته.
// `pointer: coarse` یعنی «وسیلهٔ اشارهٔ اصلی دقیق نیست» — دقیقاً همین را می‌پرسیم.
const _isTouchDevice = () => !!window.matchMedia?.('(pointer: coarse)').matches
  || (navigator.maxTouchPoints > 0 && !window.matchMedia?.('(pointer: fine)').matches);

// ─── کیفیتِ گرافیک (فقط موبایل) ─────────────────────────────────────────────
// دسکتاپ (مرورگر و Electron) همیشه کیفیتِ کامل می‌گیرد. روی موبایل انتخابِ کاربر
// در cb_fx: 'auto' | 'high' | 'low'. حالتِ کم‌مصرف فقط کلاسِ html.fx-low است و همهٔ
// تخفیف‌ها در انتهای styles.css. در 'auto': سخت‌افزارِ ضعیف از اول low؛ وگرنه نرخِ
// فریمِ اولین پخشِ کارت سنجیده می‌شود و اگر کُند بود low در cb_fx_auto می‌ماند
// (فقط رو به پایین، تا بین دو حالت نوسان نکند).
const _fxMobile = () => _isTouchDevice() && !/electron/i.test(navigator.userAgent);
const _fxPref = () => { try { return localStorage.getItem('cb_fx') || 'auto'; } catch { return 'auto'; } };
function _fxResolve() {
  if (!_fxMobile()) return 'high';
  const p = _fxPref();
  if (p !== 'auto') return p;
  const n = navigator;
  if ((n.deviceMemory && n.deviceMemory <= 2) || (n.hardwareConcurrency && n.hardwareConcurrency <= 2) || n.connection?.saveData) return 'low';
  try { return localStorage.getItem('cb_fx_auto') || 'high'; } catch { return 'high'; }
}
function applyFx() { document.documentElement.classList.toggle('fx-low', _fxResolve() === 'low'); }
const _fxLow = () => document.documentElement.classList.contains('fx-low');
applyFx();

// ponytail: یک نمونه‌برداریِ ۲ثانیه‌ای روی اولین پخش؛ اگر لگِ وسطِ بازی هم مهم شد، نمونه‌بردارِ دوره‌ای.
let _fxProbed = false;
function _fxProbe() {
  if (_fxProbed || !_fxMobile() || _fxPref() !== 'auto' || _fxLow() || document.hidden) return;
  _fxProbed = true;
  const end = performance.now() + 2000;
  let last = 0, frames = 0, slow = 0;
  const step = (t) => {
    if (last) { frames++; if (t - last > 28) slow++; }   // >28ms یعنی زیرِ ~۳۵ فریم
    last = t;
    if (t < end && !document.hidden) { requestAnimationFrame(step); return; }
    if (frames >= 30 && slow / frames > 0.25) {
      try { localStorage.setItem('cb_fx_auto', 'low'); } catch { /* noop */ }
      applyFx();
    }
  };
  requestAnimationFrame(step);
}

// دستهٔ چهاررنگ (♦ آبی، ♣ سبز): ترجیحِ محلیِ کاربر، کاملاً مستقل از اتاق و سرور.
// پیش‌فرض همان دو رنگِ کلاسیک (قرمز و مشکی) جهت ثبات دیداری صددرصد روی موبایل و دسکتاپ.
const _deck4 = () => {
  try {
    return localStorage.getItem('cb_deck4') === '1';
  } catch {
    return false;
  }
};

function updateCourtCardImages() {
  const is4c = _deck4();
  document.querySelectorAll('.card.face').forEach((c) => {
    const suit = c.dataset.cardSuit;
    const rank = c.dataset.cardRank;
    if ((suit === 'diamonds' || suit === 'clubs') && (rank === 'J' || rank === 'Q' || rank === 'K')) {
      const img = c.querySelector('.court-card-img');
      if (img) {
        const targetSrc = `/cards/${rank}-${suit}${is4c ? '-4c' : ''}.webp`;
        if (img.getAttribute('src') !== targetSrc) {
          img.src = targetSrc;
        }
      }
    }
  });
}

function applyDeck() {
  document.documentElement.classList.toggle('deck4', _deck4());
  updateCourtCardImages();
  if (typeof scheduleRender === 'function') scheduleRender();
}
if (typeof window !== 'undefined') window.applyDeck = applyDeck;
applyDeck();

function deckColorSection() {
  const sec = el('div', { className: 'rss-section' },
    el('div', { className: 'rss-sec-title' },
      el('span', { textContent: '🃏' }),
      el('strong', { textContent: t('settings.deck_colors', null, 'رنگِ خال‌ها') }),
    ),
  );
  const row = el('div', { className: 'rss-toggle-row' });
  const paint = () => {
    const on = _deck4();
    row.replaceChildren(...[[false, t('settings.deck_classic', null, '♥♠ دو رنگ')], [true, t('settings.deck_4color', null, '♦♣ چهار رنگ')]].map(([val, label]) =>
      el('button', {
        type: 'button',
        className: 'rss-toggle-btn' + (on === val ? ' active' : ''),
        textContent: label,
        onclick: () => {
          try { localStorage.setItem('cb_deck4', val ? '1' : '0'); } catch { /* noop */ }
          if (table && typeof table.setDeck4 === 'function') {
            table.setDeck4(val);
          }
          applyDeck();
          paint();
        },
      })));
  };
  paint();
  sec.append(row);
  return sec;
}

function languageSettingSection(onChanged) {
  const sec = el('div', { className: 'rss-section' },
    el('div', { className: 'rss-sec-title' },
      el('span', { textContent: '🌐' }),
      el('strong', { textContent: t('settings.language', null, 'زبان / Language') }),
    ),
  );
  const row = el('div', { className: 'rss-lang-row' });
  const paint = () => {
    const cur = getLang();
    row.replaceChildren(...Object.values(LANGUAGES).map((meta) =>
      el('button', {
        type: 'button',
        className: 'rss-lang-btn' + (cur === meta.code ? ' active' : ''),
        textContent: `${meta.flag} ${meta.nativeName}`,
        onclick: () => {
          if (setLang(meta.code)) {
            paint();
            onChanged?.();
          }
        },
      })
    ));
  };
  paint();
  sec.append(row);
  return sec;
}

function getTouchPlayMode() {
  return (typeof localStorage !== 'undefined' && localStorage.getItem('cb_touch_mode')) || 'double';
}

// بخشِ تنظیم نحوهٔ پرتاب کارت با لمس در موبایل (تک‌لمس سریع یا دو لمس ایمن)
function touchModeSettingSection() {
  const sec = el('div', { className: 'rss-section' },
    el('div', { className: 'rss-sec-title' },
      el('span', { textContent: '👆' }),
      el('strong', { textContent: t('settings.touch_mode', null, 'نحوه پرتاب کارت با لمس') }),
    ),
  );
  const row = el('div', { className: 'rss-toggle-row' });
  const paint = () => {
    const cur = getTouchPlayMode();
    row.replaceChildren(
      el('button', {
        type: 'button',
        className: 'rss-toggle-btn' + (cur === 'double' ? ' active' : ''),
        textContent: t('settings.touch_double', null, '🛡️ دو لمس (انتخاب + پرتاب)'),
        onclick: () => {
          try { localStorage.setItem('cb_touch_mode', 'double'); } catch { /* noop */ }
          paint();
        },
      }),
      el('button', {
        type: 'button',
        className: 'rss-toggle-btn' + (cur === 'single' ? ' active' : ''),
        textContent: t('settings.touch_single', null, '⚡ تک‌لمس (پرتاب سریع)'),
        onclick: () => {
          try { localStorage.setItem('cb_touch_mode', 'single'); } catch { /* noop */ }
          paint();
        },
      }),
    );
  };
  paint();
  sec.append(row);
  return sec;
}

// بخشِ «کیفیت گرافیک» برای شیتِ تنظیمات و پنلِ پروفایل؛ روی دسکتاپ null.
function fxSettingSection() {
  if (!_fxMobile()) return null;
  const sec = el('div', { className: 'rss-section' },
    el('div', { className: 'rss-sec-title' },
      el('span', { textContent: '✨' }),
      el('strong', { textContent: t('settings.fx_quality', null, 'کیفیت گرافیک') }),
    ),
  );
  const row = el('div', { className: 'rss-toggle-row' });
  const hint = el('p', { className: 'muted small fx-hint' });
  const paint = () => {
    const p = _fxPref();
    row.replaceChildren(...[['auto', t('settings.fx_auto', null, '⚙️ خودکار')], ['high', t('settings.fx_high', null, '🌟 بالا')], ['low', t('settings.fx_low', null, '🔋 کم‌مصرف')]].map(([id, label]) =>
      el('button', {
        type: 'button',
        className: 'rss-toggle-btn' + (p === id ? ' active' : ''),
        textContent: label,
        onclick: () => {
          try {
            localStorage.setItem('cb_fx', id);
            if (id === 'auto') localStorage.removeItem('cb_fx_auto');   // سنجشِ دوباره
          } catch { /* noop */ }
          applyFx();
          paint();
        },
      })));
    hint.textContent = p === 'auto'
      ? t('settings.fx_hint_auto', { mode: _fxLow() ? t('settings.fx_low', null, 'کم‌مصرف') : t('settings.fx_high', null, 'بالا') }, `بر اساسِ توانِ گوشی — اکنون: ${_fxLow() ? 'کم‌مصرف' : 'بالا'}`)
      : p === 'low' ? t('settings.fx_hint_low', null, 'بلور و افکت‌های سنگین خاموش؛ روان‌تر و کم‌مصرف‌تر') : t('settings.fx_hint_high', null, 'همهٔ افکت‌ها روشن');
  };
  paint();
  sec.append(row, hint);
  return sec;
}

function brandMark(small = false) {
  return el('div', { className: 'brand-mark' + (small ? ' sm' : '') },
    // width/height صریح: بدونِ آن‌ها مرورگر نسبتِ تصویر را نمی‌داند و کارتِ ورود
    // تا لودِ لوگو می‌پرد (layout shift).
    el('img', { className: 'brand-logo' + (small ? ' sm' : ''), src: 'logo.webp?v=20261028_428',
      alt: 'چهاربرگ', width: 420, height: 373, decoding: 'async' }),
  );
}

const SEAT_POS = ['bottom', 'right', 'top', 'left'];
function getSeatPos(seat, youSeat, playerCount = 4) {
  if (playerCount === 2) {
    if (youSeat == null || seat == null) return seat === 0 ? 'bottom' : 'top';
    return seat === youSeat ? 'bottom' : 'top';
  }
  if (youSeat == null || seat == null) return SEAT_POS[seat] || 'bottom';
  const relIdx = (seat - youSeat + 4) % 4;
  return SEAT_POS[relIdx];
}
const RED = new Set(['hearts', 'diamonds']);
const SUIT_GLYPH = { spades: '♠', hearts: '♥', diamonds: '♦', clubs: '♣' };
const HOKM_SUIT_SVG = {
  spades: '<svg viewBox="0 0 24 24" class="tbs-hokm-svg" aria-hidden="true"><path fill="currentColor" d="M12 2C9.4 6.8 4 10.8 4 15.2a4.8 4.8 0 0 0 6.8 4.38L9.5 22h5l-1.3-2.42A4.8 4.8 0 0 0 20 15.2C20 10.8 14.6 6.8 12 2z"/></svg>',
  hearts: '<svg viewBox="0 0 24 24" class="tbs-hokm-svg" aria-hidden="true"><path fill="currentColor" d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z"/></svg>',
  diamonds: '<svg viewBox="0 0 24 24" class="tbs-hokm-svg" aria-hidden="true"><path fill="currentColor" d="M12 2L4 12L12 22L20 12L12 2Z"/></svg>',
  clubs: '<svg viewBox="0 0 24 24" class="tbs-hokm-svg" aria-hidden="true"><path fill="currentColor" d="M12 2.5a4.5 4.5 0 0 0-4.36 5.61A4.6 4.6 0 0 0 2.5 12.5a4.6 4.6 0 0 0 4.6 4.6c.98 0 1.9-.31 2.66-.84L8.5 22h7l-1.26-5.74c.76.53 1.68.84 2.66.84a4.6 4.6 0 0 0 4.6-4.6 4.6 4.6 0 0 0-5.14-4.39A4.5 4.5 0 0 0 12 2.5z"/></svg>'
};
const CARD_SUIT_SVG = {
  spades: '<svg viewBox="0 0 24 24" class="card-suit-svg spade" aria-hidden="true"><path fill="currentColor" d="M12 2C9.4 6.8 4 10.8 4 15.2a4.8 4.8 0 0 0 6.8 4.38L9.5 22h5l-1.3-2.42A4.8 4.8 0 0 0 20 15.2C20 10.8 14.6 6.8 12 2z"/></svg>',
  hearts: '<svg viewBox="0 0 24 24" class="card-suit-svg heart" aria-hidden="true"><path fill="currentColor" d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z"/></svg>',
  diamonds: '<svg viewBox="0 0 24 24" class="card-suit-svg diamond" aria-hidden="true"><path fill="currentColor" d="M12 2L4 12L12 22L20 12L12 2Z"/></svg>',
  clubs: '<svg viewBox="0 0 24 24" class="card-suit-svg club" aria-hidden="true"><path fill="currentColor" d="M12 2.5a4.5 4.5 0 0 0-4.36 5.61A4.6 4.6 0 0 0 2.5 12.5a4.6 4.6 0 0 0 4.6 4.6c.98 0 1.9-.31 2.66-.84L8.5 22h7l-1.26-5.74c.76.53 1.68.84 2.66.84a4.6 4.6 0 0 0 4.6-4.6 4.6 4.6 0 0 0-5.14-4.39A4.5 4.5 0 0 0 12 2.5z"/></svg>'
};
const suitFa = (x) => {
  const glyph = SUIT_GLYPH[x] ? ` ${SUIT_GLYPH[x]}` : '';
  return suitName(x) + glyph;
};
const STATE_FA = { WAITING: t('topbar.phase_waiting', null, 'در انتظار'), IN_HAND: t('topbar.phase_playing', null, 'در حال بازی') };
// رنگ‌های آواتار بر اساس اولین حرف نام
const AVATAR_COLORS = ['#5b8cff','#ff7a7a','#36d399','#f4c95d','#c084fc','#fb923c','#38bdf8','#f472b6'];

// ─── State ───────────────────────────────────────────────────────────────────
let table, lastView;
let _cachedFelt = null;
window.__isGameActive = () => {
  return Boolean(lastView && lastView.roomState === 'IN_HAND' && !lastView.matchOver && !lastView.observerMode);
};

let muted = isMuted();
let timerInterval = null;
let occupantsOpen = false;

let authToken = localStorage.getItem('shelem_token') || null;
let networkTable = null;
let selectedGame = localStorage.getItem('cb_game') || 'shelem'; // شلم | حکم | چهاربرگ
const GAME_FA = new Proxy({ shelem: 'شلم', hokm: 'حکم', bidel: 'بی‌دل', chahar_barg: 'چهاربرگ', bluff: 'بلوف' }, {
  get(target, prop) {
    if (typeof prop === 'string' && prop in target) {
      return t(`games.${prop}`, null, target[prop]);
    }
    return target[prop];
  }
});
let _bluffSelectedCards = [];
let _cachedBluffSp = null;

// سیستم حباب محو‌شونده: seat → { text?, voiceId?, data_b64?, duration_s?, timerId }
const ephemerals = new Map();
let prevChatLen = 0;

// محدودیت صدا

// پیام‌های آماده‌ی شخصی (بارگذاری از API)

// شناسه و دوستان کاربر
let myUserId = null;
const friendsSet = new Set(); // userId های دوستان

// ─── API Helper ───────────────────────────────────────────────────────────────
async function apiFetch(method, path, body) {
  const r = await fetch(`${API}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  // توکنِ منقضی/نامعتبر: apiFetch قبلاً همین‌طور خطای {error} را ساکت برمی‌گرداند و
  // هرجا صدا زده می‌شد (از جمله بوتِ صفحه) به‌جای بازگشت به لاگین، حالتِ نامعتبر را
  // «موفق» فرض می‌کرد؛ initNetwork() با همان توکنِ مرده صدا زده می‌شد و WSِ بازی هم
  // ۴۰۱ می‌خورد (که از دیدِ مرورگر شبیهِ قطعیِ شبکه است) → حلقهٔ بی‌پایانِ reconnect.
  if (r.status === 401 && authToken) {
    authToken = null;
    try { localStorage.removeItem('shelem_token'); } catch {}
  }
  return r.json();
}

let myProfile = null;
let plansEnabled = true;
let lobbyBanner = null;   // از /api/banner — تنظیمِ lobby_banner در پنل ادمین
let supportUnreadCount = 0;

async function checkSupportUnread() {
  if (!authToken) return 0;
  try {
    const res = await apiFetch('GET', '/api/support/unread-count');
    if (res && typeof res.count === 'number') {
      supportUnreadCount = res.count;
      updateSupportBadgeUI();
      return supportUnreadCount;
    }
  } catch {}
  return 0;
}

function updateSupportBadgeUI() {
  const badgeEl = document.getElementById('lb-support-badge');
  if (!badgeEl) return;
  if (supportUnreadCount > 0) {
    badgeEl.textContent = faNum(supportUnreadCount);
    badgeEl.classList.remove('hidden');
  } else {
    badgeEl.classList.add('hidden');
  }
}

async function loadMyProfile() {
  if (!authToken) return null;
  try {
    const [me, presetsData, friendsData, pConfig, bannerData] = await Promise.all([
      apiFetch('GET', '/api/profile/me/info'),
      apiFetch('GET', '/api/profile/me/presets'),
      apiFetch('GET', '/api/friends'),
      apiFetch('GET', '/api/payment/config').catch(() => null),
      apiFetch('GET', '/api/banner').catch(() => null),
    ]);
    lobbyBanner = bannerData || null;
    myUserId = me?.id || null;
    myProfile = me || null;
    if (me?.card_back) {
      try { localStorage.setItem('cb_card_back', me.card_back); } catch {}
    }
    setCustomPresets(presetsData?.presets || []);
    try { applyServerQuick(presetsData?.quick); } catch { /* noop */ }
    try { composerUI.renderStrip(); } catch { /* هنوز ساخته نشده */ }
    if (pConfig && pConfig.plans_enabled !== undefined) {
      plansEnabled = pConfig.plans_enabled;
    }
    friendsSet.clear();
    for (const f of (friendsData?.friends || [])) friendsSet.add(f.id);
    checkSupportUnread();
    if (me?.error) return null;   // توکن نامعتبر بود؛ apiFetch پاکش کرد — به‌عنوانِ «بدونِ پروفایل» برگردان
    return me;
  } catch {
    return null;
  }
}

// ─── موتور صوتی در game/audio.js ماژولار شده است ───


let _dealSndHandNo = -1;
let _dealSndHokmSecondDealt = false;
let _isFirstSoundSnapshot = true;
let _cheerTimer = null, _matchEndTimer = null;
let prevSnd = { trickLen: 0, lastWin: null, revealShown: 0, phase: null, chatLen: 0, turnSeat: null, roomState: null, lastBluffClaim: null, bluffInterrogation: null, lastBluffResolution: null };
let _lastContractorStatus = null;
const _thrownCards = new Set(); // شناسه‌ی کارت‌هایی که انیمیشنِ پرتاب گرفته‌اند (تا دوباره انیمیشن نخورند)
let _cachedCenterEl = null;
const _cardThrowTimers = new Map(); // cardId -> timestamp when thrown
const _userThrowVec = new Map();    // cardId -> {fromX, restRot} از سوایپ کاربر — برای پرتابِ جهت‌دار

function getCardTableJitter(cardId) {
  let hash = 0, str = String(cardId);
  for (let k = 0; k < str.length; k++) hash = ((hash << 5) - hash) + str.charCodeAt(k);
  const h1 = Math.abs(hash), h2 = Math.abs(hash >> 3);
  return {
    jx: (((h1 % 17) - 8) * 1.4),   // ±11.2px
    jy: (((h2 % 15) - 7) * 1.1),   // ±7.7px
    jrot: (((h1 % 13) - 6) * 1.1), // ±6.6deg
  };
}
let _dealHandNo = -1;          // شماره‌ی دستِ جاری برای انیمیشنِ پخش
const _dealtCards = new Set();  // شناسه‌ی کارت‌های فرودآمده در دست کاربر
const _dealInfo = new Map();   // cardId -> { landAt } (Date.now() clock) تا انیمیشنِ ورود در رندرهای بعدی ادامه یابد
const DEAL_STAGGER = 28;       // فاصله‌ی ورودِ هر کارت (ms) — آبشاری سریع و بسیار روان
const DEAL_DUR = 240;           // مدتِ انیمیشنِ هر کارت (ms)

// ─── انیمیشنِ پخشِ کارت در ابتدای دست ────────────────────────────────────────
// لایهٔ بصریِ روی فلت: یک دسته‌ورقِ مرکزی، و کارت‌های پشت‌رو (همان طرحِ واقعیِ
// پشتِ کارت) یکی‌یکی با ریتمِ ساعت‌گرد به سمتِ هر صندلی پخش می‌شوند و آنجا
// روی هم می‌نشینند. به چرخهٔ رندر/reconciliation دست نمی‌زند.
let _dealFxHandNo = -1;
let _dealFxDealIndex = -1;
let _dealFxHokmStage = 0;   // 0: پنج برگ اولیه حکم، 1: هشت برگ بعد از تعیین حکم
let _resultOverlayHoldUntil = 0; // زمان انتظار برای اتمام ترنزیشن تریک هفتم
let _lastResultSeenHand = -1;
let _lastAnnouncedHokmHand = -1;
let _lastAnnouncedHokmSuit = null;
let _dealFxUntil = 0;   // تا این زمان (ms) پخش در جریان است → شیت‌های تعهد/حکم بالا نیایند
// حینِ پخش: {t0, step, anim, packs} — از رویش زمانِ فرودِ هر بستهٔ هر صندلی حساب می‌شود
let _dealDeal = null;
// مقصدِ هر صندلی روی فلت (٪ عرض/ارتفاع). مبدأ همیشه (۵۰٪, ۴۰٪) است.
const DEAL_TARGET = { bottom: [50, 84], top: [50, 22], left: [12, 48], right: [88, 48] };

function getDealTarget(pos, round, totalRounds) {
  const rtl = isRTL();
  if (pos === 'bottom') {
    if (totalRounds <= 1) return [50, 84];
    if (totalRounds === 2) {
      return [round === 0 ? (rtl ? 60 : 40) : (rtl ? 40 : 60), 84];
    }
    // پرتاب دقیق به فضای خالی دست: در دور اول سمت شروع، در دورهای بعدی به موقعیت فضای خالی باز
    const txs = rtl ? [62, 44, 33] : [38, 56, 67];
    return [txs[round] ?? 50, 84];
  }
  if (pos === 'top') {
    if (totalRounds <= 1) return [50, 22];
    if (totalRounds === 2) {
      return [round === 0 ? (rtl ? 58 : 42) : (rtl ? 42 : 58), 22];
    }
    const txs = rtl ? [60, 50, 40] : [40, 50, 60];
    return [txs[round] ?? 50, 22];
  }
  if (pos === 'left') {
    const tys = [36, 48, 60];
    return [12, tys[round] ?? 48];
  }
  if (pos === 'right') {
    const tys = [36, 48, 60];
    return [88, tys[round] ?? 48];
  }
  return DEAL_TARGET[pos] || [50, 50];
}

function getActiveCardBack(seat = null) {
  const v = typeof lastView !== 'undefined' ? lastView : null;

  // ۱. اولویت اول: اگر در اتاقی با سازنده مشخص هستیم، طرح پشت کارت سازنده برای کل میز اعمال می‌شود
  if (v) {
    const isMineCreator = Boolean(
      (v.creatorId != null && typeof myUserId !== 'undefined' && myUserId != null && String(v.creatorId) === String(myUserId)) ||
      (v.creatorId == null && v.you === 0)
    );

    let creatorBack = null;
    if (isMineCreator) {
      // من سازنده اتاق هستم: پشت کارت فعال من برای تمام میز اعمال می‌شود
      creatorBack = (typeof myProfile !== 'undefined' && myProfile?.card_back) ||
        (typeof localStorage !== 'undefined' && localStorage.getItem('cb_card_back')) ||
        (v.cardBacks && v.you != null ? v.cardBacks[v.you] : null) || null;
    } else {
      // کاربر دیگری سازنده اتاق است: پشت کارت سازنده اتاق را پیدا کن
      if (v.creatorCardBack) {
        creatorBack = v.creatorCardBack;
      }
      if (!creatorBack && v.cardBacks && Array.isArray(v.userIds) && v.creatorId != null) {
        const cSeat = v.userIds.findIndex((uid) => uid != null && String(uid) === String(v.creatorId));
        if (cSeat >= 0 && v.cardBacks[cSeat]) creatorBack = v.cardBacks[cSeat];
      }
      if (!creatorBack && v.creatorId == null && v.cardBacks && v.cardBacks[0]) {
        creatorBack = v.cardBacks[0];
      }
    }

    if (creatorBack) return creatorBack;
  }

  // ۲. اگر کاربر سازنده اتاق نباشد و سازنده اتاق هم طرح خاصی نداشته باشد (مثلاً بازی سریع بدون میزبان):
  // هر صندلی از طرح خودش، یا کاربر از پروفایل خودش استفاده می‌کند
  if (seat != null && v?.cardBacks && v.cardBacks[seat]) {
    return v.cardBacks[seat];
  }
  if (typeof myProfile !== 'undefined' && myProfile?.card_back) {
    return myProfile.card_back;
  }
  try {
    const saved = localStorage.getItem('cb_card_back');
    if (saved) return saved;
  } catch {}
  return null;
}

function playDealFx(v) {
  predecodeCourtCards(v?.yourHand);
  const felt = _cachedFelt;
  const isHokmSecondDeal = (v?.gameType === 'hokm') && (v?.hokm != null || (v?.yourHand || []).length > 5);
  const dealSndKey = (v?.gameType === 'chahar_barg')
    ? `${v.handNo}_${v.dealIndex || 0}`
    : (v?.gameType === 'hokm' ? `${v?.handNo}_${isHokmSecondDeal ? 1 : 0}` : v?.handNo);
  if (!felt || _reducedMotion()) {
    if (_reducedMotion() && v && v.handNo != null && _dealSndHandNo !== dealSndKey) {
      _dealSndHandNo = dealSndKey;
      sounds.deal({ you: v.you, fast: true });
    }
    _dealFxUntil = 0;
    _dealDeal = null;
    return;
  }
  _fxProbe();
  felt.querySelector('.deal-fx')?.remove();
  $('#table')?.classList.remove('dealing');
  const layer = el('div', { className: 'deal-fx' });
  // دسته‌ورقِ وسطِ میز (چند پشتِ کارتِ واقعیِ روی‌هم) که همراهِ پخش نازک می‌شود
  const deck = el('div', { className: 'deal-deck' });
  for (let k = 0; k < 3; k++) {
    deck.append(el('div', { className: 'deal-deck-c' }, cardEl(null, { faceDown: true, cardBack: getActiveCardBack() })));
  }
  layer.append(deck);

  // پخشِ واقعی سرور: در چهاربرگ ۴ برگ به هر نفر؛ در حکم ۵ برگ اول و سپس ۸ برگ (۴+۴)؛ در شلم ۵+۴+۳=۱۲
  const numSeats = (v?.gameType === 'chahar_barg' && v?.playerCount === 2) ? 2 : (v?.playerCount || 4);
  const totalCards = (v?.yourHand || []).length || (v?.gameType === 'hokm' ? (v?.hokm ? 13 : 5) : (v?.gameType === 'chahar_barg' ? 4 : 12));
  const roundCounts = isHokmSecondDeal
    ? [4, 4]
    : (totalCards === 13 ? [5, 4, 4] : (totalCards === 4 ? [4] : (totalCards === 5 ? [5] : [5, 4, 3])));
  const order = [];
  const perSeat = roundCounts.length;
  for (let round = 0; round < perSeat; round++) {
    for (let s = 0; s < numSeats; s++) {
      if (v?.gameType === 'hokm' && v?.hakemSeat != null) {
        order.push((v.hakemSeat + s) % numSeats);
      } else {
        order.push(v.you != null ? (v.you + 1 + s) % numSeats : s);
      }
    }
  }
  const W = felt.clientWidth || 900, H = felt.clientHeight || 520;
  // ریتم طبیعی، روان و دقیق پخش کارت — حذف کامل لگ و افت فریم
  const INITIAL_DELAY = 60; // مکث بسیار کوتاه اولیه تا چشم دسته کارت وسط میز را ببیند قبل از پرواز
  const STEP = 210;         // فاصله هر پرتاب در یک دور (ms)
  const ROUND_PAUSE = 260;  // مکث ملایم و ارگانیک بین دورها
  const ANIM = 520;         // مدت زمان پرواز هر کارت تا فرود
  const T_LAND_OFFSET = 380; // (~73% پرواز): لحظه‌ای که بسته کارت به دست می‌رسد و کارت‌های دست زیر آن باز می‌شوند

  // هماهنگی دقیق صوتی پرتاب بسته‌های کارت با انیمیشن بصری
  if (v && v.handNo != null && _dealSndHandNo !== dealSndKey) {
    _dealSndHandNo = dealSndKey;
    _dealSndHokmSecondDealt = false;
    sounds.deal({ order, you: v.you, numSeats, step: STEP, roundPause: ROUND_PAUSE, anim: ANIM, initialDelay: INITIAL_DELAY });
  }

  let lastFlightDelay = 0;
  order.forEach((seat, i) => {
    const round = Math.floor(i / numSeats);
    const sIdx = i % numSeats;
    const delay = INITIAL_DELAY + (round * numSeats + sIdx) * STEP + (round * ROUND_PAUSE);
    lastFlightDelay = Math.max(lastFlightDelay, delay);

    const pos = getSeatPos(seat, v.you, numSeats);
    // ضخامتِ بسته با تعدادِ واقعیِ برگ‌هایِ این دور (۵/۴/۳) متناسب است
    // روی لمسی/موبایل ۱ لایه کافی است تا ضمن القای ضخامت سه‌بعدی، ده‌ها لایه سنگین GPU حذف شود
    const packUnder = el('div', { className: 'deal-pack-under' });
    const layers = Math.min(roundCounts[round] - 1, _isTouchDevice() ? 1 : 2);
    for (let L = 0; L < layers; L++) {
      const layerEl = el('div', { className: 'deal-pack-layer' }, cardEl(null, { faceDown: true, cardBack: getActiveCardBack(seat) }));
      // هر لایه کمی متفاوت از بقیهٔ پرتاب‌ها باز می‌شود — یه بسته همیشه دقیقاً یک‌شکل باز نمی‌شه
      layerEl.style.setProperty('--lk', (0.78 + Math.random() * 0.5).toFixed(2));
      packUnder.append(layerEl);
    }
    const fly = el('div', { className: `deal-fly deal-to-${pos}` }, packUnder, cardEl(null, { faceDown: true, cardBack: getActiveCardBack(seat) }));
    const [tx, ty] = getDealTarget(pos, round, perSeat);
    fly.style.setProperty('--dx', ((tx - 50) / 100 * W).toFixed(1) + 'px');
    fly.style.setProperty('--dy', ((ty - 40) / 100 * H).toFixed(1) + 'px');
    if (pos === 'bottom' && perSeat > 1) {
      const rtl = isRTL();
      const tr = rtl ? (round === 0 ? 3 : (round === 2 ? -3 : 0)) : (round === 0 ? -3 : (round === 2 ? 3 : 0));
      fly.style.setProperty('--tr', `${tr}deg`);
    }
    // قوس پرواز و کمی بی‌نظمیِ طبیعی روی هر کارت — تصادفی و ارزان (فقط CSS custom prop، بدون ریفلو)
    fly.style.setProperty('--arc', (22 + Math.random() * 16).toFixed(1) + 'px');
    fly.style.setProperty('--wob', ((Math.random() - 0.5) * 6).toFixed(2) + 'deg');
    // انحرافِ جانبیِ تصادفیِ مسیر (نه فقط خطِ صاف) + زاویهٔ نشستنِ نهاییِ تصادفی
    fly.style.setProperty('--arcx', ((Math.random() - 0.5) * 2).toFixed(2));
    fly.style.setProperty('--land-jit', ((Math.random() - 0.5) * 11).toFixed(2) + 'deg');
    fly.style.setProperty('--fly-delay', delay.toFixed(1) + 'ms');
    layer.append(fly);
  });

  // استقرار فوری لایه در DOM بدون تأخیر فریم تا اولین فریم پرواز از دست نرود
  felt.append(layer);
  $('#table')?.classList.add('dealing');

  // پاک‌سازی تایمرهای پخش قبلی در صورت وجود
  if (_dealDeal?.timers) {
    _dealDeal.timers.forEach((t) => clearTimeout(t));
  }
  if (_dealDeal?.endTimer) {
    clearTimeout(_dealDeal.endTimer);
  }

  // برنامه‌ریزی زمان‌بندی رندرهای مرحله‌ای فرود و انیمیشن مرتب‌سازی پایانی
  const stageTimers = [];
  const curDealKey = (v?.gameType === 'chahar_barg')
    ? `${v.handNo}_${v.dealIndex || 0}`
    : (v?.gameType === 'hokm' ? `${v?.handNo}_${isHokmSecondDeal ? 1 : 0}` : v?.handNo);
  for (let r = 0; r < perSeat; r++) {
    const fd = INITIAL_DELAY + (r * numSeats + (numSeats - 1)) * STEP + r * ROUND_PAUSE;
    const lt = fd + T_LAND_OFFSET;
    const roundIdx = r;
    stageTimers.push(setTimeout(() => {
      if (_dealDeal && (_dealDeal.dealKey || _dealDeal.handNo) === curDealKey) {
        _dealDeal.landedPacks = Math.max(_dealDeal.landedPacks || 0, roundIdx + 1);
        scheduleRender();
      }
    }, lt));
  }

  const lastLands = lastFlightDelay + ANIM; // زمانِ فرودِ آخرین بسته
  const lastYouLand = INITIAL_DELAY + ((perSeat - 1) * numSeats + (numSeats - 1)) * STEP + (perSeat - 1) * ROUND_PAUSE + T_LAND_OFFSET;

  // پایان شمرده پخش: هماهنگ با فرود بسته‌ها و پایان افکت آبشاری ورق‌زدن کارت‌ها
  const TOTAL_DEAL_END = Math.max(lastLands, lastYouLand + (roundCounts[perSeat - 1] * 34) + 220) + 40;

  // بادبزنِ حریف‌ها پا‌به‌پای پخش پر می‌شود. کارت‌ها همین‌جا در همان رندرِ اولِ دست
  // ساخته می‌شوند و با رسیدنِ هر بستهٔ دورِ خود ظاهر می‌شوند.
  _dealDeal = {
    t0: Date.now(),
    initialDelay: INITIAL_DELAY,
    step: STEP,
    roundPause: ROUND_PAUSE,
    anim: ANIM,
    packs: perSeat,
    roundCounts,
    isHokmSecond: isHokmSecondDeal,
    numSeats,
    you: v.you ?? 0,
    handNo: v.handNo,
    dealIndex: v.dealIndex || 0,
    dealKey: curDealKey,
    landOffset: T_LAND_OFFSET,
    dealEnd: TOTAL_DEAL_END,
    landedPacks: 0,
    timers: stageTimers,
    endTimer: null,
  };

  _dealFxUntil = Date.now() + TOTAL_DEAL_END + 40; // هماهنگ با پایان کامل انیمیشن و حذف لایه
  // دسته‌ورق در طولِ پخش تحلیل می‌رود
  deck.style.transition = `opacity ${lastLands}ms linear`;
  requestAnimationFrame(() => { deck.style.opacity = '0'; });
  // بعد از فرودِ آخرین کارت، کلِ لایه نرم محو می‌شود (نه حذفِ ناگهانی)
  setTimeout(() => { layer.style.transition = 'opacity .24s ease'; layer.style.opacity = '0'; }, lastLands + 40);
  // پایانِ پخش: اول لایه برداشته و بادبزن‌ها تکمیل می‌شوند، بعد در فریمِ بعد یک render کامل
  _dealDeal.endTimer = setTimeout(() => {
    layer.remove();
    $('#table')?.classList.remove('dealing');
    if (_dealDeal?.timers) {
      _dealDeal.timers.forEach((t) => clearTimeout(t));
    }
    _dealDeal = null;
    _dealFxUntil = 0;
    scheduleRender();
  }, TOTAL_DEAL_END + 40);
}

// اعلان هوشمند تب مرورگر و لرزش گوشی هنگام نوبت کاربر
let _titleFlashTimer = null;
const ORIGINAL_TITLE = '4Barg';
function flashTitleNotification(text = '🔔 نوبت شماست!') {
  if (typeof document === 'undefined') return;
  if (document.hasFocus && document.hasFocus() && !document.hidden) return;
  if (_titleFlashTimer) return;
  let isAlt = false;
  _titleFlashTimer = setInterval(() => {
    document.title = isAlt ? text : ORIGINAL_TITLE;
    isAlt = !isAlt;
  }, 1000);
}

function resetTitleNotification() {
  if (_titleFlashTimer) {
    clearInterval(_titleFlashTimer);
    _titleFlashTimer = null;
  }
  if (typeof document !== 'undefined') {
    document.title = ORIGINAL_TITLE;
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('focus', resetTitleNotification);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) resetTitleNotification();
  });
}

function maybeSound(v) {
  const trickLen = (v.trick || []).length;
  const revShown = (v.reveal && Array.isArray(v.reveal.shown)) ? v.reveal.shown.length : 0;
  const chatMsgs = (v.chat || []).filter((m) => !m.system);
  const chatLen = chatMsgs.length;
  const yourLen = (v.yourHand || []).length;
  const discCount = Object.keys(v.discSeats || {}).length;
  const abandCount = (v.abandonedSeats || []).length;

  // در اولین اسنپ‌شاتِ ورود یا وصل مجدد، وضعیت را ذخیره کن بدون شلیک صداهای بیات
  if (_isFirstSoundSnapshot) {
    _isFirstSoundSnapshot = false;
    prevSnd = { trickLen, lastWin: v.lastWin, revealShown: revShown, phase: v.phase, result: v.result, matchOver: v.matchOver, chatLen, yourLen, turnSeat: v.turnSeat, roomState: v.roomState, discCount, abandCount, heartsBroken: v.heartsBroken, lastBluffClaim: v.lastBluffClaim, bluffInterrogation: v.bluffInterrogation, lastBluffResolution: v.lastBluffResolution, dealIndex: v.dealIndex };
    return;
  }

  // پخشِ اصلیِ کارت در شروع دست توسط playDealFx(v) انجام می‌شود تا کاملاً با انیمیشن بصری سینک باشد.
  if (v.gameType === 'hokm' && yourLen > 5 && !_dealSndHokmSecondDealt && _reducedMotion()) {
    _dealSndHokmSecondDealt = true;
    sounds.deal({ you: v.you, fast: true, order: [0, 1, 2, 3, 0, 1, 2, 3] });
  }
  if (v.gameType === 'chahar_barg' && v.dealIndex != null && v.dealIndex > 0 && v.dealIndex !== prevSnd.dealIndex && _reducedMotion()) {
    sounds.deal({ you: v.you, fast: true });
  }

  if (v.phase === 'REVEAL' && revShown > prevSnd.revealShown) sounds.reveal();
  else if (v.phase === 'HAND_STARTED' || (v.phase !== prevSnd.phase && (v.phase === 'BIDDING' || v.phase === 'CHOOSE_HOKM'))) sounds.handStart();
  else if (trickLen > prevSnd.trickLen) {
    sounds.stopDeal?.();
    // صدای پخشِ کارت از سمتِ صندلیِ همان بازیکن پن می‌شود (صدای موقعیتی)
    const lastItem = (v.trick && v.trick.length) ? v.trick[v.trick.length - 1] : null;
    const lastSeat = lastItem ? lastItem.seat : null;
    const pan = lastSeat === v.you ? 0 : _seatPan(lastSeat, v.you);
    // اگر کارت متعلق به خود کاربر باشد، در executeCardPlay فوراً پخش شده؛ از پخش مجدد پرهیز کن
    if (lastSeat !== v.you) {
      if (v.gameType === 'bidel') {
        const c = lastItem?.card || lastItem;
        const isQueenSpades = c && (c.suit === 'spades' || c.suit === 's') && (c.rank === 'Q' || c.rank === 12);
        if (isQueenSpades) {
          sounds.queenSpades(pan);
        } else {
          sounds.play(pan);
        }
      } else {
        const c = lastItem?.card || lastItem;
        const leadCard = v.trick[0]?.card;
        const leadIsTrump = leadCard && (leadCard.suit === v.hokm || isJoker(leadCard));
        const hasPriorJoker = v.trick.slice(0, -1).some((t) => isJoker(t.card));
        const isTrumpCut = v.hokm && trickLen > 1 && !leadIsTrump && !hasPriorJoker && (c && (c.suit === v.hokm || isJoker(c)));
        if (!isTrumpCut) {
          sounds.play(pan);
        }
      }
    }
  }

  // افکت سینمایی شکسته شدن دل در بی‌دل (اولین باری که کارتی از خال دل بازی می‌شود)
  if (v.gameType === 'bidel' && v.heartsBroken && !prevSnd.heartsBroken) {
    sounds.heartBroken();
  }

  // اعلان و لرزش هوشمند هنگام رسیدن نوبت کاربر (مشروط به پایان پرواز کارت‌ها و نبود تریک در حال نمایش/جمع‌آوری)
  const isDealingActive = (typeof _dealFxUntil === 'number' && Date.now() < _dealFxUntil) || (typeof _dealDeal !== 'undefined' && _dealDeal !== null);
  const isTrickHolding = v.lastWin != null;
  const isYourTurnNow = !v.observerMode && !isDealingActive && !isTrickHolding && isActiveSeat(v, v.you) && (v.roomState === 'IN_HAND' || v.phase === 'PLAYING_TURNS' || v.phase === 'BIDDING' || v.phase === 'CHOOSE_HOKM');
  const wasYourTurn = !v.observerMode && isActiveSeat(prevSnd, v.you) && (prevSnd.roomState === 'IN_HAND' || prevSnd.phase === 'PLAYING_TURNS' || prevSnd.phase === 'BIDDING' || prevSnd.phase === 'CHOOSE_HOKM');
  if (isYourTurnNow && !wasYourTurn) {
    if (navigator.vibrate) try { navigator.vibrate([70, 40, 70]); } catch {}
    flashTitleNotification('🔔 نوبت شماست!');
    sounds.yourTurn();
  }
  if (!isYourTurnNow && wasYourTurn && !isTrickHolding && !isDealingActive) {
    resetTitleNotification();
  }

  // پایش تغییر وضعیت دست و پخش افکت دراماتیک تنش و لرزش گوشی
  if (v.gameType === 'shelem' && v.contractorSeat != null && v.phase === 'PLAYING_TURNS') {
    const cStatus = getHandStatus(v, v.contractorSeat % 2).status;
    if (cStatus !== _lastContractorStatus) {
      if (cStatus === 'danger-red') {
        sounds.tension(2);
        if (navigator.vibrate) try { navigator.vibrate([60, 50, 60, 50, 100]); } catch {}
      } else if (cStatus === 'danger-orange') {
        sounds.tension(1);
        if (navigator.vibrate) try { navigator.vibrate([50, 40, 50]); } catch {}
      } else if (cStatus === 'warn-yellow' && _lastContractorStatus === 'safe-green') {
        sounds.tension(1);
        if (navigator.vibrate) try { navigator.vibrate([35, 35]); } catch {}
      }
      _lastContractorStatus = cStatus;
    }
  } else if (v.phase !== 'PLAYING_TURNS') {
    _lastContractorStatus = null;
  }

  // ناظر تیمی ندارد؛ نه تشویق می‌شنود نه صدای برد/باخت (قبلاً `you % 2` = NaN بود و
  // مقایسه همیشه false می‌شد → ناظر همیشه صدای باخت می‌شنید).
  const youTeam = (!v.observerMode && v.you != null) ? v.you % 2 : null;

  if (v.result && !prevSnd.result) {
    const r = v.result;
    if (v.gameType === 'bidel') {
      if (r.shotTheMoonSeat != null) {
        sounds.moonShot();
      } else {
        sounds.handResult();
      }
    } else {
      sounds.handResult();
      const winTeam = v.gameType === 'hokm'
        ? r.winnerTeam
        : (r.contractorTeam != null ? (r.success ? r.contractorTeam : (1 - r.contractorTeam)) : null);
      // تشویقِ بردِ این دست با تأخیر پخش می‌شود تا اگر بلافاصله MATCH_OVER رسید (پیامِ
      // جداگانه‌ای که پشتِ سرِ HAND_RESULT می‌آید) بتوان لغوش کرد — وگرنه در دستِ آخرِ یک
      // بازیِ باخته، تشویق و صدای باخت با هم پخش می‌شدند.
      clearTimeout(_cheerTimer);
      if (youTeam != null && winTeam === youTeam) _cheerTimer = setTimeout(() => sounds.cheer(), 350);
    }
  }
  if (v.matchOver && !prevSnd.matchOver) {
    clearTimeout(_cheerTimer); clearTimeout(_matchEndTimer);
    // بازیِ لغوشده هم matchOver می‌شود؛ آنجا برد/باختی در کار نیست
    if (v.gameType === 'bidel') {
      if (!v.observerMode && v.you != null && !v.matchCancelled) {
        const scores = v.matchScore || [0, 0, 0, 0];
        const minScore = Math.min(...scores);
        const won = scores[v.you] === minScore;
        _matchEndTimer = setTimeout(() => {
          won ? sounds.matchWin() : sounds.matchLose();
          if (won) _cheerTimer = setTimeout(() => sounds.cheer(), 500);
        }, 400);
      }
    } else if (youTeam != null && !v.matchCancelled) {
      const won = v.matchScore[youTeam] >= v.matchScore[1 - youTeam];
      // بعد از پایانِ handResult (~۳۳۰ms) تا روی هم نیفتند؛ تشویق هم بعدِ فانفارِ برد.
      _matchEndTimer = setTimeout(() => {
        won ? sounds.matchWin() : sounds.matchLose();
        if (won) _cheerTimer = setTimeout(() => sounds.cheer(), 500);
      }, 400);
    }
  }
  if (chatLen > prevSnd.chatLen) {
    const lastMsg = chatMsgs[chatLen - 1];
    // پیامِ خودت صدا ندارد (بازخوردِ ارسال، toast است)؛ پیامِ صوتی صدای خودش را دارد
    if (lastMsg && lastMsg.seat !== v.you) (lastMsg.voiceId ? sounds.voiceIn : sounds.chatIn)();
  }
  // ربات جای بازیکنِ قطع‌شده نشست / بازیکن برگشت
  if (discCount + abandCount > (prevSnd.discCount || 0) + (prevSnd.abandCount || 0)) sounds.botTakeover?.();
  else if (discCount < (prevSnd.discCount || 0) && abandCount === (prevSnd.abandCount || 0)) sounds.playerBack?.();
  prevSnd = { trickLen, lastWin: v.lastWin, revealShown: revShown, phase: v.phase, result: v.result, matchOver: v.matchOver, chatLen, yourLen, turnSeat: v.turnSeat, roomState: v.roomState, discCount, abandCount, heartsBroken: v.heartsBroken, lastBluffClaim: v.lastBluffClaim, bluffInterrogation: v.bluffInterrogation, lastBluffResolution: v.lastBluffResolution, dealIndex: v.dealIndex };
}

// ─── Toast ────────────────────────────────────────────────────────────────────
let toastTimer;
function toast(msg) {
  const t = $('#toast');
  t.textContent = msg;
  t.classList.remove('hidden');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.add('hidden'), 2400);
}

// ─── حباب محو‌شونده ───────────────────────────────────────────────────────────
let _bubbleSeq = 0;
function setBubble(seat, data, ms) {
  const prev = ephemerals.get(seat);
  if (prev?.timerId) clearTimeout(prev.timerId);
  const timerId = setTimeout(() => {
    ephemerals.delete(seat);
    scheduleRender();
  }, ms);
  // هر بار setBubble یک شناسهٔ تازه می‌گیرد → فقط همین حباب انیمیشنِ ورود می‌خورد، نه بقیه
  ephemerals.set(seat, { ...data, timerId, _seq: ++_bubbleSeq });
  scheduleRender();
}

function clearBubble(seat) {
  const prev = ephemerals.get(seat);
  if (prev?.timerId) clearTimeout(prev.timerId);
  ephemerals.delete(seat);
  scheduleRender();
}

// اعلامِ تعهد/پاس از سرور مستقل از رندر و انیمیشنِ پخش می‌رسد — سرور منتظرِ کلاینت
// نمی‌ماند، پس اگر حاکم/بازیکنِ بعدی (خصوصاً بات) خیلی زود تعهد بدهد، این پیام وسطِ
// پروازِ کارت‌ها می‌رسید. تا وقتی پخشِ بصری تمام نشده (_dealFxUntil)، صدا و حبابِ
// تعهد را نگه می‌داریم و همون لحظه که پخش تمام شد نشونش می‌دیم.
function handleBidMade({ seat, action }) {
  if (seat == null || !action) return;
  if (Date.now() < _dealFxUntil) {
    setTimeout(() => handleBidMade({ seat, action }), _dealFxUntil - Date.now() + 30);
    return;
  }
  if (seat !== lastView?.you) {
    if (action.type === 'BID' || action.type === 'SHELEM' || action.type === 'KENZ') sounds?.bid?.();
    else if (action.type === 'PASS') sounds?.pass?.();
  }
  if (action.type === 'PASS') {
    setBubble(seat, {
      text: t('bidding.bubble_pass', null, 'پاس ✋'),
      i18nKey: 'bidding.bubble_pass',
      isPass: true,
    }, 4000);
  } else {
    const isKenz = action.type === 'KENZ' || action.bid_type === 'kenz' || action.amount === 'kenz';
    const isShelem = action.type === 'SHELEM' || action.bid_type === 'shelem' || action.amount === 'shelem';
    let txt = t('bidding.bubble_bid', { amount: faNum(action.amount) }, `تعهد: ${faNum(action.amount)}`);
    let i18nKey = 'bidding.bubble_bid';
    let params = { amount: faNum(action.amount) };
    if (isKenz) {
      txt = t('bidding.bubble_kenz', null, '⚡ کنز (All-In)');
      i18nKey = 'bidding.bubble_kenz';
      params = null;
    } else if (isShelem) {
      txt = t('bidding.bubble_shelem', null, '🔥 شلم');
      i18nKey = 'bidding.bubble_shelem';
      params = null;
    }
    setBubble(seat, {
      text: txt,
      i18nKey,
      params,
      isBid: true,
    }, 5000);
  }
}

const BLUFF_RANK_FA = {
  '2': '۲', '3': '۳', '4': '۴', '5': '۵', '6': '۶', '7': '۷', '8': '۸', '9': '۹', '10': '۱۰',
  'J': 'سرباز', 'Q': 'بی‌بی', 'K': 'شاه', 'A': 'آس'
};

function handleBluffClaim(msg) {
  if (msg.seat == null) return;
  const name = lastView?.names?.[msg.seat] || t('hand_result.team_n', { n: msg.seat + 1 }, `بازیکن ${msg.seat + 1}`);
  const rLabel = BLUFF_RANK_FA[msg.claimedRank] || msg.claimedRank;
  const countStr = typeof faNum === 'function' ? faNum(msg.count) : msg.count;
  const text = t('bluff.bubble_claim', { count: countStr, rank: rLabel }, `🃏 ${countStr} کارت ${rLabel}`);
  setBubble(msg.seat, { text, i18nKey: 'bluff.bubble_claim', params: { count: countStr, rank: rLabel } }, 4000);
  if (msg.seat !== lastView?.you) toast(`🃏 ${name}: ${text}`);
  if (msg.seat !== lastView?.you) BluffAudio.cardSlam();
}

function handleBluffInterrogation(msg) {
  const chName = lastView?.names?.[msg.challengerSeat] || t('hand_result.team_n', { n: (msg.challengerSeat ?? 0) + 1 }, `بازیکن ${(msg.challengerSeat ?? 0) + 1}`);
  const acName = lastView?.names?.[msg.accusedSeat] || t('hand_result.team_n', { n: (msg.accusedSeat ?? 0) + 1 }, `بازیکن ${(msg.accusedSeat ?? 0) + 1}`);
  setBubble(msg.challengerSeat, { text: t('bluff.bubble_doubt', null, '🚨 مشکوکم!'), i18nKey: 'bluff.bubble_doubt' }, 3500);
  toast(`🚨 ${chName} به ادعای ${acName} شک کرد!`);
  if (msg.challengerSeat !== lastView?.you) BluffAudio.subBassDrop();
}

function handleBluffConfess(msg) {
  const acName = lastView?.names?.[msg.accusedSeat] || t('hand_result.team_n', { n: (msg.accusedSeat ?? 0) + 1 }, `بازیکن ${(msg.accusedSeat ?? 0) + 1}`);
  setBubble(msg.accusedSeat, { text: t('bluff.bubble_confess', null, '🏳️ اعتراف کردم!'), i18nKey: 'bluff.bubble_confess' }, 3500);
  toast(`🏳️ ${acName} اعتراف کرد.`);
}

function handleBluffStandGround(msg) {
  const acName = lastView?.names?.[msg.accusedSeat] || t('hand_result.team_n', { n: (msg.accusedSeat ?? 0) + 1 }, `بازیکن ${(msg.accusedSeat ?? 0) + 1}`);
  setBubble(msg.accusedSeat, { text: t('bluff.bubble_stand_ground', null, '🛡️ پای حرفم هستم!'), i18nKey: 'bluff.bubble_stand_ground' }, 3500);
  toast(`🛡️ ${acName} بر ادعایش اصرار کرد!`);
  if (msg.accusedSeat !== lastView?.you) BluffAudio.subBassDrop();
}

function handleBluffResolved(msg) {
  if (msg.outcome === 'WITHDRAWN' || msg.outcome === 'WITHDRAW' || msg.outcome === 'WITHDRAWAL') {
    const chName = lastView?.names?.[msg.challengerSeat] || t('hand_result.team_n', { n: (msg.challengerSeat ?? 0) + 1 }, `بازیکن ${(msg.challengerSeat ?? 0) + 1}`);
    if (msg.challengerSeat != null) setBubble(msg.challengerSeat, { text: t('bluff.bubble_withdrawn', null, '🏳️ عقب‌نشینی کردم'), i18nKey: 'bluff.bubble_withdrawn' }, 3500);
    if (msg.accusedSeat != null) setBubble(msg.accusedSeat, { text: t('bluff.bubble_told_truth', null, '😏 گفتم که راست می‌گم'), i18nKey: 'bluff.bubble_told_truth' }, 3500);
    toast(`🏳️ ${chName} انصراف داد و ۱ کارت جریمه گرفت.`);
    if (msg.challengerSeat !== lastView?.you) BluffAudio.curiosityChime();
  } else if (msg.isHonest) {
    const wName = lastView?.names?.[msg.winnerSeat] || t('hand_result.team_n', { n: (msg.winnerSeat ?? 0) + 1 }, `بازیکن ${(msg.winnerSeat ?? 0) + 1}`);
    const lName = lastView?.names?.[msg.loserSeat] || t('hand_result.team_n', { n: (msg.loserSeat ?? 0) + 1 }, `بازیکن ${(msg.loserSeat ?? 0) + 1}`);
    if (msg.winnerSeat != null) setBubble(msg.winnerSeat, { text: t('bluff.bubble_told_truth_excl', null, '✅ راست گفتم!'), i18nKey: 'bluff.bubble_told_truth_excl' }, 4000);
    if (msg.loserSeat != null) setBubble(msg.loserSeat, { text: t('bluff.bubble_penalized', null, '🤦 جریمه شدم!'), i18nKey: 'bluff.bubble_penalized' }, 4000);
    toast(`✅ ادعای ${wName} کاملاً راست بود! ${lName} پات را برداشت.`);
    BluffAudio.honestVictory();
  } else if (msg.loserSeat != null && msg.winnerSeat != null) {
    const wName = lastView?.names?.[msg.winnerSeat] || t('hand_result.team_n', { n: (msg.winnerSeat ?? 0) + 1 }, `بازیکن ${(msg.winnerSeat ?? 0) + 1}`);
    const lName = lastView?.names?.[msg.loserSeat] || t('hand_result.team_n', { n: (msg.loserSeat ?? 0) + 1 }, `بازیکن ${(msg.loserSeat ?? 0) + 1}`);
    setBubble(msg.loserSeat, { text: t('bluff.bubble_busted', null, '💥 لو رفتم!'), i18nKey: 'bluff.bubble_busted' }, 4000);
    setBubble(msg.winnerSeat, { text: t('bluff.bubble_caught', null, '🎯 مچت رو گرفتم!'), i18nKey: 'bluff.bubble_caught' }, 4000);
    toast(`💥 مچ‌گیری موفق! ادعای ${lName} بلوف بود.`);
    BluffAudio.bluffBusted();
  }
}

function clearBubbleWithAnimation(seat) {
  const pos = (seat != null ? getSeatPos(seat, lastView?.you) : null) || 'bottom';
  const seatEl = document.querySelector(`.seat-${pos}`);
  const bEl = document.querySelector('.seat-bubble.mine-bub') && seat === lastView?.you
    ? document.querySelector('.seat-bubble.mine-bub')
    : seatEl?.querySelector('.seat-bubble');
  if (bEl) {
    bEl.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
    bEl.style.opacity = '0';
    // --bubble-tx در صندلی‌های چپ/راست 0% است؛ hardcode کردنِ -50% باعثِ پرشِ افقی حین محو می‌شد
    bEl.style.transform = 'translateX(var(--bubble-tx, -50%)) translateY(-10px) scale(0.85)';
    setTimeout(() => {
      clearBubble(seat);
    }, 350);
  } else {
    clearBubble(seat);
  }
}

// ─── همگام‌سازی تایمر چرخشی و عدد معکوس نوبت روی آواتار (ایجاد یا به‌روزرسانی درجا) ───
function syncTurnTimer(avWrap, avSize, isTurn, turnPct, isDanger, turnSecs, square = true) {
  if (!isTurn) {
    const oldSvg = avWrap.querySelector(':scope > .radial-timer-svg');
    if (oldSvg) oldSvg.remove();
    const oldTimer = avWrap.querySelector(':scope > .avatar-turn-timer');
    if (oldTimer) oldTimer.remove();
    return;
  }

  const NS = 'http://www.w3.org/2000/svg';
  const pad = 4;
  const wrapSize = avSize + (pad * 2);
  const sqR = square ? Math.round(avSize * 0.26) : 0;
  const pctLeft = Math.max(0, Math.min(100, turnPct)) / 100;

  let svg = avWrap.querySelector(':scope > .radial-timer-svg');
  let len;
  if (!svg) {
    svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'radial-timer-svg' + (square ? ' sq' : ''));
    svg.setAttribute('viewBox', `0 0 ${wrapSize} ${wrapSize}`);
    svg.style.cssText = `width:${wrapSize}px;height:${wrapSize}px;`;

    const mk = (cls) => {
      if (square) {
        const x = pad, y = pad;
        const w = avSize, h = avSize;
        const rx = sqR;
        len = 2 * (w + h) - 8 * rx + 2 * Math.PI * rx;
        const e = document.createElementNS(NS, 'rect');
        e.setAttribute('class', cls);
        e.setAttribute('x', String(x)); e.setAttribute('y', String(y));
        e.setAttribute('width', String(w)); e.setAttribute('height', String(h));
        e.setAttribute('rx', String(rx));
        return e;
      }
      const r = avSize / 2;
      len = 2 * Math.PI * r;
      const e = document.createElementNS(NS, 'circle');
      e.setAttribute('class', cls);
      e.setAttribute('cx', String(wrapSize / 2));
      e.setAttribute('cy', String(wrapSize / 2));
      e.setAttribute('r', String(r));
      return e;
    };

    const track = mk('radial-timer-track');
    const ring = mk('radial-timer-ring' + (isDanger ? ' danger' : ''));
    ring.setAttribute('stroke-dasharray', String(len));
    const off = String(len * (1 - pctLeft));
    ring.setAttribute('stroke-dashoffset', off);
    ring.style.strokeDashoffset = off;

    svg.append(track, ring);
    avWrap.append(svg);
  } else {
    const track = svg.querySelector('.radial-timer-track');
    const ring = svg.querySelector('.radial-timer-ring');
    if (ring) {
      if (square) {
        const x = pad, y = pad;
        const w = avSize, h = avSize;
        const rx = sqR;
        len = 2 * (w + h) - 8 * rx + 2 * Math.PI * rx;
        ring.setAttribute('x', String(x)); ring.setAttribute('y', String(y));
        ring.setAttribute('width', String(w)); ring.setAttribute('height', String(h));
        ring.setAttribute('rx', String(rx));
        if (track) {
          track.setAttribute('x', String(x)); track.setAttribute('y', String(y));
          track.setAttribute('width', String(w)); track.setAttribute('height', String(h));
          track.setAttribute('rx', String(rx));
        }
      } else {
        const r = avSize / 2;
        len = 2 * Math.PI * r;
        ring.setAttribute('cx', String(wrapSize / 2)); ring.setAttribute('cy', String(wrapSize / 2));
        ring.setAttribute('r', String(r));
        if (track) {
          track.setAttribute('cx', String(wrapSize / 2)); track.setAttribute('cy', String(wrapSize / 2));
          track.setAttribute('r', String(r));
        }
      }
      svg.setAttribute('viewBox', `0 0 ${wrapSize} ${wrapSize}`);
      svg.style.cssText = `width:${wrapSize}px;height:${wrapSize}px;`;
      ring.classList.toggle('danger', isDanger);
      ring.setAttribute('stroke-dasharray', String(len));
      const off = String(len * (1 - pctLeft));
      ring.setAttribute('stroke-dashoffset', off);
      ring.style.strokeDashoffset = off;
    }
  }

  // عدد تایمر نوبت درون آواتار کاربر
  let timerOverlay = avWrap.querySelector(':scope > .avatar-turn-timer');
  if (turnSecs != null) {
    if (!timerOverlay) {
      timerOverlay = el('div', {
        className: 'avatar-turn-timer' + (isDanger ? ' danger' : ''),
        textContent: faNum(turnSecs),
        title: `زمان باقی‌مانده: ${faNum(turnSecs)} ثانیه`
      });
      timerOverlay.style.borderRadius = square ? `${sqR}px` : '50%';
      avWrap.append(timerOverlay);
    } else {
      timerOverlay.textContent = faNum(turnSecs);
      timerOverlay.title = `زمان باقی‌مانده: ${faNum(turnSecs)} ثانیه`;
      timerOverlay.classList.toggle('danger', isDanger);
    }
  } else if (timerOverlay) {
    timerOverlay.remove();
  }
}

// ─── آواتار (با ساپورت رینگ تایمر و شمارنده عدد نوبت) ──────────────
function avatarEl(name, url, size = 42, isTurn = false, turnPct = 100, isDanger = false, square = true, turnSecs = null, isBot = false, frame = null) {
  const pad = 4; // فاصله ۲ پیکسلی از هر طرف برای رینگ تایمر
  const wrapSize = size + (pad * 2);
  const sqR = square ? Math.round(size * 0.26) : 0;   // شعاعِ گوشهٔ مربعِ گوشه‌گرد
  const normFrame = frame ? (frame.startsWith('frame-') || frame.startsWith('frame_') ? frame.replace(/^frame[-_]/, '') : frame).replace(/_/g, '-') : '';
  const frameClass = normFrame ? ` frame-${normFrame}` : '';
  const wrap = el('div', { className: 'seat-av-wrap' + (square ? ' sq' : '') + (isTurn ? ' is-turn' : '') + frameClass });
  wrap.style.cssText = `width:${wrapSize}px;height:${wrapSize}px;`;

  // آواتار تصویر، حرف، یا ربات
  let av;
  if (isBot || (name && name.startsWith('ربات'))) {
    av = el('div', { className: 'seat-avatar bot-avatar' + (square ? ' sq' : ''), textContent: '🤖', title: name });
    av.style.cssText = `width:${size}px;height:${size}px;background:linear-gradient(135deg, #1e293b, #334155);font-size:${Math.round(size*0.52)}px;border:1px solid rgba(255,255,255,0.12);` + (square ? `border-radius:${sqR}px;` : '');
  } else if (url) {
    const fullUrl = (url.startsWith('/uploads/') && API) ? `${API}${url}` : url;
    av = el('img', { className: 'seat-avatar' + (square ? ' sq' : ''), src: fullUrl, title: name });
    av.style.cssText = `width:${size}px;height:${size}px;` + (square ? `border-radius:${sqR}px;` : '');
    av.onerror = () => {
      const letter = (name || '?').charAt(0);
      const color = AVATAR_COLORS[(letter.codePointAt(0) || 0) % AVATAR_COLORS.length];
      const fallback = el('div', { className: 'seat-avatar' + (square ? ' sq' : ''), textContent: letter, title: name });
      fallback.style.cssText = `width:${size}px;height:${size}px;background:${color};font-size:${Math.round(size*0.44)}px;` + (square ? `border-radius:${sqR}px;` : '');
      av.replaceWith(fallback);
    };
  } else {
    const letter = (name || '?').charAt(0);
    const color = AVATAR_COLORS[(letter.codePointAt(0) || 0) % AVATAR_COLORS.length];
    av = el('div', { className: 'seat-avatar' + (square ? ' sq' : ''), textContent: letter, title: name });
    av.style.cssText = `width:${size}px;height:${size}px;background:${color};font-size:${Math.round(size*0.44)}px;` + (square ? `border-radius:${sqR}px;` : '');
  }
  wrap.append(av);

  // رینگ تایمر SVG و عدد شمارنده درون آواتار در صورتی که نوبت این بازیکن باشد
  if (isTurn) {
    syncTurnTimer(wrap, size, isTurn, turnPct, isDanger, turnSecs, square);
  }

  return wrap;
}

// ─── کارت ────────────────────────────────────────────────────────────────────
const FACE_RANKS = new Set(['J', 'Q', 'K']);

// چیدمانِ متقارن، اصیل و استاندارد خال‌ها روی کارت‌های عددی (۲ تا ۱۰) با حریم امن قطعی از گوشه‌ها
const PIP_LAYOUT = {
  '2': [
    { x: 50, y: 15 },
    { x: 50, y: 85, inv: true }
  ],
  '3': [
    { x: 50, y: 15 },
    { x: 50, y: 50 },
    { x: 50, y: 85, inv: true }
  ],
  '4': [
    { x: 26, y: 15 }, { x: 74, y: 15 },
    { x: 26, y: 85, inv: true }, { x: 74, y: 85, inv: true }
  ],
  '5': [
    { x: 26, y: 15 }, { x: 74, y: 15 },
    { x: 50, y: 50 },
    { x: 26, y: 85, inv: true }, { x: 74, y: 85, inv: true }
  ],
  '6': [
    { x: 26, y: 15 }, { x: 74, y: 15 },
    { x: 26, y: 50 }, { x: 74, y: 50 },
    { x: 26, y: 85, inv: true }, { x: 74, y: 85, inv: true }
  ],
  '7': [
    { x: 26, y: 15 }, { x: 74, y: 15 },
    { x: 50, y: 32 },
    { x: 26, y: 50 }, { x: 74, y: 50 },
    { x: 26, y: 85, inv: true }, { x: 74, y: 85, inv: true }
  ],
  '8': [
    { x: 26, y: 15 }, { x: 74, y: 15 },
    { x: 50, y: 32 },
    { x: 26, y: 50 }, { x: 74, y: 50 },
    { x: 50, y: 68, inv: true },
    { x: 26, y: 85, inv: true }, { x: 74, y: 85, inv: true }
  ],
  '9': [
    { x: 26, y: 14 }, { x: 74, y: 14 },
    { x: 26, y: 38 }, { x: 74, y: 38 },
    { x: 50, y: 50 },
    { x: 26, y: 62, inv: true }, { x: 74, y: 62, inv: true },
    { x: 26, y: 86, inv: true }, { x: 74, y: 86, inv: true }
  ],
  '10': [
    { x: 26, y: 14 }, { x: 74, y: 14 },
    { x: 50, y: 26 },
    { x: 26, y: 38 }, { x: 74, y: 38 },
    { x: 26, y: 62, inv: true }, { x: 74, y: 62, inv: true },
    { x: 50, y: 74, inv: true },
    { x: 26, y: 86, inv: true }, { x: 74, y: 86, inv: true }
  ]
};
function pipGrid(rank, suitSvgOrGlyph) {
  const box = el('div', { className: 'pips' });
  const layout = PIP_LAYOUT[rank] || [];
  for (const p of layout) {
    const s = el('span', { className: 'pip-item' + (p.inv ? ' inv' : '') });
    s.style.left = p.x + '%';
    s.style.top = p.y + '%';
    if (typeof suitSvgOrGlyph === 'string' && suitSvgOrGlyph.startsWith('<svg')) {
      s.innerHTML = suitSvgOrGlyph;
    } else {
      s.textContent = suitSvgOrGlyph;
    }
    box.append(s);
  }
  return box;
}

// ID برگهٔ انتخاب‌شده با لمسِ اول در موبایل (الگوی دو‌مرحله‌ای: لمس اول → انتخاب، لمس دوم → پرتاب)
let _mobileSelId = null;
let _mobileSelTs = 0;

// لمسِ هر جای دیگر (میز، دکمه، خالیِ صفحه) انتخابِ دومرحله‌ای را لغو می‌کند؛ قبلاً فقط
// با لمسِ برگهٔ دیگر عوض می‌شد و برگهٔ بالاآمده تا لمسِ بعدیِ اشتباه منتظر می‌ماند.
document.addEventListener('pointerdown', (e) => {
  if (_mobileSelId == null || e.target.closest?.('.hand-strip .card')) return;
  _mobileSelId = null;
  _mobileSelTs = 0;
  document.querySelectorAll('.hand-strip .card.sel').forEach((n) => {
    n.classList.remove('sel');
    n.style.transform = '';
  });
  document.querySelectorAll('.hand-row.row-top.has-sel').forEach((n) => n.classList.remove('has-sel'));
}, { capture: true, passive: true });

// پرتاب لمسی با سوایپ به بالا (Swipe-to-throw) همگام با VSync نمایشگر (requestAnimationFrame)
function setupCardTouchInteractions(c, card) {
  if (c.__touchSwipeBound) return;
  c.__touchSwipeBound = true;

  let touchStartY = 0;
  let touchStartX = 0;
  let touchStartTime = 0;
  let touchDragging = false;
  let rAF = null;
  let latestDx = 0;
  let latestDy = 0;

  const getIsPlayable = () => c.classList.contains('click') && !c.dataset.playing;

  const doPlay = () => {
    if (table._s?.gameType === 'bluff') {
      c.click();
      return;
    }
    executeCardPlay(card, c, table._s);
  };

  c.addEventListener('touchstart', (e) => {
    if (table._s?.gameType === 'bluff') return; // در بازی بلوف، انتخاب کارت با لمس و ثبت با پنل ادعاست
    if (e.touches.length !== 1 || !getIsPlayable()) return;
    touchStartY = e.touches[0].clientY;
    touchStartX = e.touches[0].clientX;
    touchStartTime = Date.now();
    touchDragging = false;
    latestDx = 0;
    latestDy = 0;
    if (rAF) { cancelAnimationFrame(rAF); rAF = null; }
  }, { passive: true });

  c.addEventListener('touchmove', (e) => {
    if (!touchStartY || !getIsPlayable()) return;
    const curY = e.touches[0].clientY;
    const curX = e.touches[0].clientX;
    latestDy = curY - touchStartY;
    latestDx = curX - touchStartX;

    if (latestDy < -18) {
      if (!touchDragging) {
        touchDragging = true;
        c.dataset.swiping = '1';
        if (navigator.vibrate) try { navigator.vibrate(6); } catch {}
      }
      if (e.cancelable) e.preventDefault();
      if (!rAF) {
        rAF = requestAnimationFrame(() => {
          rAF = null;
          if (!touchDragging) return;
          c.style.transition = 'none';
          const tiltX = Math.max(-14, Math.min(14, latestDx * 0.14));
          c.style.transform = `translate(calc(var(--fan-x, 0px) + ${latestDx * 0.35}px), calc(var(--fan-y, 0px) + ${latestDy}px)) rotate(calc(var(--fan-rot, 0deg) + ${tiltX.toFixed(1)}deg)) scale(1.08)`;
          c.style.zIndex = '999';
        });
      }
    }
  }, { passive: false });

  const endDrag = (e) => {
    if (rAF) { cancelAnimationFrame(rAF); rAF = null; }
    if (!touchDragging) return;
    touchDragging = false;
    delete c.dataset.swiping;
    const touch = e.changedTouches?.[0];
    const dy = touch ? touch.clientY - touchStartY : latestDy;
    const dx = touch ? touch.clientX - touchStartX : latestDx;
    const duration = Date.now() - touchStartTime;
    // آستانه‌ها قبلاً ۳۰px / فلیکِ ۲۲px بود: کشیدنِ اتفاقیِ انگشت روی دست (مثلاً رفتن
    // به سمتِ چت) یک کارت می‌انداخت. حالا حرکتِ عمدی لازم است؛ لمسِ دومرحله‌ای دست‌نخورده.
    const isQuickFlick = dy < -45 && duration < 320;

    if ((dy < -70 || isQuickFlick) && getIsPlayable()) {
      c.dataset.swiped = '1';
      c.style.transition = 'transform 0.18s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.16s ease';
      c.style.transform = `translate(calc(var(--fan-x, 0px) + ${dx * 0.4}px), calc(var(--fan-y, 0px) + ${dy - 120}px)) scale(0.9)`;
      c.style.opacity = '0';
      if (navigator.vibrate) try { navigator.vibrate(10); } catch {}
      // ذخیرهٔ بردارِ سوایپ — centerArea این را می‌خواند تا پرتابِ روی میز هم‌جهت با
      // حرکتِ انگشت باشد. fromX: انحراف جانبی ملایم، restRot: زاویهٔ نهاییِ کارت روی نمد.
      // هر دو clamp شده‌اند تا کارت هرگز از محدودهٔ بصریِ میز خارج نشود.
      _userThrowVec.set(card.id, {
        fromX:   Math.max(-55, Math.min(55,  dx * 0.30)),
        restRot: Math.max(-16, Math.min(16,  dx * 0.11)),
      });
      doPlay();
    } else {
      c.style.transition = 'transform 0.24s cubic-bezier(0.25, 1.35, 0.45, 1), box-shadow 0.24s ease, filter 0.24s ease';
      c.style.transform = '';
      c.style.zIndex = '';
      setTimeout(() => {
        c.style.transition = '';
      }, 260);
      // اگر حرکت بسیار کوتاه و ناچیز بود (تپ واقعی)، در صورت لغو کلیک توسط preventDefault، مستقیماً کلیک شلیک شود
      if (duration < 350 && Math.abs(dy) < 32 && Math.abs(dx) < 32 && getIsPlayable()) {
        if (e && e.cancelable) e.preventDefault();
        c.click();
      }
    }
    touchStartY = 0;
    touchStartX = 0;
  };

  c.addEventListener('touchend', endDrag, { passive: true });
  c.addEventListener('touchcancel', endDrag, { passive: true });
}

const isJoker = (card) => card?.suit === 'joker' || card?.rank === 'JOKER_RED' || card?.rank === 'JOKER_BLUE';
const isJokerRed = (card) => card?.rank === 'JOKER_RED';
const isJokerBlue = (card) => card?.rank === 'JOKER_BLUE';

let _pendingJokerPlay = null; // { card, cardId } حین لید با جوکر در شروع دست شلم قبل از تعیین حکم

// پرتاب خوش‌بینانه کارت (Zero-latency Optimistic Card Flight)
// حذف تاخیر شبکه ۵۰ تا ۱۵۰ میلی‌ثانیه‌ای میان لمس/پرتاب کاربر و پرواز کارت روی میز
function optimisticPlayFlight(card, c, currentView) {
  if (!currentView || !card) return;
  const gt = currentView.gameType || 'shelem';
  if (gt === 'chahar_barg' || gt === 'bluff') return;
  if (currentView.phase !== 'PLAYING_TURNS') return;

  // ۱. افکت بصری محو شدن و پرواز کارت از دست بازیکن در همان فریم لمس/کلیک
  if (c) {
    c.dataset.optimisticPlayed = '1';
    if (c.dataset.swiped !== '1') {
      c.style.transition = 'transform 0.20s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.16s ease';
      c.style.transform = 'translate(var(--fan-x, 0px), calc(var(--fan-y, 0px) - 64px)) scale(0.92)';
      c.style.opacity = '0';
      c.style.pointerEvents = 'none';
    }
  }

  // ۲. افزودن آنی کارت پرتاب‌شده به مرکز میز با شتاب‌دهی سخت‌افزاری و انیمیشن پرتاب
  const center = _cachedCenterEl;
  if (!center) return;

  const cardIdStr = String(card.id);
  if (center.querySelector(`.play[data-card-id="${cardIdStr}"]`)) return;

  const jitter = getCardTableJitter(card.id);
  const baseRot = -4;
  const finalRot = _userThrowVec.has(card.id)
    ? _userThrowVec.get(card.id).restRot
    : (baseRot + jitter.jrot);

  const node = cardEl(card, { small: true });
  node.style.setProperty('--rest-rot', `${finalRot.toFixed(1)}deg`);
  node.classList.add('thrown');

  if (_userThrowVec.has(card.id)) {
    const vec = _userThrowVec.get(card.id);
    if (vec) {
      node.style.setProperty('--from-x', `${vec.fromX.toFixed(1)}px`);
      _userThrowVec.delete(card.id);
    }
  }

  // بررسی بُرش با حکم (Trump Cut) به صورت آنی
  const trick = currentView.trick || [];
  const leadCard = trick[0]?.card;
  const leadIsTrump = leadCard && (leadCard.suit === currentView.hokm || isJoker(leadCard));
  const hasPriorJoker = trick.some((t) => isJoker(t.card));
  const isTrumpCut = currentView.hokm && trick.length > 0 &&
    !leadIsTrump &&
    !hasPriorJoker &&
    (card.suit === currentView.hokm || isJoker(card));

  if (isTrumpCut) {
    node.classList.add('trump-cut-card');
    sounds.trumpCut(0);
    spawnTrumpCutSlash('bottom', center);
    const felt = center.closest('.felt');
    if (felt) {
      felt.classList.remove('trump-shake');
      requestAnimationFrame(() => {
        felt.classList.add('trump-shake');
        setTimeout(() => felt.classList.remove('trump-shake'), 320);
      });
    }
  }

  _thrownCards.add(card.id);
  _cardThrowTimers.set(card.id, Date.now());

  const removeThrown = () => {
    node.classList.remove('thrown');
  };
  node.addEventListener('animationend', removeThrown, { once: true });
  setTimeout(removeThrown, 420);

  const playEl = el('div', { className: 'play play-bottom' });
  playEl.setAttribute('data-card-id', cardIdStr);
  playEl.setAttribute('data-card-rank', card.rank);
  playEl.setAttribute('data-card-suit', card.suit);
  playEl.dataset.optimistic = '1';
  playEl.style.setProperty('--jx', `${jitter.jx.toFixed(1)}px`);
  playEl.style.setProperty('--jy', `${jitter.jy.toFixed(1)}px`);
  playEl.append(node);
  center.append(playEl);
}

function executeCardPlay(card, c, v) {
  const currentView = v || table?._s;
  const isShelem = !currentView || currentView.gameType == null || currentView.gameType === 'shelem';
  const isLeadWithoutHokm = currentView && currentView.hokm == null && (currentView.leadSuit == null || !currentView.trick || currentView.trick.length === 0);
  const isJkr = isJoker(card) || card?.suit === 'joker' || card?.rank === 'JOKER_RED' || card?.rank === 'JOKER_BLUE' || card?.id === 'JOKER_RED' || card?.id === 'JOKER_BLUE';

  if (isShelem && isLeadWithoutHokm && isJkr) {
    if (c) {
      delete c.dataset.swiped;
      c.style.opacity = '';
      c.style.transform = '';
    }
    showMinimalHokmModal(currentView, null, [], (s) => {
      table.humanPlay(card.id, s);
    });
    return;
  }
  if (c) {
    if (c.dataset.playing === '1') return;
    c.dataset.playing = '1';
    setTimeout(() => { delete c.dataset.playing; }, 600);
  }
  _mobileSelId = null;
  _mobileSelTs = 0;
  if (currentView) updateChaharBargMatchHints(null, currentView);

  // بررسی وضعیت‌های خاص صوتی کارت: بُرش با حکم یا بی‌بی پیک در بی‌دل
  const trick = currentView?.trick || [];
  const leadCard = trick[0]?.card;
  const leadIsTrump = leadCard && (leadCard.suit === currentView?.hokm || isJoker(leadCard));
  const hasPriorJoker = trick.some((t) => isJoker(t.card));
  const isTrumpCut = currentView?.hokm && trick.length > 0 &&
    !leadIsTrump &&
    !hasPriorJoker &&
    (card?.suit === currentView?.hokm || isJoker(card));
  const isQueenSpades = currentView?.gameType === 'bidel' && card && (card.suit === 'spades' || card.suit === 's') && (card.rank === 'Q' || card.rank === 12);

  if (isTrumpCut) {
    // sounds.trumpCut(0) در optimisticPlayFlight پخش خواهد شد
  } else if (isQueenSpades) {
    sounds.queenSpades(0);
  } else {
    sounds.play();
  }

  resetTitleNotification();
  optimisticPlayFlight(card, c, currentView);
  table.humanPlay(card.id);
}

// پیش‌دیکد کردن تصویر کارت‌های تصویری در شروع دست با img.decode()
// تا حین رندر نوار دست یا پرتاب کارت، رشته اصلی با دیکد تصویر مسدود نشود.
const _courtCardSources = [
  ...['clubs', 'diamonds', 'hearts', 'spades'].flatMap((s) => ['J', 'Q', 'K'].map((r) => `/cards/${r}-${s}.webp`)),
  ...['clubs', 'diamonds'].flatMap((s) => ['J', 'Q', 'K'].map((r) => `/cards/${r}-${s}-4c.webp`)),
  '/cards/joker-red.webp',
  '/cards/joker-blue.webp',
];
const _decodedImageUrls = new Set();
function predecodeCourtCards(cards = null) {
  const is4c = _deck4();
  const list = (cards && cards.length)
    ? cards.map((c) => {
        if (!c) return null;
        if (c.suit === 'joker' || c.rank === 'JOKER_RED' || c.rank === 'JOKER_BLUE') {
          return c.rank === 'JOKER_RED' ? '/cards/joker-red.webp' : '/cards/joker-blue.webp';
        }
        if (c.rank === 'J' || c.rank === 'Q' || c.rank === 'K') {
          const suffix = (is4c && (c.suit === 'diamonds' || c.suit === 'clubs')) ? '-4c' : '';
          return `/cards/${c.rank}-${c.suit}${suffix}.webp`;
        }
        return null;
      }).filter(Boolean)
    : _courtCardSources;

  for (const src of list) {
    if (_decodedImageUrls.has(src)) continue;
    _decodedImageUrls.add(src);
    const img = new Image();
    img.decoding = 'async';
    img.src = src;
    if (typeof img.decode === 'function') {
      img.decode().catch(() => {});
    }
  }
}
try { predecodeCourtCards(); } catch { /* noop */ }

function cardEl(card, { faceDown = false, clickable = false, dim = false, small = false, selectable = false, cardBack = null } = {}) {
  if (faceDown) {
    const cbCls = cardBack ? (cardBack.startsWith('cardback_') ? ` ${cardBack}` : ` cardback_${cardBack}`) : '';
    return el('div', { className: 'card back' + (small ? ' small' : '') + cbCls },
      el('span', { className: 'fb-frame' }),
      el('span', { className: 'fb-medallion' }),
    );
  }
  const isJkr = isJoker(card);
  const g = isJkr ? '🃏' : SUIT_GLYPH[card.suit];
  const isFace = !isJkr && FACE_RANKS.has(card.rank);
  const isRed = isJkr ? isJokerRed(card) : RED.has(card.suit);
  const isBlue = isJkr && isJokerBlue(card);
  const cls = 'card' + (isJkr ? ' joker' : '') + (isRed ? ' red joker-red' : '') + (isBlue ? ' blue joker-blue' : '') + (clickable ? ' click' : '') + (dim ? ' dim' : '') + (small ? ' small' : '') + (selectable ? ' selectable' : '') + (isFace ? ' face' : '');
  const c = el('div', { className: cls });
  c.dataset.cardId = card.id;
  c.dataset.cardRank = card.rank;
  c.dataset.cardSuit = card.suit;
  if (clickable) {
    c.append(el('span', { className: 'card-hit-bridge' }));
  }
  if (isJkr) {
    const jokerImg = el('img', {
      className: 'joker-card-img',
      src: isRed ? '/cards/joker-red.webp' : '/cards/joker-blue.webp',
      alt: isRed ? 'Red Joker' : 'Blue Joker',
      decoding: 'async',
      width: 300,
      height: 462,
    });
    if (jokerImg.complete) {
      c.classList.add('face-loaded');
    } else {
      jokerImg.onload = () => c.classList.add('face-loaded');
    }
    c.append(jokerImg);
  } else {
    const cornerLabel = card.rank;
    const suitSvgStr = CARD_SUIT_SVG[card.suit] || '';

    const tlCorner = el('span', { className: 'corner tl' }, el('b', { textContent: cornerLabel }));
    if (suitSvgStr) {
      tlCorner.append(el('i', { className: 'corner-suit', innerHTML: suitSvgStr }));
    } else {
      tlCorner.append(el('i', { textContent: g }));
    }
    c.append(tlCorner);

    if (isFace) {
      const is4c = _deck4() && (card.suit === 'diamonds' || card.suit === 'clubs');
      const faceImg = el('img', {
        className: 'court-card-img',
        src: `/cards/${card.rank}-${card.suit}${is4c ? '-4c' : ''}.webp`,
        alt: `${card.rank} ${card.suit}`,
        decoding: 'async',
        width: 300,
        height: 462,
      });
      if (faceImg.complete) {
        c.classList.add('face-loaded');
      } else {
        faceImg.onload = () => c.classList.add('face-loaded');
      }
      c.append(faceImg);
    } else if (PIP_LAYOUT[card.rank]) {
      c.append(pipGrid(card.rank, suitSvgStr || g));   // ۲ تا ۱۰: چیدمانِ واقعیِ خال‌ها با SVG وکتور
    } else {
      const acePip = el('span', { className: 'pip ace-pip' });
      if (suitSvgStr) {
        acePip.innerHTML = suitSvgStr;
      } else {
        acePip.textContent = g;
      }
      c.append(acePip);   // آس: یک خالِ بزرگِ مرکزی
    }

    const brCorner = el('span', { className: 'corner br' }, el('b', { textContent: cornerLabel }));
    if (suitSvgStr) {
      brCorner.append(el('i', { className: 'corner-suit', innerHTML: suitSvgStr }));
    } else {
      brCorner.append(el('i', { textContent: g }));
    }
    c.append(brCorner);
  }
  if (clickable) {
    const doPlay = () => {
      executeCardPlay(card, c, table._s);
    };

    c.onclick = (e) => {
      if (c.dataset.swiped === '1') {
        delete c.dataset.swiped;
        return;
      }
      const isRealMouse = e && e.pointerType === 'mouse';
      // ─── موبایل: بررسی حالت پرتاب (تک‌لمسی یا دو‌مرحله‌ای) ───────────
      if (_isTouchDevice() && !isRealMouse) {
        if (getTouchPlayMode() === 'single') {
          doPlay();
          return;
        }
        if (_mobileSelId === card.id) {
          // جلوگیری از شلیک کلیک مصنوعی تکراری مرورگر ناشی از همان لمس اول
          if (Date.now() - _mobileSelTs < 320) return;
          // لمسِ دوم روی همان برگه → پرتاب
          doPlay();
        } else {
          // لمسِ اول (یا تعویضِ انتخاب)
          _mobileSelId = card.id;
          _mobileSelTs = Date.now();
          // حذفِ حالتِ انتخابِ برگهٔ قبلی (استایل و انیمیشن توسط متغیرهای CSS و کلاس .sel کنترل می‌شود)
          document.querySelectorAll('.hand-strip .card.sel').forEach((el) => {
            el.classList.remove('sel');
            el.style.transform = '';
          });
          document.querySelectorAll('.hand-row.row-top.has-sel').forEach((n) => n.classList.remove('has-sel'));
          c.classList.add('sel');
          c.closest?.('.hand-row.row-top')?.classList.add('has-sel');
          c.style.transform = '';
          if (navigator.vibrate) try { navigator.vibrate(10); } catch {}
        }
        return;
      }
      // ─── دسکتاپ: کلیکِ مستقیم ──────────────────────────────────────────
      doPlay();
    };

    setupCardTouchInteractions(c, card);
  }
  return c;
}

const _DL_ANDROID_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M15.5 3.5l1-1.7a.35.35 0 0 0-.6-.35l-1.05 1.8A6.9 6.9 0 0 0 12 2.6c-1 0-2 .23-2.85.65L8.1 1.45a.35.35 0 0 0-.6.35l1 1.7A5.9 5.9 0 0 0 6 8.5h12a5.9 5.9 0 0 0-2.5-5M9 6.6a.8.8 0 1 1 0-1.6.8.8 0 0 1 0 1.6m6 0a.8.8 0 1 1 0-1.6.8.8 0 0 1 0 1.6M6 9.5v7.2c0 .72.58 1.3 1.3 1.3H8.5v3.2a1.5 1.5 0 0 0 3 0v-3.2h1v3.2a1.5 1.5 0 0 0 3 0v-3.2h1.2c.72 0 1.3-.58 1.3-1.3V9.5zM3.5 9.5A1.5 1.5 0 0 0 2 11v5a1.5 1.5 0 0 0 3 0v-5a1.5 1.5 0 0 0-1.5-1.5m17 0A1.5 1.5 0 0 0 19 11v5a1.5 1.5 0 0 0 3 0v-5a1.5 1.5 0 0 0-1.5-1.5"/></svg>';


// ─── اندروید: دکمهٔ بازگشت، روشن ماندنِ صفحه، نصبِ اپ ────────────────────────
// هر سه برای همهٔ سناریوها لازم‌اند: PWAِ نصب‌شده، TWA، و WebViewِ بومی.
// همه با «قابلیت‌سنجی» کار می‌کنند، پس روی دسکتاپ و مرورگرهای قدیمی بی‌اثرند.

// ═══ ۱) دکمهٔ بازگشت (اندروید و مرورگرِ دسکتاپ) ════════════════════════════
// مدل: سه «سطح» که با وضعیتِ واقعیِ UI مقایسه و همگام می‌شوند.
//   ۰ = ورود/لابی   ۱ = میز (آدرسِ /table)   ۲ = لایهٔ بازِ روی هر کدام
// هر بار که وضعیت عوض می‌شود، تعدادِ ورودی‌های تاریخچه با سطحِ فعلی هم‌تراز
// می‌شود؛ و با هر back، تا رسیدن به سطحی که کاربر روی آن فرود آمده، یک پله
// بسته می‌شود. چون مقایسه‌ای است (نه دستوری)، خودش را تصحیح می‌کند و هیچ
// وضعیتِ موازیِ قابلِ واگرایی نگه نمی‌دارد.
//
// چرا مسیرِ واقعی (/table) و نه هش: fallbackِ SPA در Express از قبل هر مسیری را
// به index.html می‌دهد، دکمهٔ بکِ مرورگرِ دسکتاپ معنا پیدا می‌کند (میز ← لابی)،
// و با App Linksِ اندروید هم سازگار است. (نامِ /game نشد چون پوشهٔ game/ در
// public هست و express.static آن را ۳۰۱ به /game/ می‌برد.)
const _BACK_LOBBY = 0;          // سطحِ پایه: ورود/لابی
const _BACK_TABLE_PATH = '/table';

function _openSidePanel() {
  for (const id of ['friends-panel', 'my-profile-panel']) {
    const n = document.getElementById(id);
    if (n && !n.classList.contains('hidden')) return id;
  }
  // ⚠ #occupants با ورود به اتاق `hidden` را از دست می‌دهد و بازبودنش با کلاسِ
  // `.open` مشخص می‌شود. با معیارِ `hidden`، back همیشه فکر می‌کرد باز است.
  const occ = document.getElementById('occupants');
  if (occ && occ.classList.contains('open')) return 'occupants';
  return null;
}

// پاپ‌آپ‌هایی که خودشان وضعیت نگه می‌دارند (نودشان را دستی نباید کَند)
function _ownedPopup() {
  try { if (presetsPopup?.el) return 'presets'; } catch { /* noop */ }
  try { if (profileCardUI?.el) return 'profile'; } catch { /* noop */ }
  try { if (dmPanel?.el) return 'dm'; } catch { /* noop */ }
  return null;
}

// بالاترین لایهٔ شناورِ بازِ سطحِ body (شیتِ تنظیمات، دیالوگِ تم، ریزامتیازات،
// دستِ قبل، فروشگاه، مدالِ دعوت…). این‌ها درجا و با کلاس‌های مختلف ساخته
// می‌شوند، پس به‌جای شمردنِ تک‌تک، از روی «فرزندِ مستقیمِ body با
// position:fixed» پیدا می‌شوند و ظرف‌های دائمی کنار گذاشته می‌شوند.
const _BACK_SKIP_IDS = new Set(['lobby', 'table', 'chat-rail', 'composer', 'occupants',
  'friends-panel', 'friends-overlay', 'my-profile-panel', 'floating-reactions-layer', 'toast',
  'friend-req-toast', 'dm-toast']);
function _topFloatingLayer() {
  const kids = document.body.children;
  for (let i = kids.length - 1; i >= 0; i--) {
    const n = kids[i];
    if (n.id && _BACK_SKIP_IDS.has(n.id)) continue;
    if (n.classList.contains('hidden') || n.hidden || n.classList.contains('closing')) continue;
    if (n.tagName === 'SCRIPT' || n.tagName === 'STYLE' || n.tagName === 'LINK') continue;
    const cs = getComputedStyle(n);
    if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
    return n;
  }
  return null;
}

function _tableOpen() {
  const t = document.getElementById('table');
  return !!t && !t.classList.contains('hidden');
}

// سطح جمع‌پذیر است، نه انتخابی: لایهٔ بازِ روی لابی یک پله است و لایهٔ بازِ روی
// میز دو پله. اگر «لایه» را همیشه ۲ می‌گرفتیم، بازشدنِ یک مدال در لابی هم یک
// ورودیِ /table بی‌ربط می‌ساخت.
function _backLevel() {
  let lv = _tableOpen() ? 1 : 0;
  if (_ownedPopup() || _topFloatingLayer() || _openSidePanel()) lv += 1;
  return lv;
}

// یک پله پایین. true یعنی چیزی بسته شد.
function _backCloseOne() {
  const owned = _ownedPopup();
  if (owned === 'presets') { presetsPopup.hide(); return true; }
  if (owned === 'profile') { profileCardUI.hide(); return true; }
  if (owned === 'dm') { dmPanel.close(); return true; }

  const layer = _topFloatingLayer();
  if (layer) { closeOverlayWithFade(layer); return true; }

  const panel = _openSidePanel();
  if (panel === 'friends-panel') { friendsPanel.toggle(); return true; }
  if (panel === 'my-profile-panel') { myProfilePanel.toggle(); return true; }
  if (panel === 'occupants') { occupantsOpen = false; occupantsUI.apply(); return true; }

  // میز → مسیرِ عادیِ خروج (خودش وسطِ مسابقه تأیید می‌گیرد)
  if (_tableOpen()) { leaveGame(); return true; }
  return false;
}

// pop برنامه‌ای (نه فشردنِ کاربر) — تا هندلر آن را مثلِ back نخواند
let _backSyncing = false;
function _syncBackState() {
  if (_backSyncing) return;
  let have = history.state?.cbLevel;
  if (typeof have !== 'number') have = _BACK_LOBBY;
  const want = _backLevel();
  if (want > have) {
    for (let lv = have + 1; lv <= want; lv++) {
      try {
        // آدرس از وضعیتِ **واقعیِ** میز می‌آید، نه از شمارهٔ سطح. (pushState با
        // URLِ null آدرسِ فعلی را نگه می‌دارد، پس لایه‌های روی میز هم /table می‌مانند.)
        history.pushState({ cbLevel: lv }, '', _tableOpen() ? _BACK_TABLE_PATH : null);
      } catch { /* noop */ }
    }
  } else if (want < have) {
    // لایه با ✕ بسته شد یا بازی با دکمهٔ خروج تمام شد → ورودی‌های اضافه را pop
    // کن، وگرنه یک فشردنِ back بی‌اثر می‌ماند (روی دسکتاپ خیلی بد دیده می‌شود).
    _backSyncing = true;
    setTimeout(() => { _backSyncing = false; }, 500);   // اگر popstate نیامد، قفل نماند
    try { history.go(want - have); } catch { _backSyncing = false; }
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('popstate', (e) => {
    if (_backSyncing) { _backSyncing = false; return; }
    let landed = e.state?.cbLevel;
    if (typeof landed !== 'number') landed = _BACK_LOBBY;
    let guard = 0;
    while (_backLevel() > landed && guard++ < 4) {
      if (!_backCloseOne()) break;
    }
    _syncBackState();
  });

  // همگام‌سازی در هر سه نقطه‌ای که وضعیت می‌تواند عوض شود:
  //   • لمس/کلیک (باز و بستهٔ پنل‌ها با کلاس، بدونِ تغییرِ نود)
  //   • افزوده‌شدنِ نود به body — مدال‌هایی که **بدونِ لمس** باز می‌شوند
  //     (مدالِ دعوت از پیامِ سرور، اعلانِ درخواستِ دوستی). بدونِ این، back
  //     مسلح نمی‌شد و کاربر را از سایت/اپ بیرون می‌انداخت.
  //   • ورود و خروجِ میز (در startGame/leaveGame صدا زده می‌شود)
  document.addEventListener('pointerup', () => _syncBackState(), true);
  try {
    new MutationObserver(() => _syncBackState()).observe(document.body, { childList: true });
  } catch { /* noop */ }
}

// ═══ ۲) روشن نگه‌داشتنِ صفحه ══════════════════════════════════════════════
// نوبت تا ۲۰ ثانیه طول می‌کشد و بازیکن در آن مدت دست به صفحه نمی‌زند → گوشی
// خاموش می‌شود و نوبت می‌سوزد. قفلِ بیداری با رفتن به پس‌زمینه خودکار آزاد
// می‌شود، پس باید در بازگشت دوباره گرفته شود.
let _wakeLock = null;
let _wakeLockPending = false;
let _wakeLockCooldown = 0;

async function acquireWakeLock() {
  if (!navigator.wakeLock || _wakeLock || _wakeLockPending) return;
  if (Date.now() < _wakeLockCooldown) return;
  _wakeLockPending = true;
  try {
    _wakeLock = await navigator.wakeLock.request('screen');
    _wakeLock.addEventListener('release', () => { _wakeLock = null; });
  } catch {
    _wakeLock = null;
    _wakeLockCooldown = Date.now() + 15000;
  } finally {
    _wakeLockPending = false;
  }
}
function releaseWakeLock() {
  if (_wakeLock) {
    try { _wakeLock.release(); } catch { /* noop */ }
    _wakeLock = null;
  }
}
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) return;
    if (window.__isGameActive?.()) acquireWakeLock();
  });
}

// ═══ ۳) نصبِ اپ (PWA) ═════════════════════════════════════════════════════
// اندروید/کروم این رویداد را پیش از نمایشِ نصب می‌دهد؛ نگهش می‌داریم تا دکمهٔ
// «نسخهٔ اندروید» آن را صدا بزند. (iOS این رویداد را ندارد.)
let _installPrompt = null;
const _isStandalone = () => !!window.matchMedia?.('(display-mode: standalone)').matches
  || window.navigator.standalone === true;
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    _installPrompt = e;
    document.querySelectorAll('.dl-btn.android').forEach((b) => _paintAndroidBtn(b));
  });
  window.addEventListener('appinstalled', () => {
    _installPrompt = null;
    document.querySelectorAll('.dl-btn.android').forEach((b) => b.remove());
  });
}

// نوارِ دانلودِ اپ — زیرِ کارتِ ورود.
// دکمهٔ اندروید دو حالت دارد: تا وقتی APK نیست، «نصبِ اپ» از راهِ PWA؛ و اگر
// مرورگر نصب را پیشنهاد نکند (iOS/فایرفاکس) همان «به‌زودی»ِ غیرفعال.
function _paintAndroidBtn(btn) {
  if (_installPrompt) {
    btn.className = 'dl-btn android';
    btn.disabled = false;
    btn.innerHTML = _DL_ANDROID_SVG + '<span class="dl-tt"><b>نصبِ اپ اندروید</b><i>افزودن به صفحهٔ اصلی</i></span>';
    btn.onclick = async () => {
      const p = _installPrompt;
      if (!p) return;
      _installPrompt = null;
      try { p.prompt(); await p.userChoice; } catch { /* کاربر بست */ }
    };
  } else {
    btn.className = 'dl-btn android disabled';
    btn.disabled = true;
    btn.innerHTML = _DL_ANDROID_SVG + '<span class="dl-tt"><b>نسخهٔ اندروید</b><i>به‌زودی</i></span>';
    btn.onclick = null;
  }
}

// ─── اتصال شبکه ───────────────────────────────────────────────────────────────
function initNetwork() {
  if (networkTable) { networkTable.disconnect(); networkTable = null; }
  networkTable = new NetworkTable({
    token: authToken,
    onUpdate: (v) => { lastView = v; render(v); },
    onToast: toast,
    onGuestRestriction: (msg) => showUpgradeGuestModal(msg?.reason || 'action'),
    onRooms: (rooms) => renderLobby(rooms),
    onNet: (n) => netQualityUI.apply(n),
    onLeft: (reason, msg) => {
      leaveGame({ force: true });
      if (reason === 'ROOM_CAP') showRoomCapModal(msg);
    },
    onInvite: ({ fromUsername, roomId }) => {
      showRoomInviteModal({ fromUsername, roomId });
    },
    onFriendRequest: ({ fromUsername, fromUserId, fromAvatarUrl }) => {
      showFriendRequestModal({ fromUsername, fromUserId, fromAvatarUrl });
    },
    onFriendAccepted: ({ fromUsername, fromUserId }) => {
      friendsSet.add(fromUserId);
      toast(`🎉 ${fromUsername} درخواست دوستی شما را پذیرفت! شما اکنون دوست هستید.`);
    },
    onDm: (m) => {
      if (dmPanel.peerId === Number(m.fromUserId) && dmPanel.append(m)) {
        apiFetch('GET', `/api/dm/${m.fromUserId}`).catch(() => {}); // علامت خوانده‌شدن
        if (friendsPanel?.open && friendsPanel?.activeTab === 'chats') {
          friendsPanel.renderChatsTab?.();
        }
        _refreshLobbySocialRail?.();
        return;
      }
      dmUnread.bump(m.fromUserId);
      sounds?.chatIn?.();
      showDmToast(m);
      if (friendsPanel?.open && friendsPanel?.activeTab === 'chats') {
        friendsPanel.renderChatsTab?.();
      }
      _refreshLobbySocialRail?.();
    },
    onDmTyping: ({ fromUserId }) => {
      if (dmPanel?.peerId === Number(fromUserId)) {
        dmPanel.setPeerTyping?.(fromUserId);
      }
      if (friendsPanel?.open && friendsPanel?.activeTab === 'chats') {
        friendsPanel.setPeerTyping?.(fromUserId);
      }
      const lobbyThread = document.querySelector(`.lb3-chatrow[data-thread-peer="${fromUserId}"] .lb3-chat-snippet`);
      if (lobbyThread) {
        if (!lobbyThread.dataset.origText) lobbyThread.dataset.origText = lobbyThread.textContent;
        lobbyThread.textContent = 'در حال نوشتن…';
        lobbyThread.classList.add('fp-typing-text');
        clearTimeout(lobbyThread._typingTimer);
        lobbyThread._typingTimer = setTimeout(() => {
          lobbyThread.textContent = lobbyThread.dataset.origText || '';
          lobbyThread.classList.remove('fp-typing-text');
        }, 3000);
      }
    },
    onDmRead: ({ peerId }) => {
      if (dmPanel?.peerId === Number(peerId)) {
        dmPanel.markAllRead?.();
      }
      if (friendsPanel?.open && friendsPanel?.activeTab === 'chats') {
        friendsPanel.renderChatsTab?.();
      }
      _refreshLobbySocialRail?.();
    },
    onBidMade: (payload) => handleBidMade(payload),
    onHokmPhase: ({ hakemSeat, winningBid }) => {
      if (hakemSeat != null) {
        contractorCelebratingSeat = hakemSeat;
        sounds?.royalSeal?.();
        scheduleRender();
        setTimeout(() => {
          if (contractorCelebratingSeat === hakemSeat) {
            contractorCelebratingSeat = null;
            scheduleRender();
          }
        }, 2800);
      }
    },
    onBluffClaim: (msg) => handleBluffClaim(msg),
    onBluffInterrogation: (msg) => handleBluffInterrogation(msg),
    onBluffConfess: (msg) => handleBluffConfess(msg),
    onBluffStandGround: (msg) => handleBluffStandGround(msg),
    onBluffResolved: (msg) => handleBluffResolved(msg),
  });
}

let contractorCelebratingSeat = null;

// ─── لابی ─────────────────────────────────────────────────────────────────────
let lobbyCreateOpen = false;

// ─── گرید‌بندی Elo ────────────────────────────────────────────────────────────
const ELO_GRADES = [
  { grade: 'A', label: 'استاد',     minElo: 1700, color: '#f4c95d' },
  { grade: 'B', label: 'پیشرفته',   minElo: 1500, color: '#c084fc' },
  { grade: 'C', label: 'متوسط',     minElo: 1300, color: '#38bdf8' },
  { grade: 'D', label: 'مبتدی',     minElo: 1100, color: '#36d399' },
  { grade: 'E', label: 'تازه‌کار',  minElo: 0,    color: '#9ca3af' },
];
function eloGrade(elo, gamesPlayed) {
  if ((gamesPlayed ?? 0) < 10) return { grade: '—', label: 'نامشخص', color: '#6b7280' };
  return ELO_GRADES.find((g) => (elo ?? 1200) >= g.minElo) ?? ELO_GRADES[ELO_GRADES.length - 1];
}
function gradeTag(elo, gamesPlayed) {
  const g = eloGrade(elo, gamesPlayed);
  return el('span', { className: 'grade-tag', style: `--gc:${g.color}`, title: `${g.label} — ${elo ?? 1200} تراز` }, g.grade);
}

// ─── کمکی بستن نرم و محوشدن مدال‌ها و شیت‌ها ─────────────────────────────────────
function closeOverlayWithFade(overlay, duration = 160) {
  if (!overlay || overlay._isClosing) return;
  overlay._isClosing = true;
  overlay.classList.add('closing');
  setTimeout(() => {
    try { overlay.remove(); } catch {}
  }, duration);
}

// پنلِ ساختِ اتاقِ نام‌دار/خصوصی
function createRoomPanel(onClose) {
  const nameInput = el('input', { className: 'cr-input', type: 'text', maxLength: 40,
    placeholder: t('create_room.name_placeholder', null, 'نامِ اتاق (اختیاری)') });
  let isPrivate = false;
  const playerMode = 'PVP_4';
  let chatMode = 'FULL';
  let turnTimeSec = 6;

  const privBtn = el('button', { className: 'cr-toggle', textContent: t('create_room.public', null, 'عمومی') });
  privBtn.onclick = () => {
    isPrivate = !isPrivate;
    privBtn.textContent = isPrivate ? t('create_room.private', null, 'خصوصی 🔒') : t('create_room.public', null, 'عمومی');
    privBtn.classList.toggle('on', isPrivate);
  };

  // انتخاب ۲ یا ۴ نفره برای چهاربرگ
  let cbPlayerMode = 'PVP_2';
  const cbPlayerToggle = el('div', { className: 'cr-speed-toggle cb-player-toggle' });
  const cbP2Btn = el('button', {
    type: 'button',
    className: 'cr-speed-opt on',
    onclick: () => {
      cbPlayerMode = 'PVP_2';
      cbP2Btn.classList.add('on');
      cbP4Btn.classList.remove('on');
    },
  },
    el('span', { className: 'opt-title', textContent: t('create_room.mode_2p', null, '👥 ۲ نفره (دوئل ۱ به ۱)') }),
    el('span', { className: 'opt-sub', textContent: t('create_room.mode_2p_desc', null, 'بازی سریع و جذاب رو در رو') }),
  );
  const cbP4Btn = el('button', {
    type: 'button',
    className: 'cr-speed-opt',
    onclick: () => {
      cbPlayerMode = 'PVP_4';
      cbP4Btn.classList.add('on');
      cbP2Btn.classList.remove('on');
    },
  },
    el('span', { className: 'opt-title', textContent: t('create_room.mode_4p', null, '👨‍👩‍👧‍👦 ۴ نفره (تیمی ۲ به ۲)') }),
    el('span', { className: 'opt-sub', textContent: t('create_room.mode_4p_desc', null, 'یار روبرو با امتیاز مشترک') }),
  );
  cbPlayerToggle.append(cbP2Btn, cbP4Btn);

  // سقف امتیاز چهاربرگ (پیش‌فرض ۶۲)
  let cbTargetScore = 62;
  const cbTargetMinusBtn = el('button', {
    type: 'button',
    className: 'cr-step-btn',
    textContent: '−',
    title: t('create_room.target_decrease_tip', null, 'کاهش هدف امتیاز (حداقل ۲۱)'),
    onclick: () => {
      if (cbTargetScore > 21) {
        cbTargetScore = Math.max(21, cbTargetScore - 10);
        cbTargetVal.textContent = t('create_room.points_unit', { n: faNum(cbTargetScore) }, `${faNum(cbTargetScore)} امتیاز`);
      }
    },
  });
  const cbTargetVal = el('span', { className: 'cr-step-val', textContent: t('create_room.points_unit', { n: faNum(cbTargetScore) }, `${faNum(cbTargetScore)} امتیاز`) });
  const cbTargetPlusBtn = el('button', {
    type: 'button',
    className: 'cr-step-btn',
    textContent: '+',
    title: t('create_room.target_increase_tip', null, 'افزایش هدف امتیاز (حداکثر ۱۰۱)'),
    onclick: () => {
      if (cbTargetScore < 101) {
        cbTargetScore = Math.min(101, cbTargetScore + 10);
        cbTargetVal.textContent = t('create_room.points_unit', { n: faNum(cbTargetScore) }, `${faNum(cbTargetScore)} امتیاز`);
      }
    },
  });
  const cbTargetStepper = el('div', { className: 'cr-stepper' },
    el('span', { className: 'cr-step-label', textContent: t('create_room.target_win', null, '🎯 هدف برد:') }),
    el('div', { className: 'cr-step-controls' }, cbTargetMinusBtn, cbTargetVal, cbTargetPlusBtn),
  );

  // سقف امتیاز منفی بی‌دل (حداقل ۵۰، حداکثر ۱۵۰، پیش‌فرض ۱۰۰)
  let bidelTargetScore = 100;
  const bidelTargetMinusBtn = el('button', {
    type: 'button',
    className: 'cr-step-btn',
    textContent: '−',
    title: t('create_room.loss_decrease_tip', null, 'کاهش سقف امتیاز باخت (حداقل ۵۰)'),
    onclick: () => {
      if (bidelTargetScore > 50) {
        bidelTargetScore = Math.max(50, bidelTargetScore - 10);
        updateBidelTargetDisplay();
      }
    },
  });
  const bidelTargetVal = el('span', { className: 'cr-step-val', textContent: t('create_room.penalty_unit', { n: faNum(bidelTargetScore) }, `${faNum(bidelTargetScore)} منفی`) });
  const bidelTargetRewardDisplay = el('span', { className: 'cr-target-reward-tag' });
  const bidelTargetPlusBtn = el('button', {
    type: 'button',
    className: 'cr-step-btn',
    textContent: '+',
    title: t('create_room.loss_increase_tip', null, 'افزایش سقف امتیاز باخت (حداکثر ۱۵۰)'),
    onclick: () => {
      if (bidelTargetScore < 150) {
        bidelTargetScore = Math.min(150, bidelTargetScore + 10);
        updateBidelTargetDisplay();
      }
    },
  });
  function updateBidelTargetDisplay() {
    bidelTargetVal.textContent = t('create_room.penalty_unit', { n: faNum(bidelTargetScore) }, `${faNum(bidelTargetScore)} منفی`);
    bidelTargetMinusBtn.disabled = bidelTargetScore <= 50;
    bidelTargetPlusBtn.disabled = bidelTargetScore >= 150;
    const totalCoins = Math.round(25 * (bidelTargetScore / 150));
    const winCoins = Math.round(totalCoins * 0.65);
    bidelTargetRewardDisplay.textContent = t('create_room.win_reward', { coins: faNum(winCoins) }, `(برد: +${faNum(winCoins)} سکه)`);
  }
  updateBidelTargetDisplay();

  const bidelTargetStepper = el('div', { className: 'cr-stepper' },
    el('span', { className: 'cr-step-label', textContent: t('create_room.target_loss', null, '🎯 سقف باخت:') }),
    el('div', { className: 'cr-step-controls' }, bidelTargetMinusBtn, bidelTargetVal, bidelTargetPlusBtn, bidelTargetRewardDisplay),
  );

  // سرباز خشت در بی‌دل (۱۰- امتیاز منفی / هدیه جایزه)
  let jackDiamondsBonus = false;
  const jackDiamondsToggle = el('button', {
    type: 'button',
    className: 'cr-andakhtan-toggle',
    onclick: () => {
      jackDiamondsBonus = !jackDiamondsBonus;
      jackDiamondsToggle.classList.toggle('on', jackDiamondsBonus);
      updateRulesBadge();
    },
  },
    el('span', { className: 'cr-andakhtan-box', textContent: '♦' }),
    el('span', { className: 'cr-andakhtan-txt' },
      el('b', { textContent: t('create_room.jack_diamonds_title', null, 'سرباز خشت (۱۰- امتیاز منفی)') }),
      el('i', { textContent: t('create_room.jack_diamonds_desc', null, 'برندهٔ سرباز خشت ۱۰ امتیاز منفی جایزه می‌گیرد (کاهش نمره منفی).') }),
    ),
  );

  // سوئیچ اختیاری شلم با جوکر
  let jokerMode = false;
  const jokerToggle = el('button', {
    type: 'button',
    className: 'cr-joker-toggle',
    onclick: () => {
      jokerMode = !jokerMode;
      jokerToggle.classList.toggle('on', jokerMode);
      if (jokerMode && targetScore === 1200) {
        targetScore = 1600;
      } else if (!jokerMode && targetScore > 1200) {
        targetScore = 1200;
      }
      updateTargetDisplay();
    },
  },
    el('span', { className: 'cr-joker-box', textContent: '🃏' }),
    el('span', { className: 'cr-joker-txt' },
      el('b', { textContent: t('create_room.joker_title', null, 'شلم با جوکر (دست ۲۰۰ امتیازی)') }),
      el('i', { textContent: t('create_room.joker_desc', null, '۵۲ برگ • ۲ جوکر با ارزش ۲۰ و ۱۵ امتیاز • ۴ برگ زمین') }),
    ),
  );

  // قانون انداختن (تعهد اجباری نفر آخر) — پیش‌فرض روشن
  let andakhtan = true;
  const andakhtanToggle = el('button', {
    type: 'button',
    className: 'cr-andakhtan-toggle on',
    onclick: () => {
      andakhtan = !andakhtan;
      andakhtanToggle.classList.toggle('on', andakhtan);
    },
  },
    el('span', { className: 'cr-andakhtan-box', textContent: '📜' }),
    el('span', { className: 'cr-andakhtan-txt' },
      el('b', { textContent: t('create_room.andakhtan_title', null, 'قانون انداختن (تعهد اجباری)') }),
      el('i', { textContent: t('create_room.andakhtan_desc', null, 'در صورت پاس ۳ نفر اول، نفر آخر موظف به اعلام تعهد است.') }),
    ),
  );

  // سقف امتیاز مسابقه (Match Target):
  // بدون جوکر: ۴۰۰ تا ۱۲۰۰، پیش‌فرض ۱۲۰۰
  // با جوکر: ۴۰۰ تا ۱۶۰۰، پیش‌فرض ۱۶۰۰
  const MIN_TARGET_SCORE = 400;
  let targetScore = 1200;

  const targetMinusBtn = el('button', {
    type: 'button',
    className: 'cr-step-btn',
    textContent: '−',
    title: t('create_room.target_decrease_tip', null, 'کاهش سقف امتیاز مسابقه (حداقل ۴۰۰)'),
    onclick: () => {
      if (targetScore > MIN_TARGET_SCORE) {
        targetScore = Math.max(MIN_TARGET_SCORE, targetScore - 100);
        updateTargetDisplay();
      }
    },
  });

  const targetInput = el('input', {
    type: 'number',
    className: 'cr-target-input',
    min: MIN_TARGET_SCORE,
    max: jokerMode ? 1600 : 1200,
    step: 50,
    value: targetScore,
    title: t('create_room.target_manual_tip', null, 'برای وارد کردن دستی امتیاز کلیک کنید'),
    oninput: (e) => {
      const val = parseInt(e.target.value, 10);
      if (Number.isFinite(val)) {
        targetScore = val;
        updateRewardBadge();
      }
    },
    onblur: (e) => {
      const maxTarget = jokerMode ? 1600 : 1200;
      let val = parseInt(e.target.value, 10);
      if (!Number.isFinite(val) || val < MIN_TARGET_SCORE) val = MIN_TARGET_SCORE;
      if (val > maxTarget) val = maxTarget;
      targetScore = val;
      updateTargetDisplay();
    },
  });

  const targetRewardDisplay = el('span', { className: 'cr-target-reward-tag' });

  const targetPlusBtn = el('button', {
    type: 'button',
    className: 'cr-step-btn',
    textContent: '+',
    title: t('create_room.target_increase_tip', null, 'افزایش سقف امتیاز مسابقه'),
    onclick: () => {
      const maxTarget = jokerMode ? 1600 : 1200;
      if (targetScore < maxTarget) {
        targetScore = Math.min(maxTarget, targetScore + 100);
        updateTargetDisplay();
      }
    },
  });

  function getWinReward() {
    const maxTarget = jokerMode ? 1600 : 1200;
    const maxWin = jokerMode ? 40 : 32;
    return Math.max(1, Math.round(maxWin * (targetScore / maxTarget)));
  }

  function updateRewardBadge() {
    const reward = getWinReward();
    targetRewardDisplay.textContent = t('create_room.win_reward_short', { coins: faNum(reward) }, `(برد: +${faNum(reward)})`);
  }

  function updateTargetDisplay() {
    const maxTarget = jokerMode ? 1600 : 1200;
    if (targetScore > maxTarget) targetScore = maxTarget;
    if (targetScore < MIN_TARGET_SCORE) targetScore = MIN_TARGET_SCORE;
    targetInput.value = targetScore;
    targetMinusBtn.disabled = targetScore <= MIN_TARGET_SCORE;
    targetPlusBtn.disabled = targetScore >= maxTarget;
    updateRewardBadge();
  }
  updateTargetDisplay();

  const targetStepper = el('div', { className: 'cr-stepper cr-target-stepper' },
    el('span', { className: 'cr-step-label', textContent: t('create_room.target_match', null, '🎯 سقف مسابقه:') }),
    el('div', { className: 'cr-step-controls' },
      targetMinusBtn,
      targetInput,
      targetPlusBtn,
      targetRewardDisplay,
    ),
  );

  // حالت بازی: سرعتی (پرتابِ آزاد پس از برگِ اول) یا عادیِ نوبتی — همان سوئیچی که
  // مودالِ بازیِ سریع هم نشان می‌دهد، با ترجیحِ مشترکِ ذخیره‌شده.
  let speedMode = getSpeedPref();
  const speedPicker = speedToggle(speedMode, (on) => { speedMode = on; setSpeedPref(on); });

  // «فقط کاربران پایدار» — یک شرطِ ورود، نه یک قانونِ بازی؛ پس چک‌باکسِ ساده است
  // نه سوئیچِ دوگزینه‌ای. ترجیحش ذخیره نمی‌شود: تصمیمی برای همین اتاق است.
  let stableOnly = false;
  const stableToggle = el('button', {
    type: 'button',
    className: 'cr-stable',
    onclick: () => { stableOnly = !stableOnly; stableToggle.classList.toggle('on', stableOnly); },
  },
    el('span', { className: 'cr-stable-box', textContent: '🛡' }),
    el('span', { className: 'cr-stable-txt' },
      el('b', { textContent: t('create_room.stable_only_title', null, 'فقط کاربران پایدار') }),
      el('i', { textContent: t('create_room.stable_only_desc', null, 'کسی که اتصالش مکرراً قطع می‌شود وارد نشود.') }),
    ),
  );

  // استپر زمان انداختن کارت: حداقل ۴، حداکثر ۱۵، پیش‌فرض ۶ ثانیه
  const MIN_TURN_TIME = 4;
  const MAX_TURN_TIME = 15;

  const stepMinusBtn = el('button', {
    type: 'button',
    className: 'cr-step-btn',
    textContent: '−',
    title: t('create_room.turn_decrease_tip', null, 'کاهش زمان نوبت (حداقل ۴ ثانیه)'),
    onclick: () => {
      if (turnTimeSec > MIN_TURN_TIME) {
        turnTimeSec--;
        updateTimerDisplay();
      }
    },
  });

  const stepValDisplay = el('span', { className: 'cr-step-val' });

  const stepPlusBtn = el('button', {
    type: 'button',
    className: 'cr-step-btn',
    textContent: '+',
    title: t('create_room.turn_increase_tip', null, 'افزایش زمان نوبت (حداکثر ۱۵ ثانیه)'),
    onclick: () => {
      if (turnTimeSec < MAX_TURN_TIME) {
        turnTimeSec++;
        updateTimerDisplay();
      }
    },
  });

  function updateTimerDisplay() {
    stepMinusBtn.disabled = turnTimeSec <= MIN_TURN_TIME;
    stepPlusBtn.disabled = turnTimeSec >= MAX_TURN_TIME;
    stepValDisplay.textContent = t('create_room.seconds_unit', { sec: faNum(turnTimeSec) }, `${faNum(turnTimeSec)} ثانیه`);
  }
  updateTimerDisplay();

  const timerStepper = el('div', { className: 'cr-stepper' },
    el('span', { className: 'cr-step-label', textContent: t('create_room.turn_timer', null, '⏱ نوبت:') }),
    el('div', { className: 'cr-step-controls' },
      stepMinusBtn,
      stepValDisplay,
      stepPlusBtn,
    ),
  );

  // حالت چت
  const CHAT_OPTS = [
    ['FULL', t('create_room.chat_mode_full', null, 'چت آزاد 💬')],
    ['PRESET_ONLY', t('create_room.chat_mode_preset', null, 'فقط پیش‌فرض')],
    ['DISABLED', t('create_room.chat_mode_disabled', null, 'بی‌صدا 🔇')]
  ];
  const chatSel = el('select', { className: 'cr-select' });
  for (const [v, label] of CHAT_OPTS) {
    chatSel.append(el('option', { value: v, textContent: label }));
  }
  chatSel.onchange = () => { chatMode = chatSel.value; };

  // انتخاب تم سینماتیک میز: زمردی، سورمه‌ای، زرشکی، ذغالی + تم‌های اختصاصی خریداری‌شده
  let tableTheme = localStorage.getItem('cb_table_theme') || 'ruby';
  const THEME_OPTS = [
    ['emerald', t('create_room.theme_emerald', null, '🌲 زمردی')],
    ['royal', t('create_room.theme_royal', null, '🌌 سورمه‌ای')],
    ['ruby', t('create_room.theme_ruby', null, '🍷 زرشکی')],
    ['noir', t('create_room.theme_noir', null, '🕶 ذغالی')],
  ];
  const ownedFelts = myProfile?.owned_felts || [];
  const EXCLUSIVE_THEMES = [
    ['carpet', t('create_room.theme_carpet', null, '✨ فرش ایرانی')],
    ['cyberpunk', t('create_room.theme_cyberpunk', null, '⚡ سایبرپانک')],
    ['wood', t('create_room.theme_wood', null, '🪵 چوب سلطنتی')],
    ['galaxy', t('create_room.theme_galaxy', null, '🌌 کهکشان')],
    ['gold-vip', t('create_room.theme_gold_vip', null, '👑 طلای VIP')],
    ['leather-black', t('create_room.theme_leather_black', null, '🖤 چرم مشکی کلاسیک')],
    ['velvet-navy', t('create_room.theme_velvet_navy', null, '🎰 مخمل سرمه‌ای کازینو')],
    ['marble-cream', t('create_room.theme_marble_cream', null, '🏛️ سنگ مرمر کرم')],
    ['walnut-gloss', t('create_room.theme_walnut_gloss', null, '✨ گردوی جلادار')],
    ['velvet-burgundy', t('create_room.theme_velvet_burgundy', null, '🍷 بورگاندی هتلی')],
    ['canvas-rustic', t('create_room.theme_canvas_rustic', null, '🧵 کتان روستیک')],
    ['suede-olive', t('create_room.theme_suede_olive', null, '🫒 سوئد زیتونی')],
    ['leather-vintage', t('create_room.theme_leather_vintage', null, '🧭 چرم عتیقهٔ نقشه‌دار')],
    ['silk-pinstripe', t('create_room.theme_silk_pinstripe', null, '🎩 ابریشم مشکی راه‌راه')],
    ['platinum-executive', t('create_room.theme_platinum_executive', null, '💎 پلاتین اجرایی')],
  ];
  for (const [thId, thLabel] of EXCLUSIVE_THEMES) {
    if (ownedFelts.includes(thId) || ownedFelts.includes(thId.replace('-', '_')) || ownedFelts.includes(`felt_${thId.replace('-', '_')}`)) {
      THEME_OPTS.push([thId, thLabel]);
    }
  }
  const themeRow = el('div', { className: 'cr-theme-row' });
  const themeLabel = el('span', { className: 'cr-label', textContent: t('create_room.table_theme', null, 'تم میز:') });
  const themeTabs = el('div', { className: 'cr-theme-tabs' });
  const themeBtns = [];
  THEME_OPTS.forEach(([thId, thLabel]) => {
    const b = el('button', {
      type: 'button',
      className: `cr-theme-btn ${thId}` + (tableTheme === thId ? ' active' : ''),
      onclick: () => {
        tableTheme = thId;
        localStorage.setItem('cb_table_theme', thId);
        themeBtns.forEach((btn, idx) => {
          btn.classList.toggle('active', THEME_OPTS[idx][0] === thId);
        });
      },
    },
      el('span', { className: 'theme-dot' }),
      el('span', { textContent: thLabel }),
    );
    themeBtns.push(b);
    themeTabs.append(b);
  });
  themeRow.append(themeLabel, themeTabs);

  // انتخاب رنگ دسته‌کارت (دو رنگ کلاسیک / چهار رنگ)
  let deck4Choice = _deck4();
  const deckRow = el('div', { className: 'cr-diff-row cr-deck-row' });
  const deckLabel = el('span', { className: 'cr-label', textContent: t('settings.deck_colors', null, 'رنگ خال‌ها:') });
  const deckTabs = el('div', { className: 'cr-diff-tabs' });
  const deckBtns = [];
  const DECK_OPTS = [
    [false, t('settings.deck_classic', null, '♥♠ دو رنگ')],
    [true, t('settings.deck_4color', null, '♦♣ چهار رنگ')],
  ];
  DECK_OPTS.forEach(([dVal, dLabel]) => {
    const b = el('button', {
      type: 'button',
      className: 'cr-diff-btn' + (deck4Choice === dVal ? ' active' : ''),
      textContent: dLabel,
      onclick: () => {
        deck4Choice = dVal;
        try { localStorage.setItem('cb_deck4', dVal ? '1' : '0'); } catch {}
        applyDeck();
        deckBtns.forEach((btn, idx) => {
          btn.classList.toggle('active', DECK_OPTS[idx][0] === dVal);
        });
      },
    });
    deckBtns.push(b);
    deckTabs.append(b);
  });
  deckRow.append(deckLabel, deckTabs);

  const goBtn = el('button', {
    className: 'primary cr-go',
    textContent: t('create_room.btn_create', { game: GAME_FA[selectedGame] }, `ساخت اتاق — ${GAME_FA[selectedGame]}`),
    onclick: () => {
      if (goBtn.disabled) return;
      goBtn.disabled = true;
      if (typeof onClose === 'function') onClose();
      else {
        const ov = document.getElementById('create-room-modal-overlay');
        if (ov) closeOverlayWithFade(ov);
      }
      startGame({
        create: {
          name: nameInput.value.trim(),
          gameType: selectedGame,
          private: isPrivate,
          playerMode: selectedGame === 'chahar_barg' ? cbPlayerMode : 'PVP_4',
          fillBots: false,
          jokerMode: selectedGame === 'shelem' && jokerMode,
          andakhtan: selectedGame === 'shelem' ? andakhtan : undefined,
          matchTarget: selectedGame === 'chahar_barg' ? cbTargetScore : (selectedGame === 'shelem' ? targetScore : (selectedGame === 'bidel' ? bidelTargetScore : undefined)),
          targetScore: selectedGame === 'bidel' ? bidelTargetScore : undefined,
          jackDiamondsBonus: selectedGame === 'bidel' ? jackDiamondsBonus : undefined,
          chatMode,
          turnTimeSec,
          botDifficulty: 'PRO',
          tableTheme,
          deck4: deck4Choice,
          speedMode,
          stableOnly,
        },
      });
    },
  });

  // ── آکاردئون قوانین اتاق (پیش‌فرض: باز) ──────────────────────────────────
  function countActiveRules() {
    let n = 0;
    if (selectedGame === 'shelem' && jokerMode) n++;
    if (selectedGame === 'shelem' && andakhtan) n++;
    if (selectedGame === 'bidel' && jackDiamondsBonus) n++;
    if (stableOnly) n++;
    return n;
  }

  const rulesBody = el('div', { className: 'cr-rules-body' });
  if (selectedGame === 'shelem') rulesBody.append(jokerToggle, andakhtanToggle);
  if (selectedGame === 'bidel') rulesBody.append(jackDiamondsToggle);
  rulesBody.append(stableToggle);

  const rulesBadge = el('span', { className: 'cr-rules-badge' });
  function updateRulesBadge() {
    const n = countActiveRules();
    rulesBadge.hidden = n === 0;
    rulesBadge.textContent = t('create_room.rules_active_count', { n: faNum(n) }, `${faNum(n)} روشن`);
  }
  updateRulesBadge();

  // وقتی toggle‌ها تغییر می‌کنند badge رو update کن
  [jokerToggle, andakhtanToggle, jackDiamondsToggle, stableToggle].forEach((btn) => {
    const orig = btn.onclick;
    btn.onclick = (e) => { if (orig) orig.call(btn, e); updateRulesBadge(); };
  });

  const rulesChevron = el('span', { className: 'cr-rules-chevron', textContent: '▲' });
  const rulesGroup = el('div', { className: 'cr-rules-group open' });
  const rulesHeader = el('div', { className: 'cr-rules-header',
    onclick: () => {
      rulesGroup.classList.toggle('open');
      rulesBody.hidden = !rulesGroup.classList.contains('open');
    },
  },
    el('div', { className: 'cr-rules-header-right' },
      el('span', { textContent: t('create_room.rules_accordion', null, '⚖ قوانین اتاق') }),
      rulesBadge,
    ),
    rulesChevron,
  );
  rulesGroup.append(rulesHeader, rulesBody);

  // ── آکاردئون تنظیمات پیشرفته (پیش‌فرض: بسته) ─────────────────────────────
  const advBody = el('div', { className: 'cr-advanced-body', hidden: true });
  advBody.append(el('div', { className: 'cr-row' }, chatSel, timerStepper));

  const advChevron = el('span', { className: 'cr-advanced-chevron', textContent: '▲' });
  const advGroup = el('div', { className: 'cr-advanced' });
  const advHeader = el('div', { className: 'cr-advanced-header',
    onclick: () => {
      advGroup.classList.toggle('open');
      advBody.hidden = !advGroup.classList.contains('open');
    },
  },
    el('span', { textContent: t('create_room.advanced_accordion', null, '⚙ تنظیمات پیشرفته') }),
    advChevron,
  );
  advGroup.append(advHeader, advBody);

  return el('div', { className: 'create-room' },
    el('div', { className: 'cr-row' }, nameInput, privBtn),
    selectedGame === 'chahar_barg' ? cbPlayerToggle : null,
    selectedGame === 'chahar_barg' ? cbTargetStepper : null,
    selectedGame === 'bidel' ? bidelTargetStepper : null,
    rulesGroup,
    selectedGame === 'shelem' ? targetStepper : null,
    selectedGame !== 'chahar_barg' ? speedPicker : null,
    themeRow,
    deckRow,
    advGroup,
    goBtn,
  );
}

// مدال پاپ‌آپ انتخاب سطح ربات برای بازی سریع
// «حالت بازی» یک قانونِ اتاق است و از دو مسیر ساخته می‌شود (ساختِ اتاق و بازیِ سریع)،
// پس انتخابش مثلِ cb_bot_diff و cb_table_theme در localStorage یادآوری می‌شود تا هر دو
// مسیر یک چیز ببینند و مسیرِ «بدونِ ربات» (که مودالی ندارد) بی‌صدا عادی نشود.
function getSpeedPref() { return localStorage.getItem('cb_speed_mode') === '1'; }
function setSpeedPref(on) { localStorage.setItem('cb_speed_mode', on ? '1' : '0'); }

// سوئیچِ دوگزینه‌ای «عادی / سرعتی». onChange مقدارِ جدید را می‌گیرد.
function speedToggle(initial, onChange) {
  const OPTS = [
    ['0', t('speed_toggle.classic', null, '🐢 عادی (نوبتی)'), t('speed_toggle.classic_desc', null, 'بازیِ کلاسیک، ساعتگرد و به‌نوبت.')],
    ['1', t('speed_toggle.speed', null, '⚡ سرعتی (آزاد)'), t('speed_toggle.speed_desc', null, 'پس از برگِ اول، همه هم‌زمان می‌اندازند.')],
  ];
  const btns = [];
  const wrap = el('div', { className: 'cr-speed-toggle' });
  OPTS.forEach(([val, label, sub]) => {
    const b = el('button', {
      type: 'button',
      className: 'cr-speed-opt' + (val === '1' ? ' speed' : '') + (initial === (val === '1') ? ' on' : ''),
      onclick: () => {
        const on = val === '1';
        btns.forEach((x) => x.classList.toggle('on', x.dataset.val === val));
        onChange(on);
      },
    },
      el('span', { className: 'opt-title', textContent: label }),
      el('span', { className: 'opt-sub', textContent: sub }),
    );
    b.dataset.val = val;
    btns.push(b);
    wrap.append(b);
  });
  return wrap;
}

function showBotDiffModal(onSelect) {
  const existing = document.getElementById('bot-diff-modal-overlay');
  if (existing) existing.remove();

  const overlay = el('div', {
    id: 'bot-diff-modal-overlay',
    className: 'bot-modal-overlay',
    onclick: (e) => {
      if (e.target === overlay) closeOverlayWithFade(overlay);
    },
  });

  const savedDiff = localStorage.getItem('cb_bot_diff') || 'PRO';

  const modal = el('div', { className: 'bot-modal' });

  const head = el('div', { className: 'bot-modal-head' },
    el('div', { className: 'bot-modal-title' },
      el('span', { textContent: '🤖' }),
      el('h3', { textContent: t('bot_diff.modal_title', null, 'انتخاب سطح ربات‌ها') }),
    ),
    el('button', {
      className: 'occ-close',
      textContent: '✕',
      onclick: () => closeOverlayWithFade(overlay),
    }),
  );

  const sub = el('p', {
    className: 'bot-modal-sub',
    textContent: t('bot_diff.subtitle', null, 'برای شروع بازی سریع، سطح بازی ربات‌ها را مشخص کنید:'),
  });

  let speedPick = getSpeedPref();
  const speedRow = el('div', { className: 'bot-modal-speed' },
    el('span', { className: 'bms-label', textContent: t('bot_diff.game_mode', null, '⚙ حالت بازی') }),
    speedToggle(speedPick, (on) => { speedPick = on; setSpeedPref(on); }),
  );

  const optsContainer = el('div', { className: 'bot-modal-opts' });

  const diffs = [
    { id: 'AMATEUR', icon: '🌱', label: t('bot_diff.amateur', null, 'آماتور'), desc: t('bot_diff.amateur_desc', null, 'ساده و روان — مناسب دست‌گرمی') },
    { id: 'PRO', icon: '⚡', label: t('bot_diff.pro', null, 'حرفه‌ای'), desc: t('bot_diff.pro_desc', null, 'هوشمند و حساب‌شده — چالش استاندارد') },
    { id: 'MASTER', icon: '👑', label: t('bot_diff.master', null, 'مستر'), desc: t('bot_diff.master_desc', null, 'پیشرفته و بدون خطا — چالش جدی') },
  ];

  diffs.forEach((d) => {
    const isSelected = d.id === savedDiff;
    const btn = el('button', {
      type: 'button',
      className: 'bot-modal-opt' + (isSelected ? ' active' : ''),
      onclick: () => {
        localStorage.setItem('cb_bot_diff', d.id);
        closeOverlayWithFade(overlay);
        onSelect(d.id, speedPick);
      },
    },
      el('div', { className: 'bmo-icon' }, d.icon),
      el('div', { className: 'bmo-info' },
        el('div', { className: 'bmo-name' },
          el('span', { textContent: d.label }),
          isSelected ? el('span', { className: 'bmo-badge', textContent: t('bot_diff.prev_default', null, 'پیش‌فرض قبلی') }) : null,
        ),
        el('div', { className: 'bmo-desc', textContent: d.desc }),
      ),
      el('span', { className: 'bmo-arrow', textContent: '▸' }),
    );
    optsContainer.append(btn);
  });

  modal.append(head, sub, speedRow, optsContainer);
  overlay.append(modal);
  document.body.append(overlay);
}

function showPracticeGameModal(onStart) {
  const existing = document.getElementById('practice-game-modal-overlay');
  if (existing) existing.remove();

  const overlay = el('div', {
    id: 'practice-game-modal-overlay',
    className: 'bot-modal-overlay',
    onclick: (e) => {
      if (e.target === overlay) closeOverlayWithFade(overlay);
    },
  });

  const modal = el('div', { className: 'bot-modal', style: 'max-width: 440px;' });

  const head = el('div', { className: 'bot-modal-head' },
    el('div', { className: 'bot-modal-title' },
      el('span', { textContent: '🎮' }),
      el('h3', { textContent: t('practice.modal_title', null, 'انتخاب بازی تمرینی با ربات') }),
    ),
    el('button', {
      className: 'occ-close',
      textContent: '✕',
      onclick: () => closeOverlayWithFade(overlay),
    }),
  );

  const sub = el('p', {
    className: 'bot-modal-sub',
    textContent: t('practice.subtitle', null, 'بازی مورد نظر و سطح مهارت ربات‌ها را برای شروع تمرین انتخاب کنید:'),
  });

  let chosenGame = localStorage.getItem('cb_practice_game') || selectedGame || 'shelem';
  if (chosenGame !== 'shelem' && chosenGame !== 'hokm') chosenGame = 'shelem';

  const games = [
    { id: 'shelem', icon: '👑', label: 'شلم', desc: 'بازی ۴ نفره با تعهد، خواندن، کوت و جوکر' },
    { id: 'hokm', icon: '♠️', label: 'حکم', desc: 'بازی محبوب ۴ نفره با تعیین حاکم و انتخاب خال حکم' },
  ];

  const gameSectionLabel = el('div', {
    style: 'font-size: 0.82rem; font-weight: 700; color: #94a3b8; margin: 10px 0 6px 0;',
    textContent: 'نوع بازی:',
  });

  const gameOptsContainer = el('div', { className: 'bot-modal-opts', style: 'margin-bottom: 14px;' });
  const gameButtons = [];

  games.forEach((g) => {
    const isSel = g.id === chosenGame;
    const btn = el('button', {
      type: 'button',
      className: 'bot-modal-opt' + (isSel ? ' active' : ''),
      onclick: () => {
        chosenGame = g.id;
        localStorage.setItem('cb_practice_game', g.id);
        selectedGame = g.id;
        localStorage.setItem('cb_game', g.id);
        gameButtons.forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');
      },
    },
      el('div', { className: 'bmo-icon' }, g.icon),
      el('div', { className: 'bmo-info' },
        el('div', { className: 'bmo-name' }, el('span', { textContent: g.label })),
        el('div', { className: 'bmo-desc', textContent: g.desc }),
      ),
      el('span', { className: 'bmo-arrow', textContent: '✓' }),
    );
    gameButtons.push(btn);
    gameOptsContainer.append(btn);
  });

  let chosenDiff = localStorage.getItem('cb_bot_diff') || 'PRO';
  const diffSectionLabel = el('div', {
    style: 'font-size: 0.82rem; font-weight: 700; color: #94a3b8; margin: 10px 0 6px 0;',
    textContent: 'سطح ربات‌ها:',
  });
  const diffs = [
    { id: 'AMATEUR', icon: '🌱', label: t('bot_diff.amateur', null, 'آماتور') },
    { id: 'PRO', icon: '⚡', label: t('bot_diff.pro', null, 'حرفه‌ای') },
    { id: 'MASTER', icon: '👑', label: t('bot_diff.master', null, 'مستر') },
  ];
  const diffRow = el('div', { style: 'display: flex; gap: 8px; margin-bottom: 16px;' });
  const diffButtons = [];
  diffs.forEach((d) => {
    const isSel = d.id === chosenDiff;
    const dBtn = el('button', {
      type: 'button',
      className: 'ghost-sm' + (isSel ? ' active-filter' : ''),
      style: `flex: 1; padding: 8px 6px; border-radius: 8px; font-size: 0.85rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 5px; ${isSel ? 'background: rgba(59, 130, 246, 0.25); border: 1px solid #3b82f6; color: #93c5fd;' : 'background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.12); color: #cbd5e1;'}`,
      onclick: () => {
        chosenDiff = d.id;
        localStorage.setItem('cb_bot_diff', d.id);
        diffButtons.forEach((b) => {
          b.style.background = 'rgba(255,255,255,0.05)';
          b.style.borderColor = 'rgba(255,255,255,0.12)';
          b.style.color = '#cbd5e1';
        });
        dBtn.style.background = 'rgba(59, 130, 246, 0.25)';
        dBtn.style.borderColor = '#3b82f6';
        dBtn.style.color = '#93c5fd';
      },
    },
      el('span', { textContent: d.icon }),
      el('span', { textContent: d.label }),
    );
    diffButtons.push(dBtn);
    diffRow.append(dBtn);
  });

  const startBtn = el('button', {
    type: 'button',
    className: 'auth-submit-btn',
    style: 'width: 100%; margin-top: 8px; font-size: 0.95rem; font-weight: 700; height: 44px; display: flex; align-items: center; justify-content: center; gap: 6px;',
    textContent: '🎮 شروع بازی تمرینی ▸',
    onclick: () => {
      closeOverlayWithFade(overlay);
      if (onStart) {
        onStart(chosenGame, chosenDiff);
      } else {
        startGame({ offline: true, gameType: chosenGame, botDifficulty: chosenDiff });
      }
    },
  });

  modal.append(head, sub, gameSectionLabel, gameOptsContainer, diffSectionLabel, diffRow, startBtn);
  overlay.append(modal);
  document.body.append(overlay);
}

function showJoinCodeModal() {
  showEnterCodeModal((code) => {
    if (code) startGame({ roomId: code.trim() });
  });
}

// مدال پاپ‌آپ سفارشی برای ورود با کد دعوت اتاق خصوصی
function showEnterCodeModal(onSubmit) {
  const existing = document.getElementById('enter-code-modal-overlay');
  if (existing) existing.remove();

  const overlay = el('div', {
    id: 'enter-code-modal-overlay',
    className: 'bot-modal-overlay',
    onclick: (e) => {
      if (e.target === overlay) closeOverlayWithFade(overlay);
    },
  });

  const modal = el('div', { className: 'bot-modal' });

  const head = el('div', { className: 'bot-modal-head' },
    el('div', { className: 'bot-modal-title' },
      el('span', { textContent: '🔑' }),
      el('h3', { textContent: t('lobby.join_private', null, 'ورود به اتاق خصوصی') }),
    ),
    el('button', {
      className: 'occ-close',
      textContent: '✕',
      onclick: () => closeOverlayWithFade(overlay),
    }),
  );

  const sub = el('p', {
    className: 'bot-modal-sub',
    textContent: t('lobby.join_code_prompt', null, 'کد دعوت اتاق خصوصی را وارد کنید:'),
  });

  const input = el('input', {
    type: 'text',
    className: 'cr-input enter-code-input',
    placeholder: t('lobby.join_code_placeholder', null, 'مثلاً: AB12C'),
    maxLength: 15,
  });

  const errText = el('p', { className: 'enter-code-err hidden', textContent: t('lobby.join_code_error', null, 'لطفاً کد اتاق را وارد کنید.') });

  function submit() {
    const val = input.value.trim();
    if (!val) {
      errText.classList.remove('hidden');
      input.focus();
      return;
    }
    closeOverlayWithFade(overlay);
    onSubmit(val);
  }

  input.onkeydown = (e) => {
    if (e.key === 'Enter') submit();
    else errText.classList.add('hidden');
  };

  const actions = el('div', { className: 'enter-code-actions' },
    el('button', {
      className: 'primary enter-code-btn',
      textContent: t('lobby.join_code_submit', null, 'ورود به اتاق ▸'),
      onclick: submit,
    }),
    el('button', {
      className: 'ghost-sm enter-code-cancel',
      textContent: t('common.cancel', null, 'انصراف'),
      onclick: () => closeOverlayWithFade(overlay),
    }),
  );

  modal.append(head, sub, input, errText, actions);
  overlay.append(modal);
  document.body.append(overlay);
  setTimeout(() => input.focus(), 50);
}

// ─── مدال تعاملی دعوت به اتاق ───────────────────────────────────────────────
function showRoomInviteModal({ fromUsername, roomId }) {
  const existing = document.getElementById('room-invite-overlay');
  if (existing) existing.remove();

  const overlay = el('div', {
    id: 'room-invite-overlay',
    className: 'bot-modal-overlay',
    onclick: (e) => {
      if (e.target === overlay) overlay.remove();
    },
  });

  const modal = el('div', { className: 'bot-modal room-invite-card' });
  const head = el('div', { className: 'bot-modal-head' },
    el('div', { className: 'bot-modal-title' },
      el('span', { textContent: '📨' }),
      el('h3', { textContent: 'دعوت به بازی' }),
    ),
    el('button', { className: 'occ-close', textContent: '✕', onclick: () => overlay.remove() }),
  );

  const desc = el('p', {
    className: 'bot-modal-sub',
    textContent: `«${fromUsername}» شما را به اتاق بازی دعوت کرده است. مایل به پیوستن هستید؟`,
  });

  const actions = el('div', { className: 'enter-code-actions' },
    el('button', {
      className: 'primary',
      textContent: '🎮 ورود به اتاق ▸',
      onclick: () => {
        overlay.remove();
        startGame({ roomId });
      },
    }),
    el('button', {
      className: 'ghost-sm',
      textContent: 'رد / بعداً',
      onclick: () => overlay.remove(),
    }),
  );

  modal.append(head, desc, actions);
  overlay.append(modal);
  document.body.append(overlay);
}

// ─── اعلان شناور درخواست دوستی بلادرنگ ──────────────────────────────────────
function showFriendRequestModal({ fromUsername, fromUserId, fromAvatarUrl }) {
  const existing = document.getElementById('friend-req-toast');
  if (existing) existing.remove();

  const toastEl = el('div', { id: 'friend-req-toast', className: 'friend-req-toast' },
    avatarEl(fromUsername, fromAvatarUrl, 58),
    el('div', { className: 'frt-content' },
      el('strong', { className: 'frt-name', textContent: fromUsername }),
      el('span', { className: 'frt-desc', textContent: 'درخواست دوستی فرستاد' }),
    ),
    el('div', { className: 'frt-actions' },
      el('button', {
        className: 'frt-btn accept',
        textContent: 'قبول ✓',
        onclick: async () => {
          try {
            await apiFetch('POST', `/api/friends/accept/${fromUserId}`);
            if (networkTable) networkTable.acceptFriendRequest(fromUserId);
            friendsSet.add(fromUserId);
            toast(`شما و ${fromUsername} اکنون دوست هستید! 🎉`);
          } catch {}
          toastEl.remove();
        },
      }),
      el('button', {
        className: 'frt-btn reject',
        textContent: '✕',
        onclick: async () => {
          try { await apiFetch('POST', `/api/friends/reject/${fromUserId}`); } catch {}
          toastEl.remove();
        },
      }),
    ),
  );
  document.body.append(toastEl);
  setTimeout(() => toastEl?.remove(), 25000);
}

// ─── اعلان شناور پیام خصوصی بلادرنگ ──────────────────────────────────────────
const _SVG_DM = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';
let _dmToastTimer = null;
function showDmToast(m) {
  if (!m || !m.fromUserId) return;
  const existing = document.getElementById('dm-toast');
  if (existing) {
    clearTimeout(_dmToastTimer);
    existing.remove();
  }

  const toastEl = el('div', { id: 'dm-toast', className: 'dm-toast' },
    avatarEl(m.fromName || 'کاربر', m.fromAvatarUrl, 42, false, 100, false, true),
    el('div', { className: 'dmt-content' },
      el('div', { className: 'dmt-head' },
        el('strong', { className: 'dmt-name', textContent: m.fromName || 'یک کاربر' }),
        el('span', { className: 'dmt-badge', textContent: 'پیام خصوصی' }),
      ),
      el('p', { className: 'dmt-text', textContent: m.text || '' }),
    ),
    el('div', { className: 'dmt-actions' },
      el('button', {
        className: 'dmt-open-btn',
        title: 'مشاهده و پاسخ به پیام',
        onclick: () => {
          clearTimeout(_dmToastTimer);
          toastEl.classList.add('closing');
          setTimeout(() => toastEl.remove(), 180);
          openDm(m.fromUserId, m.fromName, m.fromAvatarUrl);
        },
      },
        el('span', { className: 'dmt-btn-icon', innerHTML: _SVG_DM }),
        el('span', { textContent: 'باز کردن پیام' }),
      ),
      el('button', {
        className: 'dmt-close-btn',
        title: 'بستن',
        onclick: () => {
          clearTimeout(_dmToastTimer);
          toastEl.classList.add('closing');
          setTimeout(() => toastEl.remove(), 180);
        },
      }, '✕'),
    ),
  );

  document.body.append(toastEl);
  _dmToastTimer = setTimeout(() => {
    if (toastEl && toastEl.isConnected) {
      toastEl.classList.add('closing');
      setTimeout(() => toastEl.remove(), 180);
    }
  }, 12000);
}

// ─── مدال لیگ و رتبه‌بندی کاربران (Top 20) ──────────────────────────────────
async function showLeaderboardModal() {
  const existing = document.getElementById('lb-modal-overlay');
  if (existing) existing.remove();

  const overlay = el('div', {
    id: 'lb-modal-overlay',
    className: 'lb-modal-overlay',
    onclick: (e) => { if (e.target === overlay) closeOverlayWithFade(overlay); },
  });

  const modal = el('div', { className: 'lb-modal' });

  const head = el('div', { className: 'lb-head' },
    el('div', { className: 'lb-title-group' },
      el('span', { style: 'font-size:22px;', textContent: '🏆' }),
      el('h3', { textContent: t('leaderboard.modal_title', null, 'لیگ و رتبه‌بندی برتر') }),
    ),
    el('button', {
      className: 'lb-close-btn',
      title: t('common.close', null, 'بستن'),
      textContent: '✕',
      onclick: () => closeOverlayWithFade(overlay),
    }),
  );

  const footerNote = el('div', { className: 'lb-footer-note', textContent: t('leaderboard.footer_note', null, 'رتبه‌بندی هر دقیقه به‌روز می‌شود · امتیاز ماهانه و فصلی با بوستر، همیشگی و تراز بدون بوستر') });
  const listWrap = el('div', { className: 'lb-list-wrap' }, leaderboardPanel({ limit: 20 }));
  modal.append(head, listWrap, footerNote);
  overlay.append(modal);
  document.body.append(overlay);
}

// ─── لابیِ دسکتاپِ سه‌ستونه ──────────────────────────────────────────────────
let lobbyFilter = 'all';        // all | shelem | hokm | friends
let lobbyLbPeriod = 'all';      // ماهانه/فصلی/تراز برای ریلِ چپ
const LB_ICON = {
  rooms: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="13" height="17" rx="2"/><path d="M16 8h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-1"/><path d="M9.5 11l-1.5 1.5 1.5 1.5 1.5-1.5z"/></svg>',
  leaderboard: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2M18 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2"/><path d="M6 3h12v7a6 6 0 0 1-12 0V3z"/><path d="M9 21h6M12 16v5"/></svg>',
  friends: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
  profile: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/></svg>',
  shop: '<svg viewBox="0 0 24 24" class="shop-svg-ic shop-svg-coin" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="6" stroke-dasharray="2 2" stroke-width="1.2"/><path d="M12 8v8M10 10.5c.5-.9 2.5-.9 3 0s-.6 2.5-2 2.5 1.5 2.5 3 2.5" stroke-width="1.6" stroke-linecap="round"/></svg>',
  vip: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M4 8l4 3 4-6 4 6 4-3-1.5 11h-13z"/></svg>',
  admin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M12 3v3M12 18v3M5 12H2M22 12h-3M5.6 5.6l2 2M16.4 16.4l2 2M18.4 5.6l-2 2M7.6 16.4l-2 2"/><circle cx="12" cy="12" r="3.4"/></svg>',
  support: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M4 13v-1a8 8 0 0 1 16 0v1"/><rect x="3" y="13" width="4" height="7" rx="2"/><rect x="17" y="13" width="4" height="7" rx="2"/><path d="M20 20a4 4 0 0 1-4 3h-2.5"/></svg>',
  report: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>',
  settings: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 3v3M12 18v3M5 12H2M22 12h-3M5.6 5.6l2 2M16.4 16.4l2 2M18.4 5.6l-2 2M7.6 16.4l-2 2"/><circle cx="12" cy="12" r="3.4"/></svg>',
  help: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>',
  logout: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M14 4h5v16h-5M14 12H4M8 8l-4 4 4 4"/></svg>',
};
const LB_BOT_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><rect x="5" y="8" width="14" height="10" rx="3"/><circle cx="9.5" cy="13" r="1.4" fill="currentColor" stroke="none"/><circle cx="14.5" cy="13" r="1.4" fill="currentColor" stroke="none"/><path d="M12 4.5V8M8.5 18v1.5M15.5 18v1.5"/></svg>';

function _lobbyLogout() {
  localStorage.removeItem('shelem_token');
  authToken = null; myUserId = null; friendsSet.clear(); setCustomPresets([]);
  // نشان‌ها/اخیرِ پنلِ سریع مالِ همان حساب‌اند (روی سرور می‌مانند) — به حسابِ بعدی روی این دستگاه نرسند
  try { localStorage.removeItem('cb_qs'); } catch { /* noop */ }
  _frRailCache = { at: 0, friends: null }; _lbRailCache.clear();
  _lobbySocialPanelEl = null; _lobbyActivePeer = null;
  networkTable?.disconnect(); networkTable = null;
  renderLogin();
}

// ساخت اتاق دو گام است: ۱) انتخابِ بازی (شلم/حکم) ۲) پنجرهٔ تنظیماتِ اتاق (createRoomPanel).
// createRoomPanel قوانینِ اتاق (جوکر، انداختن، هدف) را از selectedGame می‌سازد، پس انتخاب باید قبلش ثبت شود.
function showCreateRoomModal() {
  document.getElementById('create-room-game-overlay')?.remove();
  const overlay = el('div', {
    id: 'create-room-game-overlay', className: 'bot-modal-overlay',
    onclick: (e) => { if (e.target === overlay) closeOverlayWithFade(overlay); },
  });
  const games = [
    { id: 'chahar_barg', icon: '♣', desc: t('create_room.game_desc_chahar_barg', null, 'قانون عدد ۱۱، سور و هفت‌خاج — ۲ یا ۴ بازیکن') },
    { id: 'shelem', icon: '♠', desc: t('create_room.game_desc_shelem', null, 'مزایده، حکم‌گذاری و امتیازِ تیمی — ۴ بازیکن') },
    { id: 'hokm', icon: '♥', desc: t('create_room.game_desc_hokm', null, 'حاکم حکم را تعیین می‌کند؛ اولین تیم با ۷ دست برنده است') },
    { id: 'bidel', icon: '💔', desc: t('create_room.game_desc_bidel', null, 'بازی انفرادی ۴ نفره — فرار از دل‌ها و بی‌بی پیک یا شق‌القمر!') },
    { id: 'bluff', icon: '🎭', desc: t('create_room.game_desc_bluff', null, 'دوئل بلوف و دادگاه بازجویی — خالی کردن دست، اعتراف یا قمار بزرگ!') },
  ];
  const opts = el('div', { className: 'bot-modal-opts' });
  for (const g of games) {
    const on = selectedGame === g.id;
    opts.append(el('button', {
      type: 'button', className: 'bot-modal-opt' + (on ? ' active' : ''),
      onclick: () => {
        selectedGame = g.id;
        localStorage.setItem('cb_game', g.id);
        overlay.remove();
        showCreateRoomSettings();
      },
    },
      el('div', { className: 'bmo-icon' }, g.icon),
      el('div', { className: 'bmo-info' },
        el('div', { className: 'bmo-name' },
          el('span', { textContent: GAME_FA[g.id] }),
          on ? el('span', { className: 'bmo-badge', textContent: t('create_room.last_selected', null, 'آخرین انتخاب') }) : null),
        el('div', { className: 'bmo-desc', textContent: g.desc }),
      ),
      el('span', { className: 'bmo-arrow', textContent: '▸' }),
    ));
  }
  overlay.append(el('div', { className: 'bot-modal' },
    el('div', { className: 'bot-modal-head' },
      el('div', { className: 'bot-modal-title' }, el('span', { textContent: '➕' }), el('h3', { textContent: t('create_room.modal_title', null, 'ساخت اتاق') })),
      el('button', { className: 'occ-close', textContent: '✕', onclick: () => closeOverlayWithFade(overlay) }),
    ),
    el('p', { className: 'bot-modal-sub', textContent: t('create_room.choose_game', null, 'اول بازی را انتخاب کنید:') }),
    opts,
  ));
  document.body.append(overlay);
}

function showCreateRoomSettings() {
  document.getElementById('create-room-modal-overlay')?.remove();
  const overlay = el('div', {
    id: 'create-room-modal-overlay', className: 'bot-modal-overlay',
    onclick: (e) => { if (e.target === overlay) closeOverlayWithFade(overlay); },
  });
  const modal = el('div', { className: 'bot-modal' },
    el('div', { className: 'bot-modal-head' },
      el('div', { className: 'bot-modal-title' }, el('span', { textContent: '➕' }), el('h3', { textContent: t('create_room.room_title', { game: GAME_FA[selectedGame] }, `ساخت اتاق — ${GAME_FA[selectedGame]}`) })),
      el('button', { className: 'occ-close', textContent: '✕', onclick: () => closeOverlayWithFade(overlay) }),
    ),
    createRoomPanel(() => closeOverlayWithFade(overlay)),
  );
  overlay.append(modal);
  document.body.append(overlay);
}

function showSupportModal() {
  document.getElementById('support-modal-overlay')?.remove();
  const overlay = el('div', {
    id: 'support-modal-overlay', className: 'bot-modal-overlay',
    onclick: (e) => { if (e.target === overlay) { closeOverlayWithFade(overlay); checkSupportUnread(); } },
  });

  const modal = el('div', { className: 'bot-modal support-modal' });

  const head = el('div', { className: 'bot-modal-head' },
    el('div', { className: 'bot-modal-title' }, el('span', { textContent: '💬' }), el('h3', { textContent: t('support.modal_title') })),
    el('button', { className: 'occ-close', textContent: '✕', onclick: () => { closeOverlayWithFade(overlay); checkSupportUnread(); } }),
  );

  const container = el('div', { className: 'support-container' });
  modal.append(head, container);
  overlay.append(modal);
  document.body.append(overlay);

  async function renderList() {
    container.innerHTML = `<div class="support-loading">${t('support.loading')}</div>`;

    const topBar = el('div', { className: 'support-topbar' },
      el('button', {
        className: 'btn-support-new',
        textContent: t('support.new_ticket'),
        onclick: () => renderNew(),
      }),
      el('span', { className: 'support-subtext', textContent: t('support.subtext') }),
    );

    let res;
    try {
      res = await apiFetch('GET', '/api/support/tickets');
    } catch (e) {
      container.innerHTML = `<div class="support-error">${t('support.server_error')}</div>`;
      return;
    }

    const tickets = res?.tickets || [];
    const listEl = el('div', { className: 'support-ticket-list' });

    if (!tickets.length) {
      listEl.append(
        el('div', { className: 'support-empty' },
          el('div', { className: 'empty-icon', textContent: '📩' }),
          el('p', { textContent: t('support.empty') }),
          el('button', { className: 'btn-support-new', textContent: t('support.first_ticket'), onclick: () => renderNew() }),
        ),
      );
    } else {
      for (const tck of tickets) {
        const item = el('div', { className: 'support-ticket-card' + (tck.has_unread ? ' has-unread' : ''), onclick: () => renderDetail(tck.id) });
        let stBadge;
        if (tck.has_unread) {
          stBadge = el('span', { className: 'st-badge unread-ans', textContent: t('support.status_unread') });
        } else if (tck.status === 'answered') {
          stBadge = el('span', { className: 'st-badge answered', textContent: t('support.status_answered') });
        } else if (tck.status === 'closed') {
          stBadge = el('span', { className: 'st-badge closed', textContent: t('support.status_closed') });
        } else {
          stBadge = el('span', { className: 'st-badge open', textContent: t('support.status_open') });
        }

        const dateStr = tck.updated_at ? formatLocalizedDate(tck.updated_at) : '—';
        item.append(
          el('div', { className: 'st-card-head' },
            el('span', { className: 'st-subject', textContent: tck.subject }),
            stBadge,
          ),
          el('div', { className: 'st-card-foot' },
            el('span', { className: 'st-date', textContent: dateStr }),
            el('span', { className: 'st-msgs-count', textContent: t('support.msgs_count', { count: tck.message_count || 1 }) }),
          ),
        );
        listEl.append(item);
      }
    }

    container.replaceChildren(topBar, listEl);
  }

  function renderNew() {
    const form = el('div', { className: 'support-form' });

    const backBtn = el('button', {
      className: 'support-back-btn',
      textContent: t('support.back_to_list'),
      onclick: () => renderList(),
    });

    const subjectIn = el('input', {
      className: 'support-input',
      placeholder: t('support.subject_placeholder'),
      maxLength: 150,
    });

    const msgArea = el('textarea', {
      className: 'support-textarea',
      rows: 5,
      placeholder: t('support.msg_placeholder'),
      maxLength: 3000,
    });

    const errBox = el('div', { className: 'support-err-msg' });

    const submitBtn = el('button', {
      className: 'btn-support-submit',
      textContent: t('support.send'),
      onclick: async () => {
        const subj = subjectIn.value.trim();
        const msg = msgArea.value.trim();
        if (subj.length < 3) {
          errBox.textContent = t('support.subject_min');
          return;
        }
        if (msg.length < 5) {
          errBox.textContent = t('support.msg_min');
          return;
        }
        submitBtn.disabled = true;
        submitBtn.textContent = t('support.sending');
        errBox.textContent = '';
        try {
          const res = await apiFetch('POST', '/api/support/tickets', { subject: subj, message: msg });
          if (res?.ok && res?.ticket) {
            renderDetail(res.ticket.id);
          } else {
            errBox.textContent = res?.error || t('support.send_error');
            submitBtn.disabled = false;
            submitBtn.textContent = t('support.send');
          }
        } catch (e) {
          errBox.textContent = t('support.server_error');
          submitBtn.disabled = false;
          submitBtn.textContent = t('support.send');
        }
      },
    });

    form.append(backBtn, subjectIn, msgArea, errBox, submitBtn);
    container.replaceChildren(form);
  }

  async function renderDetail(ticketId) {
    container.innerHTML = `<div class="support-loading">${t('support.loading_thread')}</div>`;

    let res;
    try {
      res = await apiFetch('GET', `/api/support/tickets/${ticketId}`);
    } catch (e) {
      container.innerHTML = `<div class="support-error">${t('support.server_error')}</div>`;
      return;
    }

    if (!res?.ok || !res?.ticket) {
      container.innerHTML = `<div class="support-error">${t('support.not_found')}</div>`;
      return;
    }

    checkSupportUnread();

    const { ticket, messages } = res;
    const detailWrap = el('div', { className: 'support-detail-wrap' });

    const topBar = el('div', { className: 'support-detail-bar' },
      el('button', {
        className: 'support-back-btn',
        textContent: t('support.ticket_list'),
        onclick: () => renderList(),
      }),
      el('div', { className: 'st-detail-title-box' },
        el('strong', { className: 'st-title-text', textContent: ticket.subject }),
        ticket.status === 'answered'
          ? el('span', { className: 'st-badge answered', textContent: t('support.status_answered') })
          : ticket.status === 'closed'
            ? el('span', { className: 'st-badge closed', textContent: t('support.status_closed') })
            : el('span', { className: 'st-badge open', textContent: t('support.status_open') }),
      ),
    );

    const dateLocale = getLang() === 'fa' ? 'fa-IR' : 'en-US';
    const msgsBox = el('div', { className: 'support-msgs-box' });
    for (const m of messages) {
      const isAdmin = m.sender_type === 'admin';
      const bubble = el('div', { className: 'st-msg-bubble ' + (isAdmin ? 'admin' : 'user') });
      const timeStr = m.created_at ? new Date(m.created_at).toLocaleTimeString(dateLocale, { hour: '2-digit', minute: '2-digit' }) : '';
      const dateStr = m.created_at ? formatLocalizedDate(m.created_at) : '';
      bubble.append(
        el('div', { className: 'st-msg-head' },
          el('span', { className: 'st-sender', textContent: isAdmin ? t('support.sender_support') : t('support.sender_you') }),
          el('span', { className: 'st-time', textContent: `${dateStr} ${timeStr}` }),
        ),
        el('div', { className: 'st-msg-body', textContent: m.body }),
      );
      msgsBox.append(bubble);
    }

    setTimeout(() => { msgsBox.scrollTop = msgsBox.scrollHeight; }, 30);

    const replyForm = el('div', { className: 'support-reply-box' });
    const replyArea = el('textarea', {
      className: 'support-textarea sm',
      rows: 2,
      placeholder: t('support.reply_placeholder'),
      maxLength: 3000,
    });
    const errBox = el('div', { className: 'support-err-msg' });
    const replyBtn = el('button', {
      className: 'btn-support-submit sm',
      textContent: t('support.reply'),
      onclick: async () => {
        const text = replyArea.value.trim();
        if (text.length < 2) {
          errBox.textContent = t('support.reply_min');
          return;
        }
        replyBtn.disabled = true;
        replyBtn.textContent = '…';
        errBox.textContent = '';
        try {
          const r = await apiFetch('POST', `/api/support/tickets/${ticket.id}/reply`, { message: text });
          if (r?.ok) {
            renderDetail(ticket.id);
          } else {
            errBox.textContent = r?.error || t('support.reply_error');
            replyBtn.disabled = false;
            replyBtn.textContent = t('support.reply');
          }
        } catch (e) {
          errBox.textContent = t('support.server_error');
          replyBtn.disabled = false;
          replyBtn.textContent = t('support.reply');
        }
      },
    });

    replyForm.append(replyArea, errBox, replyBtn);
    detailWrap.append(topBar, msgsBox, replyForm);
    container.replaceChildren(detailWrap);
  }

  renderList();
}


function _lobbySeatAv(s) {
  if (!s) return el('span', { className: 'lb3-sav empty' });
  if (s.isBot) return el('span', { className: 'lb3-sav bot', innerHTML: LB_BOT_SVG, title: 'ربات' });
  const initial = (String(s.name || '?').trim()[0]) || '?';
  return el('span', { className: 'lb3-sav', textContent: initial, title: s.name || '' });
}

function lobbyRoomCard(r) {
  const roomId = r.roomId || r.id;
  const seated = r.seated ?? 0;
  const rGame = r.gameType || 'shelem';
  const isCoop = r.playerMode === 'COOP_2V2';
  const hasBot = (r.bots || 0) > 0;
  const isLive = r.state === 'IN_HAND';
  // بازیِ در جریان هرگز صندلی نمی‌دهد (حتی اگر ربات دارد) → فقط تماشا.
  const canJoin = r.state === 'WAITING' && seated < 4;
  const seats = (Array.isArray(r.seats) && r.seats.length === 4) ? r.seats : [null, null, null, null];

  // در بی‌دل بازی انفرادی است؛ در سایر بازی‌ها جفت‌های تیمی مقابل هم
  const isBidel = rGame === 'bidel';
  const pair = (a, b, cls) => el('div', { className: 'lb3-pair ' + cls }, _lobbySeatAv(seats[a]), _lobbySeatAv(seats[b]));
  const strip = isBidel
    ? el('div', { className: 'lb3-seatstrip bidel-strip' }, _lobbySeatAv(seats[0]), _lobbySeatAv(seats[1]), _lobbySeatAv(seats[2]), _lobbySeatAv(seats[3]))
    : el('div', { className: 'lb3-seatstrip' }, pair(0, 2, 't1'), pair(1, 3, 't2'));

  const badges = el('div', { className: 'lb3-badges' },
    el('span', { className: 'lb3-bdg ' + rGame, textContent: GAME_FA[rGame] || rGame }),
    (r.jokerMode ? el('span', { className: 'lb3-bdg joker', textContent: '🃏 جوکر', title: 'شلم با جوکر قرمز و آبی' }) : null),
    (rGame !== 'hokm' && rGame !== 'bidel' && r.matchTarget ? el('span', { className: 'lb3-bdg target', textContent: `🎯 ${fmtNum(r.matchTarget)}`, title: `${t('leaderboard.score', null, 'امتیاز')}: ${fmtNum(r.matchTarget)}` }) : null),
    (isBidel && (r.targetScore || r.matchTarget) ? el('span', { className: 'lb3-bdg target bidel', textContent: t('lobby.target_loss', { score: fmtNum(r.targetScore || r.matchTarget) }, `🎯 سقف باخت ${faNum(r.targetScore || r.matchTarget)}`), title: `${t('lobby.target_loss', { score: fmtNum(r.targetScore || r.matchTarget) })}` }) : null),
    (isBidel && r.jackDiamondsBonus ? el('span', { className: 'lb3-bdg jack-bonus', textContent: t('lobby.jack_diamonds_bonus', null, '♦۱۰- جایزه'), title: t('lobby.jack_diamonds_bonus', null, '♦۱۰- جایزه') }) : null),
    (rGame !== 'hokm' && rGame !== 'bidel' && r.andakhtan !== false ? el('span', { className: 'lb3-bdg andakhtan', textContent: t('rules.andakhtan', null, '📜 انداختن'), title: t('rules.andakhtan', null, '📜 انداختن') }) : null),
    isLive
      ? el('span', { className: 'lb3-bdg live', textContent: t('lobby.playing', null, 'در حال بازی') })
      : el('span', { className: 'lb3-bdg open', textContent: canJoin ? `${fmtNum(Math.max(0, 4 - seated))} ${t('lobby.open_seats', null, 'جای خالی')}` : t('lobby.full', null, 'پر') }),
    el('span', {
      className: 'lb3-bdg ' + (r.speedMode ? 'speed' : 'normal'),
      textContent: r.speedMode ? t('rules.speed_mode', null, '⚡ سرعتی') : t('rules.normal_speed', null, 'عادی'),
      title: r.speedMode ? 'Speed' : 'Normal',
    }),
    (r.stableOnly ? el('span', {
      className: 'lb3-bdg stable',
      textContent: t('lobby.stable_only', null, '🛡 پایدار'),
      title: t('lobby.stable_only', null, '🛡 پایدار'),
    }) : null),
    (r.turnTimeSec ? el('span', { className: 'lb3-bdg', textContent: `⏱ ${fmtNum(r.turnTimeSec)}${t('common.seconds_short', null, 'ث')}` }) : null),
    (isCoop ? el('span', { className: 'lb3-bdg', textContent: t('lobby.coop_vs_bot', null, '۲ نفر مقابل ربات') }) : null),
    (hasBot && !isCoop && !isLive ? el('span', { className: 'lb3-bdg', textContent: `${fmtNum(r.bots)} ${t('lobby.bot_replacement', null, 'ربات — جایگزینی')}` }) : null),
    ((r.watching || 0) > 0 ? el('span', { className: 'lb3-bdg', textContent: `👁 ${fmtNum(r.watching)}` }) : null),
  );

  // اتاقِ پایدار + اتصالِ ناپایدار → دکمه از اول غیرفعال با توضیح، به‌جای ردِ مرموز
  // بعد از کلیک. تماشا همچنان آزاد است (ناظر بازی را نمی‌خواباند).
  const netBlocked = !!r.stableOnly && networkTable?.net?.grade === 'poor';
  const enter = el('button', {
    className: 'lb3-btn' + (canJoin && !netBlocked ? ' gold' : '') + (netBlocked ? ' net-blocked' : ''),
    textContent: netBlocked ? (canJoin ? t('net.poor', null, 'اتصال ناپایدار') : t('lobby.spectate', null, 'تماشا')) : (canJoin ? t('lobby.enter', null, 'ورود') : t('lobby.spectate', null, 'تماشا')),
    title: netBlocked
      ? t('net.poor_tip', null, 'این اتاق فقط کاربران با اتصال پایدار را می‌پذیرد. اتصال شما مکرراً قطع می‌شود.')
      : '',
    disabled: netBlocked && canJoin,
    onclick: () => {
      if (netBlocked && canJoin) return;
      if (canJoin && !netBlocked) startGame({ roomId, gameType: rGame });
      else startGame({ observer: true, roomId, gameType: rGame });
    },
  });

  return el('div', { className: 'lb3-room' + (isLive ? ' live' : '') },
    strip,
    el('div', { className: 'lb3-room-info' }, el('h4', { textContent: `${t('lobby.room', null, 'اتاق')} ${r.name || roomId}` }), badges),
    el('div', { className: 'lb3-room-cta' }, enter),
  );
}

const _lbRailCache = new Map(); // `${game}:${board}` -> { at, data }  (کاهشِ درخواست هنگام سوییچِ فیلترِ لابی)
let lobbyLbGame = 'shelem';

// ─── رتبه‌بندی هر بازی: همیشگی / ماهانه / فصلی / تراز (GET /api/leaderboard?game=&board=) ───
// ─── رتبه‌بندی هر بازی: همیشگی / ماهانه / فصلی / تراز (GET /api/leaderboard?game=&board=) ───
const getLbBoards = () => [
  ['monthly', t('leaderboard.monthly', null, 'ماهانه')],
  ['seasonal', t('leaderboard.seasonal', null, 'فصلی')],
  ['all', t('leaderboard.all_time', null, 'همیشگی')],
  ['elo', t('leaderboard.rating', null, 'تراز')]
];
const _daysLeft = (iso) => Math.max(0, Math.ceil((Date.parse(iso) - Date.now()) / 86400000));

function leaderboardPanel({ limit = 15, onBoard = null } = {}) {
  const root = el('div', { className: 'lbp' });
  const gameChips = el('div', { className: 'lbp-games' });
  const tabs = el('div', { className: 'lb3-lbtabs' });
  const info = el('div', { className: 'lbp-info' });
  const listEl = el('div', { className: 'lb3-lblist' });

  const row = (u, isMe) => {
    const menuOpts = { username: u.username, userId: u.userId, avatarUrl: u.avatar_url };
    const name = el('span', { className: 'lb3-lbname', textContent: isMe ? `${u.username} (${t('leaderboard.you', null, 'شما')})` : u.username, title: 'مشاهده پروفایل یا پیام خصوصی' });
    const av = avatarEl(u.username, u.avatar_url, 33);
    if (u.userId) { bindProfileMenu(name, menuOpts); bindProfileMenu(av, menuOpts); }
    const medal = { 1: '🥇', 2: '🥈', 3: '🥉' }[u.rank];
    const prov = !u.rank && (u.provisional || u.provisionalRank);
    return el('div', { className: 'lb3-lbrow' + (prov ? ' prov' : '') + (isMe || (u.userId && u.userId === myUserId) ? ' me' : '') },
      el('span', { className: 'lb3-lbrank' + (medal ? ' medal' : ''), textContent: medal || (u.rank ? fmtNum(u.rank) : (u.provisionalRank ? `~${fmtNum(u.provisionalRank)}` : '—')) }),
      av,
      name,
      prov ? el('span', { className: 'lbp-prov', title: `${fmtNum(u.games || 0)} / ${fmtNum(u.need || 0)}`, textContent: t('leaderboard.provisional', null, 'موقت') }) : null,
      el('span', { className: 'lb3-lbval', textContent: u.value == null ? '—' : fmtNum(u.value) }),
    );
  };

  const paint = (d) => {
    const unit = lobbyLbPeriod === 'elo' ? t('leaderboard.rating', null, 'تراز') : t('leaderboard.score', null, 'امتیاز');
    const txt = [];
    if (d.period) txt.push(`${d.period.label}${d.period.endsAt ? ` · ${t('leaderboard.days_left', { n: fmtNum(_daysLeft(d.period.endsAt)) }, `${faNum(_daysLeft(d.period.endsAt))} روز تا پایان`)}` : ''}`);
    if (d.min > 1) txt.push(t('leaderboard.min_games', { n: fmtNum(d.min) }, `حداقل ${faNum(d.min)} بازی`));
    txt.push(`${t('leaderboard.column', null, 'ستون')}: ${unit}`);
    info.textContent = txt.join(' · ');
    const rows = (d.rows || []).slice(0, limit);
    if (!rows.length) listEl.replaceChildren(el('p', { className: 'muted small lb3-mini-msg', textContent: t('leaderboard.empty', null, 'هنوز کسی به این جدول نرسیده') }));
    else {
      listEl.replaceChildren();
      rows.forEach((u, i) => {
        // مرزِ رسمی/موقت: از اینجا به بعد هنوز به حداقل بازی نرسیده‌اند
        if (u.provisional && !rows[i - 1]?.provisional) {
          listEl.append(el('div', { className: 'lbp-provhead', textContent: t('leaderboard.provisional_head', { n: fmtNum(d.min) }, `موقت — کمتر از ${faNum(d.min)} بازی`) }));
        }
        listEl.append(row(u, false));
      });
    }
    // «رتبهٔ من» وقتی در فهرستِ نمایش‌داده نیستم
    const me = d.me;
    if (me && myUserId && !rows.some((u) => u.userId === myUserId)) {
      const p = myProfile || {};
      listEl.append(el('div', { className: 'lbp-sep' }));
      listEl.append(row({ rank: me.rank, provisionalRank: me.provisionalRank, games: me.games, need: me.need, value: me.value, userId: null, username: p.display_name || p.username || t('leaderboard.you', null, 'شما'), avatar_url: p.avatar_url }, true));
      if (me.rank == null) {
        listEl.append(el('div', { className: 'lbp-need', textContent: `${fmtNum(me.games || 0)} / ${fmtNum(me.need)}` }));
      }
    } else if (myProfile?.is_guest) {
      listEl.append(el('div', { className: 'lbp-guest-banner' },
        el('div', { className: 'lbp-guest-txt', textContent: t('leaderboard.guest_notice', null, '🏆 کاربران مهمان در جدول رتبه‌بندی قرار نمی‌گیرند.') }),
        el('button', {
          type: 'button',
          className: 'lbp-guest-btn',
          textContent: t('leaderboard.guest_upgrade_btn', null, 'ثبت‌نام و ورود به جدول (+۵۰۰ سکه)'),
          onclick: () => showUpgradeGuestModal('leaderboard'),
        })
      ));
    }
  };

  const load = async () => {
    [...gameChips.children].forEach((b) => b.classList.toggle('on', b.dataset.g === lobbyLbGame));
    [...tabs.children].forEach((b) => b.classList.toggle('on', b.dataset.b === lobbyLbPeriod));
    onBoard?.();
    const key = `${lobbyLbGame}:${lobbyLbPeriod}`;
    const cached = _lbRailCache.get(key);
    if (cached && Date.now() - cached.at < 60_000) { paint(cached.data); return; }
    listEl.replaceChildren(el('p', { className: 'muted small lb3-mini-msg', textContent: t('common.loading', null, 'در حال بارگذاری…') }));
    try {
      const data = await apiFetch('GET', `/api/leaderboard?game=${lobbyLbGame}&board=${lobbyLbPeriod}`);
      if (!data?.ok) throw new Error('bad');
      _lbRailCache.set(key, { at: Date.now(), data });
      paint(data);
    } catch {
      listEl.replaceChildren(el('p', { className: 'muted small lb3-mini-msg', style: 'color:#ff8a8a', textContent: t('common.error', null, 'خطا در بارگذاری') }));
    }
  };

  const gameChipsWrap = el('div', { className: 'lbp-games-wrap' }, gameChips);

  // امکان اسکرول افقی با ماوس‌ویل روی دسکتاپ
  gameChips.addEventListener('wheel', (e) => {
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      e.preventDefault();
      gameChips.scrollLeft += e.deltaY;
    }
  }, { passive: false });

  const LB_GAMES = ['shelem', 'hokm', 'chahar_barg', 'bidel', 'bluff'];
  for (const g of LB_GAMES) {
    const btn = el('button', {
      className: 'lbp-game',
      textContent: GAME_FA[g],
      onclick: () => {
        lobbyLbGame = g;
        btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        load();
      }
    });
    btn.dataset.g = g;
    gameChips.append(btn);
  }
  const lbBoards = getLbBoards();
  for (const [b, label] of lbBoards) {
    const btn = el('button', { className: 'lb3-lbtab', textContent: label, onclick: () => { lobbyLbPeriod = b; load(); } });
    btn.dataset.b = b;
    tabs.append(btn);
  }
  if (!LB_GAMES.includes(lobbyLbGame)) lobbyLbGame = 'shelem';
  if (!lbBoards.some(([b]) => b === lobbyLbPeriod)) lobbyLbPeriod = 'monthly';
  root.append(gameChipsWrap, tabs, info, listEl);
  load();
  // اسکرول نرم به آیتم فعال در بارگذاری اولیه
  setTimeout(() => {
    gameChips.querySelector('.lbp-game.on')?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }, 100);
  return root;
}

function lobbyLeaderRail() {
  const panel = el('div', { className: 'lb3-panel lb3-mini' });
  panel.append(el('div', { className: 'lb3-mini-head' },
    el('h5', { textContent: t('leaderboard.title', null, 'رتبه‌بندی') }),
    el('button', { className: 'lb3-btn sm', textContent: t('leaderboard.all', null, 'همه'), onclick: () => showLeaderboardModal() }),
  ));
  panel.append(leaderboardPanel({ limit: 10 }));
  return panel;
}

// ─── پروفایل عمومی (فاز ۲): هدر + تب «عمومی» (خلاصه، نشان‌ها، افتخارات) + تب هر بازی (جزئیات) ───
const PV_GAMES = ['shelem', 'hokm', 'chahar_barg', 'bidel', 'bluff'];
const PV_MEDAL = { 1: '🥇', 2: '🥈', 3: '🥉' };

function _primaryGame(stats) {
  const g = stats?.games || {};
  let bestG = 'shelem', bestCount = -1;
  for (const k of PV_GAMES) {
    const cnt = g[k]?.games || 0;
    if (cnt > bestCount) { bestCount = cnt; bestG = k; }
  }
  return bestG;
}

// «عضو از مهر ۱۴۰۵» یا «Member since October 2025»
function _joinedFa(iso) {
  if (!iso) return null;
  try {
    const lang = getLang();
    if (lang === 'en') {
      // میلادی برای زبان انگلیسی
      return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long' }).format(new Date(iso));
    }
    // شمسی برای فارسی
    const parts = new Intl.DateTimeFormat('fa-IR-u-ca-persian', { year: 'numeric', month: 'long' }).formatToParts(new Date(iso));
    const get = (t) => parts.find((x) => x.type === t)?.value || '';
    return `${get('month')} ${get('year')}`.trim() || null;
  } catch { return null; }
}

const _pvSec = (title, ...kids) => el('section', { className: 'pv-sec' }, el('h4', { className: 'pv-sec-title', textContent: title }), ...kids);
const _pvEmpty = (text) => el('p', { className: 'pv-empty', textContent: text });
const _pvStat = (value, label, tone = '') => el('div', { className: 'pv-stat' + (tone ? ` ${tone}` : '') },
  el('b', { textContent: value }), el('span', { textContent: label }));

function _pvBadges(stats, self) {
  const box = el('div', { className: 'pv-badges' });
  for (const b of stats.badges || []) {
    box.append(el('span', { className: 'pv-badge', title: b.label }, el('i', { textContent: b.icon }), el('span', { textContent: b.label })));
  }
  const f = stats.founder;
  if (self && f?.open && !f.earned) {
    const pct = Math.min(100, Math.round((f.count / f.need) * 100));
    box.append(el('div', { className: 'pv-progress' },
      el('div', { className: 'pv-progress-head' },
        el('span', { textContent: t('profile_modal.founder_badge', null, '🏛 نشان بنیان‌گذار') }),
        el('b', { textContent: `${faNum(f.count)} / ${faNum(f.need)}` }),
      ),
      el('div', { className: 'pv-bar' }, el('i', { style: `width:${pct}%` })),
      el('small', { textContent: t('profile_modal.founder_hint', null, 'تا پایان ۳۰ آبان ۱۴۰۵ · بازی آماتور با ربات حساب نمی‌شود') }),
    ));
  }
  if (!box.children.length) box.append(_pvEmpty(t('profile_modal.no_badges', null, 'هنوز نشانی کسب نشده')));
  return box;
}

function _pvAchievements(list) {
  if (!list.length) return _pvEmpty(t('profile_modal.no_achievements', null, 'هنوز افتخاری ثبت نشده — رتبه‌های برتر پایان هر ماه و فصل اینجا ثبت می‌شوند'));
  const box = el('div', { className: 'pv-ach' });
  for (const a of list.slice(0, 10)) {
    box.append(el('div', { className: 'pv-ach-row' + (a.rank <= 3 ? ' top' : '') },
      el('span', { className: 'pv-ach-medal', textContent: PV_MEDAL[a.rank] || `#${faNum(a.rank)}` }),
      el('span', { className: 'pv-ach-text', textContent: `${t('profile_modal.stat_rank_val', { rank: faNum(a.rank) })} ${a.gameLabel}` }),
      el('span', { className: 'pv-ach-period', textContent: `${a.kind === 'seasonal_rank' ? t('leaderboard.seasonal') : t('leaderboard.monthly')} ${a.periodLabel}` }),
    ));
  }
  return box;
}

function _pvGeneral(data, stats, self, openGame) {
  const games = stats.games || {};
  const total = PV_GAMES.reduce((n, g) => n + (games[g]?.games || 0), 0);
  const wins = PV_GAMES.reduce((n, g) => n + (games[g]?.wins || 0), 0);
  const best = PV_GAMES.map((g) => ({ g, elo: games[g]?.elo ?? 1200 })).sort((a, b) => b.elo - a.elo)[0];
  const body = el('div', { className: 'pv-pane' });

  body.append(el('div', { className: 'pv-stats four' },
    _pvStat(faNum(total), t('profile_modal.stat_total_games', null, 'کل بازی‌ها')),
    _pvStat(faNum(wins), t('profile_modal.stat_wins', null, 'برد'), 'win'),
    _pvStat(`${faNum(total ? Math.round((wins / total) * 100) : 0)}٪`, t('profile_modal.stat_win_rate', null, 'درصد برد'), 'gold'),
    _pvStat(faNum(best.elo), t('profile_modal.stat_best_elo', { game: GAME_FA[best.g] }, `بهترین تراز · ${GAME_FA[best.g]}`), 'gold'),
  ));

  // خلاصهٔ هر بازی — کلیک → تب همان بازی
  const rows = el('div', { className: 'pv-gamerows' });
  for (const g of PV_GAMES) {
    const s = games[g] || {};
    const r = s.ranks || {};
    rows.append(el('button', { type: 'button', className: 'pv-gamerow', onclick: () => openGame(g) },
      el('span', { className: 'pv-gamerow-name', textContent: GAME_FA[g] }),
      el('span', { textContent: t('profile_modal.stat_games_count', { n: faNum(s.games || 0) }, `${faNum(s.games || 0)} بازی`) }),
      el('span', { textContent: t('profile_modal.stat_elo_val', { elo: faNum(s.elo ?? 1200) }, `تراز ${faNum(s.elo ?? 1200)}`) }),
      el('span', { className: 'pv-gamerow-rank' + (r.all?.rank ? '' : ' none'), textContent: r.all?.rank ? t('profile_modal.stat_rank_val', { rank: faNum(r.all.rank) }, `رتبهٔ ${faNum(r.all.rank)}`) : t('profile_modal.stat_no_rank', null, 'بدون رتبه') }),
      el('span', { className: 'pv-gamerow-go', textContent: '‹' }),
    ));
  }
  body.append(_pvSec(t('profile_modal.sec_games', null, 'بازی‌ها'), rows));
  body.append(_pvSec(t('profile_modal.sec_badges', null, 'نشان‌ها'), _pvBadges(stats, self)));
  body.append(_pvSec(t('profile_modal.sec_achievements', null, 'افتخارات'), _pvAchievements(stats.achievements || [])));
  if (data.bio) body.append(_pvSec(t('profile_modal.sec_about', null, 'درباره'), el('p', { className: 'pv-bio', textContent: data.bio })));
  if (stats.legacy) {
    body.append(el('div', { className: 'pv-legacy', textContent: t('profile_modal.legacy_stats', { games: faNum(stats.legacy.games), wins: faNum(stats.legacy.wins) }, `پیش از پاییز ۱۴۰۵: ${faNum(stats.legacy.games)} بازی · ${faNum(stats.legacy.wins)} برد`) }));
  }
  return body;
}

function _pvGame(stats, game) {
  const s = stats.games?.[game] || {};
  const r = s.ranks || {};
  const body = el('div', { className: 'pv-pane' });

  const need = (x) => (x && x.rank == null && x.need > 1 ? t('profile_modal.need_games', { done: faNum(x.games || 0), need: faNum(x.need) }, `${faNum(x.games || 0)} از ${faNum(x.need)} بازی`) : null);
  const tile = (label, x, sub) => el('div', { className: 'pv-rank' + (x?.rank && x.rank <= 3 ? ' top' : '') + (!x?.rank && x?.provisionalRank ? ' prov' : '') },
    el('span', { className: 'pv-rank-label', textContent: label }),
    el('b', { textContent: x?.rank ? (PV_MEDAL[x.rank] || `#${faNum(x.rank)}`) : (x?.provisionalRank ? `~${faNum(x.provisionalRank)}` : '—') }),
    el('small', { textContent: sub || ' ' }),
    !x?.rank && x?.provisionalRank ? el('em', { textContent: t('profile_modal.provisional', null, 'موقت') }) : null,
  );
  const scoreOf = (x) => (x?.value != null ? t('profile_modal.points_val', { n: faNum(x.value) }, `${faNum(x.value)} امتیاز`) : t('profile_modal.points_val', { n: faNum(0) }, '۰ امتیاز'));
  body.append(_pvSec(t('profile_modal.sec_ranks', null, 'رتبه‌ها'), el('div', { className: 'pv-ranks' },
    tile(t('profile_modal.all_time', null, 'همیشگی'), r.all, t('profile_modal.points_val', { n: faNum(s.score || 0) }, `${faNum(s.score || 0)} امتیاز`)),
    tile(t('profile_modal.monthly', null, 'ماهانه'), r.monthly, need(r.monthly) || scoreOf(r.monthly)),
    tile(t('profile_modal.seasonal', null, 'فصلی'), r.seasonal, need(r.seasonal) || scoreOf(r.seasonal)),
    tile(t('profile_modal.rating_label', null, 'تراز'), r.elo, need(r.elo) || `${faNum(s.elo ?? 1200)}`),
  )));

  const gr = eloGrade(s.elo ?? 1200, s.eloGames || 0);
  body.append(_pvSec(t('profile_modal.sec_rating', null, 'تراز'), el('div', { className: 'pv-elo' },
    el('div', { className: 'pv-elo-num' }, el('b', { textContent: faNum(s.elo ?? 1200) }), el('span', { textContent: t('profile_modal.rating_label', null, 'تراز') })),
    el('div', { className: 'pv-elo-meta' },
      el('div', {}, gradeTag(s.elo ?? 1200, s.eloGames || 0), el('span', { className: 'pv-elo-grade', style: `color:${gr.color}`, textContent: gr.label })),
      el('small', { textContent: s.eloProvisional !== false
        ? t('profile_modal.provisional_elo', { n: faNum(s.eloGames || 0) }, `موقت — ${faNum(s.eloGames || 0)} بازی ترازدار (تثبیت پس از ۱۰ بازی)`)
        : t('profile_modal.settled_elo', { n: faNum(s.eloGames || 0) }, `${faNum(s.eloGames || 0)} بازی ترازدار`) }),
    ),
  )));

  const games = s.games || 0;
  body.append(_pvSec(t('profile_modal.sec_stats', null, 'آمار'), el('div', { className: 'pv-stats' },
    _pvStat(faNum(games), t('profile_modal.stat_games', null, 'بازی')),
    _pvStat(faNum(s.wins || 0), t('profile_modal.stat_wins', null, 'برد'), 'win'),
    _pvStat(faNum(s.losses || 0), t('profile_modal.stat_losses', null, 'باخت'), 'loss'),
    _pvStat(`${faNum(s.winRate || 0)}٪`, t('profile_modal.stat_win_rate', null, 'درصد برد'), 'gold'),
    _pvStat(faNum(s.abandoned || 0), t('profile_modal.stat_abandoned', null, 'ترک بازی'), 'warn'),
    _pvStat(faNum(s.score || 0), t('profile_modal.stat_total_score', null, 'امتیاز کل')),
  )));

  const partners = s.partners || [];
  let pBox;
  if (!partners.length) {
    pBox = _pvEmpty(t('profile_modal.no_partners', null, 'یارهایی که حداقل ۳ بازی با هم داشته‌اید اینجا نمایش داده می‌شوند'));
  } else {
    pBox = el('div', { className: 'pv-table' },
      el('div', { className: 'pv-trow head' }, el('span', { textContent: t('profile_modal.th_partner', null, 'یار') }), el('span', { textContent: t('profile_modal.th_games', null, 'بازی') }), el('span', { textContent: t('profile_modal.th_wins', null, 'برد') }), el('span', { textContent: t('profile_modal.th_win_rate', null, 'درصد برد') })),
    );
    for (const p of partners) {
      const tone = p.winRate >= 60 ? 'good' : p.winRate >= 45 ? 'mid' : 'bad';
      const who = el('span', { className: 'pv-who' }, avatarEl(p.username, p.avatar_url, 28), el('span', { textContent: p.username }));
      bindProfileMenu(who, { username: p.username, userId: p.userId, avatarUrl: p.avatar_url });
      pBox.append(el('div', { className: 'pv-trow' },
        who,
        el('span', { textContent: faNum(p.games) }),
        el('span', { textContent: faNum(p.wins) }),
        el('span', { className: 'pv-rate ' + tone },
          el('i', { className: 'pv-bar' }, el('i', { style: `width:${p.winRate}%` })),
          el('b', { textContent: `${faNum(p.winRate)}٪` }),
        ),
      ));
    }
  }
  body.append(_pvSec(t('profile_modal.sec_top_partners', null, 'یارهای اصلی'), pBox));

  const ach = (stats.achievements || []).filter((a) => a.game === game);
  body.append(_pvSec(t('profile_modal.sec_game_achievements', { game: GAME_FA[game] }, `افتخارات ${GAME_FA[game]}`), _pvAchievements(ach)));
  return body;
}

// data = پاسخ /api/profile/* (شامل stats). extras = المان‌هایی زیر هدر (مثلاً سکه و دکمهٔ ویرایش در پروفایل خودم)
function profileView(data, { self = false, extras = [] } = {}) {
  const stats = data.stats || { games: {}, badges: [], achievements: [] };
  const name = data.display_name || data.username || '?';
  const main = _primaryGame(stats);
  const ms = stats.games?.[main] || {};
  const g = eloGrade(ms.elo ?? 1200, ms.eloGames || 0);

  const meta = [];
  if (data.gender === 'male') meta.push(t('profile_modal.mr', null, 'آقا'));
  else if (data.gender === 'female') meta.push(t('profile_modal.ms', null, 'خانم'));
  if (data.age) meta.push(t('profile_modal.years_old', { n: faNum(data.age) }, `${faNum(data.age)} ساله`));
  const joined = _joinedFa(data.created_at);
  if (joined) meta.push(t('profile_modal.member_since', { date: joined }, `عضو از ${joined}`));

  const hero = el('div', { className: 'pv-hero' },
    el('div', { className: 'pv-av' }, avatarEl(name, data.avatar_url, 84, false, 100, false, true, null, false, data.avatar_frame)),
    el('div', { className: 'pv-id' },
      el('div', { className: 'pv-name' },
        el('span', { textContent: name }),
        data.player_title ? el('span', { className: 'pv-title', textContent: data.player_title }) : null,
        (!self && data.id && data.id !== myUserId) ? el('button', {
          type: 'button',
          className: 'pv-report-inline-btn',
          title: t('profile_modal.btn_report_tip', null, 'گزارش تخلف این کاربر به مدیریت'),
          textContent: t('profile_modal.btn_report', null, '🚩 گزارش تخلف'),
          onclick: () => openReportUserModal(data.id, name)
        }) : null,
      ),
      meta.length ? el('div', { className: 'pv-meta', textContent: meta.join(' · ') }) : null,
      el('div', { className: 'pv-headline' },
        gradeTag(ms.elo ?? 1200, ms.eloGames || 0),
        el('span', { style: `color:${g.color}`, textContent: g.label }),
        el('span', { className: 'pv-dot', textContent: '•' }),
        el('span', { textContent: `${GAME_FA[main]} ${faNum(ms.elo ?? 1200)}` }),
      ),
    ),
  );
  const headline = hero.querySelector('.pv-headline');
  for (const b of (stats.badges || []).slice(0, 4)) headline.append(el('span', { className: 'pv-mini-badge', title: b.label, textContent: b.icon }));

  const tabs = el('div', { className: 'pv-tabs', role: 'tablist' });
  const pane = el('div', { className: 'pv-body' });
  const show = (key) => {
    [...tabs.children].forEach((b) => b.classList.toggle('on', b.dataset.k === key));
    pane.replaceChildren(key === 'general' ? _pvGeneral(data, stats, self, show) : _pvGame(stats, key));
  };
  const addTab = (key, label, count) => {
    const b = el('button', { type: 'button', className: 'pv-tab', role: 'tab', onclick: () => show(key) },
      el('span', { textContent: label }),
      count != null ? el('small', { textContent: faNum(count) }) : null,
    );
    b.dataset.k = key;
    tabs.append(b);
  };
  addTab('general', t('profile_modal.tab_general', null, 'عمومی'));
  for (const game of PV_GAMES) addTab(game, GAME_FA[game], stats.games?.[game]?.games || 0);

  const root = el('div', { className: 'pv' }, hero);
  for (const x of extras) if (x) root.append(x);
  root.append(tabs, pane);
  show('general');
  return root;
}

let _frRailCache = { at: 0, friends: null }; // کاهشِ درخواستِ /api/friends هنگام سوییچِ فیلترِ لابی
let _chatsRailCache = { at: 0, threads: null }; // کش SWR جهت نمایش خوش‌بینانه و بدون مکث گفتگوها
let _lobbySocialTab = 'friends'; // 'friends' | 'chats'
let _lobbyActivePeer = null;     // { id, username }
let _lobbySearchOpen = false;
let _lobbySearchQuery = '';
let _refreshLobbySocialRail = null;
let _openLobbyChatInline = null;
let _lobbySocialPanelEl = null;

function openDm(userId, username, avatarUrl) {
  if (friendsPanel?.open) {
    friendsPanel.openChat(userId, username, avatarUrl);
  } else if (typeof _openLobbyChatInline === 'function' && !$('#lobby')?.classList.contains('hidden')) {
    _openLobbyChatInline(userId, username, avatarUrl);
  } else {
    dmPanel.open(userId, username, { avatarUrl });
  }
}

function lobbyFriendsRail() {
  if (_lobbySocialPanelEl) {
    return _lobbySocialPanelEl;
  }
  const panel = el('div', { className: 'lb3-panel lb3-mini lb3-social-panel' });
  _lobbySocialPanelEl = panel;

  const renderWidget = () => {
    // اگر در حال چت درون‌خطی با یک فرد هستیم:
    if (_lobbyActivePeer) {
      panel.classList.add('lb3-in-chat');
      panel.replaceChildren();
      dmPanel.open(_lobbyActivePeer.id, _lobbyActivePeer.username, {
        avatarUrl: _lobbyActivePeer.avatarUrl,
        inlineContainer: panel,
        onBack: () => {
          _lobbyActivePeer = null;
          panel.classList.remove('lb3-in-chat');
          renderWidget();
        },
      });
      return;
    }

    panel.classList.remove('lb3-in-chat');

    // بستن پیام تکی اگر باز مانده باشد
    if (dmPanel.isInline) {
      dmPanel.close();
    }

    panel.replaceChildren();

    // هدر پنل دوستان با دکمه جستجو و افزودن دوست
    const headTitle = el('div', { className: 'lb3-fr-head-title' },
      el('span', {
        className: 'lb3-tab-icon',
        innerHTML: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
      }),
      el('span', { className: 'lb3-fr-title-text', textContent: t('social.friends', null, 'دوستان') }),
    );

    const searchBtn = el('button', {
      type: 'button',
      className: 'lb3-btn sm' + (_lobbySearchOpen ? ' highlight' : ''),
      title: t('common.search', null, 'جستجو'),
      innerHTML: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
      onclick: () => {
        _lobbySearchOpen = !_lobbySearchOpen;
        if (!_lobbySearchOpen) _lobbySearchQuery = '';
        renderWidget();
      },
    });

    const addFriendBtn = el('button', {
      type: 'button',
      className: 'lb3-btn sm',
      title: t('friends.add_friend', null, 'افزودن دوست جدید'),
      innerHTML: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
      onclick: () => {
        friendsPanel.activeTab = 'friends';
        if (!friendsPanel.open) friendsPanel.toggle();
        else friendsPanel.render();
      },
    });

    const head = el('div', { className: 'lb3-mini-head lb3-fr-unified-head' },
      headTitle,
      el('div', { style: 'display:flex;gap:4px;' }, searchBtn, addFriendBtn),
    );
    panel.append(head);

    // بخش جستجوی درون‌خطی
    if (_lobbySearchOpen) {
      const searchInput = el('input', {
        className: 'lb3-rail-search-input',
        placeholder: t('friends.search_friends', null, 'جستجوی دوستان…'),
        value: _lobbySearchQuery,
      });
      searchInput.oninput = (e) => {
        _lobbySearchQuery = e.target.value.trim().toLowerCase();
        filterAndPaint();
      };
      const clearBtn = el('button', {
        className: 'lb3-rail-search-clear',
        innerHTML: '✕',
        title: t('common.close_search', null, 'بستن جستجو'),
        onclick: () => {
          _lobbySearchOpen = false;
          _lobbySearchQuery = '';
          renderWidget();
        },
      });
      panel.append(el('div', { className: 'lb3-rail-search-wrap' }, searchInput, clearBtn));
      setTimeout(() => searchInput.focus(), 30);
    }

    let _lastData = _frRailCache.friends || [];

    const listEl = el('div', { className: 'lb3-frlist' });
    panel.append(listEl);

    const filterAndPaint = () => {
      let friends = _lastData || [];
      if (_lobbySearchQuery) {
        friends = friends.filter((f) => (f.username || '').toLowerCase().includes(_lobbySearchQuery));
      }
      paintFriends(friends);
    };

    const paintFriends = (friends) => {
      if (!friends.length) {
        listEl.replaceChildren(el('p', {
          className: 'muted small lb3-mini-msg',
          textContent: _lobbySearchQuery ? t('common.not_found', null, 'موردی یافت نشد') : t('friends.no_friends', null, 'هنوز دوستی ندارید'),
        }));
        return;
      }
      const onlineList = friends.filter((f) => f.online);
      const offlineList = friends.filter((f) => !f.online);

      // اولویت با پیام‌های خوانده‌نشده در هر بخش، سپس الفبا
      const sortListWithUnreadFirst = (arr) => [...arr].sort((a, b) => {
        const uA = (a.unread_dms != null ? a.unread_dms : dmUnread.getForUser(a.id)) || 0;
        const uB = (b.unread_dms != null ? b.unread_dms : dmUnread.getForUser(b.id)) || 0;
        if (uA !== uB) return uB - uA;
        return String(a.username).localeCompare(String(b.username), 'fa');
      });

      const sortedOnline = sortListWithUnreadFirst(onlineList);
      const sortedOffline = sortListWithUnreadFirst(offlineList);

      const renderFriendRow = (f) => {
        const nm = el('span', { className: 'lb3-frname', textContent: f.username });
        const menuOpts = { username: f.username, userId: f.id, avatarUrl: f.avatar_url };
        const unreadCount = (f.unread_dms != null ? f.unread_dms : dmUnread.getForUser(f.id)) || 0;
        if (f.unread_dms != null) {
          if (f.unread_dms > 0) dmUnread.bySender[f.id] = f.unread_dms;
          else delete dmUnread.bySender[f.id];
        }
        const hasUnread = unreadCount > 0;
        const badgeEl = el('i', {
          className: 'fr-av-badge sm' + (!hasUnread ? ' hidden' : ''),
          textContent: hasUnread ? fmtNum(unreadCount > 99 ? '99+' : unreadCount) : '',
          style: !hasUnread ? 'display:none;' : '',
        });
        badgeEl.hidden = !hasUnread;
        badgeEl.setAttribute('data-dm-user-badge', String(f.id));

        const avEl = avatarEl(f.username, f.avatar_url, 36);
        const avBox = el('div', { className: 'fr-av-box' }, avEl, badgeEl);

        const chatBtn = el('button', {
          type: 'button',
          className: 'lb3-btn sm lb3-chat-quick-btn' + (hasUnread ? ' unread-btn' : ''),
          title: hasUnread ? t('friends.unread_dms_title', { n: fmtNum(unreadCount) }, `${fmtNum(unreadCount)} پیام خوانده‌نشده`) : t('friends.send_dm', null, 'ارسال پیام خصوصی'),
          innerHTML: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
          onclick: (e) => {
            e.stopPropagation();
            _openLobbyChatInline(f.id, f.username, f.avatar_url);
          },
        });

        const row = el('div', {
          className: 'lb3-frrow' + (f.online === false ? ' off' : '') + (hasUnread ? ' has-unread' : ''),
          title: f.username,
          onclick: () => profileCardUI.showById(menuOpts),
        }, avBox, nm);

        if (f.online != null) {
          row.append(el('span', { className: 'lb3-frseen' + (f.online ? ' on' : ''), textContent: f.online ? t('friends.online', null, 'آنلاین') : t('friends.offline', null, 'آفلاین') }));
        }
        row.append(chatBtn);
        return row;
      };

      const items = [];
      if (sortedOnline.length) {
        items.push(el('div', { className: 'lb3-fr-sec-title on', textContent: `${t('friends.online', null, 'آنلاین')} — ${fmtNum(sortedOnline.length)}` }));
        items.push(...sortedOnline.map(renderFriendRow));
      }
      if (sortedOffline.length) {
        items.push(el('div', { className: 'lb3-fr-sec-title off', textContent: `${t('friends.offline', null, 'آفلاین')} — ${fmtNum(sortedOffline.length)}` }));
        items.push(...sortedOffline.map(renderFriendRow));
      }
      listEl.replaceChildren(...items);
    };

    const loadData = async () => {
      if (!_frRailCache.friends) {
        listEl.replaceChildren(el('p', { className: 'muted small lb3-mini-msg', textContent: t('social.loading_friends', null, 'در حال بارگذاری دوستان…') }));
      }
      try {
        const res = await apiFetch('GET', '/api/friends');
        const friends = res?.friends || [];
        _frRailCache = { at: Date.now(), friends };
        _lastData = friends;
        filterAndPaint();
      } catch (err) {
        console.error('[lobbySocialRail] load friends error:', err);
        if (!_lastData || !_lastData.length) {
          listEl.replaceChildren(el('p', { className: 'muted small lb3-mini-msg', style: 'color:#ff8a8a', textContent: t('social.error_friends', null, 'خطا در بارگذاری دوستان') }));
        }
      }
    };

    if (_frRailCache.friends) {
      filterAndPaint();
    }
    loadData();
  };

  _openLobbyChatInline = (peerId, username, avatarUrl) => {
    const numId = Number(peerId);
    _lobbyActivePeer = { id: numId, username, avatarUrl };
    if (_frRailCache.friends) {
      const f = _frRailCache.friends.find((item) => Number(item.id) === numId);
      if (f) f.unread_dms = 0;
    }
    renderWidget();
  };

  _refreshLobbySocialRail = () => {
    if (!_lobbyActivePeer) {
      renderWidget();
    }
  };

  if (dmUnread.n > 0) {
    _lobbySocialTab = 'chats';
  }

  renderWidget();
  return panel;
}

// جعبهٔ درخواست‌های دوستی در ریلِ لابی — فقط وقتی حداقل یک درخواست باشد نمایش داده می‌شود
function lobbyFriendReqBox() {
  const panel = el('div', { className: 'lb3-panel lb3-friendreq', hidden: true });
  panel.append(el('div', { className: 'lb3-mini-head' }, el('h5', { className: 'lb3-fr-title', textContent: t('social.friend_requests', null, 'درخواست‌های دوستی') })));
  const listEl = el('div', { className: 'lb3-frreq-list' });
  panel.append(listEl);

  const paint = (reqs) => {
    if (!reqs.length) { panel.hidden = true; return; }
    panel.hidden = false;
    panel.querySelector('.lb3-fr-title').textContent = t('social.friend_requests_count', { n: faNum(reqs.length) }, `درخواست‌های دوستی — ${faNum(reqs.length)}`);
    listEl.replaceChildren(...reqs.map((r) => {
      const row = el('div', { className: 'lb3-frreq-row' }, avatarEl(r.username, r.avatar_url, 39),
        el('span', { className: 'lb3-frreq-name', textContent: r.username }));
      const act = el('div', { className: 'lb3-frreq-act' },
        el('button', { className: 'lb3-btn sm gold', textContent: t('social.accept', null, 'قبول'), onclick: async () => {
          try {
            await apiFetch('POST', `/api/friends/accept/${r.sender_id}`);
            networkTable?.acceptFriendRequest?.(r.sender_id);
            friendsSet.add(r.sender_id);
            toast(t('social.friend_accepted_toast', { username: r.username }, `شما و ${r.username} اکنون دوست هستید! 🎉`));
          } catch { toast(t('social.friend_accept_err', null, 'خطا در پذیرش درخواست')); }
          row.remove();
          if (!listEl.children.length) panel.hidden = true;
        } }),
        el('button', { className: 'lb3-btn sm', textContent: t('social.reject', null, 'رد'), onclick: async () => {
          try { await apiFetch('POST', `/api/friends/reject/${r.sender_id}`); } catch {}
          row.remove();
          if (!listEl.children.length) panel.hidden = true;
        } }),
      );
      row.append(act);
      return row;
    }));
  };

  (async () => {
    try { paint((await apiFetch('GET', '/api/friends/requests'))?.requests || []); } catch { panel.hidden = true; }
  })();
  return panel;
}

// ─── نشانگرِ کیفیتِ اتصال ───────────────────────────────────────────────────────
// درجه از **سرور** می‌آید: سرور فاصلهٔ رسیدنِ همان PINGهایی را که کلاینت از قبل هر
// ۵ ثانیه می‌فرستد اندازه می‌گیرد. پس معیار «وقفه» است نه پینگ — اتصالِ کُندِ منظم
// (که در ایران عادی است) سالم شمرده می‌شود و فقط قطعی‌های واقعی دیده می‌شوند.
const getNetGrade = (grade) => {
  const map = {
    measuring: { bars: 1, cls: 'measuring', label: t('net.measuring', null, 'در حال سنجش اتصال…'), tip: t('net.measuring_tip', null, 'چند ثانیه طول می‌کشد تا کیفیت اتصال مشخص شود.') },
    good:      { bars: 3, cls: 'good',      label: t('net.good', null, 'اتصال پایدار'),       tip: t('net.good_tip', null, 'اتصال شما بدون وقفه است.') },
    fair:      { bars: 2, cls: 'fair',      label: t('net.fair', null, 'اتصال متوسط'),        tip: t('net.fair_tip', null, 'یک وقفهٔ کوتاه در اتصال شما دیده شد.') },
    poor:      { bars: 1, cls: 'poor',      label: t('net.poor', null, 'اتصال ناپایدار'),     tip: t('net.poor_tip', null, 'اتصال شما مکرراً قطع می‌شود — بازی ممکن است متوقف شود.') },
  };
  return map[grade] || map.measuring;
};

const NET_GRADE = new Proxy({}, {
  get: (_, prop) => getNetGrade(prop)
});

function netChip(grade) {
  const g = getNetGrade(grade);
  const chip = el('span', { className: `net-chip ${g.cls}`, title: g.tip + ' ' + t('net.reconnect_tip', null, '(کلیک برای اتصال مجدد)') });
  const sig = el('span', { className: 'tb-sig' });
  for (let i = 1; i <= 3; i++) sig.append(el('i', { className: i <= g.bars ? 'on' : '' }));
  chip.append(sig, el('span', { className: 'net-chip-l', textContent: g.label }));
  chip.onclick = (e) => {
    e.stopPropagation();
    networkTable?.ensureConnected(true);
    networkTable?.listRooms();
    toast(t('net.reconnecting', null, 'در حال بررسی و اتصال مجدد به سرور…'));
  };
  return chip;
}

function updateNetChip(chip, grade) {
  if (!chip) return;
  const g = getNetGrade(grade);
  chip.className = `net-chip ${g.cls}`;
  chip.title = g.tip + ' ' + t('net.reconnect_tip', null, '(کلیک برای اتصال مجدد)');
  const sig = chip.querySelector('.tb-sig');
  if (sig) {
    const bars = sig.querySelectorAll('i');
    bars.forEach((bar, i) => {
      bar.className = (i + 1) <= g.bars ? 'on' : '';
    });
  }
  const label = chip.querySelector('.net-chip-l');
  if (label) {
    label.textContent = g.label;
  }
}

// نشانگرِ لابی هر ۵ ثانیه (با هر PONG) درجا به‌روز می‌شود — بدونِ رندرِ دوبارهٔ لابی.
const netQualityUI = {
  nodes: new Set(),
  mount() {
    const node = netChip(networkTable?.net?.grade || 'measuring');
    this.nodes.add(node);
    return node;
  },
  apply(n) {
    const grade = n?.grade || 'measuring';
    for (const node of Array.from(this.nodes)) {
      if (node && node.isConnected) {
        updateNetChip(node, grade);
      } else {
        this.nodes.delete(node);
      }
    }
  },
};

let _profFreshAt = 0;
let _mobileLobbyTab = 'rooms'; // 'rooms' | 'leaderboard' | 'friends' | 'profile'
let _lastLobbyRooms = null;

if (typeof window !== 'undefined' && !window.__lobbyResizeBound) {
  window.__lobbyResizeBound = true;
  let _lastW = window.innerWidth;
  window.addEventListener('resize', () => {
    const w = window.innerWidth;
    if ((_lastW <= 900 && w > 900) || (_lastW > 900 && w <= 900)) {
      _lastW = w;
      if ($('#lobby') && !$('#lobby').classList.contains('hidden') && _lastLobbyRooms) {
        renderLobby(_lastLobbyRooms);
      }
    }
  }, { passive: true });
}

let _desktopUpdateInfo = null;
let _desktopUpdateChecked = false;
let _desktopUpdateModalShown = false;

function showDesktopUpdateModal(info, currentVer) {
  if (_desktopUpdateModalShown || $('#desktop-update-overlay')) return;
  _desktopUpdateModalShown = true;

  const cur = currentVer || window.__DESKTOP_VERSION__ || '0.1.0';
  const newVer = String(info.version || '');
  const dlUrl = info.url || 'https://4barg.matrixdev.ir/downloads/4Barg-Setup-x64.exe';
  const notes = info.notes || t('update_modal.default_notes', null, 'آخرین بهبودها و امکانات جدید بازی آماده دریافت است.');

  const overlay = el('div', { id: 'desktop-update-overlay', className: 'desktop-update-overlay' });
  const card = el('div', { className: 'desktop-update-card' },
    el('button', {
      type: 'button',
      className: 'duc-close',
      innerHTML: '&times;',
      title: t('common.close', null, 'بستن'),
      onclick: close,
    }),
    el('div', { className: 'duc-badge' },
      el('span', { className: 'duc-badge-dot' }),
      el('span', { textContent: t('update_modal.badge', null, 'نسخهٔ جدید در دسترس است') })
    ),
    el('h3', { className: 'duc-title', textContent: t('update_modal.title', null, 'بروزرسانی بازی چهاربرگ') }),
    el('div', { className: 'duc-versions' },
      el('div', { className: 'duc-ver-chip current' },
        el('span', { className: 'duc-ver-lbl', textContent: t('update_modal.your_version', null, 'نسخه شما:') }),
        el('span', { className: 'duc-ver-val', textContent: faNum(cur) })
      ),
      el('div', { className: 'duc-arrow', innerHTML: '&#8592;' }),
      el('div', { className: 'duc-ver-chip new' },
        el('span', { className: 'duc-ver-lbl', textContent: t('update_modal.new_version', null, 'نسخه جدید:') }),
        el('span', { className: 'duc-ver-val', textContent: faNum(newVer) })
      )
    ),
    el('div', { className: 'duc-notes' },
      el('div', { className: 'duc-notes-title', textContent: t('update_modal.whats_new', null, 'تغییرات و امکانات جدید:') }),
      el('div', { className: 'duc-notes-body', textContent: notes })
    ),
    el('div', { className: 'duc-actions' },
      el('button', {
        type: 'button',
        className: 'duc-btn-primary',
        onclick: () => {
          window.open(dlUrl, '_blank');
          close();
        }
      },
        el('span', { className: 'duc-btn-icon', textContent: '📥' }),
        el('span', { textContent: t('update_modal.download_install', null, 'دانلود و نصب نسخه جدید') })
      ),
      el('button', {
        type: 'button',
        className: 'duc-btn-secondary',
        textContent: t('update_modal.remind_later', null, 'بعداً یادآوری کن'),
        onclick: close
      })
    )
  );

  overlay.append(card);
  document.body.append(overlay);

  function close() {
    overlay.classList.add('closing');
    setTimeout(() => overlay.remove(), 250);
  }

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) close();
  });
}
window.__showDesktopUpdateModal = showDesktopUpdateModal;

function checkDesktopWebUpdate() {
  const isElectron = /electron/i.test(navigator.userAgent) || typeof window.__DESKTOP_VERSION__ !== 'undefined';
  if (!isElectron || _desktopUpdateChecked) return;
  _desktopUpdateChecked = true;
  const updateUrl = (window.location.origin.includes('localhost') || window.location.origin.includes('127.0.0.1'))
    ? 'https://4barg.matrixdev.ir/downloads/version.json?t=' + Date.now()
    : '/downloads/version.json?t=' + Date.now();
  fetch(updateUrl)
    .then((r) => r.ok ? r.json() : null)
    .then((info) => {
      if (!info || !info.version) return;
      const cur = window.__DESKTOP_VERSION__ || '0.1.0';
      const rVer = String(info.version).trim().split('.').map((x) => parseInt(x, 10) || 0);
      const cVer = String(cur).trim().split('.').map((x) => parseInt(x, 10) || 0);
      let newer = false;
      for (let i = 0; i < Math.max(rVer.length, cVer.length); i++) {
        if ((rVer[i] || 0) > (cVer[i] || 0)) { newer = true; break; }
        if ((rVer[i] || 0) < (cVer[i] || 0)) break;
      }
      if (newer) {
        _desktopUpdateInfo = info;
        showDesktopUpdateModal(info, cur);
        if ($('#lobby')?.classList.contains('lb3-mode')) {
          renderLobby(_lastLobbyRooms);
        }
      }
    })
    .catch(() => {});
}

// تراز من در لابی: تراز بازیِ اصلی (بازی‌ای که بیشتر بازی کرده) + تراز بازی دیگر؛ بدون stats همان عدد قدیمی
function _myEloLine(p, compact = false) {
  const st = p.stats?.games;
  if (!st) {
    return [gradeTag(p.elo_rating, p.games_played),
      el('span', { className: compact ? 'lb3-mh-stat-val' : '', textContent: compact ? `${faNum(Math.round(p.elo_rating ?? 1200))} تراز` : `${faNum(Math.round(p.elo_rating ?? 1200))} تراز · ${faNum(p.games_played ?? 0)} بازی` })];
  }
  const main = _primaryGame(p.stats);
  const other = main === 'shelem' ? 'hokm' : 'shelem';
  const m = st[main] || { elo: 1200, eloGames: 0 };
  const o = st[other] || { elo: 1200, eloGames: 0 };
  return [gradeTag(m.elo, m.eloGames),
    el('span', { className: compact ? 'lb3-mh-stat-val' : '', textContent: compact
      ? `${GAME_FA[main] || main} ${faNum(m.elo ?? 1200)}`
      : `${GAME_FA[main] || main} ${faNum(m.elo ?? 1200)} · ${GAME_FA[other] || other} ${faNum(o.elo ?? 1200)}` })];
}

// بنر لابی — فضای ثابت بالای فهرست اتاق‌ها؛ محتوا (تصویر یا HTML) از پنل ادمین می‌آید.
function lobbyBannerEl() {
  const b = lobbyBanner;
  if (!b?.enabled) return null;
  const endsMs = b.ends_at ? Date.parse(b.ends_at) : 0;
  if (endsMs && endsMs <= Date.now()) return null;
  let inner = null;
  if (b.mode === 'html' && b.html) {
    let content = b.html;
    if (getLang() === 'en' && content.includes('فصل بنیان‌گذاران')) {
      content = `<div style="padding:16px 14px;text-align:center;background:linear-gradient(100deg,#3b2a6b,#7a2d5a);color:#fff"><div style="font-weight:800;font-size:17px">${t('banner.founders_title')}</div><div style="font-size:13px;opacity:.9;margin-top:6px">${t('banner.founders_desc')}</div></div>`;
    }
    inner = el('div', { className: 'lb3-banner-html', dir: 'auto', innerHTML: content });
  } else if (b.image_url) {
    const src = b.image_url.startsWith('/') ? `${API}${b.image_url}` : b.image_url;
    inner = el('img', { className: 'lb3-banner-img', src, alt: '', loading: 'lazy' });
  }
  if (!inner) return null;
  const box = b.link_url
    ? el('a', { className: 'lb3-banner', href: b.link_url, target: b.link_url.startsWith('/') ? '_self' : '_blank', rel: 'noopener' }, inner)
    : el('div', { className: 'lb3-banner' }, inner);
  const daysLeft = endsMs ? Math.ceil((endsMs - Date.now()) / 86400000) : Infinity;
  if (daysLeft <= 7) {
    box.append(el('span', { className: 'lb3-banner-count', textContent: daysLeft <= 1 ? t('banner.last_day', null, 'آخرین روز!') : t('banner.days_left', { days: fmtNum(daysLeft) }, `${faNum(daysLeft)} روز مانده`) }));
  }
  return box;
}

function renderLobby(rooms) {
  _lastLobbyRooms = rooms;
  checkDesktopWebUpdate();
  try { chatRailUI?.hide(); } catch { /* noop */ }
  try { composerUI?.root?.classList.add('hidden'); } catch { /* noop */ }
  const tableEl = $('#table');
  if (tableEl && !tableEl.classList.contains('hidden')) {
    tableEl.classList.add('hidden');
  }
  const root = $('#lobby');
  if (root && root.classList.contains('hidden')) {
    root.classList.remove('hidden');
  }
  // حذف اسپینر اولیه (قبل از لود JS نشان داده می‌شد) و بستن نرم اسپلش
  const spinner = root ? root.querySelector('#init-spinner') : null;
  if (spinner) spinner.remove();
  window.dismissSplash?.();
  if (root) root.className = 'lobby lb3-mode';
  const p = myProfile || {};

  const buildIdCard = () => {
    const nameStr = p.display_name || p.username || t('common.guest', null, 'مهمان');
    return el('div', { className: 'lb3-panel lb3-id' },
      avatarEl(p.display_name || p.username || '?', p.avatar_url, 63, false, 100, false, true, null, false, p.avatar_frame),
      el('div', { className: 'lb3-id-txt' },
        el('div', { className: 'lb3-id-name', style: 'display:flex;align-items:center;gap:6px;flex-wrap:wrap;' },
          p.has_booster ? el('span', { className: 'seat-booster-badge', title: t('lobby.booster_active_x', { x: fmtNum(p.booster_multiplier || 1.5) }, `بوستر ${faNum(p.booster_multiplier || 1.5)}x فعال`), textContent: '⚡' }) : null,
          el('span', { textContent: nameStr }),
          p.player_title ? el('span', { className: 'seat-player-title', textContent: p.player_title }) : null,
          p.is_guest ? el('button', {
            type: 'button',
            className: 'lb3-guest-pill',
            title: t('auth.guest_pill_tooltip', null, 'حالت مهمان — برای ثبت حساب و دریافت ۵۰۰ سکه کلیک کنید'),
            textContent: '🎮 مهمان (ارتقا ✨)',
            onclick: () => showUpgradeGuestModal('profile'),
          }) : null,
        ),
        el('div', { className: 'lb3-id-sub', style: 'cursor:pointer', title: t('lobby.view_my_profile', null, 'مشاهده پروفایل عمومی من'), onclick: () => myUserId && profileCardUI.showById({ userId: myUserId, username: nameStr, avatarUrl: p.avatar_url }) },
          ..._myEloLine(p),
        ),
        netQualityUI.mount(),
      ),
    );
  };

  const buildBadgesCard = () => {
    const row = el('div', { className: 'lb3-badges-row' });
    if (p.is_guest) {
      const upgradeBtn = el('button', {
        type: 'button',
        className: 'lb3-guest-upgrade-badge',
        title: t('auth.guest_upgrade_tooltip', null, 'ثبت شماره، ذخیره دائمی حساب و دریافت ۵۰۰ سکه هدیه'),
        onclick: () => showUpgradeGuestModal('lobby_badge'),
      },
        el('div', { className: 'lb3-badge-icon', textContent: '✨' }),
        el('span', { className: 'lb3-badge-val', textContent: t('auth.guest_upgrade_badge', null, 'ثبت شماره + ۵۰۰ سکه') }),
      );
      row.append(upgradeBtn);
    }
    const coinBtn = el('button', {
      type: 'button',
      className: 'lb3-coin-badge',
      title: t('lobby.view_shop_coins', null, 'مشاهده فروشگاه و مدیریت سکه‌ها'),
      onclick: () => shopModal.show(),
    },
      el('div', { className: 'lb3-badge-icon' }, '🪙'),
      el('span', { className: 'lb3-badge-val', textContent: `${fmtNum(p.coins || 0)} ${t('lobby.coins', null, 'سکه')}` }),
    );
    row.append(coinBtn);
    const boosterBtn = el('button', {
      type: 'button',
      className: 'lb3-booster-badge',
      title: p.has_booster ? t('lobby.booster_active', null, 'بوستر امتیاز فعال است') : t('lobby.buy_booster', null, 'خرید بوستر امتیاز'),
      onclick: () => shopModal.show('booster'),
    },
      el('div', { className: 'lb3-badge-icon' }, '⚡'),
      el('span', { className: 'lb3-badge-val', textContent: p.has_booster ? `${fmtNum(p.booster_multiplier || 1.5)}x` : t('lobby.booster', null, 'بوستر') }),
    );
    row.append(boosterBtn);

    const curLang = getLang();
    const otherLang = curLang === 'fa' ? 'en' : 'fa';
    const otherMeta = LANGUAGES[otherLang];
    const langBtn = el('button', {
      type: 'button',
      className: 'lb3-booster-badge',
      style: 'background: rgba(255, 255, 255, 0.05); border-color: rgba(255, 255, 255, 0.12); cursor: pointer; min-width: 60px;',
      title: curLang === 'fa' ? 'تغییر زبان به انگلیسی (English)' : 'تغییر زبان به فارسی',
      onclick: () => setLang(otherLang),
    },
      el('div', { className: 'lb3-badge-icon' }, '🌐'),
      el('span', { className: 'lb3-badge-val', textContent: otherMeta.code.toUpperCase() }),
    );
    row.append(langBtn);
    return row;
  };

  const buildActions = () => {
    const quickWrap = el('div', { className: 'lb3-quick-wrap' });

    let _onOutsideClick = null;

    const renderQuickCta = () => {
      if (_onOutsideClick) {
        document.removeEventListener('click', _onOutsideClick);
        _onOutsideClick = null;
      }
      quickWrap.innerHTML = '';
      const quick = el('button', {
        type: 'button',
        className: 'lb3-quick',
        onclick: (e) => {
          e.stopPropagation();
          renderQuickModeSelect();
        }
      });
      quick.innerHTML = `<span class="lb3-quick-title">${t('lobby.quick_game', null, 'بازی سریع')}</span>`;
      quickWrap.append(quick);
    };

    const renderQuickModeSelect = () => {
      quickWrap.innerHTML = '';
      const selector = el('div', { className: 'lb3-quick-selector' });
      for (const g of ['chahar_barg', 'hokm', 'shelem', 'bidel', 'bluff']) {
        const btn = el('button', {
          type: 'button',
          className: 'lb3-quick-opt' + (selectedGame === g ? ' on' : ''),
          textContent: GAME_FA[g],
          onclick: (e) => {
            e.stopPropagation();
            selectedGame = g;
            localStorage.setItem('cb_game', g);
            renderQuickCta();
            showBotDiffModal((diff, speed) => startGame({ gameType: g, noBot: false, botDifficulty: diff, speedMode: speed }));
          }
        });
        selector.append(btn);
      }
      const closeBtn = el('button', {
        type: 'button',
        className: 'lb3-quick-opt-back',
        title: t('common.cancel', null, 'انصراف'),
        onclick: (e) => {
          e.stopPropagation();
          renderQuickCta();
        }
      });
      closeBtn.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>`;
      selector.append(closeBtn);
      quickWrap.append(selector);

      setTimeout(() => {
        _onOutsideClick = (e) => {
          if (!quickWrap.contains(e.target)) {
            renderQuickCta();
          }
        };
        document.addEventListener('click', _onOutsideClick, { once: true });
      }, 50);
    };

    renderQuickCta();

    const actRow = el('div', { className: 'lb3-actrow' });
    const joinCodeBtn = el('button', {
      type: 'button',
      className: 'lb3-act-btn',
      onclick: () => showJoinCodeModal()
    });
    joinCodeBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="8" cy="15" r="3.2"></circle><path d="M10.3 12.7L18 5"></path><path d="M15.5 7.5l2 2"></path><path d="M18.2 4.8l2 2"></path></svg><span>${t('lobby.join', null, 'ورود با کد')}</span>`;

    const createRoomBtn = el('button', {
      type: 'button',
      className: 'lb3-act-btn',
      textContent: t('lobby.create_room', null, 'ساخت اتاق'),
      onclick: () => showCreateRoomModal()
    });

    const helpBtn = el('button', {
      type: 'button',
      className: 'lb3-act-btn',
      onclick: () => showHelpModal(selectedGame)
    });
    helpBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg><span>${t('nav.help', null, 'راهنما')}</span>`;

    actRow.append(joinCodeBtn, createRoomBtn, helpBtn);

    return el('div', { className: 'lb3-actions' }, quickWrap, actRow);
  };

  const buildNav = () => {
    const nav = el('div', { className: 'lb3-panel lb3-nav' });
    const navLink = (icon, label, onclick, danger, badgeId) => {
      const a = el('a', {
        href: '#',
        className: 'lb3-navlink' + (danger ? ' danger' : ''),
        onclick: (e) => { e.preventDefault(); onclick(); },
      });
      const iconWrap = el('span', { className: 'lb3-navlink-icon', innerHTML: icon });
      const textWrap = el('span', { className: 'lb3-navlink-text', textContent: label });
      a.append(iconWrap, textWrap);
      if (badgeId) {
        const b = el('span', {
          id: badgeId,
          className: 'lb3-navbadge' + (supportUnreadCount > 0 ? '' : ' hidden'),
          textContent: supportUnreadCount > 0 ? faNum(supportUnreadCount) : '',
        });
        a.append(b);
      }
      return a;
    };
    nav.append(navLink(LB_ICON.profile, t('nav.profile', null, 'ویرایش پروفایل'), () => myProfilePanel.toggle()));
    nav.append(navLink(LB_ICON.shop, t('nav.shop', null, 'فروشگاه'), () => shopModal.show()));
    nav.append(navLink(LB_ICON.settings, t('nav.settings', null, 'تنظیمات'), () => showSettingsSheet()));
    nav.append(navLink(LB_ICON.help, t('nav.help', null, 'راهنمای بازی‌ها'), () => showHelpModal(selectedGame)));
    if (plansEnabled) nav.append(navLink(LB_ICON.vip, 'VIP', () => shopModal.show('vip')));
    if (myProfile?.role === 'admin') {
      const a = el('a', { href: '/admin/', target: '_blank', className: 'lb3-navlink' });
      a.innerHTML = `<span class="lb3-navlink-icon">${LB_ICON.admin}</span><span class="lb3-navlink-text">${t('nav.admin', null, 'مدیریت')}</span>`;
      nav.append(a);
    }
    nav.append(navLink(LB_ICON.support, t('nav.support', null, 'پشتیبانی'), () => showSupportModal(), false, 'lb-support-badge'));
    checkSupportUnread();
    nav.append(navLink(LB_ICON.report, t('nav.report', null, 'گزارش تخلف'), () => openReportUserModal()));
    nav.append(navLink(LB_ICON.logout, t('nav.logout', null, 'خروج'), () => _lobbyLogout(), true));
    return nav;
  };

  // ═══ ستونِ مرکز: فهرستِ اتاق‌ها ═══
  const center = el('div', { className: 'lb3-center' });
  if (_desktopUpdateInfo) {
    center.append(el('div', { className: 'desktop-update-banner' },
      el('span', { className: 'dub-icon', textContent: '🚀' }),
      el('span', { className: 'dub-text', innerHTML: `<b>${t('update_modal.desktop_banner', { ver: faNum(_desktopUpdateInfo.version) }, `نسخهٔ جدید دسکتاپ (${faNum(_desktopUpdateInfo.version)}) موجود است!`)}</b> ${_desktopUpdateInfo.notes || ''}` }),
      el('a', {
        className: 'dub-btn',
        href: _desktopUpdateInfo.url || '/downloads/4Barg-Setup-x64.exe',
        target: '_blank',
        textContent: t('update_modal.desktop_banner_btn', null, 'دانلود و نصب'),
      }),
    ));
  }
  const banner = lobbyBannerEl();
  if (banner) center.append(banner);
  center.append(el('div', { className: 'lb3-rooms-head' },
    el('h3', { textContent: t('lobby.open_rooms', null, 'اتاق‌های باز') }),
    el('button', { className: 'lb3-btn sm', textContent: t('lobby.refresh', null, 'بروزرسانی'), onclick: () => networkTable?.listRooms() }),
  ));

  const filters = el('div', { className: 'lb3-filters' });
  for (const [id, label] of [['all', t('lobby.all', null, 'همه')], ['chahar_barg', GAME_FA.chahar_barg], ['shelem', GAME_FA.shelem], ['hokm', GAME_FA.hokm], ['bidel', GAME_FA.bidel], ['bluff', GAME_FA.bluff], ['friends', t('lobby.friends', null, 'دوستان')]]) {
    filters.append(el('button', {
      className: 'lb3-fchip' + (lobbyFilter === id ? ' on' : ''),
      textContent: label,
      onclick: () => { lobbyFilter = id; renderLobby(rooms); },
    }));
  }
  center.append(filters);

  const listEl = el('div', { className: 'lb3-room-list' });
  if (!rooms) {
    listEl.append(el('p', { className: 'muted', style: 'text-align:center;padding:26px', textContent: t('common.loading', null, 'در حال بارگذاری…') }));
    networkTable?.listRooms();
  } else {
    let list = rooms.filter((r) => {
      if (lobbyFilter === 'chahar_barg') return r.gameType === 'chahar_barg';
      if (lobbyFilter === 'shelem') return (r.gameType || 'shelem') === 'shelem';
      if (lobbyFilter === 'hokm') return r.gameType === 'hokm';
      if (lobbyFilter === 'bidel') return r.gameType === 'bidel';
      if (lobbyFilter === 'bluff') return r.gameType === 'bluff';
      if (lobbyFilter === 'friends') return (r.seats || []).some((s) => s && s.userId && friendsSet.has(s.userId));
      return true;
    });
    const joinable = (r) => (r.state === 'WAITING' ? (r.seated ?? 0) < (r.playerCount || 4) : ((r.bots || 0) > 0 && r.playerMode !== 'COOP_2V2'));
    const open = list.filter(joinable).sort((a, b) => (a.seated ?? 0) - (b.seated ?? 0));
    const busy = list.filter((r) => !joinable(r));

    if (!list.length) {
      const emptyBox = el('div', { className: 'lb3-empty' });
      const iconWrap = el('div', { className: 'lb3-empty-icon' });
      iconWrap.innerHTML = `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="2" y="6" width="7" height="10" rx="1.4" transform="rotate(-8 5.5 11)"></rect><rect x="9.5" y="4" width="7" height="12" rx="1.4"></rect><rect x="17" y="6" width="7" height="10" rx="1.4" transform="rotate(8 20.5 11)"></rect></svg>`;
      const txtBox = el('div', { style: 'display:flex;flex-direction:column;gap:4px;' },
        el('h4', { textContent: lobbyFilter === 'all' ? t('lobby.no_open_rooms', null, 'اتاقی باز نیست') : t('lobby.no_rooms_filter', null, 'اتاقی با این فیلتر نیست') }),
        el('p', { textContent: t('lobby.empty_hint', null, 'همین حالا یک میز بساز یا وارد بازی سریع شو تا با یک حریف جفت شوی') }),
      );
      const playBtn = el('button', {
        className: 'lb3-empty-btn',
        textContent: t('lobby.quick_game', null, 'بازی سریع'),
        onclick: () => {
          showBotDiffModal((diff, speed) => startGame({ noBot: false, botDifficulty: diff, speedMode: speed }));
        },
      });
      emptyBox.append(iconWrap, txtBox, playBtn);
      listEl.append(emptyBox);
    } else {
      for (const r of open) listEl.append(lobbyRoomCard(r));
      if (busy.length) {
        listEl.append(el('div', { className: 'lb3-divider', textContent: t('lobby.playing', null, 'در حال بازی') }));
        for (const r of busy) listEl.append(lobbyRoomCard(r));
      }
    }
  }
  center.append(listEl);

  // ═══ ریلِ چپ (RTL ستونِ ۳): رتبه‌بندی + منوی سیستم ═══
  const railR = el('div', { className: 'lb3-railR' }, lobbyLeaderRail(), buildNav());

  // ═══ تعیین نحوه رندر برای دسکتاپ یا موبایل ═══
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 900;

  if (!isMobile) {
    // در حالت دسکتاپ: چیدمان استاندارد و کامل سه‌ستونه (ریل راست، مرکز، ریل چپ) بدون هیچ منوی همبرگری
    const rail = el('div', { className: 'lb3-rail' }, buildIdCard(), buildBadgesCard(), lobbyFriendReqBox(), buildActions(), lobbyFriendsRail());
    const mainContent = el('div', { className: 'lb3' }, rail, center, railR);
    root.replaceChildren(mainContent);
    return;
  }

  // ═══ حالت موبایل (عرض صفحه <= 900px) با اکشن‌بار پایینی و چیپ‌های وکتور SVG ═══
  const switchMobileTab = (tab) => {
    _mobileLobbyTab = tab;
    renderLobby(_lastLobbyRooms || rooms);
  };

  const statBadge = el('div', {
    className: 'lb3-mh-stat',
    title: 'تراز و درجه بازیکن',
    onclick: () => switchMobileTab('profile'),
  },
    ..._myEloLine(p, true),
  );

  const vipBtn = el('button', {
    type: 'button',
    className: 'lb3-mh-vip' + (p.is_vip ? ' is-vip' : ''),
    title: p.is_vip ? t('lobby.vip_member', null, 'عضویت ویژه VIP') : t('lobby.vip_upgrade', null, 'خرید اشتراک VIP'),
    onclick: () => shopModal.show(),
  });
  vipBtn.innerHTML = `${LB_ICON.vip}<span>${p.is_vip ? 'VIP' : t('lobby.upgrade', null, 'ارتقا')}</span>`;

  const supBtn = el('button', {
    type: 'button',
    className: 'lb3-mh-icon-btn',
    title: t('nav.support', null, 'پشتیبانی'),
    onclick: () => showSupportModal(),
  });
  supBtn.innerHTML = LB_ICON.support;
  if (supportUnreadCount > 0) {
    supBtn.append(el('span', { className: 'lb3-mh-badge', textContent: fmtNum(supportUnreadCount) }));
  }

  const reportBtn = el('button', {
    type: 'button',
    className: 'lb3-mh-icon-btn',
    title: t('nav.report', null, 'گزارش تخلف'),
    onclick: () => openReportUserModal(),
  });
  reportBtn.innerHTML = LB_ICON.report;

  const mobileHeader = el('div', { className: 'lb3-mobile-header' },
    el('div', { className: 'lb3-mh-user', onclick: () => switchMobileTab('profile') },
      avatarEl(p.display_name || p.username || '?', p.avatar_url, 45),
      el('div', { className: 'lb3-mh-uinfo' },
        el('span', { className: 'lb3-mh-name', textContent: p.display_name || p.username || 'مهمان' }),
        statBadge,
      ),
    ),
    el('div', { className: 'lb3-mh-actions' },
      netQualityUI.mount(),
      vipBtn,
      supBtn,
      reportBtn,
    ),
  );

  // ویوِ پروفایل (فقط نمایش): آواتارِ مربعیِ بزرگ و وسط‌چین، نام زیرش، و همهٔ آمار و رتبه‌ها.
  // ویرایش در myProfilePanel است و فقط فیلدهای قابل‌ویرایش را دارد (بدونِ تکرارِ آمار).
  const buildProfileOverview = () => {
    const name = p.display_name || p.username || 'مهمان';
    const games = p.games_played ?? 0;
    const wins = p.games_won ?? 0;
    const losses = p.games_lost ?? Math.max(0, games - wins);
    const abandons = p.games_abandoned ?? 0;
    const winRate = games > 0 ? Math.round((wins / games) * 100) : 0;
    const elo = Math.round(p.elo_rating ?? 1200);
    const g = eloGrade(elo, games);
    const ranks = p.ranks || {};
    const rk = (r) => (r ? faNum(r) : '—');
    const stat = (num, lbl, tone = '') => el('div', { className: 'pf-stat' + (tone ? ` ${tone}` : '') },
      el('b', { textContent: num }),
      el('span', { textContent: lbl }),
    );

    // فاز ۲: همان پروفایل عمومی (هدر + عمومی + تب هر بازی) + ردیف کیف پول/ویرایش مخصوص خودم
    if (p.stats?.games) {
      const wallet = el('div', { className: 'pv-wallet' },
        el('button', { type: 'button', className: 'lb3-coin-badge', onclick: () => shopModal.show() },
          el('div', { className: 'lb3-badge-icon' }, '🪙'),
          el('span', { className: 'lb3-badge-val', textContent: `${faNum(p.coins || 0)} ${t('lobby.coins', null, 'سکه')}` }),
        ),
        p.has_booster ? el('button', { type: 'button', className: 'lb3-booster-badge', onclick: () => shopModal.show('booster') },
          el('div', { className: 'lb3-badge-icon' }, '⚡'),
          el('span', { className: 'lb3-badge-val', textContent: `${faNum(p.booster_multiplier || 1.5)}x` }),
        ) : null,
        el('button', { type: 'button', className: 'pv-edit', textContent: t('profile_modal.edit_profile_title', null, '✎ ویرایش پروفایل'), onclick: () => myProfilePanel.toggle() }),
      );
      return el('div', { className: 'lb3-panel pv-panel' }, profileView(p, { self: true, extras: [wallet] }));
    }

    return el('div', { className: 'lb3-panel pf-card' },
      el('button', { type: 'button', className: 'pf-edit', textContent: t('common.edit', null, '✎ ویرایش'), onclick: () => myProfilePanel.toggle() }),
      el('div', { className: 'pf-av' }, avatarEl(name, p.avatar_url, 98, false, 100, false, true, null, false, p.avatar_frame)),
      el('h3', { className: 'pf-name', style: 'display:flex;align-items:center;justify-content:center;gap:6px;flex-wrap:wrap;' },
        p.has_booster ? el('span', { className: 'seat-booster-badge', textContent: '⚡' }) : null,
        el('span', { textContent: name }),
        p.player_title ? el('span', { className: 'seat-player-title', textContent: p.player_title }) : null,
      ),
      el('div', { style: 'margin:6px 0 10px;display:flex;justify-content:center;gap:8px;' },
        el('button', {
          type: 'button',
          className: 'lb3-coin-badge',
          onclick: () => shopModal.show(),
        },
          el('div', { className: 'lb3-badge-icon' }, '🪙'),
          el('span', { className: 'lb3-badge-val', textContent: `${faNum(p.coins || 0)} ${t('lobby.coins', null, 'سکه')}` }),
        ),
        p.has_booster ? el('button', {
          type: 'button',
          className: 'lb3-booster-badge',
          onclick: () => shopModal.show('booster'),
        },
          el('div', { className: 'lb3-badge-icon' }, '⚡'),
          el('span', { className: 'lb3-badge-val', textContent: `${faNum(p.booster_multiplier || 1.5)}x` }),
        ) : null,
      ),
      el('div', { className: 'pf-grade' }, gradeTag(elo, games), el('span', { style: `color:${g.color}`, textContent: g.label })),
      p.bio ? el('p', { className: 'pf-bio', textContent: p.bio }) : null,
      el('div', { className: 'pf-sec', textContent: t('profile.stats', null, 'آمار بازی') }),
      el('div', { className: 'pf-grid' },
        stat(faNum(elo), t('profile_modal.rating_label', null, 'تراز'), 'gold'),
        stat(faNum(games), t('profile.stats', null, 'کل بازی‌ها')),
        stat(`${faNum(winRate)}٪`, t('profile.win_rate', null, 'درصد برد'), 'gold'),
        stat(faNum(wins), t('profile.wins', null, 'برد'), 'win'),
        stat(faNum(losses), t('profile.losses', null, 'باخت'), 'loss'),
        stat(faNum(abandons), t('profile_modal.stat_abandoned_tip', null, 'ترک بازی'), 'warn'),
      ),
      el('div', { className: 'pf-sec', textContent: t('profile_modal.ranks_title', null, 'رتبه') }),
      el('div', { className: 'pf-grid' },
        stat(rk(p.rank), t('profile_modal.rank_all_time', null, 'رتبهٔ کل'), 'gold'),
        stat(rk(ranks.seasonal), t('profile_modal.rank_seasonal', null, 'فصل جاری')),
        stat(p.last_season ? faNum(p.last_season.rank) : '—', t('profile_modal.rank_last_season', null, 'پایان فصل قبل')),
        stat(rk(ranks.monthly), t('profile_modal.rank_monthly', null, 'این ماه')),
        stat(rk(ranks.weekly), t('profile_modal.rank_weekly', null, 'این هفته')),
        stat(rk(ranks.daily), 'امروز'),
      ),
    );
  };

  // منوی پروفایل در موبایل: کارت‌های ۳تایی به‌جای فهرست. «پروفایل» اینجا نیست چون همین
  // صفحه پروفایل است و دکمهٔ ویرایش دارد.
  const buildMenuGrid = () => {
    const grid = el('div', { className: 'pf-menu' });
    const item = (icon, label, onclick, cls = '') => {
      const b = el('button', { type: 'button', className: 'pf-menu-item' + cls, onclick });
      b.innerHTML = `${icon}<span>${label}</span>`;
      return b;
    };
    grid.append(item(LB_ICON.shop, t('nav.shop', null, 'فروشگاه'), () => shopModal.show()));
    grid.append(item(LB_ICON.help, t('nav.help', null, 'راهنمای بازی‌ها'), () => showHelpModal(selectedGame)));
    grid.append(item(LB_ICON.settings, t('nav.settings', null, 'تنظیمات'), () => showSettingsSheet()));
    if (plansEnabled) grid.append(item(LB_ICON.vip, p.is_vip ? 'VIP' : 'VIP', () => shopModal.show('vip')));
    const sup = item(LB_ICON.support, t('nav.support', null, 'پشتیبانی'), () => showSupportModal());
    if (supportUnreadCount > 0) sup.append(el('span', { className: 'pf-menu-badge', textContent: fmtNum(supportUnreadCount) }));
    grid.append(sup);
    grid.append(item(LB_ICON.report, t('nav.report', null, 'گزارش تخلف'), () => openReportUserModal()));
    if (myProfile?.role === 'admin') {
      const a = el('a', { href: '/admin/', target: '_blank', className: 'pf-menu-item' });
      a.innerHTML = `${LB_ICON.admin}<span>${t('nav.admin', null, 'مدیریت')}</span>`;
      grid.append(a);
    }
    grid.append(item(LB_ICON.logout, t('nav.logout', null, 'خروج'), () => _lobbyLogout(), ' danger'));
    return grid;
  };

  // آمارِ پروفایل بعد از هر بازی عوض می‌شود؛ با ورود به این تب (حداکثر هر ۳۰ ثانیه) تازه شود.
  if (_mobileLobbyTab === 'profile' && Date.now() - _profFreshAt > 30_000) {
    _profFreshAt = Date.now();
    loadMyProfile().then(() => {
      if (_mobileLobbyTab === 'profile' && !$('#lobby').classList.contains('hidden')) renderLobby(_lastLobbyRooms || rooms);
    }).catch(() => {});
  }

  // نوار ناوبری پایینی موبایل با آیکون‌های وکتور SVG (بدون ایموجی)
  const bNav = el('nav', { className: 'mobile-bottom-nav' });
  const tabsDef = [
    { id: 'rooms', icon: LB_ICON.rooms, label: t('nav.table', null, 'میزها') },
    { id: 'leaderboard', icon: LB_ICON.leaderboard, label: t('nav.leaderboard', null, 'رتبه‌بندی') },
    { id: 'friends', icon: LB_ICON.friends, label: t('nav.friends', null, 'دوستان') },
    { id: 'profile', icon: LB_ICON.profile, label: t('nav.profile', null, 'پروفایل') },
  ];
  for (const t of tabsDef) {
    const isActive = _mobileLobbyTab === t.id;
    const tabBtn = el('button', {
      type: 'button',
      className: 'mb-nav-tab' + (isActive ? ' active' : ''),
      onclick: () => switchMobileTab(t.id),
    });
    const iconSpan = el('span', { className: 'mb-tab-icon' });
    iconSpan.innerHTML = t.icon;
    tabBtn.append(iconSpan, el('span', { textContent: t.label }));
    if (t.id === 'profile' && supportUnreadCount > 0) {
      tabBtn.append(el('span', { className: 'mb-tab-badge', textContent: faNum(supportUnreadCount) }));
    }
    bNav.append(tabBtn);
  }

  let mainContent;
  if (_mobileLobbyTab === 'leaderboard') {
    mainContent = el('div', { className: 'mobile-tab-content' }, lobbyLeaderRail());
  } else if (_mobileLobbyTab === 'friends') {
    mainContent = el('div', { className: 'mobile-tab-content' }, lobbyFriendReqBox(), lobbyFriendsRail());
  } else if (_mobileLobbyTab === 'profile') {
    // سربرگِ مشترکِ تب‌ها در پروفایل تکراری است (آواتار/نام/تراز بالای پنلِ پروفایل هست، VIP و پشتیبانی در کارت‌های پایین) → حذف
    mainContent = el('div', { className: 'mobile-tab-content' }, buildProfileOverview(), buildMenuGrid());
  } else {
    // 'rooms'
    mainContent = el('div', { className: 'mobile-tab-content' }, mobileHeader, buildBadgesCard(), buildActions(), center);
  }

  root.replaceChildren(mainContent, bNav);
}

// ─── بنر وضعیت اتصال مجدد و پایداری شبکه ──────────────────────────────────
// قطعیِ کوتاهِ موبایل (زیرِ ۲ ثانیه، بیشترِ reconnectها) بنر نمی‌گیرد: بنر بالای میز
// ظاهر و محو می‌شد و کلِ چیدمان را یک لحظه پایین هل می‌داد. «وصل شد» هم فقط وقتی
// نمایش داده می‌شود که «در حال اتصال» واقعاً دیده شده باشد.
let _reconnSince = 0;
let _reconnShown = false;
function _bannerWanted(v) {
  if (v.reconnecting) {
    if (!_reconnSince) {
      _reconnSince = Date.now();
      setTimeout(() => { if (lastView?.reconnecting) scheduleRender(); }, 2100);
    }
    if (Date.now() - _reconnSince >= 2000) _reconnShown = true;
    return _reconnShown;
  }
  _reconnSince = 0;
  if (v.reconnectedJustNow) return _reconnShown;
  _reconnShown = false;
  return false;
}

function reconnectBanner(v) {
  const isReconnecting = !!v.reconnecting;
  return el('div', {
    className: `reconnect-banner ${isReconnecting ? 'reconnecting' : 'reconnected'}`,
  },
    el('span', { className: 'rb-icon', textContent: isReconnecting ? '⚡' : '✅' }),
    el('span', {
      className: 'rb-text',
      textContent: isReconnecting ? 'اتصال ضعیف شد — اتصال مجدد…' : 'اتصال برقرار شد',
    }),
  );
}

// ─── دکمه و مدال بازبینی دست قبل ──────────────────────────────────────────
function lastTrickButton(v) {
  return el('button', {
    type: 'button',
    className: 'last-trick-btn',
    title: 'مشاهده کارت‌های دور قبل',
    onclick: (e) => {
      e.stopPropagation();
      showLastTrickModal(v);
    },
  },
    el('span', { className: 'lt-btn-icon', textContent: '🃏' }),
    el('span', { className: 'lt-btn-text', textContent: 'دست قبل' }),
  );
}

function showLastTrickModal(v) {
  const existing = document.getElementById('last-trick-modal-overlay');
  if (existing) existing.remove();

  const info = v.lastCompletedTrick;
  if (!info || !info.trick || info.trick.length === 0) {
    toast('هنوز هیچ دستی در این دور بازی نشده است');
    return;
  }

  const overlay = el('div', {
    id: 'last-trick-modal-overlay',
    className: 'bot-modal-overlay',
    onclick: (e) => {
      if (e.target === overlay) closeOverlayWithFade(overlay);
    },
  });

  const modal = el('div', { className: 'bot-modal last-trick-modal' });
  const head = el('div', { className: 'bot-modal-head' },
    el('div', { className: 'bot-modal-title' },
      el('span', { textContent: '🃏' }),
      el('h3', { textContent: 'کارت‌های دست قبل' }),
    ),
    el('button', {
      className: 'occ-close',
      textContent: '✕',
      onclick: () => closeOverlayWithFade(overlay),
    }),
  );

  const winnerName = info.winnerName || (v.names && v.names[info.winnerSeat]) || 'بازیکن';
  const isYouWin = info.winnerSeat === v.you;
  const isTeamWin = (info.winnerSeat % 2) === ((v.you ?? 0) % 2);
  const winTag = isYouWin ? ' (شما)' : (isTeamWin ? ' (یار شما)' : ' (تیم حریف)');

  const sub = el('div', { className: 'last-trick-summary' },
    el('span', { className: 'lt-winner-badge', textContent: `🏆 برنده: ${winnerName}${winTag}` }),
    (v.gameType !== 'hokm' && info.points) ? el('span', { className: 'lt-points-badge', textContent: `+${faNum(info.points)} امتیاز` }) : null,
  );

  const cardsRow = el('div', { className: 'last-trick-cards-row' });
  for (const item of info.trick) {
    const isWinner = item.seat === info.winnerSeat;
    const pName = (v.names && v.names[item.seat]) || `صندلی ${item.seat + 1}`;
    const cardCol = el('div', { className: 'lt-card-col' + (isWinner ? ' lt-winner-card' : '') },
      cardEl(item.card, { small: false }),
      el('span', { className: 'lt-player-name', textContent: pName }),
      isWinner ? el('span', { className: 'lt-crown-tag', textContent: '👑 برنده' }) : null,
    );
    cardsRow.append(cardCol);
  }

  const closeBtn = el('button', {
    type: 'button',
    className: 'primary last-trick-close-btn',
    textContent: 'متوجه شدم ✓',
    onclick: () => overlay.remove(),
  });

  modal.append(head, sub, cardsRow, closeBtn);
  overlay.append(modal);
  document.body.append(overlay);
}

// ─── رندر میز ─────────────────────────────────────────────────────────────────
// رندرهای «محلی» (حباب، تایمرهای جشن/کوت/بنر) از این صف می‌روند، نه render() مستقیم:
// هر اعلامِ تعهد قبلاً دو رندرِ کامل بود (setBubble هم‌گام + آپدیتِ وضعیت) و هر پیامِ
// چت یک render تو‌در‌تو داخلِ خودِ render. حالا حداکثر یک رندر در هر فریم. اگر آپدیتِ
// شبکه در صف است همان رندر حباب‌ها را هم می‌کشد (ephemerals را در لحظهٔ رندر می‌خواند).
// تبِ مخفی → تایمر، چون rAF آن‌جا اجرا نمی‌شود (همان منطقِ NetworkTable._emit).
var _rq = null;   // { id, raf }
function scheduleRender() {
  if (_rq) return;
  const run = () => {
    _rq = null;
    if (table?._emitHandle) return;
    if (lastView) render(lastView);
  };
  _rq = document.hidden ? { id: setTimeout(run, 16), raf: false } : { id: requestAnimationFrame(run), raf: true };
}
function _cancelScheduledRender() {
  if (!_rq) return;
  (_rq.raf ? cancelAnimationFrame : clearTimeout)(_rq.id);
  _rq = null;
}

let _lastHandActiveState = null;
function render(v) {
  if (!v) v = lastView || table?._s;
  if (!v) return;
  window.__render = render;
  lastView = v;

  // اگر در لابی هستیم و میزی فعال نیست، هرگز جدول بازی رندر نشود تا لابی مخدوش نگردد
  const inTable = !!(v.roomId || v.roomState || v.observerMode || (table && table !== networkTable));
  const tableEl = $('#table');
  const lobbyEl = $('#lobby');
  if (!inTable) {
    if (tableEl && !tableEl.classList.contains('hidden')) {
      tableEl.classList.add('hidden');
    }
    document.body.classList.remove('has-clear-hand');
    if (lobbyEl && lobbyEl.classList.contains('hidden')) {
      lobbyEl.classList.remove('hidden');
    }
    try { chatRailUI?.hide(); } catch { /* noop */ }
    try { composerUI?.root?.classList.add('hidden'); } catch { /* noop */ }
    return;
  }

  // اگر میزی فعال است، اطمینان حاصل کن که میز نمایش داده شده و لابی مخفی است
  if (tableEl && tableEl.classList.contains('hidden')) {
    tableEl.classList.remove('hidden');
  }
  if (lobbyEl && !lobbyEl.classList.contains('hidden')) {
    lobbyEl.classList.add('hidden');
  }

  // اگر صفحه انتظار اولیه در جدول است، آن را فوراً پاک کن تا تحت هیچ شرایطی فریز نماند
  clearTimeout(_tableConnectTimeout);
  const loadingScreen = tableEl?.querySelector('.table-loading-screen');
  if (loadingScreen) {
    loadingScreen.remove();
    _cachedFelt = null;
    tableEl.replaceChildren();
  }

  _renderSeq++;          // کشِ نودهای تایمرِ ۲۰۰ms را باطل کن (DOM تازه ساخته شد)
  maybeSound(v);
  const isHandActive = v.roomState === 'IN_HAND' && !v.matchOver && !v.observerMode;
  if (isHandActive !== _lastHandActiveState) {
    _lastHandActiveState = isHandActive;
    if (isHandActive) acquireWakeLock();
    else releaseWakeLock();
  }

  // تشخیص پیام‌های چت جدید → حباب محو‌شونده
  // ⚠ prevChatLen را «قبل» از حلقه به‌روز کن. setBubble دیگر render را هم‌گام صدا نمی‌زند
  // (scheduleRender)، ولی این ترتیب را نگه دار: قبلاً همین‌جا بازگشتِ بی‌پایان (stack overflow) می‌ساخت.
  const chat = v.chat || [];
  const startIdx = prevChatLen;
  prevChatLen = chat.length;
  for (let i = startIdx; i < chat.length; i++) {
    const m = chat[i];
    if (m && !m.system && m.seat != null) {
      const isVoice = !!m.voiceId;
      const ttl = isVoice ? Math.max(8_000, ((m.duration_s || 3) + 3) * 1000) : 6_000;
      setBubble(m.seat, m, ttl);
      // پخش مستقیم و خودکار ویس ارسالی بدون نیاز به کلیک دکمه
      const isLiveMessage = startIdx > 0 || chat.length === 1;
      if (isVoice && m.data_b64 && isLiveMessage) {
        if (!isMuted()) {
          playVoice(m.voiceId, m.data_b64, m.seat, m.duration_s || 0);
        }
        table?.markVoiceListened?.(m.voiceId);
      }
    }
  }

  // چت و کامپوزر مستقل و اولِ کار رندر می‌شوند تا یک خطا در رندرِ میز آن‌ها را قفل نکند
  try { composerUI.show(v); } catch (e) { console.error('[composer]', e); }
  try { chatRailUI.render(v); } catch (e) { console.error('[chatRail]', e); }

  try {
    _renderTable(v);
  } catch (e) {
    console.error('[render table]', e);
    const tableEl = $('#table');
    if (tableEl && !tableEl.querySelector('.board, .table-waiting-panel, .overlay')) {
      tableEl.replaceChildren(el('div', {
        className: 'table-error-fallback',
        style: 'display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;color:#fff;gap:14px;text-align:center;padding:24px;'
      },
        el('div', { style: 'font-size:36px;' }, '⚠️'),
        el('div', { style: 'font-weight:700;font-size:17px;color:#f8fafc;', textContent: t('table.render_error', null, 'خطا در بارگذاری میز بازی') }),
        el('div', { className: 'muted small', style: 'max-width:340px;color:#94a3b8;line-height:1.6;', textContent: t('table.render_error_desc', null, 'خطایی در نمایش صفحه بازی رخ داد. لطفاً صفحه را دوباره بارگذاری کنید.') }),
        el('button', {
          className: 'btn gold',
          style: 'padding:10px 28px;margin-top:6px;border-radius:10px;font-weight:bold;cursor:pointer;',
          textContent: t('table.reload_page', null, 'بارگذاری مجدد'),
          onclick: () => location.reload()
        })
      ));
    }
  }
  try { occupantsUI.update(v); } catch (e) { console.error('[occupants]', e); }
  try { renderReactions(v); } catch (e) { console.error('[reactions]', e); }
  // هر scheduleRender که قبل یا حینِ همین رندر درخواست شده، با همین رندر پوشش داده شد
  _cancelScheduledRender();
}
if (typeof window !== 'undefined') {
  window.render = render;
  window.__render = render;
  window.renderLobby = renderLobby;
  window.biddingOverlay = biddingOverlay;
  window.showLeaderboardModal = showLeaderboardModal;
  window.leaderboardPanel = leaderboardPanel;
}

// ─── مقیاسِ متناسبِ تخته ────────────────────────────────────────────────────
// ناحیهٔ بازی داخلِ .board-inner (بومِ عرض‌ثابت BOARD_W) است. .board کلِ فضای
// عمودیِ باقی‌مانده را می‌گیرد. fitBoard():
//   • --board-s: بوم را کوچک/بزرگ می‌کند تا در عرضِ موجود جا شود (کف/سقف دارد)،
//   • --board-h: ارتفاعِ بوم را طوری می‌دهد که بعد از مقیاس دقیقاً ارتفاعِ موجود
//     را پر کند → هیچ فضای خالیِ پایین. ولی هرگز زیرِ BOARD_H_MIN نمی‌رود تا روی
//     صفحه‌های کوتاه صندلی/کارت روی هم نیفتند.
// زیرِ ۵۶۱px چیدمانِ اختصاصیِ موبایل فعال است و این منطق اعمال نمی‌شود.
const BOARD_W = 1200;       // px مرجع — باید با --board-w در CSS یکی باشد
const BOARD_H_MIN = 560;    // کمینه ارتفاعِ منطقیِ بوم (زیرِ این، همه‌چیز مقیاس می‌خورد)
const BOARD_H_MAX = 1320;   // بیشینه — بوم بلندتر می‌شود تا فاصله‌ی زیرِ نوار پر شود
const BOARD_S_MIN = 0.40;
const BOARD_S_MAX = 1.35;

function fitBoard() {
  const root = $('#table');
  if (!root || root.classList.contains('hidden')) return;
  const board = root.querySelector(':scope > .board');
  if (!board) return;
  if (window.innerWidth <= 560) {
    board.style.removeProperty('--board-s');
    board.style.removeProperty('--board-h');
    return;
  }

  const box = board.getBoundingClientRect();       // فضای در دسترس (flex:1 پرش کرده)
  const availW = Math.max(1, box.width - 8);
  const availH = Math.max(1, box.height - 4);

  let s = Math.min(availW / BOARD_W, availH / BOARD_H_MIN, BOARD_S_MAX);
  s = Math.max(s, BOARD_S_MIN);
  const innerH = Math.min(BOARD_H_MAX, Math.max(BOARD_H_MIN, availH / s));

  const rs = s.toFixed(3), rh = Math.round(innerH) + 'px';
  if (board.dataset.s !== rs) { board.dataset.s = rs; board.style.setProperty('--board-s', rs); }
  if (board.dataset.h !== rh) { board.dataset.h = rh; board.style.setProperty('--board-h', rh); }
}

let _fitRAF = 0;
let _fitMobileHand = null;
function scheduleFit() {
  if (_fitRAF) return;
  _fitRAF = requestAnimationFrame(() => {
    _fitRAF = 0;
    try { fitBoard(); } catch (e) { console.error('[fitBoard]', e); }
    // عبور از مرزِ دستِ موبایل/دسکتاپ (تغییرِ اندازهٔ پنجره) → نوارِ دست با هندسهٔ درست بازسازی شود
    const m = _isMobileHand();
    if (_fitMobileHand !== null && m !== _fitMobileHand && lastView) render(lastView);
    _fitMobileHand = m;
  });
}

let _fitBound = false;
function bindBoardFit() {
  if (_fitBound) return;
  _fitBound = true;
  window.addEventListener('resize', scheduleFit, { passive: true });
  window.addEventListener('orientationchange', scheduleFit, { passive: true });
  const root = $('#table');
  if (root && 'ResizeObserver' in window) {
    // تغییرِ عرضِ #table (باز/بستهٔ ریلِ گفتگو) یا ارتفاعِ chrome داخلش
    new ResizeObserver(scheduleFit).observe(root);
  }
}

function _renderTable(v) {
  const root = $('#table');
  bindBoardFit();
  const theme = v.tableTheme || localStorage.getItem('cb_table_theme') || 'ruby';
  const isHidden = root.classList.contains('hidden');
  const isKotPhase = !v.observerMode && v.phase === 'PASS_KOT' && v.hakemSeat === v.you;
  const isHokmChoosing = !v.observerMode && v.gameType === 'hokm' && (v.phase === 'CHOOSE_HOKM' || v.phase === 'CHOOSING_HOKM') && (v.turnSeat === v.you || v.hakemSeat === v.you);
  const isDealing = !isHokmChoosing && (!!root.querySelector('.deal-fx') || (Date.now() < _dealFxUntil));
  root.className = `table theme-${theme}` + (isHidden ? ' hidden' : '') + (isKotPhase ? ' kot-mode' : '') + (isDealing ? ' dealing' : '');
  root.setAttribute('data-player-count', String(v.playerCount || 4));
  root.setAttribute('data-game-type', v.gameType || 'shelem');

  // اگر صفحه انتظار اولیه در جدول است، آن را فوراً پاک کن
  clearTimeout(_tableConnectTimeout);
  const loadingScreen = root.querySelector('.table-loading-screen');
  if (loadingScreen) {
    loadingScreen.remove();
    _cachedFelt = null;
    root.replaceChildren();
  }

  // اگر دست به تازگی تمام شده، مکث کوتاه جهت مشاهده جمع‌آوری تریک هفتم و کارت برنده
  if (v.result && _lastResultSeenHand !== v.handNo) {
    _lastResultSeenHand = v.handNo;
    const hasRecentTrick = (v.trick && v.trick.length > 0) || (v.lastWin != null) || (_cachedCenterEl && _cachedCenterEl.querySelectorAll('.play').length > 0);
    if (hasRecentTrick && !_reducedMotion()) {
      _resultOverlayHoldUntil = Date.now() + 1350;
      setTimeout(scheduleRender, 1370);
    } else {
      _resultOverlayHoldUntil = 0;
    }
  } else if (!v.result) {
    _lastResultSeenHand = -1;
    _resultOverlayHoldUntil = 0;
  }

  // اعلام رسمی و باشکوه حکم سلطنتی در مرکز میز با جلوه صوتی مهر شاهی
  if (v.gameType === 'hokm' && v.hokm && (v.phase === 'PLAYING_TURNS' || v.phase === 'DEALING')) {
    if (_lastAnnouncedHokmHand !== v.handNo || _lastAnnouncedHokmSuit !== v.hokm) {
      _lastAnnouncedHokmHand = v.handNo;
      _lastAnnouncedHokmSuit = v.hokm;
      const isFreshHand = (v.trickIndex === 0 || !v.trickIndex) && (!v.tricksWon || (v.tricksWon[0] === 0 && v.tricksWon[1] === 0));
      if (isFreshHand) {
        spawnHokmAnnouncement(v.hokm, v.hakemSeat, v);
        sounds?.royalSeal?.();
      }
    }
  } else if (!v.hokm || v.phase === 'CHOOSE_HOKM' || v.phase === 'CHOOSING_HOKM') {
    _lastAnnouncedHokmHand = -1;
    _lastAnnouncedHokmSuit = null;
  }

  // فریم اولیه: ساختار کامل و اولیه را به صورت ترتیبی مستقر کن
  if (!_cachedFelt || !root.contains(_cachedFelt)) {
    _cachedFelt = el('div', { className: `felt theme-${theme}` + (v.hokm ? ` hokm-${v.hokm}` : '') });
    root.replaceChildren();
    if (_bannerWanted(v)) {
      root.append(reconnectBanner(v));
    }
    const tb0 = topbar(v);
    tb0.dataset.sig = topbarSig(v);
    root.append(tb0);
    // نوارِ مشکیِ امتیاز حذف شد؛ همهٔ اطلاعاتش به توپ‌بار منتقل شد → میز فضای عمودیِ بیشتری دارد.
    // ناحیهٔ بازی (نمد + دست + تایمر) داخلِ .board-inner می‌نشیند تا با یک ضریبِ
    // واحد (fitBoard) به‌تناسب کوچک/بزرگ شود و المان‌ها هرگز روی هم نیفتند.
    const boardInner = el('div', { className: 'board-inner' });
    // اولین فریمِ نصبِ میز هم باید پیش از handStrip باشد (مثلِ شاخهٔ فریم‌های بعدی)
    // تا اگر همین فریم شروعِ یک دست است، _dealDeal پیش از ساختِ نوارِ دست آماده باشد.
    const isHokmSecond0 = v.gameType === 'hokm' && (v.hokm != null || (v.yourHand || []).length > 5);
    const hokmStage0 = isHokmSecond0 ? 1 : 0;
    const isHokmDealingAllowed0 = v.gameType === 'hokm' && v.phase !== 'REVEAL' && v.phase !== 'DETERMINE_HAKEM';
    const isDealNeeded0 = v.handNo != null && v.roomState === 'IN_HAND' && (v.trick || []).length === 0 && (
      (isHokmDealingAllowed0 && ((v.handNo !== _dealFxHandNo) || (hokmStage0 === 1 && _dealFxHokmStage === 0)))
      || (v.handNo !== _dealFxHandNo && (v.gameType === 'chahar_barg' || ['DEAL', 'DEALING', 'IDLE', 'BIDDING', 'CHOOSE_HOKM', null, undefined].includes(v.phase)))
      || (v.gameType === 'chahar_barg' && v.dealIndex != null && v.dealIndex > 0 && v.dealIndex !== _dealFxDealIndex)
    );
    if (isDealNeeded0) {
      if (v.handNo !== _dealFxHandNo) {
        _dealFxHokmStage = 0;
      }
      _dealFxHandNo = v.handNo;
      _dealFxDealIndex = v.dealIndex || 0;
      if (v.gameType === 'hokm' && hokmStage0 === 1) {
        _dealFxHokmStage = 1;
      }
      playDealFx(v);
    }
    const hs0 = handStrip(v);
    hs0.dataset.sig = handStripSig(v);
    boardInner.append(_cachedFelt, hs0);
    const bh0 = boardHud(v);
    bh0.dataset.sig = boardHudSig(v);
    root.append(el('div', { className: 'board' }, boardInner, bh0));
    // راهنمای چرخاندنِ گوشی — یک‌بار ساخته می‌شود و پایدار می‌ماند؛ نمایش/پنهانیِ
    // آن کاملاً با media query است (هیچ لیسنرِ orientation لازم نیست).
    root.append(el('div', { className: 'rotate-hint' },
      el('div', { className: 'rotate-hint-ic', textContent: '📱' }),
      el('b', { textContent: 'گوشی را عمودی بگیرید' }),
      el('span', { textContent: 'میزِ چهاربرگ برای حالتِ عمودی طراحی شده. بازی همچنان در جریان است — کافی است گوشی را بچرخانید.' }),
    ));
    fitBoard();
  } else {
    // فریم‌های بعدی: به‌روزرسانی درجا بدون جدا کردن فلت میز و سنتر از درخت DOM
    let banner = root.querySelector(':scope > .reconnect-banner');
    if (_bannerWanted(v)) {
      if (!banner) root.prepend(reconnectBanner(v));
      else banner.className = `reconnect-banner ${v.reconnecting ? 'reconnecting' : 'reconnected'}`;
    } else if (banner) {
      banner.remove();
    }

    // .board-inner ناحیهٔ مقیاس‌شونده است (نمد + دست). نمد همیشه بچهٔ آن است.
    const inner = _cachedFelt.parentNode;
    const board = root.querySelector(':scope > .board');

    // توپ‌بار فقط وقتی بازساخته می‌شود که چیزی در آن عوض شده باشد (۴۵ نود + پنج
    // پارسِ SVG در هر رندر بود، حتی برای یک پیامِ چت).
    const tbSig = topbarSig(v);
    let tb = root.querySelector(':scope > .topbar');
    if (!tb || tb.dataset.sig !== tbSig) {
      const newTb = topbar(v);
      newTb.dataset.sig = tbSig;
      if (tb) tb.replaceWith(newTb);
      else if (board) board.before(newTb);
      else root.prepend(newTb);
    }

    // نوارِ امتیازِ قدیمی اگر از نسخهٔ کش‌شده مانده بود پاک شود
    const oldHud = root.querySelector(':scope > .score-panel');
    if (oldHud) oldHud.remove();

    // HUDِ گوشه‌های میز (حکم + لغو) — فقط با تغییرِ امضا
    if (board) {
      const bhSig = boardHudSig(v);
      const oldBh = board.querySelector(':scope > .board-hud');
      if (!oldBh || oldBh.dataset.sig !== bhSig) {
        const newBh = boardHud(v);
        newBh.dataset.sig = bhSig;
        if (oldBh) oldBh.replaceWith(newBh); else board.append(newBh);
      }
    }

    _cachedFelt.className = `felt theme-${theme}` + (v.hokm ? ` hokm-${v.hokm}` : '');

    // انیمیشنِ پخشِ کارت: یک‌بار در شروعِ هر دست (فقط فازهای ابتدایی، تریکِ خالی —
    // تا روی reconnect وسطِ دست پخش نشود). عمداً قبل از handStrip: هم‌شرط کردنِ ظاهرشدنِ
    // کارت‌های خودِ کاربر با فرودِ کارتِ پرنده نیاز به _dealDeal دارد که اینجا ساخته می‌شود.
    const isHokmSecond = v.gameType === 'hokm' && (v.hokm != null || (v.yourHand || []).length > 5);
    const hokmStage = isHokmSecond ? 1 : 0;
    const isHokmDealingAllowed = v.gameType === 'hokm' && v.phase !== 'REVEAL' && v.phase !== 'DETERMINE_HAKEM';
    const isDealNeeded = v.handNo != null && v.roomState === 'IN_HAND' && (v.trick || []).length === 0 && (
      (isHokmDealingAllowed && ((v.handNo !== _dealFxHandNo) || (hokmStage === 1 && _dealFxHokmStage === 0)))
      || (v.handNo !== _dealFxHandNo && (v.gameType === 'chahar_barg' || ['DEAL', 'DEALING', 'IDLE', 'BIDDING', 'CHOOSE_HOKM', null, undefined].includes(v.phase)))
      || (v.gameType === 'chahar_barg' && v.dealIndex != null && v.dealIndex > 0 && v.dealIndex !== _dealFxDealIndex)
    );
    if (isDealNeeded) {
      if (v.handNo !== _dealFxHandNo) {
        _dealFxHokmStage = 0;
      }
      _dealFxHandNo = v.handNo;
      _dealFxDealIndex = v.dealIndex || 0;
      if (v.gameType === 'hokm' && hokmStage === 1) {
        _dealFxHokmStage = 1;
      }
      playDealFx(v);
    }

    // نوارِ دست فقط وقتی بازساخته می‌شود که واقعاً چیزی در آن عوض شده باشد. قبلاً هر
    // رندر (و هر اعلامِ تعهد یک رندر است) ۱۳ کارتِ صورتِ سنگین را از نو می‌ساخت و
    // جایگزین می‌کرد → برگ‌ها یک لحظه محو و دوباره پیدا می‌شدند.
    const hsSig = handStripSig(v);
    let hs = inner.querySelector(':scope > .hand-strip');
    if (!hs || hs.dataset.sig !== hsSig) {
      const newHs = handStrip(v, hs);
      newHs.dataset.sig = hsSig;
      if (hs && hs !== newHs) hs.replaceWith(newHs);
      else if (!hs) _cachedFelt.after(newHs);
    }

    let tBar = inner.querySelector(':scope > .timer-bar-wrap');
    if (tBar) tBar.remove();
  }

  // ارتفاعِ chrome (نوارِ امتیاز/بازاتصال) بین فریم‌ها عوض می‌شود → ضریب را تازه کن
  scheduleFit();

  const felt = _cachedFelt;

  // صندلی‌ها: حریفان داخلِ نمد؛ صندلیِ خودم داخلِ .board-inner (بیرون از transformِ
  // نمد) تا از زیرِ شیشهٔ بلورِ فازِ تعهد بیرون بماند و z-index کار کند.
  const bInner = felt.parentNode;
  const pCount = v.playerCount || 4;
  for (let seat = 0; seat < 4; seat++) {
    const mineSeat = seat === v.you;
    const seatHost = mineSeat ? bInner : felt;
    const otherHost = mineSeat ? felt : bInner;
    // صندلیِ قدیمیِ احتمالی در هاستِ دیگر را بردار (اگر بازیکن جابجا شده)
    const staleOther = otherHost.querySelector(`:scope > .seat[data-seat="${seat}"]`);
    if (staleOther) staleOther.remove();

    if (seat >= pCount) {
      seatHost.querySelector(`:scope > .seat[data-seat="${seat}"]`)?.remove();
      continue;
    }

    const existingSeat = seatHost.querySelector(`:scope > .seat[data-seat="${seat}"]`);
    // امضای کامل صندلی عوض نشده → دست نزن.
    const sSig = seatSig(v, seat);
    if (existingSeat && existingSeat.dataset.sig === sSig) continue;

    // فاز ۳: اگر هویتِ بازیکن و موقعیتِ صندلی همان است، فقط وضعیت را درجا (In-place) به‌روز کن
    // بدون تخریبِ DOM آواتار، رینگِ SVG، تاج و بادبزنِ کارت‌ها.
    const idSig = seatIdentitySig(v, seat);
    if (existingSeat && existingSeat.dataset.idSig === idSig) {
      updateSeatInPlace(existingSeat, v, seat);
      existingSeat.dataset.sig = sSig;
      continue;
    }

    // در غیر این صورت (تغییر بازیکن، تغییر آواتار یا رندر اولیه): ساخت صندلی از نو
    const newSeat = seatBox(v, seat);
    newSeat.setAttribute('data-seat', String(seat));
    newSeat.dataset.idSig = idSig;
    newSeat.dataset.sig = sSig;
    if (existingSeat) {
      const keepBubble = seat !== v.you ? existingSeat.querySelector(':scope > .seat-bubble') : null;
      if (keepBubble) newSeat.append(keepBubble);
      existingSeat.replaceWith(newSeat);
    } else {
      seatHost.append(newSeat);
    }
  }

  // حباب‌های صندلی — جدا از seatBox مدیریت می‌شوند تا نودشان پایدار بماند:
  // فقط وقتی محتوایِ حباب واقعاً عوض شده باشد نودِ تازه می‌سازیم (و انیمیشنِ ورود می‌خورد).
  const boardInner = felt.parentNode;
  for (let seat = 0; seat < pCount; seat++) {
    const isMine = seat === v.you;
    const seatEl = (isMine ? boardInner : felt).querySelector(`:scope > .seat[data-seat="${seat}"]`);
    if (!seatEl) continue;
    const bubble = ephemerals.get(seat);
    // حبابِ صندلیِ خودم به .board-inner می‌رود (نه صندلی) و سمتِ راستِ آواتار می‌نشیند،
    // تا از زیرِ فنِ کارت و شیشهٔ بلور بیرون بماند.
    const host = isMine ? boardInner : seatEl;
    const cur = (isMine ? boardInner.querySelector(':scope > .seat-bubble.mine-bub')
                        : seatEl.querySelector(':scope > .seat-bubble'));
    if (!bubble || (isMine && isKotPhase)) { cur?.remove(); continue; }
    if (cur && cur.dataset.bseq === String(bubble._seq)) continue; // همان حباب — دست نزن
    cur?.remove();
    const bEl = bubbleEl(bubble, seat, v);
    if (isMine) bEl.classList.add('mine-bub');
    host.append(bEl);
  }

  // مرکز میز و کارت‌های وسط دور (پایدار در درخت DOM جهت اجرای روان انیمیشن پرتاب)
  const centerEl = centerArea(v);
  if (!felt.contains(centerEl)) {
    felt.append(centerEl);
  }

  // دکمه بازبینی دست قبل
  const existingLtBtn = felt.querySelector(':scope > .last-trick-btn');
  if (existingLtBtn) existingLtBtn.remove();
  if (v.lastCompletedTrick && v.roomState === 'IN_HAND') {
    felt.append(lastTrickButton(v));
  }

  // کنترل‌های بلوف: چیپ‌های رنک و دکمه‌های ثبت ادعا / مشکوکم
  let bctrl = root.querySelector(':scope > .bluff-controls-host');
  const isBluffPlayPhase = v.gameType === 'bluff' && v.roomState === 'IN_HAND' && !v.matchOver && !v.observerMode && v.phase !== 'DEFENSE' && v.phase !== 'RESOLVE';

  if (isBluffPlayPhase) {
    if (!bctrl) {
      bctrl = el('div', { className: 'bluff-controls-host' });
      root.append(bctrl);
    }
    _bluffSelectedCards = _bluffSelectedCards.filter((c) => (v.yourHand || []).some((h) => h.id === (c.id || c)));
    renderBluffControls(v, bctrl, { el, faNum, toast }, _bluffSelectedCards, (act) => {
      if (act.type === 'BLUFF_CLAIM') {
        table.bluffClaim(act.cardIds, act.claimedRank);
        _bluffSelectedCards = [];
      } else if (act.type === 'BLUFF_CHALLENGE') {
        table.bluffChallenge();
      } else if (act.type === 'BLUFF_CONFIRM_WINNER') {
        table.bluffConfirmWinner();
      }
    });
  } else if (bctrl) {
    bctrl.remove();
  }

  // ═══ اورلی‌های وضعیت بازی (انتخاب حکم، اعلام تعهد، پایان دست و…) ═══
  // ⚠ قبلاً با **هر** رندر (و هر پیامِ چت/ری‌اکشن/حضور یک رندر است) کلِ اورلی
  // نابود و از نو ساخته می‌شد. پنلِ تعهد در موبایل `overflow-y:auto` دارد، پس
  // اسکرولِ کاربر وسطِ انتخاب به بالا پرت می‌شد و یک لمسِ در جریان روی نودِ تازه
  // می‌نشست. حالا مثلِ handStrip با یک امضا فقط وقتی عوض شده بازساخته می‌شود.
  const ovSig = overlaySig(v);
  let ov = root.querySelector(':scope > .overlay');
  root.querySelectorAll(':scope > .observer-banner').forEach((o) => o.remove());
  if (v.observerMode) root.append(el('div', { className: 'observer-banner', textContent: '👁 حالت تماشا — شما فقط ناظر هستید' }));

  if (ov && ov.dataset.ovsig === ovSig) {
    // همان اورلی با همان محتوا — دست نزن (اسکرول و فوکوس حفظ می‌شود)
  } else {
    ov?.remove();
    let fresh = null;

    // پاکسازی قطعی _dealDeal در صورتی که زمان پخش سپری شده باشد
    if (_dealDeal && Date.now() - _dealDeal.t0 >= ((_dealDeal.dealEnd || 1500) + 40)) {
      if (_dealDeal.timers) _dealDeal.timers.forEach((t) => clearTimeout(t));
      if (_dealDeal.endTimer) clearTimeout(_dealDeal.endTimer);
      _dealDeal = null;
      _dealFxUntil = 0;
      root.querySelector('.deal-fx')?.remove();
      root.classList.remove('dealing');
    }

    const isDealingNow = (_dealDeal != null || (typeof _dealFxUntil === 'number' && Date.now() < _dealFxUntil));

    if (v.matchCancelled) fresh = matchCancelledOverlay(v);
    else if (v.matchOver) fresh = matchOverOverlay(v);
    else if (v.roomState === 'WAITING' && !v.observerMode) fresh = waitingOverlay(v);
    else if (v.result) {
      if (Date.now() < _resultOverlayHoldUntil) {
        const waitMs = Math.max(30, _resultOverlayHoldUntil - Date.now() + 20);
        setTimeout(scheduleRender, waitMs);
      } else {
        fresh = resultOverlay(v);
      }
    }
    else if (isDealingNow) {
      /* در حالِ پخشِ کارت — هیچ شیتِ انتخابی بالا نیاید تا کارت‌ها کاملاً فرود بیایند و مستقر شوند */
      if (_dealFxUntil > 0 && Date.now() < _dealFxUntil) {
        const waitMs = Math.max(30, _dealFxUntil - Date.now() + 20);
        setTimeout(() => {
          if (_dealDeal && Date.now() - _dealDeal.t0 >= (_dealDeal.dealEnd || 1200)) {
            _dealDeal = null;
          }
          _dealFxUntil = 0;
          scheduleRender();
        }, waitMs);
      } else {
        _dealDeal = null;
        _dealFxUntil = 0;
        scheduleRender();
      }
    }
    else if (!v.observerMode && v.gameType === 'hokm' && (v.phase === 'CHOOSE_HOKM' || v.phase === 'CHOOSING_HOKM') && (v.turnSeat === v.you || v.hakemSeat === v.you)) fresh = chooseHokmOverlay(v);
    else if (!v.observerMode && _pendingJokerPlay && v.phase === 'PLAYING_TURNS' && v.turnSeat === v.you) fresh = chooseJokerHokmOverlay(v, _pendingJokerPlay);
    else if (!v.observerMode && v.phase === 'BIDDING' && v.turnSeat === v.you) fresh = biddingOverlay(v);
    else if (v.gameType === 'bluff' && (v.phase === 'DEFENSE' || v.phase === 'RESOLVE')) fresh = bluffInterrogationOverlay(v);
    if (fresh) {
      fresh.dataset.ovsig = ovSig;
      if (fresh.matches('.bidding-overlay, .choose-hokm-overlay')) guardChoiceTaps(fresh);
      root.append(fresh);
    }
  }
  const hasClearHand = !!root.querySelector('.overlay.clear-hand-overlay');
  root.classList.toggle('has-clear-hand', hasClearHand);
  document.body.classList.toggle('has-clear-hand', hasClearHand);
  if (v.phase !== 'PLAYING_TURNS' || v.turnSeat !== v.you) {
    _pendingJokerPlay = null;
  }
  if (v.phase !== 'PASS_KOT') {
    passKotSelection.isSubmitting = false;
    passKotSelection.selectedIds.clear();
    passKotSelection.hokm = null;
  }
}

// ─── لایه ری‌اکشن‌های شناور روی میز ──────────────────────────────────────────
let _seenReactions = new Set();
function getOrCreateReactionsLayer() {
  let layer = document.getElementById('floating-reactions-layer');
  if (!layer) {
    layer = el('div', { id: 'floating-reactions-layer', className: 'floating-reactions-layer' });
    document.body.append(layer);
  }
  return layer;
}

let _recentSelfReactions = [];
let _recentSelfTaunts = [];
function renderReactions(v) {
  const layer = getOrCreateReactionsLayer();
  const reactions = v.reactions || [];
  const now = Date.now();
  _recentSelfReactions = _recentSelfReactions.filter((t) => now - t.ts < 3000);
  _recentSelfTaunts = _recentSelfTaunts.filter((t) => now - t.ts < 3000);

  for (const r of reactions) {
    if (_seenReactions.has(r.id)) continue;
    _seenReactions.add(r.id);
    if (_seenReactions.size > 100) {
      _seenReactions = new Set([..._seenReactions].slice(-50));
    }
    if (r.isTaunt) {
      if (r.seat === v.you) {
        const matchIdx = _recentSelfTaunts.findIndex((m) => m.text === r.text);
        if (matchIdx >= 0) {
          _recentSelfTaunts.splice(matchIdx, 1);
          continue;
        }
      }
      if (r.audioUrl && !isMuted()) {
        try {
          sounds.voiceTaunt?.(r.audioUrl, 0.85);
        } catch {}
      } else {
        try { sounds.reaction(); } catch {}
      }
      spawnFloatingTaunt(r.seat, r.text, v.you);
      continue;
    }
    // اگر ری‌اکشن صندلی خودمان بود و قبلاً به صورت آنی نشان داده شده، انیمیشن مجدد نزن
    if (r.seat === v.you) {
      const matchIdx = _recentSelfReactions.findIndex((m) => m.emoji === r.emoji);
      if (matchIdx >= 0) {
        _recentSelfReactions.splice(matchIdx, 1);
        continue;
      }
    }
    sounds.reaction();
    spawnFloatingEmoji(layer, r.seat, r.emoji, v.you);
  }
}

function spawnFloatingTaunt(seat, text, youSeat) {
  const layer = getOrCreateReactionsLayer();
  const bubble = el('div', { className: 'voice-taunt-bubble show' },
    el('span', { textContent: '🗣️ ' }),
    el('b', { textContent: text || '' }),
  );
  const pos = (seat != null ? getSeatPos(seat, youSeat) : null) || 'bottom';
  const seatEl = document.querySelector(`.seat-${pos}`);
  if (seatEl) {
    const rect = seatEl.getBoundingClientRect();
    bubble.style.position = 'fixed';
    bubble.style.left = `${rect.left + rect.width / 2}px`;
    bubble.style.top = `${Math.max(10, rect.top - 24)}px`;
  } else {
    bubble.style.position = 'fixed';
    bubble.style.left = '50%';
    bubble.style.top = '50%';
  }
  layer.append(bubble);
  setTimeout(() => {
    bubble.style.opacity = '0';
    bubble.style.transform = 'translateX(-50%) translateY(-15px) scale(0.85)';
    setTimeout(() => bubble.remove(), 300);
  }, 2800);
}

function spawnFloatingEmoji(layer, seat, emoji, youSeat) {
  if (!layer) layer = getOrCreateReactionsLayer();
  const item = el('div', { className: 'floating-emoji', textContent: emoji });

  const winW = window.innerWidth;
  const winH = window.innerHeight;
  const centerX = winW / 2;
  const centerY = winH / 2;

  // پیدا کردن مختصات آواتار بازیکن
  let cx = centerX;
  let cy = winH * 0.82;
  const pos = (seat != null ? getSeatPos(seat, youSeat) : null) || 'bottom';
  const seatEl = document.querySelector(`.seat-${pos}`);

  if (seatEl) {
    const rect = seatEl.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      cx = rect.left + rect.width / 2;
      cy = rect.top + rect.height / 2;
    }
  } else {
    if (pos === 'bottom') { cx = centerX; cy = winH * 0.82; }
    else if (pos === 'top') { cx = centerX; cy = winH * 0.16; }
    else if (pos === 'left') { cx = winW * 0.18; cy = centerY; }
    else if (pos === 'right') { cx = winW * 0.82; cy = centerY; }
  }

  // حرکت به سمت مرکز نمد
  const midX = cx + (centerX - cx) * 0.45 + (Math.random() - 0.5) * 30;
  const midY = cy + (centerY - cy) * 0.45 + (Math.random() - 0.5) * 30;

  // نقطه انتهایی شناور (حرکت آرام بیشتر به سمت مرکز نمد، بدون خروج از صفحه)
  const endX = midX + (centerX - midX) * 0.3;
  const endY = pos === 'top' ? (midY + 40) : (midY - 45);

  // کلمپ کردن تمام مختصات با حاشیه امن ۲۰ پیکسل از لبه‌ها
  const clampX = (val) => Math.max(16, Math.min(winW - 66, val - 25));
  const clampY = (val) => Math.max(16, Math.min(winH - 66, val - 25));

  const startX = clampX(cx);
  const startY = clampY(cy);
  const finalMidX = clampX(midX);
  const finalMidY = clampY(midY);
  const finalEndX = clampX(endX);
  const finalEndY = clampY(endY);
  const rot = (Math.random() - 0.5) * 30;

  item.style.setProperty('--startX', `${Math.round(startX)}px`);
  item.style.setProperty('--startY', `${Math.round(startY)}px`);
  item.style.setProperty('--midX', `${Math.round(finalMidX)}px`);
  item.style.setProperty('--midY', `${Math.round(finalMidY)}px`);
  item.style.setProperty('--endX', `${Math.round(finalEndX)}px`);
  item.style.setProperty('--endY', `${Math.round(finalEndY)}px`);
  item.style.setProperty('--rot', `${Math.round(rot)}deg`);

  layer.append(item);
  setTimeout(() => item.remove(), 2400);
}

// ─── امضای بخش‌های پایدارِ میز (توپ‌بار / HUD / صندلی‌ها) ─────────────────────
// ⚠ چرا: هر آپدیتِ سرور ۱۱۹ تا ۱۶۳ نود را از نو می‌ساخت (توپ‌بار ۴۵، سه صندلیِ حریف ۵۸،
// صندلیِ خودم ۹، board-hud ۷) — حتی برای یک پیامِ چت یا یک PONG. همهٔ این نودها داخلِ
// لایهٔ ۳بعدیِ `.felt`اند، پس هر بازساخت یعنی ری‌رسترِ کلِ میز روی GPUِ گوشی.
// همان الگوی `handStripSig`/`overlaySig`: تا امضا عوض نشود، نود دست‌نخورده می‌ماند.
// ⚠ هر فیلدی که این توابع می‌خوانند باید در امضا باشد، وگرنه HUD کهنه می‌ماند.
// مقادیرِ زندهٔ تایمر (turnStartTs/turnMs/ping numeric) عمداً نیستند: تیکِ ۲۰۰ms
// خودش عدد و رینگ را درجا به‌روز می‌کند و نوبتِ تازه با turnSeat در امضا دیده می‌شود.
function topbarSig(v) {
  const lvl = v.ping == null ? '' : (v.ping < 90 ? 3 : v.ping < 180 ? 2 : 1);
  return [
    v.phase, v.roomState, v.gameType, v.you, v.handNo, v.hokm, v.hakemSeat,
    v.bid, v.bid_type, v.contractorSeat, v.jokerMode ? 1 : 0, v.speedMode ? 1 : 0,
    (v.matchScore || []).join(','), (v.points || []).join(','), (v.tricksWon || []).join(','),
    (v.penaltyPoints || []).join(','), v.heartsBroken ? 1 : 0, v.targetScore || 100, v.hasQueenSpadesTaken ? 1 : 0,
    v.matchTarget, (v.occupants || []).length, v.watching,
    v.netGrade, lvl, muted ? 1 : 0, dmUnread.n,
  ].join('|');
}

function boardHudSig(v) {
  return [
    v.roomState, v.playerMode, v.you, v.observerMode ? 1 : 0,
    v.matchOver ? 1 : 0, v.matchCancelled ? 1 : 0,
    (v.names || []).join(' '), (v.bots || []).map((x) => (x ? 1 : 0)).join(''),
    v.cancelVoteCount || 0, (v.cancelVotes || []).join(','),
  ].join('|');
}

// امضای هویتِ صندلی (بازیکن، آواتار، نام، بوستر، تراز، قالب، صندلی، زاویه):
// این موارد در طولِ بازی به ندرت عوض می‌شوند. تا وقتی این امضا یکسان است،
// کلِ صندلی نابود نمی‌شود؛ فقط کلاس‌ها، رینگِ تایمر، تاج و بادبزنِ کارت‌ها درجا به‌روزرسانی می‌شوند.
// تعهدِ این دست برای چیپِ کنارِ آواتارِ متعهد: { state: pending|reached|burned, text } یا null.
// وضعیت از همان getHandStatus می‌آید (تنها منبعِ حقیقتِ «سوخت»)؛ فقط شلم.
function seatBidInfo(v, seat) {
  if (v.gameType === 'hokm' || v.contractorSeat == null || seat !== v.contractorSeat) return null;
  const cap = v.jokerMode ? 200 : 165;
  const special = (v.bid === 'kenz' || v.bid_type === 'kenz') ? 'کنز'
    : (v.bid === 'shelem' || v.bid_type === 'shelem') ? 'شلم' : '';
  const bid = special ? cap : (Number(v.bid) || 0);
  if (!bid) return null;
  const team = seat % 2;
  const pts = (v.points && v.points[team]) ?? 0;
  const state = /danger/.test(getHandStatus(v, team).status) ? 'burned' : (pts >= bid ? 'reached' : 'pending');
  return { state, text: special || faNum(bid) };
}

// چیپِ تعهد روی گوشهٔ آواتارِ متعهد (جایگزینِ چیپِ داخلِ نوارِ امتیاز). درجا همگام می‌شود.
function syncSeatBidChip(avWrap, v, seat) {
  const info = seatBidInfo(v, seat);
  let chip = avWrap.querySelector(':scope > .seat-bid-chip');
  if (!info) { chip?.remove(); return; }
  if (!chip) { chip = el('div', { className: 'seat-bid-chip', title: `تعهد: ${info.text}` }); avWrap.append(chip); }
  const cls = `seat-bid-chip ${info.state}`;
  if (chip.className !== cls) chip.className = cls;
  const html = info.text;
  if (chip.dataset.h !== html) { chip.dataset.h = html; chip.textContent = html; }
  chip.title = `تعهد: ${info.text}`;
}

// تاجِ حاکم: SVGِ مینیمالِ طلایی (نه ایموجی)؛ موقعیتش ثابت است و فقط جواهرها/هاله می‌درخشند (CSS).
const CROWN_SVG = '<svg viewBox="0 0 26 18" aria-hidden="true"><path class="cr-body" d="M2.5 15.5 1.2 5.2l6.1 4.6L13 2l5.7 7.8 6.1-4.6-1.3 10.3z"/><rect class="cr-band" x="2.5" y="15.5" width="21" height="2" rx="1"/><circle class="cr-gem g1" cx="1.6" cy="4.6" r="1.5"/><circle class="cr-gem g2" cx="13" cy="1.9" r="1.6"/><circle class="cr-gem g3" cx="24.4" cy="4.6" r="1.5"/></svg>';
function crownEl() {
  const c = el('div', { className: 'hakem-crown', title: 'حاکم' });
  c.innerHTML = CROWN_SVG;
  return c;
}

function seatIdentitySig(v, seat) {
  const pos = getSeatPos(seat, v.you, v.playerCount);
  const myTeam = seat % 2 === v.you % 2;
  const isBotSeat = Boolean(v.bots?.[seat] || (v.names?.[seat] && v.names[seat].startsWith('ربات')));
  const seatAvatarUrl = isBotSeat ? '' : ((v.avatarUrls || [])[seat] || (seat === v.you ? (myProfile?.avatar_url || '') : ''));
  const seatFrame = isBotSeat ? '' : ((v.avatarFrames || [])[seat] || (seat === v.you ? (myProfile?.avatar_frame || '') : ''));
  const playerTitle = (v.playerTitles || [])[seat] || (seat === v.you ? (myProfile?.player_title || '') : '');
  const playerBooster = (v.hasBoosters || [])[seat] || (seat === v.you ? (Boolean(myProfile?.active_booster) ? 1 : 0) : 0);
  const playerElo = (v.eloRatings || [])[seat] ?? '';
  const playerGames = (v.gamesPlayed || [])[seat] ?? '';
  const cardBack = getActiveCardBack(seat) || '';

  return [
    seat,
    v.you,
    pos,
    myTeam ? 1 : 0,
    v.gameType,
    (v.names || [])[seat] || '',
    seatAvatarUrl,
    seatFrame,
    playerTitle,
    playerBooster ? 1 : 0,
    playerElo,
    playerGames,
    isBotSeat ? 1 : 0,
    cardBack,
    window.innerWidth <= 560 ? 1 : 0,
    _dealDeal ? _dealDeal.t0 : '',
  ].join('|');
}

function seatSig(v, seat) {
  const rv = v.reveal;
  return [
    seat, v.you, getSeatPos(seat, v.you, v.playerCount), v.phase, v.gameType,
    // ⚠ فقط وضعیتِ **همین** صندلی. turnSeat/openSeats/lastWin/trick.length مشترکِ همهٔ
    // صندلی‌هاست؛ وقتی خام اینجا بودند هر آپدیت (= هر کارت) هر ۴ صندلی را با آواتار و
    // رینگ و تاج از نو می‌ساخت (۱۲۷ نود/آپدیت) و انیمیشنِ تاج با هر کارت از صفر می‌پرید.
    isActiveSeat(v, seat) ? 1 : 0, v.speedMode ? 1 : 0,
    // فقط برای صندلیِ دارای نوبت: TURNِ تازه برای **همان** صندلی (مثلاً بعد از بازاتصال)
    // باید رینگ و کلاسِ danger را از صفر بسازد، نه اینکه تا تیکِ بعدی کهنه بماند.
    isActiveSeat(v, seat) ? v.turnStartTs : '',
    rv ? `${(rv.shown || []).length}:${rv.shown?.[rv.shown.length - 1]?.seat ?? ''}:${rv.done ? 1 : 0}` : '',
    (v.names || [])[seat] || '', (v.avatarUrls || [])[seat] || '', v.bots?.[seat] ? 1 : 0,
    (v.handCounts || [])[seat] ?? '', (v.eloRatings || [])[seat] ?? '', (v.gamesPlayed || [])[seat] ?? '',
    v.hakemSeat, v.contractorSeat,
    (() => { const b = seatBidInfo(v, seat); return b ? `${b.state}:${b.text}` : ''; })(),
    v.lastWin === seat && (v.trick || []).length >= 4 ? 1 : 0,   // isTrickWinner در seatBox
    v.afkSeats?.includes(seat) ? 1 : 0, v.abandonedSeats?.includes(seat) ? 1 : 0,
    v.discSeats?.[seat] ?? '',
    contractorCelebratingSeat === seat ? 1 : 0,
    seat === v.you ? (myProfile?.avatar_url || '') : '',
    // قاب/لقب/بوستر هم در seatBox خوانده می‌شوند (قبلاً چون هر آپدیت همه‌چیز را از نو
    // می‌ساخت، نبودنشان در امضا دیده نمی‌شد)
    (v.avatarFrames || [])[seat] || '', (v.playerTitles || [])[seat] || '', (v.hasBoosters || [])[seat] ? 1 : 0,
    seat === v.you ? `${myProfile?.avatar_frame || ''}:${myProfile?.player_title || ''}:${myProfile?.active_booster ? 1 : 0}` : '',
    _dealDeal ? _dealDeal.t0 : '',          // تأخیرهای انیمیشنِ پخش روی کارت‌های بادبزن
    window.innerWidth <= 560 ? 1 : 0,       // اندازهٔ آواتار به عرضِ صفحه بسته است
  ].join('|');
}

// ─── نوار بالا ────────────────────────────────────────────────────────────────
const TB_SVG = {
  settings: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>',
  soundOn: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>',
  soundOff: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>',
  users: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><circle cx="9" cy="9" r="3.2"/><circle cx="17" cy="10" r="2.6"/><path d="M3 20c0-3 3-5 6-5s6 2 6 5"/></svg>',
  friends: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-12.2 7.5L3.5 20.5l1.6-4.9A8.4 8.4 0 1 1 21 11.5z"/></svg>',
  more: '<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="5" cy="12" r="1.9"/><circle cx="12" cy="12" r="1.9"/><circle cx="19" cy="12" r="1.9"/></svg>',
  leave: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>',
};

// مقدارهای آخرین ساختِ نوارِ امتیاز — تاپ‌بار با هر امضای تازه از نو ساخته می‌شود و ترنزیشنِ CSS
// هرگز اجرا نمی‌شد. نودِ تازه با مقدارِ قبلیِ «همان دست» ساخته و بعد از درج به مقدارِ جدید برده می‌شود.
// ⚠ باید سطحِ ماژول باشد: topbarScoreWidget داخلِ topbar() تعریف شده و متغیرِ محلی هر بار ریست می‌شد.
let _tbPrev = null;

// منوی «⋯» توپ‌بارِ موبایل: تنظیمات / حاضرین / دوستان. روی body است (توپ‌بار با هر امضای
// تازه بازساخته می‌شود)؛ آمارش را لحظهٔ باز شدن از lastView می‌خواند.
function toggleTbMenu(anchor) {
  const old = document.getElementById('tb-menu');
  if (old) { old._close(); return; }
  const v = lastView || {};
  const menu = el('div', { id: 'tb-menu', className: 'tb-menu' });
  const away = (e) => { if (!menu.contains(e.target) && !anchor.contains(e.target)) menu._close(); };
  menu._close = () => { menu.remove(); document.removeEventListener('pointerdown', away, true); };
  const row = (svg, label, fn, badge, neutral, danger) => {
    const b = el('button', { className: 'tb-menu-row' + (danger ? ' danger' : ''), onclick: () => { menu._close(); fn(); } });
    b.innerHTML = svg;
    b.append(el('span', { className: 'tb-menu-t', textContent: label }));
    if (badge) b.append(el('i', { className: 'tb-menu-b' + (neutral ? ' neutral' : ''), textContent: badge }));
    menu.append(b);
  };
  row(TB_SVG.settings, t('topbar.room_settings', null, 'تنظیمات میز و اتاق'), () => showRoomSettingsModal(lastView || v));
  row(TB_SVG.users, t('topbar.occupants', null, 'حاضرین اتاق'), () => { occupantsOpen = !occupantsOpen; occupantsUI.apply(); },
    faNum((v.occupants || []).length + (v.watching || 0)), true);
  row(TB_SVG.friends, t('topbar.friends_messages', null, 'دوستان و پیام‌ها'), () => friendsPanel.toggle(),
    dmUnread.n > 0 ? faNum(dmUnread.n > 99 ? '99+' : dmUnread.n) : '');
  row(TB_SVG.leave, t('topbar.leave_game', null, 'خروج از اتاق بازی'), () => leaveGame(), null, false, true);
  const r = anchor.getBoundingClientRect();
  menu.style.top = `${Math.round(r.bottom + 6)}px`;
  menu.style.right = `${Math.max(6, Math.round(innerWidth - r.right))}px`;
  document.body.append(menu);
  document.addEventListener('pointerdown', away, true);
}

function topbar(v) {
  const phaseFa = {
    WAITING: t('topbar.phase_waiting', null, 'در انتظار'),
    IDLE: t('topbar.phase_idle', null, 'آماده‌باش'),
    DEAL: t('topbar.phase_deal', null, 'پخشِ کارت'),
    DEALING: t('topbar.phase_deal', null, 'پخشِ کارت'),
    REVEAL: t('topbar.phase_reveal', null, 'تعیین حاکم'),
    DETERMINE_HAKEM: t('topbar.phase_reveal', null, 'تعیین حاکم'),
    BIDDING: t('topbar.phase_bidding', null, 'اعلام تعهد'),
    PASS_KOT: t('topbar.phase_choose_hokm', null, 'انتخاب حکم'),
    CHOOSE_HOKM: t('topbar.phase_choose_hokm', null, 'انتخاب حکم'),
    CHOOSING_HOKM: t('topbar.phase_choose_hokm', null, 'انتخاب حکم'),
    PLAYING_TURNS: t('topbar.phase_playing', null, 'بازی'),
    IN_HAND: t('topbar.phase_playing', null, 'بازی'),
    SCORE_CALC: t('topbar.phase_score_calc', null, 'پایان دست'),
    SCORING: t('topbar.phase_score_calc', null, 'پایان دست'),
    MATCH_OVER: t('topbar.phase_match_over', null, 'پایان مسابقه'),
  }[v.phase || v.roomState] || (v.roomState === 'WAITING' ? t('topbar.phase_waiting', null, 'در انتظار') : t('topbar.phase_playing', null, 'بازی'));
  const bar = el('div', { className: 'topbar' });
  const isShelem = v.gameType !== 'hokm';
  const youTeam = (v.you != null ? v.you : 0) % 2;
  const inGame = v.roomState !== 'WAITING';

  const iconBtn = (svg, title, onclick, badge) => {
    const b = el('button', { className: 'tb-ic', title, onclick });
    b.innerHTML = svg;
    if (badge != null && badge !== '' && badge !== '۰') b.append(el('i', { className: 'tb-ic-b', textContent: badge }));
    return b;
  };

  // ═══ سمت راست (RTL): خروج + تنظیمات + صدا + پینگ + دست/مرحله + مجموعِ امتیازِ مسابقه ═══
  const right = el('div', { className: 'tb-right' });
  const leaveBtn = iconBtn(TB_SVG.leave, t('topbar.leave_game', null, 'خروج از اتاق بازی'), () => leaveGame());
  leaveBtn.classList.add('tb-leave');
  const setBtn = iconBtn(TB_SVG.settings, t('topbar.room_settings', null, 'تنظیمات میز و اتاق'), () => showRoomSettingsModal(v));
  setBtn.classList.add('tb-settings');
  right.append(leaveBtn, setBtn);
  const sndBtn = iconBtn(
    muted ? TB_SVG.soundOff : TB_SVG.soundOn,
    muted ? t('topbar.sound_off_tip', null, 'صدای بازی: خاموش (کلیک برای روشن)') : t('topbar.sound_on_tip', null, 'صدای بازی: روشن (کلیک برای قطع)'),
    () => {
      toggleMute();
      toast(muted ? t('topbar.sound_muted_toast', null, 'صدای بازی خاموش شد 🔇') : t('topbar.sound_unmuted_toast', null, 'صدای بازی روشن شد 🔊'));
    }
  );
  if (muted) sndBtn.classList.add('muted');
  // زیرِ ۵۶۱px این دکمه با CSS پنهان می‌شود و جایش در شیتِ تنظیمات است — عرضِ
  // آزادشده به ویجتِ امتیازِ مرکزِ توپ‌بار می‌رسد.
  sndBtn.classList.add('tb-sound');
  right.append(sndBtn);
  // حاضرین/دوستان: زیرِ ۹۰۰px اینجا (ستونِ گفتگو نیست)، ۹۰۰px به بالا در هدرِ گفتگو (با CSS مخفی)
  const occBtn = iconBtn(TB_SVG.users, t('topbar.occupants', null, 'حاضرین اتاق'), () => { occupantsOpen = !occupantsOpen; occupantsUI.apply(); },
    faNum((v.occupants || []).length + (v.watching || 0)));
  occBtn.classList.add('tb-social');
  occBtn.querySelector('.tb-ic-b')?.classList.add('neutral');   // شمارندهٔ حاضرین خاکستری؛ رنگ فقط برای پیامِ نخوانده
  const frBtn = iconBtn(TB_SVG.friends, t('topbar.friends_messages', null, 'دوستان و پیام‌ها'), () => friendsPanel.toggle());
  frBtn.classList.add('tb-social');
  if (dmUnread.n > 0) frBtn.append(el('i', { className: 'tb-ic-b dm-badge', textContent: faNum(dmUnread.n > 99 ? '99+' : dmUnread.n) }));
  right.append(occBtn, frBtn);
  // ≤۵۶۰px: تنظیمات/حاضرین/دوستان با CSS پنهان‌اند و این یک دکمه جایشان را می‌گیرد (جای
  // نوارِ امتیاز آزاد می‌شود). نشانِ پیامِ نخوانده روی خودِ دکمه می‌آید.
  const moreBtn = iconBtn(TB_SVG.more, t('topbar.menu', null, 'منو'), () => toggleTbMenu(moreBtn));
  moreBtn.classList.add('tb-more');
  if (dmUnread.n > 0) moreBtn.append(el('i', { className: 'tb-ic-b dm-badge', textContent: faNum(dmUnread.n > 99 ? '99+' : dmUnread.n) }));
  right.append(moreBtn);
  if (!isShelem) {
    right.append(el('div', { className: 'tb-hp' }, t('topbar.hand_title', null, 'دست') + ' ', el('b', { textContent: fmtNum(v.handNo) }),
      el('span', { className: 'tb-hp-sep' }), phaseFa));
  }

// ─── ویجت یکپارچه امتیاز و خال حکم در مرکز تاپ‌بار (تفکیک دوگانه: نوار گرانشی در دسکتاپ + کپسول‌های تیمی در موبایل) ───
function topbarScoreWidget(v, youTeam, isShelem) {
  const oppTeam = 1 - youTeam;
  const youM = (v.matchScore && v.matchScore[youTeam]) ?? 0;
  const oppM = (v.matchScore && v.matchScore[oppTeam]) ?? 0;
  const gap = Math.abs(youM - oppM);
  const isYouLead = youM >= oppM;

  const youHandPts = isShelem
    ? ((v.points && v.points[youTeam]) ?? 0)
    : ((v.tricksWon && v.tricksWon[youTeam]) ?? 0);
  const oppHandPts = isShelem
    ? ((v.points && v.points[oppTeam]) ?? 0)
    : ((v.tricksWon && v.tricksWon[oppTeam]) ?? 0);

  // سقف امتیاز دست جاری: شلم ۱۶۵ (یا ۲۰۰ جوکر)؛ حکم ۷ دست
  const handMax = isShelem ? (v.jokerMode ? 200 : 165) : 7;
  const youPct = Math.min(100, Math.max(0, (youHandPts / handMax) * 100));
  const oppPct = Math.min(100, Math.max(0, (oppHandPts / handMax) * 100));

  // هدف کل مسابقه: شلم ۱۱۶۵ (جوکر ۱۶۰۰) یا هدف ست‌شده در اتاق؛ حکم ۷ دست
  const target = isShelem
    ? (v.matchTarget || (v.jokerMode ? 1600 : MATCH_GAP_TARGET))
    : 7;

  // تحلیل تعهد و پیمان دست
  let contractorTeam = null;
  let isContrYou = false;
  let isContrOpp = false;
  let isKenz = false;
  let isShelemBid = false;
  let bidVal = null;
  let bidLabel = '';
  let contrPts = 0;
  let defPts = 0;
  let burnThreshold = null;
  let kotThreshold = null;
  let isReached = false;
  let isBurned = false;
  let isKot = false;

  if (isShelem && v.bid && v.contractorSeat != null) {
    contractorTeam = v.contractorSeat % 2;
    isContrYou = (contractorTeam === youTeam);
    isContrOpp = (contractorTeam === oppTeam);
    isKenz = (v.bid === 'kenz' || v.bid_type === 'kenz');
    isShelemBid = (v.bid === 'shelem' || v.bid_type === 'shelem');
    bidVal = (isKenz || isShelemBid) ? handMax : (Number(v.bid) || 100);
    bidLabel = isKenz ? 'کنز' : (isShelemBid ? 'شلم' : faNum(bidVal));

    contrPts = (v.points && v.points[contractorTeam]) || 0;
    defPts = (v.points && v.points[1 - contractorTeam]) || 0;

    burnThreshold = Math.max(5, (handMax - bidVal) + 5);
    kotThreshold = v.jokerMode ? 105 : 85;

    isReached = contrPts >= bidVal;
    isBurned = !isKenz && !isShelemBid && defPts >= burnThreshold;
    isKot = !isKenz && defPts >= kotThreshold;
  } else if (v.highestBid) {
    bidLabel = faNum(v.highestBid);
  }

  // لحن و ریسک هاد
  let handTone = '';
  if (isShelem && v.bid && v.contractorSeat != null) {
    const st = getHandStatus(v, youTeam);
    handTone = /danger/.test(st.status) ? 'danger' : (st.status === 'warn-yellow' ? 'warn' : 'safe');
  }

  const hud = el('div', {
    className: 'tb-score-hud tbs-split-hud' + (handTone ? ` tone-${handTone}` : ''),
    title: `ریزِ امتیازات مسابقه و دست · اختلاف مسابقه: ${faNum(gap)} (${gap === 0 ? 'برابر' : isYouLead ? 'پیشتازی شما' : 'پیشتازی حریف'})`
      + ` · این دست: شما ${faNum(youHandPts)} - حریف ${faNum(oppHandPts)}`
      + (bidLabel ? ` · تعهد: ${bidLabel} (${isContrYou ? 'تیم شما' : 'تیم حریف'})` : ''),
    onclick: () => showScoreBreakdownModal(v, youTeam),
  });

  // ═══════════════════════════════════════════════════════════════════════
  // ۱) نسخه دسکتاپ: نوار گرانشی تقابلی مسابقه + ریل نئون‌گلس با نگین شناور حکم
  // ═══════════════════════════════════════════════════════════════════════
  const rtl = isRTL();
  const maxTravel = 36;
  const leadRatio = target > 0 ? Math.min(1, gap / target) : 0;
  const offset = leadRatio * maxTravel;
  const youSideSign = rtl ? +1 : -1;
  const gemTargetLeft = gap === 0 ? 50 : (isYouLead ? (50 + youSideSign * offset) : (50 - youSideSign * offset));

  const prev = (_tbPrev && _tbPrev.hand === v.handNo && _tbPrev.game === v.gameType
    && !document.hidden && !_reducedMotion()) ? _tbPrev : null;
  const fromLeft = prev && prev.gemLeft != null ? prev.gemLeft : gemTargetLeft;
  const fromYouPct = prev && prev.youHandPts != null ? Math.min(100, (prev.youHandPts / handMax) * 100) : youPct;
  const fromOppPct = prev && prev.oppHandPts != null ? Math.min(100, (prev.oppHandPts / handMax) * 100) : oppPct;
  const later = [];

  const deskColYou = el('div', {
    className: 'tbs-col you',
    title: `امتیاز کل مسابقه تیم شما: ${faNum(youM)}`,
  },
    el('b', { className: 'tbs-match-score you', textContent: faNum(youM) }),
  );

  const deskTrack = el('div', { className: 'tbs-track' });
  deskTrack.append(
    el('i', { className: 'tbs-tick q1', title: '۲۵٪' }),
    el('i', { className: 'tbs-center-mark', title: 'توازن ۵۰٪' }),
    el('i', { className: 'tbs-tick q3', title: '۷۵٪' }),
  );

  if (gap > 0 && offset > 0.5) {
    const beamSide = isYouLead ? 'you' : 'opp';
    const isBeamOnRight = rtl ? isYouLead : !isYouLead;
    const bLeft = isBeamOnRight ? 50 : (50 - offset);
    const bWidth = offset;
    const fromWidth = prev && prev.gemLeft != null ? Math.abs(prev.gemLeft - 50) : bWidth;
    const fromBLeft = prev && prev.gemLeft != null ? (isBeamOnRight ? 50 : (50 - fromWidth)) : bLeft;

    const beam = el('div', {
      className: `tbs-lead-beam ${beamSide}`,
      style: `left:${fromBLeft.toFixed(1)}%;width:${fromWidth.toFixed(1)}%`,
    });
    if (fromBLeft !== bLeft || fromWidth !== bWidth) {
      later.push(() => {
        beam.style.left = `${bLeft.toFixed(1)}%`;
        beam.style.width = `${bWidth.toFixed(1)}%`;
      });
    }
    deskTrack.append(beam);
  }

  const isRed = v.hokm ? RED.has(v.hokm) : false;
  const suitCls = v.hokm ? ` suit-${v.hokm} ${isRed ? 'red' : 'black'}` : ' none';
  const gem = el('div', {
    className: 'tbs-hokm-gem' + suitCls
      + (leadRatio >= 0.75 ? ' hot-lead' : ''),
    style: `left:${fromLeft.toFixed(1)}%`,
    title: v.hokm
      ? `خال حکم: ${suitFa(v.hokm)} · اختلاف مسابقه: ${faNum(gap)}`
      : 'خال حکم با اولین برگ حاکم مشخص می‌شود',
  });
  if (v.hokm && HOKM_SUIT_SVG[v.hokm]) {
    gem.innerHTML = HOKM_SUIT_SVG[v.hokm];
  } else {
    gem.append(el('span', { className: 'tbs-hokm-glyph', textContent: v.hokm ? SUIT_GLYPH[v.hokm] : '؟' }));
  }
  deskTrack.append(gem);

  if (fromLeft !== gemTargetLeft) {
    later.push(() => {
      gem.style.left = `${gemTargetLeft.toFixed(1)}%`;
    });
  }

  const deskColOpp = el('div', {
    className: 'tbs-col opp',
    title: `امتیاز کل مسابقه تیم حریف: ${faNum(oppM)}`,
  },
    el('b', { className: 'tbs-match-score opp', textContent: faNum(oppM) }),
  );

  const deskYouPill = el('span', {
    className: 'tbs-hand-pill you' + (youHandPts === 0 ? ' empty' : ''),
    textContent: youHandPts > 0 ? `+${faNum(youHandPts)}` : '۰',
    title: `امتیاز این دست شما: ${faNum(youHandPts)}`,
  });

  const deskOppPill = el('span', {
    className: 'tbs-hand-pill opp' + (oppHandPts === 0 ? ' empty' : ''),
    textContent: oppHandPts > 0 ? `+${faNum(oppHandPts)}` : '۰',
    title: `امتیاز این دست حریف: ${faNum(oppHandPts)}`,
  });

  const deskHandTrack = el('div', {
    className: 'tbs-hand-track',
    title: `پیشرفت امتیازات دست جاری (سقف: ${faNum(handMax)})`,
  });

  let bidPinEl = null;
  let burnPinEl = null;
  let kotPinEl = null;
  let deskYouStatus = '';
  let deskOppStatus = '';

  if (isShelem && v.bid && v.contractorSeat != null) {
    const bidPct = Math.min(100, Math.max(0, (bidVal / handMax) * 100));
    const contrRemain = Math.max(0, bidVal - contrPts);
    const bidTitle = isContrYou
      ? `هدف تعهد شما: ${faNum(bidVal)} (${contrRemain === 0 ? 'محقق شد ✓' : `${faNum(contrRemain)} مانده تا موفقیت`})`
      : `هدف تعهد حریف: ${faNum(bidVal)} (${contrRemain === 0 ? 'محقق شد ✓' : `${faNum(contrRemain)} مانده تا موفقیت`})`;

    const contrSide = isContrYou ? (rtl ? 'right' : 'left') : (rtl ? 'left' : 'right');
    const defSide = isContrYou ? (rtl ? 'left' : 'right') : (rtl ? 'right' : 'left');

    bidPinEl = el('i', {
      className: 'tbs-marker tbs-marker-bid' + (contrPts >= bidVal ? ' reached' : ''),
      style: `${contrSide}:${bidPct.toFixed(1)}%`,
      title: bidTitle,
    });

    if (burnThreshold <= handMax && !isKenz && !isShelemBid) {
      const burnPct = Math.min(100, Math.max(0, (burnThreshold / handMax) * 100));
      const defBurnRemain = Math.max(0, burnThreshold - defPts);
      const burnTitle = isContrYou
        ? `مرز سوختن تعهد شما: حریف با ${faNum(burnThreshold)} امتیاز تعهد شما را می‌سوزاند (${defBurnRemain === 0 ? 'تعهد سوخت ⚠️' : `${faNum(defBurnRemain)} امتیاز تا سوختن`})`
        : `مرز سوزاندن تعهد حریف: تیم شما با ${faNum(burnThreshold)} امتیاز تعهد حریف را می‌سوزاند (${defBurnRemain === 0 ? 'حریف سوخت ✓' : `${faNum(defBurnRemain)} امتیاز مانده تا شکست حریف`})`;

      burnPinEl = el('i', {
        className: 'tbs-marker tbs-marker-burn' + (defPts >= burnThreshold ? ' burned' : ''),
        style: `${defSide}:${burnPct.toFixed(1)}%`,
        title: burnTitle,
      });
    }

    if (kotThreshold <= handMax && !isKenz) {
      const kotPct = Math.min(100, Math.max(0, (kotThreshold / handMax) * 100));
      const defKotRemain = Math.max(0, kotThreshold - defPts);
      const kotTitle = isContrYou
        ? `مرز دبل شدن (کوت ۲×): حریف با رسیدن به ${faNum(kotThreshold)} امتیاز شما را کوت می‌کند (${defKotRemain === 0 ? 'کوت شدید 💥' : `${faNum(defKotRemain)} امتیاز تا کوت`})`
        : `مرز دبل کردن حریف (کوت ۲×): تیم شما با رسیدن به ${faNum(kotThreshold)} امتیاز حریف را کوت می‌کند (${defKotRemain === 0 ? 'کوت کردید 🎉' : `${faNum(defKotRemain)} امتیاز مانده تا دبل ۲×`})`;

      kotPinEl = el('i', {
        className: 'tbs-marker tbs-marker-kot' + (defPts >= kotThreshold ? ' kot' : ''),
        style: `${defSide}:${kotPct.toFixed(1)}%`,
        title: kotTitle,
      });
    }

    if (isContrYou) {
      if (contrPts >= bidVal) deskYouStatus = ' reached';
      else if (defPts >= burnThreshold) deskYouStatus = ' burned';
      if (defPts >= kotThreshold) deskOppStatus = ' kot-hero';
      else if (defPts >= burnThreshold) deskOppStatus = ' burn-hero';
    } else {
      if (contrPts >= bidVal) deskOppStatus = ' reached';
      else if (defPts >= burnThreshold) deskOppStatus = ' burned';
      if (defPts >= kotThreshold) deskYouStatus = ' kot-hero';
      else if (defPts >= burnThreshold) deskYouStatus = ' burn-hero';
    }
  }

  const deskYouFill = el('div', {
    className: 'tbs-hand-fill you' + deskYouStatus,
    style: `width:${fromYouPct.toFixed(1)}%`,
  });
  const deskOppFill = el('div', {
    className: 'tbs-hand-fill opp' + deskOppStatus,
    style: `width:${fromOppPct.toFixed(1)}%`,
  });
  if (fromYouPct !== youPct) {
    later.push(() => { deskYouFill.style.width = `${youPct.toFixed(1)}%`; });
  }
  if (fromOppPct !== oppPct) {
    later.push(() => { deskOppFill.style.width = `${oppPct.toFixed(1)}%`; });
  }
  deskHandTrack.append(deskYouFill, deskOppFill);
  if (bidPinEl) deskHandTrack.append(bidPinEl);
  if (burnPinEl) deskHandTrack.append(burnPinEl);
  if (kotPinEl) deskHandTrack.append(kotPinEl);

  const deskHandRow = el('div', { className: 'tbs-hand-row' },
    deskYouPill,
    deskHandTrack,
    deskOppPill,
  );

  const deskCenterWrap = el('div', { className: 'tbs-center-wrap' },
    deskTrack,
    deskHandRow,
  );

  const desktopView = el('div', { className: 'tbs-desktop-view' },
    deskColYou, deskCenterWrap, deskColOpp
  );

  // ═══════════════════════════════════════════════════════════════════════
  // ۲) نسخه موبایل: کپسول‌های تفکیک‌شده تیمی + مرکزیت تعهد و حکم (پیشنهاد ۱)
  // ═══════════════════════════════════════════════════════════════════════
  let youBadgeClass = 'tbs-team-badge you';
  if (isContrYou) {
    youBadgeClass += ' is-contractor';
    if (isReached) youBadgeClass += ' status-reached';
    else if (isBurned) youBadgeClass += ' status-burned';
  } else if (isContrOpp) {
    if (isKot) youBadgeClass += ' status-kot-hero';
    else if (isBurned) youBadgeClass += ' status-burn-hero';
  }

  const youBadge = el('div', {
    className: youBadgeClass,
    title: `تیم شما · مجموع مسابقه: ${faNum(youM)} · این دست: ${faNum(youHandPts)}` + (isContrYou ? ' (متعهد دست)' : ''),
  });

  const youScoreEl = el('b', { className: 'tbs-match-score you', textContent: faNum(youM) });
  const youHandPill = el('span', {
    className: 'tbs-hand-pill you' + (youHandPts === 0 ? ' empty' : ''),
    textContent: youHandPts > 0 ? `+${faNum(youHandPts)}` : '۰',
  });

  youBadge.append(youScoreEl, youHandPill);
  if (isContrYou) {
    const crownEl = el('i', { className: 'tbs-crown-icon', title: 'تیم شما متعهد این دست است' }, '👑');
    youBadge.append(crownEl);
  }

  const centerSuitCls = v.hokm ? ` suit-${v.hokm} ${isRed ? 'red' : 'black'}` : ' none';
  const centerBadge = el('div', {
    className: 'tbs-center-badge' + centerSuitCls + (isReached ? ' reached' : '') + (isBurned ? ' burned' : ''),
    title: v.hokm
      ? `خال حکم: ${suitFa(v.hokm)}${bidLabel ? ` · تعهد: ${bidLabel}` : ''}`
      : (bidLabel ? `تعهد: ${bidLabel}` : 'خال حکم با اولین برگ حاکم مشخص می‌شود'),
  });

  const hokmIconWrap = el('div', { className: 'tbs-center-hokm' });
  if (v.hokm && HOKM_SUIT_SVG[v.hokm]) {
    hokmIconWrap.innerHTML = HOKM_SUIT_SVG[v.hokm];
  } else {
    hokmIconWrap.append(el('span', { className: 'tbs-center-hokm-glyph', textContent: v.hokm ? SUIT_GLYPH[v.hokm] : (v.phase === 'BIDDING' ? '🤝' : '؟') }));
  }
  if (v.hokm) {
    hokmIconWrap.append(el('span', { className: 'tbs-center-hokm-name', textContent: suitName(v.hokm) }));
  }

  const bidValEl = el('div', {
    className: 'tbs-center-bid' + (!bidLabel ? ' dim' : ''),
    textContent: bidLabel || (v.phase === 'BIDDING' ? 'تعهد' : '—'),
  });

  centerBadge.append(hokmIconWrap, bidValEl);

  if (bidVal && contractorTeam != null) {
    const progTrack = el('div', { className: 'tbs-bid-prog-track' });
    const progPct = Math.min(100, Math.max(0, (contrPts / bidVal) * 100));
    const progFill = el('div', {
      className: `tbs-bid-prog-fill ${isContrYou ? 'you' : 'opp'}` + (isReached ? ' reached' : '') + (isBurned ? ' burned' : ''),
      style: `width:${progPct.toFixed(1)}%`,
    });
    progTrack.append(progFill);
    centerBadge.append(progTrack);
  }

  let oppBadgeClass = 'tbs-team-badge opp';
  if (isContrOpp) {
    oppBadgeClass += ' is-contractor';
    if (isReached) oppBadgeClass += ' status-reached';
    else if (isBurned) oppBadgeClass += ' status-burned';
  } else if (isContrYou) {
    if (isKot) oppBadgeClass += ' status-kot-hero';
    else if (isBurned) oppBadgeClass += ' status-burn-hero';
  }

  const oppBadge = el('div', {
    className: oppBadgeClass,
    title: `تیم حریف · مجموع مسابقه: ${faNum(oppM)} · این دست: ${faNum(oppHandPts)}` + (isContrOpp ? ' (متعهد دست)' : ''),
  });

  if (isContrOpp) {
    const crownEl = el('i', { className: 'tbs-crown-icon opp', title: 'تیم حریف متعهد این دست است' }, '👑');
    oppBadge.append(crownEl);
  }

  const oppHandPill = el('span', {
    className: 'tbs-hand-pill opp' + (oppHandPts === 0 ? ' empty' : ''),
    textContent: oppHandPts > 0 ? `+${faNum(oppHandPts)}` : '۰',
  });
  const oppScoreEl = el('b', { className: 'tbs-match-score opp', textContent: faNum(oppM) });

  oppBadge.append(oppHandPill, oppScoreEl);

  const mobileView = el('div', { className: 'tbs-mobile-view' },
    youBadge, centerBadge, oppBadge
  );

  hud.append(desktopView, mobileView);
  _tbPrev = { hand: v.handNo, game: v.gameType, gemLeft: gemTargetLeft, youM, oppM, isYouLead, youHandPts, oppHandPts, contrPts, bidVal };
  if (later.length) requestAnimationFrame(() => requestAnimationFrame(() => later.forEach((f) => f())));
  return hud;
}

// ─── ویجت اختصاصی امتیاز و خال حکم در بازی حکم (چمبرهای ۷ تایی گسسته + نشان حاکم + هشدار کوت) ───
function hokmTopbarScoreWidget(v, youTeam) {
  const oppTeam = 1 - youTeam;
  const youM = (v.matchScore && v.matchScore[youTeam]) ?? 0;
  const oppM = (v.matchScore && v.matchScore[oppTeam]) ?? 0;
  const matchTarget = v.matchTarget || 7;

  const youTricks = (v.tricksWon && v.tricksWon[youTeam]) ?? 0;
  const oppTricks = (v.tricksWon && v.tricksWon[oppTeam]) ?? 0;

  const isYouHakem = (v.hakemSeat != null) && ((v.hakemSeat % 2) === youTeam);
  const isOppHakem = (v.hakemSeat != null) && ((v.hakemSeat % 2) === oppTeam);
  const hakemName = (v.hakemSeat != null && v.names) ? (v.names[v.hakemSeat] || 'حاکم') : 'حاکم';

  // استیت‌های بحرانی کوت (۷-۰) و حاکم‌کوت (۷-۰ علیه حاکم)
  const isYouKotHunt = youTricks >= 5 && oppTricks === 0;
  const isOppKotHunt = oppTricks >= 5 && youTricks === 0;

  let tensionCls = '';
  let tensionTitle = '';
  if (isYouKotHunt) {
    tensionCls = isOppHakem ? ' hakem-kot-hunt' : ' kot-hunt';
    tensionTitle = isOppHakem
      ? ` 🔥 در آستانهٔ حاکم‌کوت! (${faNum(youTricks)}-۰) — ارزش: ۳ دست مسابقه`
      : ` ⚡ در آستانهٔ کوت! (${faNum(youTricks)}-۰) — ارزش: ۲ دست مسابقه`;
  } else if (isOppKotHunt) {
    tensionCls = isYouHakem ? ' hakem-kot-danger' : ' kot-danger';
    tensionTitle = isYouHakem
      ? ` ⚠️ خطر شدید حاکم‌کوت! (${faNum(oppTricks)}-۰) — نیاز به ۱ تریک برای نجات از باخت ۳ برگی`
      : ` ⚠️ خطر کوت! (${faNum(oppTricks)}-۰) — نیاز به ۱ تریک برای نجات از باخت ۲ برگی`;
  }

  const prev = (_tbPrev && _tbPrev.hand === v.handNo && _tbPrev.game === v.gameType
    && !document.hidden && !_reducedMotion()) ? _tbPrev : null;

  const hud = el('div', {
    className: 'tb-score-hud tb-hokm-hud' + tensionCls,
    title: `ریزِ امتیازات حکم · مسابقه: شما ${faNum(youM)} - حریف ${faNum(oppM)} (هدف: ${faNum(matchTarget)})`
      + ` · این دست: شما ${faNum(youTricks)} - حریف ${faNum(oppTricks)}`
      + (v.hakemSeat != null ? ` · حاکم: ${hakemName} (${isYouHakem ? 'تیم شما' : 'تیم حریف'})` : '')
      + tensionTitle,
    onclick: () => showScoreBreakdownModal(v, youTeam),
  });

  // چمبر شمارش ۷ تایی گسسته (Discrete 7-Pip Tally)
  const renderPips = (won, side) => {
    const chamber = el('div', { className: `hkm-pips-chamber ${side}` });
    for (let i = 1; i <= 7; i++) {
      const isWon = i <= won;
      const isWinningTrick = (i === 7);
      const isNew = prev && prev[side + 'Tricks'] != null && won > prev[side + 'Tricks'] && i === won;
      const pip = el('i', {
        className: 'hkm-pip' + (isWon ? ' active' : ' empty') + (isWinningTrick ? ' climax' : '') + (isNew ? ' pop-in' : ''),
        title: `تریک ${faNum(i)} از ۷ (${isWon ? 'کسب شده ✓' : (isWinningTrick ? 'دست پیروزی راند 🏆' : 'هنوز کسب نشده')})`,
      });
      chamber.append(pip);
    }
    return chamber;
  };

  // ── جناح راست (RTL): تیم شما ──
  const colYou = el('div', { className: 'hkm-side you' },
    el('div', { className: 'hkm-score-box you', title: `دست‌های مسابقه تیم شما: ${faNum(youM)} از ${faNum(matchTarget)}` },
      isYouHakem ? el('span', { className: 'hkm-crown you', title: `حاکم این دست: ${hakemName} (تیم شما)` }, '👑') : null,
      el('b', { className: 'tbs-match-score you', textContent: faNum(youM) }),
    ),
    renderPips(youTricks, 'you'),
  );

  // ── مرکز: نگین خال حکم ──
  const isRed = v.hokm ? RED.has(v.hokm) : false;
  const hkmSuitCls = v.hokm ? ` suit-${v.hokm} ${isRed ? 'red' : 'black'}` : ' none';
  const centerGem = el('div', {
    className: 'hkm-center-gem' + hkmSuitCls + (tensionCls ? ' pulsating' : ''),
    title: v.hokm
      ? `خال حکم: ${suitFa(v.hokm)}`
      : t('topbar.hokm_choosing', null, 'در انتظار تعیین خال حکم توسط حاکم'),
  });
  if (v.hokm && HOKM_SUIT_SVG[v.hokm]) {
    centerGem.innerHTML = HOKM_SUIT_SVG[v.hokm];
  } else {
    centerGem.append(el('span', { className: 'tbs-hokm-glyph', textContent: '؟' }));
  }
  if (v.hokm) {
    centerGem.append(el('span', { className: 'hkm-center-gem-name', textContent: suitName(v.hokm) }));
  }

  // ── جناح چپ (LTR): تیم حریف (رو به مرکز) ──
  const colOpp = el('div', { className: 'hkm-side opp' },
    el('div', { className: 'hkm-score-box opp', title: `دست‌های مسابقه تیم حریف: ${faNum(oppM)} از ${faNum(matchTarget)}` },
      isOppHakem ? el('span', { className: 'hkm-crown opp', title: `حاکم این دست: ${hakemName} (تیم حریف)` }, '👑') : null,
      el('b', { className: 'tbs-match-score opp', textContent: faNum(oppM) }),
    ),
    renderPips(oppTricks, 'opp'),
  );

  hud.append(colYou, centerGem, colOpp);
  _tbPrev = { hand: v.handNo, game: v.gameType, youM, oppM, youTricks, oppTricks };
  return hud;
}

// ─── ویجت اختصاصی ۴ نفره بی‌دل در مرکز تاپ‌بار (۴ ستون گیج خطر + وضعیت دل و بی‌بی پیک) ───
function bidelTopbarScoreWidget(v) {
  const target = v.targetScore || 100;
  const matchScore = v.matchScore || [0, 0, 0, 0];
  const penHand = v.penaltyPoints || [0, 0, 0, 0];
  const youSeat = v.you != null ? v.you : 0;
  const isFirstTrick = (v.trickIndex === 0 || (v.trickIndex == null && v.yourHand && v.yourHand.length === 13));

  let minScore = Infinity;
  let maxScore = -Infinity;
  for (let s = 0; s < 4; s++) {
    const sc = matchScore[s] ?? 0;
    if (sc < minScore) minScore = sc;
    if (sc > maxScore) maxScore = sc;
  }

  const isMatchCritical = (maxScore / target) >= 0.8;
  const criticalCls = isMatchCritical ? ' bidel-match-critical' : '';

  const hud = el('div', {
    className: 'tb-score-hud tb-bidel-hud' + criticalCls,
    title: `ریز امتیازات بی‌دل · سقف باخت: ${faNum(target)} · برای مشاهده جدول کلیک کنید`,
    onclick: () => showBidelScoreModal(v),
  });

  // چهار ستون بازیکنان (اول خود کاربر، سپس سایرین به ترتیب دور میز)
  const seatOrder = [youSeat, (youSeat + 1) % 4, (youSeat + 2) % 4, (youSeat + 3) % 4];
  const colsWrap = el('div', { className: 'bidel-cols-wrap' });

  seatOrder.forEach((seat) => {
    const isYou = (seat === youSeat);
    const rawName = isYou ? 'شما' : (v.names?.[seat] || `یار ${faNum(seat + 1)}`);
    const name = rawName.length > 6 ? rawName.slice(0, 5) + '…' : rawName;
    const fullName = isYou ? 'شما' : (v.names?.[seat] || `بازیکن ${faNum(seat + 1)}`);
    const totalPen = matchScore[seat] ?? 0;
    const handPen = penHand[seat] ?? 0;
    const pct = Math.min(100, Math.max(0, (totalPen / target) * 100));

    let tier = 'safe';
    if (pct >= 90) tier = 'fatal';
    else if (pct >= 70) tier = 'danger';
    else if (pct >= 35) tier = 'warn';

    const isLeader = (totalPen === minScore);
    const leaderBadge = isLeader ? ' 👑' : '';

    const col = el('div', {
      className: `bidel-seat-col ${tier}${isYou ? ' is-you' : ''}${isLeader ? ' is-leader' : ''}`,
      title: `${fullName}${leaderBadge} · مجموع جریمه: ${faNum(totalPen)} از ${faNum(target)} (${faNum(Math.round(pct))}٪)`
        + (handPen > 0 ? ` · این دست: +${faNum(handPen)}` : ''),
    });

    const nameEl = el('div', { className: 'bidel-col-header' },
      el('span', { className: 'bidel-col-name', textContent: name }),
      isLeader ? el('span', { className: 'bidel-col-crown', textContent: '👑' }) : null,
      handPen > 0 ? el('span', { className: 'bidel-col-hand-pen', textContent: `+${faNum(handPen)}` }) : null,
    );

    const scoreRow = el('div', { className: 'bidel-col-score-row' },
      el('b', { className: 'bidel-col-score', textContent: faNum(totalPen) }),
    );

    const meterWrap = el('div', { className: 'bidel-meter-wrap' },
      el('div', {
        className: `bidel-meter-fill ${tier}`,
        style: `width:${pct.toFixed(1)}%`,
      }),
    );

    col.append(nameEl, scoreRow, meterWrap);
    colsWrap.append(col);
  });

  // نگین مرکزی وضعیت بی‌دل
  const centerStatus = el('div', { className: 'bidel-center-badge' });

  let heartIcon = '💖';
  let heartTitle = 'دل‌ها بسته‌اند (لید با دل ممنوع)';
  let heartCls = 'hearts-locked';
  if (isFirstTrick) {
    heartIcon = '♣۲';
    heartTitle = 'دست اول: شروع با ۲ گشنیز · خون ممنوع';
    heartCls = 'hearts-trick0';
  } else if (v.heartsBroken) {
    heartIcon = '💔';
    heartTitle = 'دل شکسته شد! (خون جاری شد — لید دل مجاز است)';
    heartCls = 'hearts-broken';
  }

  const heartBadge = el('div', {
    className: `bidel-heart-indicator ${heartCls}`,
    title: heartTitle,
  },
    el('span', { className: 'bidel-heart-icon', textContent: heartIcon }),
  );

  const qSpadesTaken = !!v.hasQueenSpadesTaken;
  const qBadge = el('div', {
    className: `bidel-queen-indicator ${qSpadesTaken ? 'queen-taken' : 'queen-hunting'}`,
    title: qSpadesTaken ? 'بی‌بی پیک در این دست شکار شد (۱۳ جریمه)' : 'بی‌بی پیک (۱۳ جریمه) هنوز در دست بازیکنان است',
  },
    el('span', { className: 'bidel-queen-icon', textContent: qSpadesTaken ? '💀' : '♠Q' }),
  );

  centerStatus.append(heartBadge, qBadge);
  hud.append(colsWrap, centerStatus);
  return hud;
}

  // ═══ مرکز: ویجت امتیاز و حکم در حین بازی / لوگو در لابی ═══
  const center = el('div', { className: 'tb-center' });
  if (inGame) {
    if (v.gameType === 'chahar_barg' || v.gameType === 'bluff') {
      // ⚠ بلوف قبلاً به شاخهٔ else می‌افتاد و نوار امتیازِ *شلم* را می‌گرفت
      // (تیم شما/حریف، هدف ۱۱۶۵، matchScore که برای بلوف هرگز پر نمی‌شود ⇒ ۰—۰ ثابت).
      // شاخهٔ بلوفِ داخل scorePanel کد مرده بود.
      center.append(scorePanel(v));
    } else if (v.gameType === 'bidel') {
      center.append(bidelTopbarScoreWidget(v));
    } else if (v.gameType === 'hokm') {
      center.append(hokmTopbarScoreWidget(v, youTeam));
    } else {
      center.append(topbarScoreWidget(v, youTeam, isShelem));
    }
  } else {
    center.append(brandMark(true));
  }

  // ═══ سمت چپ (RTL): وضعیت سرعتی + سه خط اتصال پینگ + لوگو ═══
  const left = el('div', { className: 'tb-left' });
  // ≤۵۶۰px نگینِ حکم از داخلِ نوار به این چیپ می‌آید (CSS)؛ لمس = نامِ خال (title در موبایل نیست)
  if (inGame) {
    if (v.gameType === 'chahar_barg') {
      const dealInfo = `دست ${faNum(v.dealIndex != null ? v.dealIndex + 1 : 1)} از ${faNum(v.totalDeals || (v.playerCount === 2 ? 6 : 3))}`;
      left.append(el('button', {
        className: 'tb-hokm-chip black',
        title: dealInfo, textContent: '♣',
        onclick: () => toast(dealInfo),
      }));
    } else if (v.gameType === 'bidel') {
      const bidelMsg = v.heartsBroken ? 'دل شکسته شد (لید با دل آزاد است)' : 'دل‌ها بسته‌اند (لید دل ممنوع)';
      left.append(el('button', {
        className: 'tb-hokm-chip' + (v.heartsBroken ? ' red' : ' none'),
        title: bidelMsg, textContent: v.heartsBroken ? '💔' : '💖',
        onclick: () => toast(bidelMsg),
      }));
    } else {
      const hokmMsg = v.hokm ? t('topbar.hokm_suit', { suit: suitFa(v.hokm) }, `خال حکم: ${suitFa(v.hokm)}`) : t('topbar.hokm_unknown', null, 'خال حکم با اولین برگ حاکم مشخص می‌شود');
      const chipSuitCls = v.hokm ? ` suit-${v.hokm} ${RED.has(v.hokm) ? 'red' : 'black'}` : ' none';
      left.append(el('button', {
        className: 'tb-hokm-chip' + chipSuitCls,
        title: hokmMsg, textContent: v.hokm ? SUIT_GLYPH[v.hokm] : '؟',
        onclick: () => toast(hokmMsg),
      }));
    }
  }
  if (v.speedMode) {
    const speedMsg = t('topbar.speed_mode_msg', null, 'حالتِ سرعتی: پس از برگِ اول، همه هم‌زمان کارت می‌اندازند');
    left.append(el('span', { className: 'tb-speed', title: speedMsg, onclick: () => toast(speedMsg) }, '⚡'));
  }
  // نشانگر کیفیت اتصال و پینگ همیشه در سمت چپ تاپ‌بار فعال و در دسترس است
  const isOnline = Boolean(window.networkTable?.isConnected?.() || v.roomState || v.ping != null);
  const g = getNetGrade(v.netGrade || (isOnline ? 'good' : 'measuring'));
  const lvl = g ? g.bars : (v.ping != null ? (v.ping < 90 ? 3 : v.ping < 180 ? 2 : 1) : 3);
  const bad = g ? (v.netGrade === 'poor' || g.cls === 'poor') : (v.ping != null && v.ping >= 180);
  const isFair = g?.cls === 'fair' || (v.ping != null && v.ping >= 90 && v.ping < 180);
  const pingText = v.ping != null ? `پینگ: ${faNum(v.ping)}ms` : (g ? g.label : 'اتصال پایدار');
  const pingMsg = t('topbar.ping_ms', { ping: faNum(v.ping || 0) }, pingText) + (g && v.ping != null ? ` — ${g.label}` : '');
  const pingCls = 'tb-ping' + (bad ? ' bad' : (isFair ? ' fair' : ' good'));
  const ping = el('span', { className: pingCls, title: pingMsg, onclick: () => toast(pingMsg) });
  ping.innerHTML = `<span class="tb-sig"><i class="${lvl >= 1 ? 'on' : ''}"></i><i class="${lvl >= 2 ? 'on' : ''}"></i><i class="${lvl >= 3 ? 'on' : ''}"></i></span>`;
  left.append(ping);

  if (inGame) {
    const target = v.gameType === 'chahar_barg'
      ? (v.matchTarget || 62)
      : (v.gameType === 'bidel'
        ? (v.targetScore || 100)
        : (isShelem ? (v.matchTarget || (v.jokerMode ? 1600 : MATCH_GAP_TARGET)) : 7));
    const goalTitle = v.gameType === 'chahar_barg'
      ? `هدف برد مسابقه: ${faNum(target)} امتیاز`
      : (v.gameType === 'bidel'
        ? `سقف امتیاز جریمه مسابقه: ${faNum(target)}`
        : (isShelem ? `امتیازِ هدف مسابقه: ${faNum(target)}` : `هدف مسابقه: ${faNum(target)} دست`));
    left.append(el('button', {
      className: 'tb-goal-pill',
      title: goalTitle,
      onclick: () => toast(goalTitle),
    }, faNum(target)));
    left.append(el('div', { className: 'tb-mini-brand', title: GAME_FA[v.gameType] || 'بازی' }, brandMark(true)));
  }

  bar.append(right, center, left);
  return bar;
}

// ─── HUDِ گوشه‌های میز: دکمه درخواست لغو در گوشه سمت راست میز ───
function boardHud(v) {
  const inGame = v.roomState !== 'WAITING';
  const hud = el('div', { className: 'board-hud' });
  const is4P = v.playerMode === 'PVP_4' || (v.names && v.names.filter(Boolean).length === 4 && (!v.bots || v.bots.filter(Boolean).length === 0));
  if (is4P && inGame && !v.matchOver && !v.matchCancelled && !v.observerMode) {
    const voteCount = v.cancelVoteCount || (v.cancelVotes ? v.cancelVotes.length : 0);
    const hasVoted = v.cancelVotes && v.you != null && v.cancelVotes.includes(v.you);
    const cancelBtn = el('button', {
      className: 'hud-cancel' + (hasVoted ? ' voted' : ''),
      title: hasVoted ? t('cancel.voted_tip', null, 'شما با لغو موافقت کرده‌اید (کلیک برای پس گرفتن رأی)') : t('cancel.vote_tip', null, 'درخواست لغو بازی (نیاز به ۳ موافقت)'),
      onclick: () => (hasVoted ? table.voteCancel?.(true) : table.voteCancel?.(false)),
    },
      el('span', { className: 'tb-cancel-lights' },
        el('i', { className: voteCount >= 1 ? 'on' : '' }),
        el('i', { className: voteCount >= 2 ? 'on' : '' }),
        el('i', { className: voteCount >= 3 ? 'on' : '' }),
      ),
    );
    hud.append(cancelBtn);
  }
  return hud;
}

// ─── محاسبه وضعیت و خطر امتیاز دست (سلامت/خطر تعهد شلم) ─────────────────────
function getHandStatus(v, teamIndex) {
  if (v.gameType !== 'shelem' || !v.bid || v.contractorSeat == null) {
    return { status: 'normal', badge: '', tooltip: '' };
  }
  const maxScore = v.jokerMode ? 200 : 165;
  const kotThresh = v.jokerMode ? 100 : 85;
  const oppKotThreshold = maxScore - kotThresh;
  const contractorTeam = v.contractorSeat % 2;
  const isContractor = teamIndex === contractorTeam;
  const isKenz = v.bid === 'kenz' || v.bid_type === 'kenz';
  const isShelemBid = v.bid === 'shelem' || v.bid_type === 'shelem';
  const bid = (isKenz || isShelemBid) ? maxScore : (Number(v.bid) || 100);
  const contractorPts = (v.points && v.points[contractorTeam]) || 0;
  const opponentPts = (v.points && v.points[1 - contractorTeam]) || 0;
  const maxPossibleContractor = maxScore - opponentPts;

  if (isKenz) {
    if (isContractor) {
      if (opponentPts > 0) {
        return {
          status: 'danger-red',
          badge: 'کنز سوخت 💥',
          tooltip: 'تعهد کنز سوخت! حریف امتیاز گرفت و کل مسابقه را برنده شد.',
        };
      }
      if (contractorPts >= maxScore) {
        return {
          status: 'safe-green',
          badge: 'کنز محقق شد ⚡',
          tooltip: 'تعهد کنز با موفقیت محقق شد! کل مسابقه را بردید.',
        };
      }
      return {
        status: 'warn-yellow',
        badge: 'کنز ⚡',
        tooltip: 'قرارداد کنز (مرگ ناگهانی): باید ۱۰۰٪ تریک‌ها را بدون واگذاری حتی ۱ امتیاز ببرید.',
      };
    } else {
      if (opponentPts > 0) {
        return {
          status: 'safe-green',
          badge: 'برد مسابقه 🏆',
          tooltip: 'کنز حریف شکست خورد! تیم شما کل مسابقه را برنده شد.',
        };
      }
      return {
        status: 'danger-orange',
        badge: 'دفاع کنز 🛡️',
        tooltip: 'قرارداد کنز حریف: با گرفتن حتی ۱ تریک یا امتیاز، کل مسابقه را بلافاصله می‌برید!',
      };
    }
  }

  if (isShelemBid) {
    if (isContractor) {
      if (opponentPts > 0) {
        return {
          status: 'danger-red',
          badge: 'شلم سوخت ⚠️',
          tooltip: `تعهد شلم سوخت! حریف ${faNum(opponentPts)} گرفت (جریمه منفی ۲ برابر).`,
        };
      }
      if (contractorPts >= maxScore) {
        return {
          status: 'safe-green',
          badge: 'شلم محقق شد 🎉',
          tooltip: `قرارداد شلم با موفقیت محقق شد! تمام ${faNum(maxScore)} امتیاز را گرفتید.`,
        };
      }
      return {
        status: 'warn-yellow',
        badge: 'شلم 🔥',
        tooltip: `قرارداد شلم: باید تمام ${faNum(maxScore)} امتیاز بازی را ببرید.`,
      };
    } else {
      if (opponentPts > 0) {
        return {
          status: 'safe-green',
          badge: 'شلم حریف سوخت ✓',
          tooltip: 'تعهد شلم حریف سوزانده شد و جریمه دوبل منفی می‌خورد!',
        };
      }
      return {
        status: 'normal',
        badge: 'دفاع شلم 🛡️',
        tooltip: 'تلاش برای گرفتن حداقل ۱ امتیاز و سوزاندن شلم حریف',
      };
    }
  }

  if (isContractor) {
    // ۰. شلم حریف (گرفتن تمام امتیازات توسط حریف)
    if (opponentPts >= maxScore) {
      return {
        status: 'danger-red',
        badge: 'شلم حریف 💥',
        tooltip: `شلم شدید! حریف تمام ${faNum(maxScore)} امتیاز را گرفت (جریمه منفی ۲ برابر).`,
      };
    }
    // شلم تیم خودی (کسب تمام امتیازات توسط متعهد)
    if (contractorPts >= maxScore) {
      return {
        status: 'safe-green',
        badge: 'شلم! 🎉',
        tooltip: `شلم کردید! تمام ${faNum(maxScore)} امتیاز را بردید (امتیاز ۲ برابر).`,
      };
    }
    // ۱. قرمز: کوت قطعی (حریف بیش از حد نصاب امتیاز گرفته -> سقف امتیاز زیر حد نصاب -> جریمه ۲ برابر منفی)
    if (opponentPts > oppKotThreshold) {
      return {
        status: 'danger-red',
        badge: 'کوت ۲× 💥',
        tooltip: `کوت قطعی! حریف ${faNum(opponentPts)} گرفت؛ سقف تیم شما ${faNum(maxPossibleContractor)} (زیر ${faNum(kotThresh)}) شد.`,
      };
    }
    // ۲. نارنجی: تعهد سوخت / خوردن
    if (maxPossibleContractor < bid) {
      return {
        status: 'danger-orange',
        badge: 'سوخت ⚠️',
        tooltip: `تعهد سوخت! رسیدن به ${faNum(bid)} ناممکن شد. برای نجات از کوت به ${faNum(kotThresh)} نیاز است.`,
      };
    }
    // ۳. اگر تعهد در همین دست محقق شده (سبز درخشان)
    if (contractorPts >= bid) {
      return {
        status: 'safe-green',
        badge: 'تعهد ✓',
        tooltip: `تعهد ${faNum(bid)} با موفقیت محقق شد!`,
      };
    }
    // ۴. زرد: در مرز خطر
    const allowance = maxScore - bid;
    if (opponentPts >= allowance * 0.5 && opponentPts > 0) {
      return {
        status: 'warn-yellow',
        badge: 'هشدار ⚡',
        tooltip: `حریف ${faNum(opponentPts)} از ${faNum(allowance)} امتیاز مجاز را گرفته.`,
      };
    }
    // ۵. سبز: اوضاع عالی و امن
    return {
      status: 'safe-green',
      badge: 'امن 🌱',
      tooltip: `تعهد ${faNum(bid)} — امتیاز کسب‌شده: ${faNum(contractorPts)}`,
    };
  } else {
    // تیم مدافع (رقیب متعهد)
    if (contractorPts >= maxScore) {
      return {
        status: 'danger-red',
        badge: 'شلم شدید 💥',
        tooltip: `شلم شدید! حریف تمام ${faNum(maxScore)} امتیاز را گرفت.`,
      };
    }
    if (opponentPts >= maxScore) {
      return {
        status: 'safe-green',
        badge: 'شلم! 🎉',
        tooltip: `شلم کردید! تمام ${faNum(maxScore)} امتیاز را بردید (جریمه منفی ۲ برابر برای حریف).`,
      };
    }
    if (opponentPts > oppKotThreshold) {
      return {
        status: 'safe-green',
        badge: 'کوت! 🎉',
        tooltip: `حریف کوت شد و جریمه منفی ۲ برابر می‌خورد!`,
      };
    }
    if (maxPossibleContractor < bid) {
      return {
        status: 'safe-green',
        badge: 'شکست ✓',
        tooltip: `تعهد حریف با موفقیت سوزانده شد!`,
      };
    }
    const allowance = maxScore - bid;
    if (opponentPts >= allowance * 0.5 && opponentPts > 0) {
      return {
        status: 'warn-yellow',
        badge: 'در مرز',
        tooltip: `${faNum(allowance - opponentPts + 5)} امتیاز دیگر تا سوزاندن تعهد حریف`,
      };
    }
    return {
      status: 'normal',
      badge: 'مدافع 🛡️',
      tooltip: `تلاش برای کسب ${faNum(allowance + 5)} امتیاز جهت شکست تعهد`,
    };
  }
}

// پایانِ مسابقه وقتی «اختلافِ» امتیازِ دو تیم ≥ این عدد شود، یا امتیازِ یک تیم
// ≥ این عدد شود. مقدارِ پیش‌فرض ۱۲۰۰ است (در بازی با جوکر ۱۶۰۰) ولی سازندهٔ اتاق
// می‌تواند سقفِ سفارشی تعیین کند. هم‌گام با Room.MATCH_TARGET.
const MATCH_GAP_TARGET = 1200;

// ─── نوارِ امتیازِ یکپارچه (زیرِ نوارِ بالا) ───────────────────────────────────
// یک نوار تکی با دو لایهٔ نمودار روی هم:
//   لایهٔ پایه (مسابقه): نوار واگرای دوطرفه از وسط — اختلاف کل مسابقه.
//   لایهٔ رو  (دست):    پیشرفت دست جاری (تعهد/تریک) با رنگ متمایز.
// RTL: «تیمِ شما» سمتِ راست، حریف سمتِ چپ — ثابت.
function scorePanel(v) {
  if (v.gameType === 'chahar_barg') {
    return renderChaharBargScorePanel(v, { el, faNum, showBreakdownModal: showScoreBreakdownModal });
  }
  if (v.gameType === 'bluff') {
    // میزبان کش می‌شود: با ساختِ دوبارهٔ آن در هر رندر (و هر پیامِ چت/حضور یک رندر
    // است) transition نوار پیشرفت هرگز اجرا نمی‌شد و انیمیشن dangerPulse از صفر
    // ری‌استارت می‌کرد ⇒ پرشِ قرمز.
    if (!_cachedBluffSp) _cachedBluffSp = el('div', { className: 'sp bluff-sp-host' });
    renderBluffScoreBar(v, _cachedBluffSp, { el, faNum });
    return _cachedBluffSp;
  }
  const youTeam = (v.you != null ? v.you : 0) % 2;
  const oppTeam = 1 - youTeam;
  const isShelem = v.gameType !== 'hokm';
  const youMatch = (v.matchScore && v.matchScore[youTeam]) ?? 0;
  const oppMatch = (v.matchScore && v.matchScore[oppTeam]) ?? 0;

  // ── محاسبات نوار مسابقه ──
  const matchGap = Math.abs(youMatch - oppMatch);
  const leadYou  = youMatch >= oppMatch;
  const matchTarget = v.matchTarget || (v.jokerMode ? 1600 : MATCH_GAP_TARGET);
  const matchProg = Math.max(matchGap, youMatch, oppMatch);
  const matchFill = isShelem
    ? Math.min(50, (matchProg / matchTarget) * 50)
    : Math.min(50, (matchProg / 7) * 50);
  const matchNearTarget = matchFill >= 40;

  // ── محاسبات نوار دست ──
  let handPct = 0, handTone = '', handHint = '', handPctOpp = 0;
  if (isShelem && v.bid && v.contractorSeat != null) {
    const isContractor = v.contractorSeat % 2 === youTeam;
    const st = getHandStatus(v, youTeam).status || '';
    handTone = /danger/.test(st) ? 'danger' : (st === 'warn-yellow' ? 'warn' : (st === 'safe-green' ? 'ok' : ''));
    const youPts  = (v.points && v.points[youTeam])  ?? 0;
    const oppPts  = (v.points && v.points[oppTeam])  ?? 0;
    const maxHandScore = v.jokerMode ? 200 : 165;
    const isKenz = v.bid === 'kenz' || v.bid_type === 'kenz';
    const isShelemBid = v.bid === 'shelem' || v.bid_type === 'shelem';
    const bidTarget = (isKenz || isShelemBid) ? maxHandScore : (Number(v.bid) || 100);
    const youNeed = isContractor ? bidTarget : (isKenz ? 1 : Math.max(5, maxHandScore - bidTarget + 5));
    const oppNeed = isContractor ? (isKenz ? 1 : Math.max(5, maxHandScore - bidTarget + 5)) : bidTarget;
    handPct     = Math.min(100, (youPts  / youNeed) * 100);
    handPctOpp  = Math.min(100, (oppPts  / oppNeed) * 100);
    const roleLabel = isContractor ? 'متعهد' : 'مدافع';
    const bidLabel = isKenz ? 'کنز ⚡' : (isShelemBid ? 'شلم 🔥' : faNum(v.bid));
    handHint = `${bidLabel} · ${roleLabel} · ${faNum(youPts)}/${faNum(youNeed)}`;
  } else if (!isShelem) {
    const tricks    = (v.tricksWon && v.tricksWon[youTeam])  ?? 0;
    const tricksOpp = (v.tricksWon && v.tricksWon[oppTeam]) ?? 0;
    handPct    = Math.min(100, (tricks    / 7) * 100);
    handPctOpp = Math.min(100, (tricksOpp / 7) * 100);
    handHint   = `${faNum(tricks)} / ۷ تریک`;
  }

  // ── ساخت پنل ──
  const panel = el('div', {
    className: 'score-panel sp2-panel',
    title: 'ریزِ امتیازات',
    onclick: () => showScoreBreakdownModal(v, youTeam),
  });


  // ── امتیاز دست این راند ──
  const youHandPts = isShelem
    ? ((v.points && v.points[youTeam]) ?? 0)
    : ((v.tricksWon && v.tricksWon[youTeam]) ?? 0);
  const oppHandPts = isShelem
    ? ((v.points && v.points[oppTeam]) ?? 0)
    : ((v.tricksWon && v.tricksWon[oppTeam]) ?? 0);

  // ── ستون سمت راست: تیم شما (در RTL فرزند اول، سمت راست رندر می‌شود) ──
  const sideYou = el('div', { className: 'sp2-side sp2-you' },
    el('span', { className: 'sp2-label', textContent: 'شما' }),
    el('b',    { className: 'sp2-match', textContent: faNum(youMatch) }),
    youHandPts > 0
      ? el('span', { className: 'sp2-hand-pts', textContent: `+${faNum(youHandPts)}` })
      : el('span', { className: 'sp2-hand-pts empty', textContent: '۰' }),
  );

  // ── مرکز: خال حکم + نوار دوسطحی یکپارچه + راهنما ──
  const sp2SuitCls = v.hokm ? ` suit-${v.hokm} ` + (RED.has(v.hokm) ? 'red' : 'black') : '';
  const hokmEl = v.hokm
    ? el('div', {
        className: 'sp2-hokm' + sp2SuitCls,
        textContent: SUIT_GLYPH[v.hokm],
        title: `خال حکم: ${suitFa(v.hokm)}`,
      })
    : el('div', { className: 'sp2-hokm dim', textContent: '؟', title: 'حکم با اولین برگ مشخص می‌شود' });

  // ردیف ۱: نوار پیشرفت دست جاری
  const trackHand = el('div', { className: 'sp2-track sp2-track-hand' });
  if (isShelem) {
    const youPct = Math.min(100, (youHandPts / 165) * 100);
    const oppPct = Math.min(100, (oppHandPts / 165) * 100);
    if (youPct > 0) {
      trackHand.append(el('i', {
        className: 'sp2-fill-hand-you' + (handTone ? ` ${handTone}` : ''),
        style: `width:${youPct.toFixed(1)}%`,
      }));
    }
    if (oppPct > 0) {
      trackHand.append(el('i', {
        className: 'sp2-fill-hand-opp',
        style: `width:${oppPct.toFixed(1)}%`,
      }));
    }
    if (v.bid) {
      const isContractorYou = (v.contractorSeat != null && (v.contractorSeat % 2 === youTeam));
      const isKenz = v.bid === 'kenz' || v.bid_type === 'kenz';
      const isShelemBid = v.bid === 'shelem' || v.bid_type === 'shelem';
      const maxSc = v.jokerMode ? 200 : 165;
      const numBid = (isKenz || isShelemBid) ? maxSc : (Number(v.bid) || 0);
      const bidPosPct = Math.min(100, (numBid / maxSc) * 100);
      const bidLabel = isKenz ? 'کنز ⚡' : (isShelemBid ? 'شلم 🔥' : faNum(v.bid));
      const markerStyle = isContractorYou
        ? `right:${bidPosPct.toFixed(1)}%`
        : `left:${bidPosPct.toFixed(1)}%`;
      trackHand.append(el('span', {
        className: 'sp2-bid-marker',
        style: markerStyle,
        title: `نقطه تعهد: ${bidLabel}`,
      }));
    }
  } else {
    const youTricksPct = Math.min(50, (youHandPts / 7) * 50);
    const oppTricksPct = Math.min(50, (oppHandPts / 7) * 50);
    if (youTricksPct > 0) {
      trackHand.append(el('i', { className: 'sp2-fill-hand-you ok', style: `width:${youTricksPct.toFixed(1)}%` }));
    }
    if (oppTricksPct > 0) {
      trackHand.append(el('i', { className: 'sp2-fill-hand-opp', style: `width:${oppTricksPct.toFixed(1)}%` }));
    }
    trackHand.append(el('span', { className: 'sp2-mid-line' }));
  }

  // ردیف ۲: نوار موازنه کل مسابقه
  const trackMatch = el('div', {
    className: 'sp2-track sp2-track-match' + (matchNearTarget ? ' near-target' : ''),
  },
    el('span', { className: 'sp2-mid-line' }),
    matchGap > 0
      ? el('i', {
          className: leadYou ? 'sp2-fill-match lead-you' : 'sp2-fill-match lead-opp',
          style: `width:${matchFill.toFixed(1)}%`,
        })
      : null,
  );

  const meterBox = el('div', { className: 'sp2-meter-box' },
    trackHand,
    trackMatch,
  );

  const hintEl = handHint
    ? el('div', { className: 'sp2-hint' },
        el('span', { textContent: handHint }),
        el('span', { className: 'sp2-hint-sep', textContent: ' · ' }),
        el('span', { textContent: `اختلاف مسابقه: ${faNum(matchGap)}` }),
      )
    : el('div', { className: 'sp2-hint dim', textContent: `اختلاف مسابقه: ${faNum(matchGap)}` });

  const center = el('div', { className: 'sp2-center' },
    hokmEl,
    el('div', { className: 'sp2-center-body' },
      meterBox,
      hintEl,
    ),
  );

  // ── ستون سمت چپ: تیم حریف (در RTL فرزند سوم، سمت چپ رندر می‌شود) ──
  const sideOpp = el('div', { className: 'sp2-side sp2-opp' },
    el('span', { className: 'sp2-label', textContent: 'حریف' }),
    el('b',    { className: 'sp2-match', textContent: faNum(oppMatch) }),
    oppHandPts > 0
      ? el('span', { className: 'sp2-hand-pts', textContent: `+${faNum(oppHandPts)}` })
      : el('span', { className: 'sp2-hand-pts empty', textContent: '۰' }),
  );

  panel.append(sideYou, center, sideOpp);
  return panel;
}

// ─── مودال / شیت ریزامتیازات مسابقه بی‌دل (۴ نفره انفرادی) ──────────
function showBidelScoreModal(v) {
  const existing = document.getElementById('bidel-score-overlay');
  if (existing) existing.remove();

  const target = v.targetScore || 100;
  const matchScore = v.matchScore || [0, 0, 0, 0];
  const penHand = v.penaltyPoints || [0, 0, 0, 0];
  const youSeat = v.you != null ? v.you : 0;

  const overlay = el('div', {
    id: 'bidel-score-overlay',
    className: 'score-breakdown-overlay',
    onclick: (e) => {
      if (e.target === overlay) closeOverlayWithFade(overlay);
    },
  });

  const modal = el('div', { className: 'score-breakdown-modal bidel-score-modal' });

  // سربرگ
  const head = el('div', { className: 'sbm-head' },
    el('div', { className: 'sbm-title' },
      el('span', { className: 'sbm-icon', textContent: '💔' }),
      el('h3', { textContent: `جدول امتیازات بی‌دل — سقف باخت: ${faNum(target)}` }),
    ),
    el('button', { className: 'occ-close', textContent: '✕', onclick: () => closeOverlayWithFade(overlay) }),
  );

  const body = el('div', { className: 'sbm-body' });

  // جدول ۴ نفره
  const table = el('div', { className: 'bidel-modal-table' });
  const rows = [0, 1, 2, 3].map((seat) => {
    const isYou = (seat === youSeat);
    const name = isYou ? 'شما' : (v.names?.[seat] || `بازیکن ${faNum(seat + 1)}`);
    const totalPen = matchScore[seat] ?? 0;
    const handPen = penHand[seat] ?? 0;
    const pct = Math.min(100, Math.max(0, (totalPen / target) * 100));
    const dist = Math.max(0, target - totalPen);

    let tier = 'safe';
    if (pct >= 90) tier = 'fatal';
    else if (pct >= 70) tier = 'danger';
    else if (pct >= 35) tier = 'warn';

    return el('div', { className: `bidel-modal-row ${tier}${isYou ? ' is-you' : ''}` },
      el('div', { className: 'bidel-mr-player' },
        el('span', { className: 'bidel-mr-icon' }, isYou ? '👤' : (v.bots?.[seat] ? '🤖' : '🎮')),
        el('b', { className: 'bidel-mr-name', textContent: name }),
        isYou ? el('span', { className: 'bidel-mr-tag', textContent: 'شما' }) : null,
      ),
      el('div', { className: 'bidel-mr-stat' },
        el('span', { className: 'bidel-mr-lbl', textContent: 'این دست' }),
        el('b', { className: 'bidel-mr-val' + (handPen > 0 ? ' has-pen' : ''), textContent: handPen > 0 ? `+${faNum(handPen)}` : '۰' }),
      ),
      el('div', { className: 'bidel-mr-stat' },
        el('span', { className: 'bidel-mr-lbl', textContent: 'مجموع جریمه' }),
        el('b', { className: 'bidel-mr-val total', textContent: faNum(totalPen) }),
      ),
      el('div', { className: 'bidel-mr-stat' },
        el('span', { className: 'bidel-mr-lbl', textContent: 'فاصله تا سقف' }),
        el('span', { className: 'bidel-mr-val dist', textContent: dist === 0 ? 'باخت 💀' : faNum(dist) }),
      ),
      el('div', { className: 'bidel-mr-bar' },
        el('div', { className: `bidel-mr-bar-fill ${tier}`, style: `width:${pct.toFixed(1)}%` }),
      ),
    );
  });

  table.append(...rows);

  // راهنمای سریع
  const guide = el('div', { className: 'bidel-modal-guide' },
    el('div', { className: 'bidel-guide-chip' }, el('b', { textContent: '♥ دل‌ها:' }), ' هر برگ ۱ جریمه'),
    el('div', { className: 'bidel-guide-chip' }, el('b', { textContent: '♠ بی‌بی پیک:' }), ' ۱۳ جریمه'),
    v.jackDiamondsBonus ? el('div', { className: 'bidel-guide-chip bonus' }, el('b', { textContent: '♦ سرباز خشت:' }), ' ۱۰- پاداش') : null,
    el('div', { className: 'bidel-guide-chip moon' }, el('b', { textContent: '🌙 شق‌القمر:' }), ' گرفتن تمام ۲۶ امتیاز = صفر برای شما، ۲۶+ برای رقبا'),
  );

  body.append(table, guide);
  modal.append(head, body);
  overlay.append(modal);
  document.body.append(overlay);
}

// ─── مودال / شیت ریزامتیازات دست (داشبورد سریع و درشت زیر ۲ ثانیه) ──────────
function showScoreBreakdownModal(v, teamIndex) {
  const existing = document.getElementById('score-breakdown-overlay');
  if (existing) existing.remove();

  const youTeam = (v.you != null ? v.you : 0) % 2;
  const isYou = teamIndex === youTeam;
  const isShelem = v.gameType !== 'hokm';
  const isContractor = isShelem && v.contractorSeat != null && (v.contractorSeat % 2 === teamIndex);
  const statusInfo = getHandStatus(v, teamIndex);

  const matchPts = (v.matchScore && v.matchScore[teamIndex]) ?? 0;
  const handPts = (v.points && v.points[teamIndex]) ?? 0;
  const tricksCount = (v.tricksWon && v.tricksWon[teamIndex]) ?? 0;
  const oppHandPts = (v.points && v.points[1 - teamIndex]) ?? 0;

  const overlay = el('div', {
    id: 'score-breakdown-overlay',
    className: 'score-breakdown-overlay',
    onclick: (e) => {
      if (e.target === overlay) closeOverlayWithFade(overlay);
    },
  });

  const modal = el('div', { className: 'score-breakdown-modal' });

  // سربرگ
  const teamLabel = isYou
    ? (t('hand_result.your_team', null, 'تیم شما') + ' 🤝')
    : (t('hand_result.opp_team', null, 'تیم حریف') + ' ⚔️');
  const head = el('div', { className: 'sbm-head' },
    el('div', { className: 'sbm-title' },
      el('span', { className: 'sbm-icon', textContent: '📊' }),
      el('h3', { textContent: t('score_breakdown.title', { team: teamLabel }, `${teamLabel} — وضعیت دست`) }),
    ),
    el('button', { className: 'occ-close', textContent: '✕', onclick: () => closeOverlayWithFade(overlay) }),
  );

  const body = el('div', { className: 'sbm-body' });

  // ۴ کاشی عددی درشت و سریع (خوانش زیر ۱ ثانیه)
  const statGrid = el('div', { className: 'sbm-stat-grid-4' });

  if (v.gameType === 'chahar_barg') {
    const surs = (v.surs && v.surs[teamIndex]) ?? 0;
    const jackSurs = (v.jackSurs && v.jackSurs[teamIndex]) ?? 0;
    const matchTarget = v.matchTarget || 62;
    const dealIdx = (v.dealIndex != null ? v.dealIndex + 1 : 1);
    const totalDeals = v.totalDeals || (v.playerCount === 2 ? 6 : 3);

    statGrid.append(
      el('div', { className: 'sbm-tile' },
        el('span', { className: 'sbm-tile-lbl', textContent: t('score_breakdown.surs', null, 'سورها') }),
        el('strong', { className: 'sbm-tile-val gold', textContent: t('score_breakdown.surs_val', { n: faNum(surs) }, `${faNum(surs)} سور`) }),
      ),
      el('div', { className: 'sbm-tile' },
        el('span', { className: 'sbm-tile-lbl', textContent: t('score_breakdown.jack_sur', null, 'سور سرباز') }),
        el('strong', { className: 'sbm-tile-val ok', textContent: faNum(jackSurs) }),
      ),
      el('div', { className: 'sbm-tile' },
        el('span', { className: 'sbm-tile-lbl', textContent: t('score_breakdown.deal_stage', null, 'مرحله توزیع') }),
        el('strong', { className: 'sbm-tile-val', textContent: t('score_breakdown.deal_stage_val', { cur: faNum(dealIdx), total: faNum(totalDeals) }, `دست ${faNum(dealIdx)} از ${faNum(totalDeals)}`) }),
      ),
      el('div', { className: 'sbm-tile' },
        el('span', { className: 'sbm-tile-lbl', textContent: t('score_breakdown.match_total', null, 'مجموع مسابقه') }),
        el('strong', { className: 'sbm-tile-val', textContent: `${faNum(matchPts)} / ${faNum(matchTarget)}` }),
      ),
    );

    const guideBox = el('div', { className: 'sbm-chaharbarg-rules', style: 'margin-top:16px;padding:12px 16px;border-radius:12px;background:rgba(255,255,255,0.04);font-size:0.85rem;line-height:1.7;color:#cbd5e1;' },
      el('h4', { style: 'color:var(--gold);margin-bottom:6px;', textContent: t('score_breakdown.chahar_barg_rules_title', null, 'قوانین شمارش امتیاز چهاربرگ (یازده):') }),
      el('div', {}, t('score_breakdown.cb_rule_clubs', null, '♣ هفت‌خاج: تیمی که بیشترین گشنیز (حداقل ۷ برگ) را داشته باشد = ۷ امتیاز')),
      el('div', {}, t('score_breakdown.cb_rule_specials', null, '♦ ۱۰ خشت: ۳ امتیاز · ♣ ۲ گشنیز: ۲ امتیاز')),
      el('div', {}, t('score_breakdown.cb_rule_faces', null, 'سربازها: هر کدام ۱ امتیاز (مجموعاً ۴ امتیاز) · آس‌ها: هر کدام ۱ امتیاز (مجموعاً ۴ امتیاز)')),
      el('div', {}, t('score_breakdown.cb_rule_surs', null, '⭐ سور: هر سور ۵ امتیاز (سور سرباز ۱۰ امتیاز) · در ۴ برگ آخر بازی سور حساب نمی‌شود.')),
    );

    body.append(statGrid, guideBox);
    modal.append(head, body);
    overlay.append(modal);
    document.body.append(overlay);
    return;
  }

  if (isShelem) {
    const isSpecialKenz = v.bidType === 'kenz' || v.bid === 'kenz';
    const isSpecialShelem = v.bidType === 'shelem' || v.bid === 'shelem';
    const maxScore = (v.hasJoker || v.mode === 'joker' || v.jokerMode) ? 200 : 165;
    const bidTarget = (isSpecialKenz || isSpecialShelem) ? maxScore : (Number(v.bid) || 0);
    const remainingToBid = bidTarget ? Math.max(0, bidTarget - handPts) : 0;
    const maxCanScore = maxScore - oppHandPts;
    const bidDisplay = isSpecialKenz ? (t('hand_result.kenz_label', null, 'کنز ⚡')) : (isSpecialShelem ? (t('hand_result.shelem_label', null, 'شلم 👑')) : (v.bid ? faNum(v.bid) : '—'));

    statGrid.append(
      el('div', { className: 'sbm-tile' },
        el('span', { className: 'sbm-tile-lbl', textContent: t('score_breakdown.bid', null, 'تعهد') }),
        el('strong', { className: 'sbm-tile-val gold', textContent: bidDisplay }),
      ),
      el('div', { className: `sbm-tile ${statusInfo.status}` },
        el('span', { className: 'sbm-tile-lbl', textContent: t('score_breakdown.earned', null, 'کسب‌شده') }),
        el('strong', { className: 'sbm-tile-val', textContent: faNum(handPts) }),
      ),
      el('div', { className: 'sbm-tile' },
        el('span', { className: 'sbm-tile-lbl', textContent: isContractor ? t('score_breakdown.needed_to_target', null, 'نیاز تا هدف') : t('score_breakdown.max_possible', null, 'سقف ممکن') }),
        el('strong', { className: isContractor && remainingToBid === 0 ? 'sbm-tile-val ok' : 'sbm-tile-val', textContent: isContractor ? (remainingToBid === 0 ? t('score_breakdown.complete', null, '✓ کامل') : faNum(remainingToBid)) : faNum(maxCanScore) }),
      ),
      el('div', { className: 'sbm-tile' },
        el('span', { className: 'sbm-tile-lbl', textContent: t('score_breakdown.match_total', null, 'مجموع مسابقه') }),
        el('strong', { className: 'sbm-tile-val', textContent: faNum(matchPts) }),
      ),
    );
  } else {
    const oppTricks = (v.tricksWon && v.tricksWon[1 - teamIndex]) ?? 0;
    const matchTarget = v.matchTarget || 7;
    const isHakemTeam = (v.hakemSeat != null) && ((v.hakemSeat % 2) === teamIndex);
    const hakemPlayerName = (v.hakemSeat != null && v.names) ? (v.names[v.hakemSeat] || t('table.hakem', null, 'حاکم')) : t('table.hakem', null, 'حاکم');

    let kotText = t('score_breakdown.normal_1hand', null, 'عادی (۱ دست)');
    let kotTone = 'normal';
    let statusBannerText = '';
    let statusBannerCls = 'neutral';

    if (oppTricks === 0 && tricksCount >= 1) {
      if (!isHakemTeam) {
        kotText = t('score_breakdown.hakem_kot_3hands', null, 'حاکم‌کوت 🔥 (۳ دست)');
        kotTone = 'gold';
        statusBannerText = t('score_breakdown.banner_verge_hakem_kot', null, '🔥 در آستانهٔ حاکم‌کوت! اگر حریف تا پایان هیچ تریکی نگیرد، ۳ دست مسابقه نصیب شما می‌شود.');
        statusBannerCls = 'gold-glow';
      } else {
        kotText = t('score_breakdown.kot_2hands', null, 'کوت ⚡ (۲ دست)');
        kotTone = 'ok';
        statusBannerText = t('score_breakdown.banner_verge_kot', null, '⚡ در آستانهٔ کوت! با ادامهٔ کلین‌شیت و صفر نگه داشتن حریف، ۲ دست مسابقه می‌گیرید.');
        statusBannerCls = 'safe-green';
      }
    } else if (tricksCount === 0 && oppTricks >= 5) {
      if (isHakemTeam) {
        kotText = t('score_breakdown.risk_hakem_kot', null, 'خطر حاکم‌کوت ⚠️ (-۳ دست)');
        kotTone = 'danger';
        statusBannerText = t('score_breakdown.banner_crit_hakem_kot', null, '⚠️ هشدار بحرانی: تیم شما حاکم است و تریکی نگرفته؛ باخت ۷-۰ مساوی با ۳ امتیاز به سود حریف است! سریعاً تریک بگیرید.');
        statusBannerCls = 'danger-red';
      } else {
        kotText = t('score_breakdown.risk_kot', null, 'خطر کوت ⚠️ (-۲ دست)');
        kotTone = 'warn';
        statusBannerText = t('score_breakdown.banner_crit_kot', null, '⚠️ در خطر کوت شدن: حداقل ۱ تریک جهت نجات تیم از شکست ۲ امتیازی لازم است.');
        statusBannerCls = 'warn-yellow';
      }
    } else if (oppTricks > 0 && tricksCount > 0) {
      kotText = t('score_breakdown.normal_1hand', null, 'عادی (۱ دست)');
      kotTone = 'normal';
      statusBannerText = t('score_breakdown.banner_normal', null, 'برد عادی: هر دو تیم حداقل ۱ تریک گرفته‌اند و کوت در این دست منتفی است (ارزش برد: ۱ دست).');
      statusBannerCls = 'neutral';
    }

    statGrid.append(
      el('div', { className: 'sbm-tile' },
        el('span', { className: 'sbm-tile-lbl', textContent: t('score_breakdown.match_hands', null, 'دست‌های مسابقه') }),
        el('strong', { className: 'sbm-tile-val gold', textContent: t('score_breakdown.of_target', { cur: faNum(matchPts), target: faNum(matchTarget) }, `${faNum(matchPts)} از ${faNum(matchTarget)}`) }),
      ),
      el('div', { className: 'sbm-tile' },
        el('span', { className: 'sbm-tile-lbl', textContent: t('score_breakdown.this_hand_tricks', null, 'تریک‌های این دست') }),
        el('strong', { className: 'sbm-tile-val', textContent: t('score_breakdown.of_target', { cur: faNum(tricksCount), target: faNum(7) }, `${faNum(tricksCount)} از ۷`) }),
      ),
      el('div', { className: 'sbm-tile' },
        el('span', { className: 'sbm-tile-lbl', textContent: t('score_breakdown.hakem_role', null, 'حاکمیت راند') }),
        el('strong', { className: isHakemTeam ? 'sbm-tile-val ok' : 'sbm-tile-val', textContent: isHakemTeam ? t('score_breakdown.hakem_name', { name: hakemPlayerName }, `👑 ${hakemPlayerName}`) : t('score_breakdown.defender', null, '⚔️ مدافع') }),
      ),
      el('div', { className: `sbm-tile ${kotTone}` },
        el('span', { className: 'sbm-tile-lbl', textContent: t('score_breakdown.round_win_val', null, 'ارزش برد این راند') }),
        el('strong', { className: `sbm-tile-val ${kotTone}`, textContent: kotText }),
      ),
    );
  }
  body.append(statGrid);

  // شمارنده و ارزش کارت‌های امتیاز شلم (بصری و مینیاتوری)
  if (isShelem) {
    const cardsRow = el('div', { className: 'sbm-cards-hud' },
      el('div', { className: 'sbm-ch-item' },
        el('span', { className: 'sbm-ch-badge', textContent: t('score_breakdown.fives', null, '🂵 ۵ها') }),
        el('span', { className: 'sbm-ch-val', textContent: t('score_breakdown.fives_val', null, '۲۰ امتیاز (۴ کارت)') }),
      ),
      el('div', { className: 'sbm-ch-item' },
        el('span', { className: 'sbm-ch-badge', textContent: t('score_breakdown.tens', null, '🂪 ۱۰ها') }),
        el('span', { className: 'sbm-ch-val', textContent: t('score_breakdown.tens_val', null, '۴۰ امتیاز (۴ کارت)') }),
      ),
      el('div', { className: 'sbm-ch-item' },
        el('span', { className: 'sbm-ch-badge', textContent: t('score_breakdown.kings', null, '🂾 شاه‌ها') }),
        el('span', { className: 'sbm-ch-val', textContent: t('score_breakdown.kings_val', null, '۴۰ امتیاز (۴ کارت)') }),
      ),
      el('div', { className: 'sbm-ch-item' },
        el('span', { className: 'sbm-ch-badge', textContent: t('score_breakdown.last_trick', null, '🏆 تریک آخر') }),
        el('span', { className: 'sbm-ch-val', textContent: t('score_breakdown.last_trick_val', null, '۵ امتیاز بونوس') }),
      ),
    );
    body.append(cardsRow);

    // وضعیت کلیدی در یک خط
    if (v.bid) {
      const isSpecialKenz = v.bidType === 'kenz' || v.bid === 'kenz';
      const isSpecialShelem = v.bidType === 'shelem' || v.bid === 'shelem';
      const maxScore = (v.hasJoker || v.mode === 'joker' || v.jokerMode) ? 200 : 165;
      const kotThresh = (v.hasJoker || v.mode === 'joker' || v.jokerMode) ? 100 : 85;
      let statusKey = '';

      if (isSpecialKenz) {
        if (isContractor) {
          statusKey = oppHandPts > 0 ? t('score_breakdown.kenz_lost_trick', null, '🔴 باخت تعهد کنز (مرگ آنی) — حریف تریک گرفت')
            : (handPts >= maxScore ? t('score_breakdown.kenz_won_all', null, '🟢 پیروزی کنز! فتح کامل دست و برد فوری مسابقه') : t('score_breakdown.kenz_pending', null, '⚡ تعهد کنز — حریف نباید هیچ تریک یا امتیازی بگیرد'));
        } else {
          statusKey = oppHandPts > 0 ? t('score_breakdown.kenz_def_won', null, '🟢 پیروزی فوری مسابقه! کنز حریف با موفقیت شکست خورد')
            : t('score_breakdown.kenz_def_pending', null, '🛡️ دفاع مقابل کنز — با گرفتن ۱ تریک مسابقه را می‌برید');
        }
      } else if (isSpecialShelem) {
        if (isContractor) {
          statusKey = oppHandPts > 0 ? t('score_breakdown.shelem_lost_trick', null, '🔴 تعهد شلم سوخت (جریمه منفی دوبل)')
            : (handPts >= maxScore ? t('score_breakdown.shelem_won_all', null, '🟢 شلم محقق شد (+دوبل امتیاز)') : t('score_breakdown.shelem_pending', null, '⚡ تعهد شلم — نباید هیچ تریک یا امتیازی به حریف برسد'));
        } else {
          statusKey = oppHandPts > 0 ? t('score_breakdown.shelem_def_burned', null, '🟢 تعهد شلم حریف سوزانده شد') : t('score_breakdown.shelem_def_pending', null, '🛡️ دفاع برای جلوگیری از شلم حریف');
        }
      } else if (isContractor) {
        statusKey = oppHandPts > kotThresh ? t('score_breakdown.contractor_kot_risk', null, '🔴 سقوط زیر حد نصاب و جریمه منفی دوبل')
          : (maxScore - oppHandPts < v.bid ? t('score_breakdown.contractor_burned_save_kot', null, '🟠 تعهد سوخت — تلاش برای نجات از کوت')
          : (handPts >= v.bid ? t('score_breakdown.contractor_fulfilled', null, '🟢 تعهد با موفقیت محقق شد') : t('score_breakdown.contractor_in_progress', null, '🟢 در مسیر پیشرفت تعهد')));
      } else {
        statusKey = oppHandPts > kotThresh ? t('score_breakdown.def_opponent_kot', null, '🟢 موفق شدید حریف را کوت کنید')
          : (maxScore - oppHandPts < v.bid ? t('score_breakdown.def_opponent_burned', null, '🟢 تعهد حریف با موفقیت شکست خورد') : t('score_breakdown.def_pending', null, '🛡️ دفاع برای سوزاندن تعهد حریف'));
      }
      body.append(el('div', { className: `sbm-status-banner ${statusInfo.status}` }, statusKey));
    }
  } else {
    const cardsRow = el('div', { className: 'sbm-cards-hud' },
      el('div', { className: 'sbm-ch-item' },
        el('span', { className: 'sbm-ch-badge', textContent: t('score_breakdown.rule_round_win', null, '🏆 برد راند') }),
        el('span', { className: 'sbm-ch-val', textContent: t('score_breakdown.rule_round_win_val', null, '۷ تریک = ۱ دست') }),
      ),
      el('div', { className: 'sbm-ch-item' },
        el('span', { className: 'sbm-ch-badge', textContent: t('score_breakdown.rule_kot', null, '⚡ کوت') }),
        el('span', { className: 'sbm-ch-val', textContent: t('score_breakdown.rule_kot_val', null, 'برد ۷-۰ = ۲ دست') }),
      ),
      el('div', { className: 'sbm-ch-item' },
        el('span', { className: 'sbm-ch-badge', textContent: t('score_breakdown.rule_hakem_kot', null, '👑 حاکم‌کوت') }),
        el('span', { className: 'sbm-ch-val', textContent: t('score_breakdown.rule_hakem_kot_val', null, 'برد ۷-۰ بر حاکم = ۳ دست') }),
      ),
      el('div', { className: 'sbm-ch-item' },
        el('span', { className: 'sbm-ch-badge', textContent: t('score_breakdown.rule_target', null, '🎯 هدف مسابقه') }),
        el('span', { className: 'sbm-ch-val', textContent: t('score_breakdown.rule_target_val', { n: faNum(v.matchTarget || 7) }, `رسیدن به ${faNum(v.matchTarget || 7)} دست`) }),
      ),
    );
    body.append(cardsRow);
    if (statusBannerText) {
      body.append(el('div', { className: `sbm-status-banner ${statusBannerCls}` }, statusBannerText));
    }
  }

  const footer = el('div', { className: 'sbm-foot' },
    el('button', { className: 'primary sbm-close-btn', textContent: t('common.close', null, 'بستن'), onclick: () => closeOverlayWithFade(overlay) }),
  );

  modal.append(head, body, footer);
  overlay.append(modal);
  document.body.append(overlay);
}

// ─── تنظیماتِ برنامه (از منوی پروفایل/لابی) ─────────────────────────────────────
function soundSection() {
  const sec = el('div', { className: 'rss-section' },
    el('div', { className: 'rss-sec-title' },
      el('span', { textContent: '🔊' }),
      el('strong', { textContent: t('settings.sound', null, 'صدای بازی') }),
    ),
  );
  const row = el('div', { className: 'rss-toggle-row' });
  const paint = () => {
    row.replaceChildren(
      el('button', { type: 'button', className: 'rss-toggle-btn' + (!muted ? ' active' : ''), textContent: `🔊 ${t('settings.sound_on', null, 'روشن')}`,
        onclick: () => { if (muted) { toggleMute(); paint(); } } }),
      el('button', { type: 'button', className: 'rss-toggle-btn' + (muted ? ' active' : ''), textContent: `🔇 ${t('settings.sound_off', null, 'خاموش')}`,
        onclick: () => { if (!muted) { toggleMute(); paint(); } } }),
    );
  };
  paint();
  sec.append(row);
  return sec;
}

const KNOWN_CARD_BACKS = {
  cardback_art_deco: 'نیلوفر آرت دکو',
  cardback_ruby_gem: 'یاقوت سرخ سلطنتی',
  cardback_ouroboros_dragon: 'اژدهای اوروبوروس',
  cardback_damask_velvet: 'مخمل داماسک',
  cardback_mystic_journey: 'سفر کیهانی',
  cardback_crimson_sigil: 'طلسم سرخ',
  cardback_celestial_zodiac: 'فلک‌الافلاک',
  cardback_ancient_mosaic: 'لوح توتم باستانی',
  cardback_arcane_grimoire: 'طومار کیمیاگر',
  cardback_golden_peacock: 'طاووس زرین',
  cardback_midnight_lineart: 'شمس لاجوردی',
  cardback_vintage_parchment: 'کارت آنتیک کاغذی',
  cardback_tarot_feathers: 'تاروت کلاغ سیاه',
  cardback_baroque_leather: 'چرم باروک زرین',
  cardback_twin_dragons: 'اژدهای دوگانه',
  cardback_cosmic_lovers: 'عشاق کیهانی',
  cardback_golden_shamsah: 'شمسه‌ زرین',
  cardback_gatsby_dancer: 'بانوی آرت‌دکو',
  cardback_turquoise_toranj: 'ترنج فیروزه',
  cardback_origins_swords: 'شاهزادگان نخستین',
  cardback_crimson_toranj: 'ترنج زرشکی',
  cardback_hermetic_alchemy: 'کیمیای هرمس',
  cardback_classic_red: 'کلاسیک سرخ',
};

function buildCardBackSelector(data, onChange) {
  const wrap = el('div', { className: 'pf-cardbacks-section' });
  const head = el('div', { className: 'pf-cardbacks-head' },
    el('div', { className: 'pf-cardbacks-title' },
      el('span', { textContent: '🎴' }),
      el('span', { textContent: t('settings.card_back_style', null, 'طرح پشت کارت') }),
    ),
  );

  const grid = el('div', { className: 'pf-cardbacks-grid' });
  let currentKey = data?.card_back || null;

  const rawOwned = data?.owned_card_backs || [];
  const normalizedOwned = rawOwned.map((item) => {
    const k = typeof item === 'string' ? item : item.key;
    const defaultTitle = typeof item === 'string' ? (KNOWN_CARD_BACKS[k] || 'طرح اختصاصی') : (item.title || KNOWN_CARD_BACKS[k] || 'طرح اختصاصی');
    return { key: k, title: t(`shop.items.${k}.title`, null, defaultTitle) };
  });

  const seenKeys = new Set();
  const filteredOwned = [];
  for (const o of normalizedOwned) {
    if (o.key && !seenKeys.has(o.key)) {
      seenKeys.add(o.key);
      filteredOwned.push(o);
    }
  }

  const allOptions = [
    { key: null, title: t('settings.classic', null, 'کلاسیک') },
    ...filteredOwned,
  ];

  const paintGrid = () => {
    grid.replaceChildren();
    allOptions.forEach((opt) => {
      const isAct = (currentKey === opt.key) || (!currentKey && !opt.key);
      const cardBox = el('div', {
        className: 'pf-cardback-card' + (isAct ? ' active' : ''),
        title: opt.title,
        onclick: async () => {
          if ((currentKey === opt.key) || (!currentKey && !opt.key)) return;
          try {
            toast('در حال تغییر طرح کارت…');
            const res = await apiFetch('POST', '/api/shop/equip', {
              category: 'card_back',
              itemKey: opt.key || null,
            });
            if (res && res.ok !== false) {
              currentKey = opt.key || null;
              if (data) data.card_back = currentKey;
              if (typeof myProfile !== 'undefined' && myProfile) {
                myProfile.card_back = currentKey;
              }
              try { localStorage.setItem('cb_card_back', currentKey || ''); } catch {}
              if (typeof lastView !== 'undefined' && lastView?.cardBacks && lastView.you != null) {
                lastView.cardBacks[lastView.you] = currentKey || null;
              }
              toast(`طرح پشت‌کارت روی «${opt.title}» تنظیم شد`, 'ok');
              paintGrid();
              if (typeof onChange === 'function') onChange(currentKey);
              if (typeof render === 'function' && typeof lastView !== 'undefined' && lastView) {
                render(lastView);
              }
            } else {
              toast(res?.error || 'خطا در تغییر طرح کارت');
            }
          } catch (err) {
            toast('خطا در برقراری ارتباط با سرور');
          }
        },
      });

      const preview = cardEl(null, { faceDown: true, small: true, cardBack: opt.key });
      preview.style.pointerEvents = 'none';
      cardBox.append(preview);

      if (isAct) {
        cardBox.append(el('span', { className: 'pf-cardback-badge', textContent: t('settings.active_badge', null, '✓ فعال') }));
      }

      cardBox.append(el('span', { className: 'pf-cardback-name', textContent: opt.title }));
      grid.append(cardBox);
    });
  };

  paintGrid();

  const shopBtn = el('button', {
    type: 'button',
    className: 'pf-cardback-shop-btn',
    onclick: () => {
      if (typeof myProfilePanel !== 'undefined' && myProfilePanel.open) {
        myProfilePanel.toggle();
      }
      const appSettingsOv = document.getElementById('app-settings-overlay');
      if (appSettingsOv) closeOverlayWithFade(appSettingsOv);
      shopModal.show('card_back');
    },
  },
    el('span', { textContent: '🛒' }),
    el('span', { textContent: t('settings.view_shop_cardbacks', null, 'مشاهده و خرید طرح‌های جدید در فروشگاه') }),
  );

  wrap.append(head, grid, shopBtn);
  return wrap;
}

// تنظیماتِ شخصی (نه پروفایل): صدا، کیفیتِ گرافیک، رنگِ خال‌ها، پیام‌های آماده، میانبرها.
// همان ظاهرِ شیتِ تنظیماتِ میز را دارد تا کاربر یک الگو ببیند.
function showSettingsSheet() {
  document.getElementById('app-settings-overlay')?.remove();
  const ov = el('div', {
    id: 'app-settings-overlay',
    className: 'room-settings-overlay',
    onclick: (e) => { if (e.target === ov) closeOverlayWithFade(ov); },
  });
  const sheet = el('div', { className: 'room-settings-sheet' });
  const head = el('div', { className: 'rss-head' },
    el('div', { className: 'rss-title' },
      el('span', { className: 'rss-icon', textContent: '⚙️' }),
      el('h3', { textContent: t('settings.title', null, 'تنظیمات') }),
    ),
    el('button', { className: 'occ-close', textContent: '✕', onclick: () => closeOverlayWithFade(ov) }),
  );
  const body = el('div', { className: 'rss-body' });
  body.append(languageSettingSection(() => showSettingsSheet()));
  body.append(soundSection());
  const fxSec = fxSettingSection();
  if (fxSec) body.append(fxSec);
  body.append(deckColorSection());
  body.append(touchModeSettingSection());
  if (typeof myProfile !== 'undefined' && myProfile) {
    body.append(buildCardBackSelector(myProfile, (newKey) => {
      if (myProfile) myProfile.card_back = newKey;
    }));
  }
  body.append(el('div', { className: 'rss-section' },
    el('div', { className: 'rss-sec-title' }, el('span', { textContent: '💬' }), el('strong', { textContent: t('chat.quick_phrases', null, 'پیام‌های آماده') })),
    el('button', { type: 'button', className: 'ghost-sm kb-help-link', textContent: t('settings.quick_chat_edit', null, '✏️ تنظیم پیام‌های آمادهٔ من'),
      onclick: () => { closeOverlayWithFade(ov); presetsPopup.showEditor(); } }),
  ));
  body.append(el('div', { className: 'rss-section' },
    el('div', { className: 'rss-sec-title' }, el('span', { textContent: '📖' }), el('strong', { textContent: t('settings.rules_title', null, 'راهنما و قوانین بازی‌ها') })),
    el('button', { type: 'button', className: 'ghost-sm kb-help-link', style: 'color:#f4c542;', textContent: t('settings.open_rules', null, '📖 مشاهده قوانین ساده همه بازی‌ها'),
      onclick: () => { closeOverlayWithFade(ov); showHelpModal(selectedGame); } }),
  ));
  body.append(el('div', { className: 'rss-section' },
    el('div', { className: 'rss-sec-title' }, el('span', { textContent: '🚩' }), el('strong', { textContent: t('settings.report_title', null, 'سلامت و امنیت بازی') })),
    el('button', { type: 'button', className: 'ghost-sm kb-help-link', style: 'color:#f87171;', textContent: t('settings.report_user', null, '🚩 ثبت گزارش تخلف بازیکن به مدیریت'),
      onclick: () => { closeOverlayWithFade(ov); openReportUserModal(); } }),
  ));
  if (!_isTouchDevice()) {
    body.append(el('button', { type: 'button', className: 'ghost-sm kb-help-link', textContent: t('settings.keyboard_help', null, '⌨️ میانبرهای صفحه‌کلید (?)'),
      onclick: () => { closeOverlayWithFade(ov); _kbHelp(); } }));
  }
  sheet.append(head, body);
  ov.append(sheet);
  document.body.append(ov);
}

// ─── شیت تنظیمات اتاق و میز (Context Menu / Bottom Sheet) ─────────────────────
function showRoomSettingsModal(v) {
  const existing = document.getElementById('room-settings-modal-overlay');
  if (existing) existing.remove();

  const overlay = el('div', {
    id: 'room-settings-modal-overlay',
    className: 'room-settings-overlay',
    onclick: (e) => {
      if (e.target === overlay) closeOverlayWithFade(overlay);
    },
  });

  const modal = el('div', { className: 'room-settings-sheet' });

  // سربرگ
  const head = el('div', { className: 'rss-head' },
    el('div', { className: 'rss-title' },
      el('span', { className: 'rss-icon', textContent: '⚙️' }),
      el('h3', { textContent: t('settings.room_settings_title', null, 'تنظیمات میز و اتاق') }),
    ),
    el('button', { className: 'occ-close', textContent: '✕', onclick: () => closeOverlayWithFade(overlay) }),
  );

  const body = el('div', { className: 'rss-body' });

  // ۰. زبان و صدا
  body.append(languageSettingSection(() => showRoomSettingsModal(v)));
  body.append(soundSection());
  const fxSec = fxSettingSection();
  if (fxSec) body.append(fxSec);
  body.append(deckColorSection());
  body.append(touchModeSettingSection());
  body.append(el('button', {
    type: 'button', className: 'ghost-sm kb-help-link', style: 'color:#f4c542;margin-top:8px;', textContent: `📖 راهنما و قوانین بازی ${GAME_FA[v?.gameType || selectedGame] || ''}`,
    onclick: () => { closeOverlayWithFade(overlay); showHelpModal(v?.gameType || selectedGame); },
  }));
  if (!_isTouchDevice()) {
    body.append(el('button', {
      type: 'button', className: 'ghost-sm kb-help-link', textContent: t('settings.keyboard_help', null, '⌨️ میانبرهای صفحه‌کلید (?)'),
      onclick: () => { closeOverlayWithFade(overlay); _kbHelp(); },
    }));
  }

  // ۱. تغییر تم میز
  const currentTheme = v.tableTheme || localStorage.getItem('cb_table_theme') || 'ruby';
  const themeSec = el('div', { className: 'rss-section' },
    el('div', { className: 'rss-sec-title' },
      el('span', { textContent: '🎨' }),
      el('strong', { textContent: t('settings.theme_section', null, 'تم و پس‌زمینه میز') }),
    ),
  );
  const themeGrid = el('div', { className: 'rss-theme-grid' });
  const themes = [
    { id: 'emerald', name: t('create_room.theme_emerald', null, '🌲 زمردی'), color: '#173623' },
    { id: 'royal', name: t('create_room.theme_royal', null, '🌌 سورمه‌ای'), color: '#16223b' },
    { id: 'ruby', name: t('create_room.theme_ruby', null, '🍷 زرشکی'), color: '#3d121c' },
    { id: 'noir', name: t('create_room.theme_noir', null, '🕶 ذغالی'), color: '#1c2024' },
  ];
  const ownedFelts = myProfile?.owned_felts || [];
  const EXCLUSIVE_THEME_ITEMS = [
    { id: 'carpet', name: t('create_room.theme_carpet', null, '✨ فرش ایرانی'), color: '#8b301d' },
    { id: 'cyberpunk', name: t('create_room.theme_cyberpunk', null, '⚡ سایبرپانک'), color: '#2d1354' },
    { id: 'wood', name: t('create_room.theme_wood', null, '🪵 چوب سلطنتی'), color: '#4f3119' },
    { id: 'galaxy', name: t('create_room.theme_galaxy', null, '🌌 کهکشان'), color: '#130e43' },
    { id: 'gold-vip', name: t('create_room.theme_gold_vip', null, '👑 طلای VIP'), color: '#63501f' },
    { id: 'leather-black', name: t('create_room.theme_leather_black', null, '🖤 چرم مشکی کلاسیک'), color: '#2c2621' },
    { id: 'velvet-navy', name: t('create_room.theme_velvet_navy', null, '🎰 مخمل سرمه‌ای کازینو'), color: '#101337' },
    { id: 'marble-cream', name: t('create_room.theme_marble_cream', null, '🏛️ سنگ مرمر کرم'), color: '#d9cdb8' },
    { id: 'walnut-gloss', name: t('create_room.theme_walnut_gloss', null, '✨ گردوی جلادار'), color: '#492012' },
    { id: 'velvet-burgundy', name: t('create_room.theme_velvet_burgundy', null, '🍷 بورگاندی هتلی'), color: '#390931' },
    { id: 'canvas-rustic', name: t('create_room.theme_canvas_rustic', null, '🧵 کتان روستیک'), color: '#4a5563' },
    { id: 'suede-olive', name: t('create_room.theme_suede_olive', null, '🫒 سوئد زیتونی'), color: '#4a5c2e' },
    { id: 'leather-vintage', name: t('create_room.theme_leather_vintage', null, '🧭 چرم عتیقهٔ نقشه‌دار'), color: '#796349' },
    { id: 'silk-pinstripe', name: t('create_room.theme_silk_pinstripe', null, '🎩 ابریشم مشکی راه‌راه'), color: '#11141d' },
    { id: 'platinum-executive', name: t('create_room.theme_platinum_executive', null, '💎 پلاتین اجرایی'), color: '#1f292d' },
  ];
  for (const th of EXCLUSIVE_THEME_ITEMS) {
    if (ownedFelts.includes(th.id) || ownedFelts.includes(th.id.replace('-', '_')) || ownedFelts.includes(`felt_${th.id.replace('-', '_')}`)) {
      themes.push(th);
    }
  }
  themes.forEach((th) => {
    const isAct = th.id === currentTheme;
    const btn = el('button', {
      type: 'button',
      className: 'rss-theme-btn' + (isAct ? ' active' : ''),
      style: `background: ${th.color}`,
      onclick: () => {
        localStorage.setItem('cb_table_theme', th.id);
        if (table && table.setTableTheme) table.setTableTheme(th.id);
        v.tableTheme = th.id;
        if (lastView) lastView.tableTheme = th.id;
        render(v);
        toast(t('settings.theme_changed', { name: th.name }, `تم میز به ${th.name} تغییر یافت ✨`), 'ok');
        overlay.remove();
      },
    },
      el('span', { className: 'rss-theme-name', textContent: th.name }),
      isAct ? el('span', { className: 'rss-theme-check', textContent: '✓' }) : null,
    );
    themeGrid.append(btn);
  });
  themeSec.append(themeGrid);

  const isCreator = Boolean(
    !networkTable ||
    (v.creatorId != null && myUserId != null && String(v.creatorId) === String(myUserId)) ||
    (v.creatorId == null && v.you === 0)
  );

  // ۲. حالت چت
  const chatSec = el('div', { className: 'rss-section' },
    el('div', { className: 'rss-sec-title' },
      el('span', { textContent: '💬' }),
      el('strong', { textContent: t('settings.chat_mode_section', null, 'حالت چت و گفتگو') }),
      !isCreator ? el('span', { className: 'muted small', style: 'margin-right: auto; font-size: 11px;', textContent: t('settings.chat_mode_admin_only', null, '(تنظیم توسط مدیر)') }) : null,
    ),
  );
  const chatGrid = el('div', { className: 'rss-toggle-row' });
  const chatModes = [
    { id: 'FULL', label: t('settings.chat_mode_full', null, '💭 آزاد') },
    { id: 'PRESET_ONLY', label: t('settings.chat_mode_preset', null, '💬 فقط آماده') },
    { id: 'DISABLED', label: t('settings.chat_mode_disabled', null, '🔕 غیرفعال') },
  ];
  chatModes.forEach((cm) => {
    const isAct = (v.chatMode || 'FULL') === cm.id;
    const btn = el('button', {
      type: 'button',
      className: 'rss-toggle-btn' + (isAct ? ' active' : ''),
      textContent: cm.label,
      onclick: () => {
        if (!isCreator) {
          toast(t('settings.chat_mode_admin_err', null, 'تنها مدیر اتاق می‌تواند حالت چت را تغییر دهد'), 'info');
          return;
        }
        table.setChatMode(cm.id);
        v.chatMode = cm.id;
        if (lastView) lastView.chatMode = cm.id;
        toast({
          FULL: t('settings.chat_mode_full_toast', null, 'چت آزاد شد'),
          PRESET_ONLY: t('settings.chat_mode_preset_toast', null, 'فقط پیام‌های آماده'),
          DISABLED: t('settings.chat_mode_disabled_toast', null, 'چت غیرفعال شد')
        }[cm.id]);
        overlay.remove();
      },
    });
    chatGrid.append(btn);
  });
  chatSec.append(chatGrid);

  // ۳. پیام صوتی (ویس)
  const voiceEnabled = v.voiceEnabled !== false;
  const voiceSec = el('div', { className: 'rss-section' },
    el('div', { className: 'rss-sec-title' },
      el('span', { textContent: '🎙️' }),
      el('strong', { textContent: t('settings.voice_section', null, 'پیام صوتی (ویس)') }),
      !isCreator ? el('span', { className: 'muted small', style: 'margin-right: auto; font-size: 11px;', textContent: t('settings.chat_mode_admin_only', null, '(تنظیم توسط مدیر)') }) : null,
    ),
  );
  const voiceGrid = el('div', { className: 'rss-toggle-row', style: 'grid-template-columns: repeat(2, 1fr);' });
  const voiceModes = [
    { enabled: true, label: t('settings.voice_enabled', null, '🎙️ فعال'), active: voiceEnabled },
    { enabled: false, label: t('settings.voice_disabled', null, '🔇 غیرفعال'), active: !voiceEnabled },
  ];
  voiceModes.forEach((vm) => {
    const btn = el('button', {
      type: 'button',
      className: 'rss-toggle-btn' + (vm.active ? ' active' : ''),
      textContent: vm.label,
      onclick: () => {
        if (!isCreator) {
          toast(t('settings.voice_admin_err', null, 'تنها مدیر اتاق می‌تواند ارسال پیام صوتی را فعال یا غیرفعال کند'), 'info');
          return;
        }
        if (table && table.setVoiceEnabled) {
          table.setVoiceEnabled(vm.enabled);
        }
        v.voiceEnabled = vm.enabled;
        if (lastView) lastView.voiceEnabled = vm.enabled;
        toast(vm.enabled ? t('settings.voice_enabled_toast', null, 'پیام صوتی برای اتاق فعال شد 🎙') : t('settings.voice_disabled_toast', null, 'پیام صوتی برای اتاق غیرفعال شد 🔇'), 'ok');
        overlay.remove();
      },
    });
    voiceGrid.append(btn);
  });
  voiceSec.append(voiceGrid);

  const voiceHint = el('p', {
    className: 'rss-hint',
    textContent: voiceEnabled
      ? t('settings.voice_hint_enabled', null, 'برای ارسال ویس، دکمه میکروفون 🎙 در پایین صفحه را نگه دارید و با رها کردن ارسال کنید.')
      : t('settings.voice_hint_disabled', null, 'ارسال پیام صوتی در این اتاق توسط مدیر غیرفعال شده است.'),
  });
  const roomReportSec = el('div', { className: 'rss-section' },
    el('div', { className: 'rss-sec-title' }, el('span', { textContent: '🚩' }), el('strong', { textContent: t('settings.report_room_title', null, 'سلامت و گزارش تخلف') })),
    el('button', { type: 'button', className: 'ghost-sm kb-help-link', style: 'color:#f87171;', textContent: t('settings.report_room_user', null, '🚩 ثبت گزارش تخلف در این اتاق یا بازیکن'),
      onclick: () => { overlay.remove(); openReportUserModal(); } }),
  );

  body.append(themeSec, chatSec, voiceSec, roomReportSec);
  modal.append(head, body);
  overlay.append(modal);
  document.body.append(overlay);
}

// ─── تایمر ────────────────────────────────────────────────────────────────────
// در حالتِ سرعتی، «نوبت» یک صندلی نیست: هر صندلیِ داخلِ openSeats هنوز می‌تواند
// کارت بیندازد. یک منبعِ حقیقتِ واحد برای همه‌ی جاهایی که تا الان v.turnSeat===seat
// را چک می‌کردند (هایلایتِ صندلی، تایمر، صدای نوبت، لیستِ حاضرین).
function isActiveSeat(v, seat) {
  if (seat == null) return false;
  if (v.turnSeat === seat) return true;
  if (v.gameType === 'hokm' && (v.phase === 'CHOOSE_HOKM' || v.phase === 'CHOOSING_HOKM') && v.hakemSeat === seat) return true;
  return !!v.speedMode && Array.isArray(v.openSeats) && v.openSeats.includes(seat);
}

// ─── به‌روزرسانی درجا (In-place) صندلی بدون تخریب DOM ──────────────────────────
function updateSeatInPlace(box, v, seat) {
  const isTurn = isActiveSeat(v, seat) ||
    (v.reveal && !v.reveal.done && Array.isArray(v.reveal.shown) && v.reveal.shown[v.reveal.shown.length - 1]?.seat === seat);
  const isAfk = Boolean(v.afkSeats?.includes(seat));
  const isAbandoned = Boolean(v.abandonedSeats?.includes(seat));
  const discDeadline = v.discSeats?.[seat];
  const isDisc = !isAbandoned && discDeadline != null;
  const isHakem = seat === v.hakemSeat;
  const isCelebrating = contractorCelebratingSeat === seat;
  const isKotHidingYou = seat === v.you && v.phase === 'PASS_KOT' && v.hakemSeat === v.you;
  const isTrickWinner = v.lastWin === seat && (v.trick || []).length >= 4;

  box.classList.toggle('turn', isTurn);
  box.classList.toggle('afk', isAfk);
  box.classList.toggle('is-hakem', isHakem);
  box.classList.toggle('seat-won', isTrickWinner);
  box.classList.toggle('contractor-celebrate', isCelebrating);
  box.classList.toggle('seat-disc', isDisc);
  box.classList.toggle('seat-abandoned', isAbandoned);
  box.classList.toggle('kot-hidden', isKotHidingYou);

  const avWrap = box.querySelector(':scope > .seat-av-wrap');
  if (avWrap) {
    avWrap.classList.toggle('is-turn', isTurn);

    let turnPct = 100, isDanger = false, secsLeft = null;
    if (isTurn && v.turnStartTs && v.turnMs) {
      const elapsed = Math.max(0, Date.now() - v.turnStartTs);
      turnPct = Math.max(0, Math.min(100, ((v.turnMs - elapsed) / v.turnMs) * 100));
      isDanger = turnPct < 30;
      const maxSecs = Math.max(1, Math.ceil(v.turnMs / 1000));
      secsLeft = Math.max(0, Math.min(maxSecs, Math.ceil((v.turnMs - elapsed) / 1000)));
    }
    const isMe = (seat === v.you);
    const showTurnNumber = isTurn && (!v.speedMode || isMe);
    const baseSize = window.innerWidth <= 560 ? 46 : 52;
    const avSize = isMe ? baseSize : Math.round(baseSize * 0.85);
    syncTurnTimer(avWrap, avSize, isTurn, turnPct, isDanger, showTurnNumber ? secsLeft : null, true);

    // نشانِ قطعِ اتصال / رهاسازی
    let badge = avWrap.querySelector(':scope > .bank-badge');
    if (isAbandoned) {
      if (!badge) {
        badge = el('div', { className: 'bank-badge abandoned' });
        avWrap.append(badge);
      } else {
        badge.className = 'bank-badge abandoned';
      }
      badge.textContent = '🤖 ربات';
      badge.title = 'این بازیکن مسابقه را ترک کرد — ربات حرفه‌ای تا پایان بازی می‌کند';
      delete badge.dataset.deadline;
    } else if (isDisc) {
      const left = Math.max(0, Math.round((discDeadline - Date.now()) / 1000));
      if (!badge) {
        badge = el('div', { className: 'bank-badge' });
        avWrap.append(badge);
      } else {
        badge.className = 'bank-badge';
      }
      badge.innerHTML = `<span class="bank-ic">🤖</span><b class="bank-secs">${faNum(left)}</b><span class="bank-th">ث</span>`;
      badge.dataset.deadline = String(discDeadline);
      badge.title = 'قطع اتصال — بانک زمان تا جایگزینی دائمی ربات';
    } else if (badge) {
      badge.remove();
    }

    // تاجِ حاکم
    let crown = avWrap.querySelector(':scope > .hakem-crown');
    if (isHakem) {
      if (!crown) avWrap.append(crownEl());
    } else if (crown) {
      crown.remove();
    }

    syncSeatBidChip(avWrap, v, seat);

    const oldCnt = avWrap.querySelector(':scope > .card-count');
    if (oldCnt) oldCnt.remove();
  }

  // کارت‌های پشت‌رو (بادبزنِ حریف)
  if (seat !== v.you) {
    const n = (v.handCounts || [])[seat] ?? 0;
    let fanWrap = box.querySelector(':scope > .fan-wrap');
    if (!fanWrap) {
      fanWrap = el('div', { className: 'fan-wrap' });
      box.append(fanWrap);
    }
    let fan = fanWrap.querySelector(':scope > .fan');
    if (!fan) {
      fan = el('div', { className: 'fan' });
      fanWrap.append(fan);
    }

    const sliver = Math.max(9, Math.min(18, 165 / Math.max(1, n))) * 0.8;
    fan.style.setProperty('--fan-sliver', sliver.toFixed(1) + 'px');
    fan.style.setProperty('--fan-mid', ((n - 1) / 2).toFixed(2));
    fan.style.setProperty('--fan-spread', Math.min(5, 44 / Math.max(1, n)).toFixed(2) + 'deg');

    while (fan.children.length > n) {
      fan.lastElementChild.remove();
    }
    while (fan.children.length < n) {
      fan.append(fanCardEl(seat, fan.children.length));
    }
  }
}

// ─── صندلی (با آواتار + حباب) ─────────────────────────────────────────────────
function seatBox(v, seat) {
  const pos = getSeatPos(seat, v.you, v.playerCount);
  const myTeam = v.gameType === 'bidel' ? (seat === v.you) : (seat % 2 === v.you % 2);
  const isTurn = isActiveSeat(v, seat) ||
    (v.reveal && !v.reveal.done && Array.isArray(v.reveal.shown) && v.reveal.shown[v.reveal.shown.length - 1]?.seat === seat);
  const isAfk = v.afkSeats?.includes(seat);
  const isAbandoned = v.abandonedSeats?.includes(seat);
  const discDeadline = v.discSeats?.[seat];
  const isDisc = !isAbandoned && discDeadline != null;
  const isHakem = seat === v.hakemSeat;
  const isContractor = seat === v.contractorSeat && v.gameType === 'shelem';
  const isCelebrating = contractorCelebratingSeat === seat;
  const isKotHidingYou = seat === v.you && v.phase === 'PASS_KOT' && v.hakemSeat === v.you;
  // برندهٔ دوری که همین حالا بسته شد. سرور بینِ TRICK_WON و TURN مکث می‌کند، پس این
  // حالت ~۷۰۰ms روی صفحه می‌ماند و «چه کسی برد» واقعاً دیده می‌شود.
  const isTrickWinner = v.lastWin === seat && (v.trick || []).length >= 4;
  const box = el('div', {
    className: `seat seat-${pos} ${myTeam ? 'team-you' : 'team-opp'}` +
      (isTurn ? ' turn' : '') + (isAfk ? ' afk' : '') + (isHakem ? ' is-hakem' : '') +
      (isTrickWinner ? ' seat-won' : '') +
      (isCelebrating ? ' contractor-celebrate' : '') +
      (isDisc ? ' seat-disc' : '') + (isAbandoned ? ' seat-abandoned' : '') +
      (isKotHidingYou ? ' kot-hidden' : ''),
  });
  box.setAttribute('data-seat', String(seat));
  box.dataset.idSig = seatIdentitySig(v, seat);
  // انیمیشن‌های تزئینیِ بی‌پایان (تاجِ حاکم، قابِ آواتار، بوستر) با این delayِ منفی روی
  // ساعتِ سراسری فاز می‌گیرند → بازسازیِ صندلی آن‌ها را از صفر شروع نمی‌کند (پرشِ تاج).
  box.style.setProperty('--sync', `-${Math.round(performance.now())}ms`);

  // آواتار (همراه با رینگ تایمر دایره‌ای در صورت نوبت)
  let turnPct = 100, isDanger = false, secsLeft = null;
  if (isTurn && v.turnStartTs && v.turnMs) {
    const elapsed = Math.max(0, Date.now() - v.turnStartTs);
    turnPct = Math.max(0, Math.min(100, ((v.turnMs - elapsed) / v.turnMs) * 100));
    isDanger = turnPct < 30;
    const maxSecs = Math.max(1, Math.ceil(v.turnMs / 1000));
    secsLeft = Math.max(0, Math.min(maxSecs, Math.ceil((v.turnMs - elapsed) / 1000)));
  }
  // در حالت سرعتی: هر کاربر فقط تایمر عدد معکوس را روی آواتار خود می‌بیند؛
  // در حالت نوبتی کلاسیک: عدد تایمر روی آواتار بازیکنِ دارای نوبت برای همه دیده می‌شود.
  const isMe = (seat === v.you);
  const showTurnNumber = isTurn && (!v.speedMode || isMe);
  const baseSize = window.innerWidth <= 560 ? 46 : 52;
  const avSize = isMe ? baseSize : Math.round(baseSize * 0.85);
  const isBotSeat = Boolean(v.bots?.[seat] || (v.names?.[seat] && v.names[seat].startsWith('ربات')));
  const seatAvatarUrl = isBotSeat ? null : ((v.avatarUrls || [])[seat] || (isMe ? (myProfile?.avatar_url || null) : null));
  const seatFrame = isBotSeat ? null : ((v.avatarFrames || [])[seat] || (isMe ? (myProfile?.avatar_frame || null) : null));
  const av = avatarEl(v.names?.[seat] || '?', seatAvatarUrl, avSize, isTurn, turnPct, isDanger, true, showTurnNumber ? secsLeft : null, isBotSeat, seatFrame);

  // نشانِ قطعِ اتصال / رهاسازی: مستقیماً متصل به لفاف آواتار تا چرخش نام صندلی آن را جابجا نکند
  if (isDisc || isAbandoned) {
    const badge = el('div', { className: 'bank-badge' + (isAbandoned ? ' abandoned' : '') });
    if (isAbandoned) {
      badge.textContent = '🤖 ربات';
      badge.title = 'این بازیکن مسابقه را ترک کرد — ربات حرفه‌ای تا پایان بازی می‌کند';
    } else {
      const left = Math.max(0, Math.round((discDeadline - Date.now()) / 1000));
      badge.innerHTML = `<span class="bank-ic">🤖</span><b class="bank-secs">${faNum(left)}</b><span class="bank-th">ث</span>`;
      badge.dataset.deadline = String(discDeadline);
      badge.title = 'قطع اتصال — بانک زمان تا جایگزینی دائمی ربات';
    }
    av.append(badge);
  }

  if (seat !== v.you) {
    av.style.cursor = 'pointer';
    av.onclick = (e) => { e.stopPropagation(); profileCardUI.show(lastView || v, seat, av); };
  }
  // تاجِ حاکم مستقیماً روی آواتار
  if (isHakem) av.append(crownEl());
  syncSeatBidChip(av, v, seat);
  box.append(av);

  // فقط نام — نقشِ حاکم/متعهد با تاجِ بالای آواتار نشان داده می‌شود، نه متنِ داخلِ کادر
  const playerElo = (v.eloRatings || [])[seat];
  const playerGames = (v.gamesPlayed || [])[seat];
  const playerTitle = (v.playerTitles || [])[seat] || (seat === v.you ? (myProfile?.player_title || null) : null);
  const playerBooster = (v.hasBoosters || [])[seat] || (seat === v.you ? (Boolean(myProfile?.active_booster) || null) : null);
  const name = el('div', { className: 'seat-name' },
    playerElo != null ? gradeTag(playerElo, playerGames) : null,
    playerBooster ? el('span', { className: 'seat-booster-badge', title: 'بوستر امتیاز فعال ⚡', textContent: '⚡' }) : null,
    el('span', { textContent: (v.names?.[seat] || (v.roomState === 'WAITING' ? t('waiting.empty_seat', null, 'صندلی خالی') : '')) + (seat === v.you ? ' (' + t('waiting.you', null, 'شما') + ')' : '') }),
    playerTitle ? el('span', { className: 'seat-player-title', textContent: playerTitle }) : null,
  );
  if (seat !== v.you) {
    name.style.cursor = 'pointer';
    name.onclick = (e) => { e.stopPropagation(); profileCardUI.show(lastView || v, seat, name); };
  }
  box.append(name);

  // کارت‌های پشت‌رو (بازیکنان دیگر) — همه‌ی کارت‌ها نمایش داده می‌شوند؛
  // با کم‌شدنِ تعداد، هم‌پوشانی کمتر می‌شود (تراکمِ داینامیک).
  if (seat !== v.you) {
    const n = (v.handCounts || [])[seat] ?? 0;
    const full = n;
    const fan = el('div', { className: 'fan' });
    // پهنای نوارِ دیدهٔ هر کارت — ۲۰٪ فشرده‌تر از قبل (× ۰.۸)
    const sliver = Math.max(9, Math.min(18, 165 / Math.max(1, full))) * 0.8;
    fan.style.setProperty('--fan-sliver', sliver.toFixed(1) + 'px');
    fan.style.setProperty('--fan-mid', ((full - 1) / 2).toFixed(2));
    fan.style.setProperty('--fan-spread', Math.min(5, 44 / Math.max(1, full)).toFixed(2) + 'deg');
    // حینِ پخش، کارت‌ها از **مرکزِ بادبزن به بیرون** ظاهر می‌شوند تا هر لحظه یک بادبزنِ
    // کوچک‌ترِ وسط‌چین دیده شود (پرشدن از یک لبه، مثلِ کارت‌های ولو روی میز دیده می‌شد).
    // نودها همان اولِ دست ساخته شده‌اند؛ فقط animation-delay دارند. delayِ منفی یعنی
    // «قبلاً ظاهر شده»، پس رندرهای بعدی انیمیشن را از نو اجرا نمی‌کنند.
    const D = _dealDeal;
    const rc = D && D.roundCounts;
    // نوبتِ این صندلی داخلِ هر دورِ پخش (ساعت‌گرد، از نفرِ بعدِ کاربر)
    const si = D ? ((seat - D.you - 1 + 4) % 4) : 0;
    const packAt = (r) => D.t0 + (D.initialDelay || 0) + (r * 4 + si) * D.step + r * (D.roundPause || 0) + (D.landOffset || Math.round(D.anim * 0.73));
    const mid = (n - 1) / 2, band = D ? (n / 2) / D.packs : 1;
    const nowMs = D ? Date.now() : 0;
    for (let i = 0; i < n; i++) {
      const c = fanCardEl(seat, i);
      if (D) {
        let delayMs;
        if (rc) {
          // دقیقاً همون تقسیم‌بندیِ واقعیِ ۵/۴/۳ که hand-strip خودت استفاده می‌کنه،
          // به‌علاوه‌ی ظاهرشدنِ دون‌دونه (نه یهویی) داخلِ هر دسته
          let r = rc.length - 1, within = 0, acc = 0;
          for (let rr = 0; rr < rc.length; rr++) {
            if (i < acc + rc[rr]) { r = rr; within = i - acc; break; }
            acc += rc[rr];
          }
          delayMs = packAt(r) - nowMs + within * DEAL_STAGGER;
        } else {
          const r = Math.min(D.packs - 1, Math.floor(Math.abs(i - mid) / band));
          delayMs = packAt(r) - nowMs;
        }
        c.style.animation = 'fan-in .24s ease-out both';
        c.style.animationDelay = delayMs + 'ms';
      }
      fan.append(c);
    }
    box.append(el('div', { className: 'fan-wrap' }, fan));
  }
  return box;
}

// یک کارتِ پشت‌روِ بادبزنِ حریف. کجیِ «دستی» قطعی است (صندلی+اندیس) تا با هر رندر نپرد.
function fanCardEl(seat, i) {
  const cardBack = getActiveCardBack(seat);
  const c = cardEl(null, { faceDown: true, small: true, cardBack });
  c.style.setProperty('--i', String(i));
  c.style.setProperty('--jit', (((seat * 13 + i * 7) % 5) - 2) * 0.5 + 'deg');
  c.style.setProperty('--jity', ((((seat * 5 + i * 11) % 4) - 1.5) * 0.8).toFixed(1) + 'px');
  return c;
}

// حبابِ پیامِ صوتی در ui/chatVoice.js ماژولار شده است
// ─── المان حباب ───────────────────────────────────────────────────────────────
function bubbleEl(bubble, seat, v) {
  const isBid = bubble.isBid;
  const isPass = bubble.isPass;
  const wrap = el('div', {
    className: 'seat-bubble' +
      (bubble.voiceId ? ' voice' : '') +
      (isBid ? ' bid' : '') +
      (isPass ? ' pass' : '') + ' is-new',
  });
  if (bubble._seq != null) wrap.dataset.bseq = String(bubble._seq);
  // انیمیشنِ ورود فقط یک‌بار. بعد از پخش، کلاس برداشته می‌شود تا ورودِ دوبارهٔ
  // نود به سند (هنگام جایگزینیِ صندلی در رندرِ بعدی) آن را از نو اجرا نکند.
  const dropIsNew = () => wrap.classList.remove('is-new');
  wrap.addEventListener('animationend', dropIsNew, { once: true });
  setTimeout(dropIsNew, 400);   // پشتیبان: اگر انیمیشن اجرا نشد (reduced-motion)
  if (bubble.voiceId) {
    const dur = bubble.duration_s || 0;
    const isPlaying = getCurrentVoicePlayback()?.voiceId === bubble.voiceId;
    const voiceCard = el('div', {
      className: 'seat-bubble-voice' + (isPlaying ? ' playing' : ''),
      id: `bubble-voice-${bubble.voiceId}`,
      title: 'در حال پخش پیام صوتی (برای قطع لمس کنید)',
      onclick: (e) => {
        e.stopPropagation();
        if (getCurrentVoicePlayback()?.voiceId === bubble.voiceId) {
          stopCurrentVoice();
          clearBubbleWithAnimation(seat);
          return;
        }
        playVoice(bubble.voiceId, bubble.data_b64, seat, dur);
        table?.markVoiceListened?.(bubble.voiceId);
      },
    },
      el('span', { className: 'sb-voice-icon', textContent: '🎙️' }),
      el('span', { className: 'sb-voice-wave' },
        el('i'), el('i'), el('i'), el('i'), el('i')
      ),
      el('span', { className: 'sb-voice-dur', textContent: `${faNum(dur)}″` }),
    );
    wrap.append(voiceCard);
  } else {
    wrap.textContent = bubble.i18nKey ? t(bubble.i18nKey, bubble.params, bubble.text) : (bubble.text || '');
  }
  return wrap;
}

// ─── مرکز میز ────────────────────────────────────────────────────────────────
let _lastWinPos = null;             // جهتِ برندهٔ آخرین دور، برای انیمیشنِ جمع‌کردن
let _kotPhaseHandNo = -1;
let _kotPhaseStartTs = 0;
let _biddingKotHandNo = -1;

function centerArea(v) {
  if (!_cachedCenterEl) {
    _cachedCenterEl = el('div', { className: 'center' });
  }
  const c = _cachedCenterEl;

  if (v.gameType === 'chahar_barg') {
    return renderChaharBargCenter(v, c, { cardEl, el, faNum, getSeatPos: (s, y) => getSeatPos(s, y, v.playerCount) });
  }
  if (v.gameType === 'bluff') {
    renderBluffCenter(v, c, { cardEl, el, faNum });
    return c;
  }

  // reveal فقط در فازِ تعیینِ حاکم (حکم) نشان داده شود؛ در شلم نباید هیچ کارتی رو شود.
  if (v.gameType !== 'shelem' && v.reveal && Array.isArray(v.reveal.shown) && v.phase === 'REVEAL' && (v.trick || []).length === 0) {
    c.replaceChildren();
    // نمایش آخرین کارت کشیده شده برای هر صندلی تا میز پویا و باهویت باشد
    const latestPerSeat = new Map();
    for (const item of v.reveal.shown) {
      if (item && item.seat != null) latestPerSeat.set(item.seat, item);
    }
    const last = v.reveal.shown[v.reveal.shown.length - 1];
    for (const [seat, item] of latestPerSeat.entries()) {
      const pos = getSeatPos(seat, v.you);
      const isWinner = v.reveal.done && (v.reveal.hakemSeat === seat);
      const isLatest = last && (last.seat === seat);
      c.append(el('div', {
        className: `play play-${pos}` + (isWinner ? ' win' : (isLatest ? ' pop' : '')),
      }, cardEl(item.card, { small: true })));
    }
    if (last) {
      c.append(el('div', { className: 'reveal-banner', textContent: v.reveal.done ? (t('game.hakem_is', { name: v.names?.[v.reveal.hakemSeat] || '' }, `حاکم: ${v.names?.[v.reveal.hakemSeat] || ''}`)) : t('game.determining_hakem', null, 'در حال تعیین حاکم…') }));
    }
    return c;
  }

  // نمایش مدال سلطنتی در مرکز میز در فاز انتخاب حکم (بازی حکم)
  if (v.gameType === 'hokm' && v.phase === 'CHOOSE_HOKM' && (v.trick || []).length === 0) {
    c.replaceChildren();
    const isHakem = v.hakemSeat === v.you;
    const hakemName = (v.hakemSeat != null && v.names) ? (v.names[v.hakemSeat] || 'حاکم') : 'حاکم';
    const choosingMedallion = el('div', { className: 'felt-hokm-choosing' },
      el('div', { className: 'fhc-crown-ring' },
        el('div', { className: 'fhc-pulsing-orbit' }),
        el('div', { className: 'fhc-crown-core' },
          el('span', { className: 'fhc-crown-emoji' }, '👑')
        )
      ),
      el('div', { className: 'fhc-badge' },
        el('span', {
          className: 'fhc-badge-text',
          textContent: isHakem
            ? t('table.hand_hint_choose_hokm', null, 'کارت‌های شما برای انتخاب حکم')
            : `${hakemName} در حال تعیین خال حکم…`
        })
      )
    );
    c.append(choosingMedallion);
    return c;
  }

  // نمایش ۴ برگ زمین در بازی شلم حین پخش، بیدینگ و فاز تعیین حکم
  if (v.gameType === 'shelem' && (v.trick || []).length === 0 && v.phase !== 'REVEAL') {
    if (v.phase === 'BIDDING' || v.phase === 'DEALING') {
      const kotCount = 4;
      const existingKot = c.querySelector('.felt-kot-deck:not(.revealed)');
      if (existingKot && _biddingKotHandNo === v.handNo && existingKot.querySelectorAll('.card').length === kotCount) {
        return c; // از قبل روی میز است — بدون انهدام DOM و انیمیشن پرش مجدد
      }
      _biddingKotHandNo = v.handNo;
      c.replaceChildren();
      const kotDeckCards = [];
      for (let i = 0; i < kotCount; i++) kotDeckCards.push(cardEl({}, { faceDown: true, small: true, cardBack: getActiveCardBack() }));
      const kotDeck = el('div', { className: 'felt-kot-deck' },
        el('div', { className: 'kot-deck-cards' }, ...kotDeckCards),
        el('span', { className: 'kot-deck-badge', textContent: `${faNum(kotCount)} برگ زمین` })
      );
      c.append(kotDeck);
      return c;
    }
    if (v.phase === 'PASS_KOT') {
      if (_kotPhaseHandNo !== v.handNo) {
        _kotPhaseHandNo = v.handNo;
        _kotPhaseStartTs = Date.now();
        if (v.hakemSeat === v.you) {
          sounds.kotReveal();
          clearBubble(v.you);
        }
        setTimeout(scheduleRender, 1900);
      }
      const elapsed = Date.now() - _kotPhaseStartTs;
      if (elapsed < 2100) {
        c.replaceChildren();
        const isHakem = v.hakemSeat === v.you;
        const isGliding = elapsed >= 1600;
        const kotCount = 4;
        const deckCls = 'felt-kot-deck' + (isHakem ? ' revealed' : '') +
          (isGliding ? (isHakem ? ' gliding-to-hand' : ` gliding-to-seat-${getSeatPos(v.hakemSeat, v.you)}`) : '');
        const kotDeck = el('div', { className: deckCls });
        const cardsWrap = el('div', { className: 'kot-deck-cards' });
        if (isHakem) {
          const kCards = (v.kotCards && v.kotCards.length === kotCount) ? v.kotCards : (v.yourHand || []).slice(-kotCount);
          for (const card of kCards) {
            cardsWrap.append(cardEl(card, { small: true }));
          }
          kotDeck.append(cardsWrap, el('span', { className: 'kot-deck-badge gold', textContent: `${faNum(kotCount)} برگ زمین به دست شما اضافه شد…` }));
        } else {
          for (let i = 0; i < kotCount; i++) {
            cardsWrap.append(cardEl({}, { faceDown: true, small: true, cardBack: getActiveCardBack() }));
          }
          kotDeck.append(cardsWrap, el('span', { className: 'kot-deck-badge', textContent: `${faNum(kotCount)} برگ زمین برای ${v.names?.[v.hakemSeat] || 'حاکم'}` }));
        }
        c.append(kotDeck);
        return c;
      }
    }
  }

  // اگر بنر reveal، کوت قبلی یا مدال انتخاب حکم در کانتینر مانده بود، پاکش کن
  const revBanner = c.querySelector('.reveal-banner');
  const prevKotDeck = c.querySelector('.felt-kot-deck');
  const prevHokmMedallion = c.querySelector('.felt-hokm-choosing');
  if (revBanner || prevKotDeck || prevHokmMedallion) c.replaceChildren();

  const trick = v.trick || [];
  if (v.handNo !== _dealHandNo) {
    _thrownCards.clear();
    _cardThrowTimers.clear();
    _userThrowVec.clear();
  } else if (trick.length === 0) {
    for (const id of Array.from(_thrownCards)) {
      const isOptimistic = c.querySelector(`.play[data-card-id="${id}"][data-optimistic="1"]`);
      if (!isOptimistic) {
        _thrownCards.delete(id);
        _cardThrowTimers.delete(id);
        _userThrowVec.delete(id);
      }
    }
  }

  // جهتِ برندهٔ آخرین دور را نگه دار تا هنگامِ پاک‌شدنِ تریک، کارت‌ها به سمتِ او جمع شوند.
  if (v.lastWin != null) _lastWinPos = getSeatPos(v.lastWin, v.you);

  // Keyed DOM reconciliation: نگاشت کارت‌های فعلی داخل کانتینر
  const existingMap = new Map();
  for (const child of Array.from(c.querySelectorAll('.play[data-card-id]:not(.collecting)'))) {
    existingMap.set(child.getAttribute('data-card-id'), child);
  }

  const currentIds = new Set(trick.map((t) => String(t.card.id)));

  // ۱. حذف کارت‌هایی که دیگر روی میز نیستند. اگر ۳ کارت یا بیشتر هم‌زمان می‌روند
  // یعنی یک دور کامل شده → به‌جای ناپدیدشدنِ آنی، به سمتِ صندلیِ برنده جمع می‌شوند.
  const toRemove = [...existingMap.entries()].filter(([id, node]) => {
    if (currentIds.has(id)) return false;
    if (node.dataset.optimistic === '1') {
      const thrownAt = _cardThrowTimers.get(id) || 0;
      if (Date.now() - thrownAt < 1500) return false;
    }
    return true;
  });
  const trickCollect = toRemove.length >= 3 && _lastWinPos && !_reducedMotion();
  if (toRemove.length >= 3) {
    sounds.trick();
  }
  if (trickCollect) {
    let trickPts = 0;
    for (const [id, node] of toRemove) {
      const rank = node.getAttribute('data-card-rank');
      if (rank) trickPts += getCardPoints(rank);
    }
    if (trickPts > 0) {
      // معادلِ بصریِ و صوتی: امتیازِ دور با کارت‌ها به‌سمتِ برنده پرواز می‌کند.
      // (حکم امتیازِ کارتی ندارد — آنجا فقط کارت‌ها جمع می‌شوند و صدا پخش نمی‌شود.)
      if (v.gameType !== 'hokm') {
        sounds.pointHarvest(trickPts, _lastWinPos === 'left' ? -0.5 : _lastWinPos === 'right' ? 0.5 : 0);
        const chip = el('div', { className: `trick-pts to-${_lastWinPos}`, textContent: '+' + faNum(trickPts) });
        c.append(chip);
        setTimeout(() => chip.remove(), 850);
      }
    }
  }
  toRemove.forEach(([id, node], k) => {
    existingMap.delete(id);
    if (trickCollect) {
      node.style.zIndex = String(30 - k);
      node.classList.add('collecting', 'collect-' + _lastWinPos);
      setTimeout(() => node.remove(), 420);
    } else {
      node.remove();
    }
  });
  if (trickCollect) _lastWinPos = null;

  // ۲. افزودن یا به‌روزرسانی کارت‌های دور جاری با حفظ المان‌های قبلی در DOM
  for (let i = 0; i < trick.length; i++) {
    const { seat, card } = trick[i];
    const cardIdStr = String(card.id);
    let playEl = existingMap.get(cardIdStr);
    const isWin = (trick.length >= 4 || v.phase === 'REVEAL') && v.lastWin === seat;
    const pos = getSeatPos(seat, v.you);
    const targetClass = `play play-${pos}` + (isWin ? ' win' : '');
    const baseRotByPos = { bottom: -4, top: 5, left: -8, right: 7 };
    const jitter = getCardTableJitter(card.id);
    const baseRot = baseRotByPos[pos] ?? 0;

    // بررسی بُرش با حکم (Trump Cut): جوکر سر است؛ اگر جوکر در تریک بازی شده باشد، حکم برش نیست
    const leadCard = trick[0]?.card;
    const leadIsTrump = leadCard && (leadCard.suit === v.hokm || isJoker(leadCard));
    const hasPriorJoker = trick.slice(0, i).some((t) => isJoker(t.card));
    const isTrumpCut = v.hokm && i > 0 &&
      !leadIsTrump &&
      !hasPriorJoker &&
      (card.suit === v.hokm || isJoker(card));

    if (!playEl) {
      const node = cardEl(card, { small: true });
      const finalRot = (pos === 'bottom' && _userThrowVec.has(card.id))
        ? _userThrowVec.get(card.id).restRot
        : (baseRot + jitter.jrot);
      node.style.setProperty('--rest-rot', `${finalRot.toFixed(1)}deg`);

      if (!_thrownCards.has(card.id)) {
        node.classList.add('thrown');
        // اگر این کارتِ خودِ بازیکن است و با سوایپ پرتاب شده، جهتِ حرکتِ انگشت را
        // به انیمیشنِ پرتابِ روی میز منتقل کن. کارت‌های حریفان (top/left/right)
        // بردار لمسی ندارند و همان مقادیرِ پیش‌فرضِ CSS را می‌گیرند.
        if (pos === 'bottom') {
          const vec = _userThrowVec.get(card.id);
          if (vec) {
            node.style.setProperty('--from-x', `${vec.fromX.toFixed(1)}px`);
            _userThrowVec.delete(card.id);
          }
        }
        if (isTrumpCut) {
          node.classList.add('trump-cut-card');
          sounds.trumpCut(_seatPan(seat, v.you));
          spawnTrumpCutSlash(pos, c);
          const felt = c.closest('.felt');
          if (felt) {
            felt.classList.remove('trump-shake');
            requestAnimationFrame(() => {
              felt.classList.add('trump-shake');
              setTimeout(() => felt.classList.remove('trump-shake'), 320);
            });
          }
        }
        _thrownCards.add(card.id);
        _cardThrowTimers.set(card.id, Date.now());
        const removeThrown = () => {
          node.classList.remove('thrown');
        };
        node.addEventListener('animationend', removeThrown, { once: true });
        setTimeout(removeThrown, 420);
      }
      playEl = el('div', { className: targetClass });
      playEl.setAttribute('data-card-id', cardIdStr);
      playEl.setAttribute('data-card-rank', card.rank);
      playEl.setAttribute('data-card-suit', card.suit);
      playEl.style.setProperty('--jx', `${jitter.jx.toFixed(1)}px`);
      playEl.style.setProperty('--jy', `${jitter.jy.toFixed(1)}px`);
      playEl.append(node);
      c.append(playEl);
    } else {
      delete playEl.dataset.optimistic;
      // کارت از قبل روی میز است — مطمئن شو فقط در صورت اتمام انیمیشن پرتاب، کلاس thrown پاک می‌شود
      const innerCard = playEl.querySelector('.card');
      if (innerCard) {
        const thrownAt = _cardThrowTimers.get(card.id) || 0;
        if (Date.now() - thrownAt >= 420) {
          innerCard.classList.remove('thrown');
        }
      }
      if (playEl.className !== targetClass) {
        playEl.className = targetClass;
      }
    }
  }

  // نشانگر شناور خال زمینه (Lead Suit Pin) در بازی حکم حین جریان تریک
  let leadPin = c.querySelector('.lead-suit-pin');
  if (v.gameType === 'hokm' && trick.length > 0 && trick.length < 4 && v.leadSuit) {
    const isRed = RED.has(v.leadSuit);
    const glyph = SUIT_GLYPH[v.leadSuit] || '';
    const sName = suitName(v.leadSuit);
    if (!leadPin) {
      leadPin = el('div', { className: 'lead-suit-pin' },
        el('span', { className: 'lsp-label', textContent: t('table.lead_suit_lbl', null, 'خال زمینه:') }),
        el('span', { className: `lsp-badge ${isRed ? 'red' : 'black'}` },
          el('span', { className: 'lsp-glyph', textContent: glyph }),
          el('span', { className: 'lsp-name', textContent: sName })
        )
      );
      c.append(leadPin);
    } else {
      const badge = leadPin.querySelector('.lsp-badge');
      if (badge) {
        badge.className = `lsp-badge ${isRed ? 'red' : 'black'}`;
        const glyphEl = badge.querySelector('.lsp-glyph');
        const nameEl = badge.querySelector('.lsp-name');
        if (glyphEl) glyphEl.textContent = glyph;
        if (nameEl) nameEl.textContent = sName;
      }
    }
  } else if (leadPin) {
    leadPin.remove();
  }

  return c;
}

// ─── دست بازیکن ──────────────────────────────────────────────────────────────
// ترتیبِ نمایشِ دست: مرتب‌سازی دلخواه (بر اساس خال یا رتبه کارت‌ها از بزرگ به کوچک)
let handSortMode = (typeof localStorage !== 'undefined' && localStorage.getItem('cb_hand_sort')) || 'suit'; // 'suit' | 'rank'

const SUIT_SORT = { joker: -2, spades: 0, hearts: 1, clubs: 2, diamonds: 3 };
const RANK_SORT = { JOKER_RED: 16, JOKER_BLUE: 15, A: 14, K: 13, Q: 12, J: 11, '10': 10, 9: 9, 8: 8, 7: 7, 6: 6, 5: 5, 4: 4, 3: 3, 2: 2 };
function sortHand(cards, hokm = null) {
  const suitOrder = { ...SUIT_SORT };
  if (hokm && suitOrder[hokm] !== undefined) {
    suitOrder[hokm] = -1; // خال حکم در صدر دست قرار می‌گیرد
  }
  return [...cards].sort((a, b) => {
    if (handSortMode === 'rank') {
      const aIsHokm = hokm && a.suit === hokm ? 1 : 0;
      const bIsHokm = hokm && b.suit === hokm ? 1 : 0;
      if (aIsHokm !== bIsHokm) return bIsHokm - aIsHokm;
      return (RANK_SORT[b.rank] - RANK_SORT[a.rank]) || (suitOrder[a.suit] - suitOrder[b.suit]);
    }
    return (suitOrder[a.suit] - suitOrder[b.suit]) || (RANK_SORT[b.rank] - RANK_SORT[a.rank]);
  });
}

let passKotSelection = {
  selectedIds: new Set(),
  hokm: null,
  handNo: null,
  isSubmitting: false,
};

const CARD_PTS = { A: 10, '10': 10, '5': 5, JOKER_RED: 20, JOKER_BLUE: 15 };
function getCardPoints(rank) { return CARD_PTS[rank] || 0; }

function spawnFloatingPoints(pts, fromEl) {
  if (!pts) return;
  const particle = el('div', {
    className: 'floating-points-particle',
    textContent: `+${faNum(pts)} 🏆`,
  });
  if (fromEl) {
    const rect = fromEl.getBoundingClientRect();
    particle.style.left = `${rect.left + rect.width / 2}px`;
    particle.style.top = `${rect.top}px`;
  } else {
    particle.style.left = '50%';
    particle.style.top = '70%';
  }
  document.body.append(particle);
  setTimeout(() => particle.remove(), 1250);
}

// تولید خط نوری برشی در لحظه بُرش با حکم (The Trump Slash)
function spawnTrumpCutSlash(pos, container) {
  if (!container) return;
  const slash = el('div', { className: `trump-cut-slash cut-from-${pos || 'bottom'}` });
  container.append(slash);
  setTimeout(() => slash.remove(), 460);
}

// اسپلش‌بنر سه‌بعدی اعلام حکم سلطنتی در مرکز میز
function spawnHokmAnnouncement(suit, hakemSeat, v) {
  const felt = document.querySelector('.felt') || document.querySelector('.table') || document.body;
  if (!felt) return;
  felt.querySelectorAll('.hokm-splash-banner').forEach((el) => el.remove());

  const isRed = RED.has(suit);
  const glyph = SUIT_GLYPH[suit] || '';
  const sName = suitName(suit);
  const hakemPlayer = (v && v.players && hakemSeat != null) ? v.players[hakemSeat] : null;
  const hakemName = (v?.names && hakemSeat != null && v.names[hakemSeat])
    ? v.names[hakemSeat]
    : (hakemPlayer?.username ? hakemPlayer.username : null);
  const subText = hakemName
    ? t('table.hokm_announced_by', { name: hakemName }, `اعلام توسط حاکم (${hakemName})`)
    : t('table.hokm_announced', null, 'حکم این دست تعیین شد');

  const banner = el('div', { className: `hokm-splash-banner suit-${suit} ${isRed ? 'red' : 'black'}` },
    el('div', { className: 'hsb-seal-icon' },
      el('span', { className: 'hsb-glyph', textContent: glyph })
    ),
    el('div', { className: 'hsb-content' },
      el('div', { className: 'hsb-pre-title', textContent: t('table.royal_decree', null, 'حُکـم شاهـی') }),
      el('div', { className: 'hsb-title' },
        el('span', { className: 'hsb-suit-name', textContent: sName }),
        el('span', { className: 'hsb-suit-symbol', textContent: glyph })
      ),
      el('div', { className: 'hsb-sub', textContent: subText })
    )
  );

  felt.append(banner);
  setTimeout(() => {
    banner.classList.add('fade-out');
    setTimeout(() => banner.remove(), 450);
  }, 2300);
}

// تولید ذرات خاکسترِ سوخته و جرقه‌های آتشِ ریخته‌شده از کارت
function spawnCardBurnParticles(cardNode) {
  if (!cardNode || _fxLow()) return;   // ۲۲ نودِ سایه‌دار؛ در کم‌مصرف فقط محوِ سادهٔ CSS
  const rect = cardNode.getBoundingClientRect();
  const cardW = rect.width || 80;
  const cardH = rect.height || 115;

  // ۱. تکه‌های سوخته و خاکسترِ ورق که خرد شده و به سمت پایین می‌ریزند (Ash flakes falling)
  const flakeCount = 14;
  for (let i = 0; i < flakeCount; i++) {
    const flake = document.createElement('div');
    flake.className = 'card-ash-flake';

    // اندازه و شکل نامتقارن تکه سوخته
    const w = Math.floor(6 + Math.random() * 9);
    const h = Math.floor(5 + Math.random() * 8);
    flake.style.width = `${w}px`;
    flake.style.height = `${h}px`;
    flake.style.borderRadius = `${Math.floor(1 + Math.random() * 4)}px ${Math.floor(3 + Math.random() * 6)}px ${Math.floor(1 + Math.random() * 5)}px ${Math.floor(2 + Math.random() * 5)}px`;

    // بافت و رنگ سوخته (زغال مات، یا دارای لبه قرمز آتشین)
    const hasEmberEdge = Math.random() < 0.45;
    if (hasEmberEdge) {
      flake.style.background = `linear-gradient(${Math.floor(Math.random() * 360)}deg, #0e0a08 0%, #1e1511 60%, #ff4500 100%)`;
      flake.style.boxShadow = '0 0 4px rgba(255, 69, 0, 0.75), inset 0 0 2px rgba(255, 140, 0, 0.5)';
      flake.style.border = '0.5px solid rgba(255, 69, 0, 0.4)';
    } else {
      flake.style.background = '#141110';
      flake.style.boxShadow = 'inset 0 0 3px #050302';
      flake.style.border = '0.5px solid rgba(40, 30, 25, 0.6)';
    }

    // محل شروع روی سطح کارت با پراکندگی طبیعی
    const startX = rect.left + 6 + Math.random() * (cardW - 12);
    const startY = rect.top + 6 + Math.random() * (cardH - 14);
    flake.style.left = `${startX}px`;
    flake.style.top = `${startY}px`;

    // متغیرهای فیزیک پرتاب، چرخش و ریزش به پایین
    const driftSign = Math.random() < 0.5 ? -1 : 1;
    const dx1 = Math.round(Math.random() * 14 - 7);
    const dy1 = Math.round(-6 - Math.random() * 16);
    const rot1 = Math.round(driftSign * (20 + Math.random() * 60));

    const dx2 = Math.round(driftSign * (10 + Math.random() * 25));
    const dy2 = Math.round(30 + Math.random() * 40);
    const rot2 = Math.round(driftSign * (90 + Math.random() * 150));

    const dx3 = Math.round(driftSign * (18 + Math.random() * 35));
    const dy3 = Math.round(70 + Math.random() * 55);
    const rot3 = Math.round(driftSign * (200 + Math.random() * 220));

    const dx4 = Math.round(driftSign * (24 + Math.random() * 45));
    const dy4 = Math.round(110 + Math.random() * 70);
    const rot4 = Math.round(driftSign * (340 + Math.random() * 360));

    flake.style.setProperty('--dx1', `${dx1}px`);
    flake.style.setProperty('--dy1', `${dy1}px`);
    flake.style.setProperty('--rot1', `${rot1}deg`);
    flake.style.setProperty('--dx2', `${dx2}px`);
    flake.style.setProperty('--dy2', `${dy2}px`);
    flake.style.setProperty('--rot2', `${rot2}deg`);
    flake.style.setProperty('--dx3', `${dx3}px`);
    flake.style.setProperty('--dy3', `${dy3}px`);
    flake.style.setProperty('--rot3', `${rot3}deg`);
    flake.style.setProperty('--dx4', `${dx4}px`);
    flake.style.setProperty('--dy4', `${dy4}px`);
    flake.style.setProperty('--rot4', `${rot4}deg`);

    const dur = 0.85 + Math.random() * 0.25;
    flake.style.setProperty('--fall-dur', `${dur}s`);
    flake.style.animationDelay = `${Math.floor(Math.random() * 300)}ms`;

    document.body.append(flake);
    setTimeout(() => flake.remove(), 1450);
  }

  // ۲. جرقه‌ها و دانه‌های درخشان آتش برخاسته از کارت (Fiery sparks)
  const sparkCount = 8;
  for (let j = 0; j < sparkCount; j++) {
    const spark = document.createElement('div');
    spark.className = 'card-fire-spark';

    const sz = Math.floor(3 + Math.random() * 4);
    spark.style.width = `${sz}px`;
    spark.style.height = `${sz}px`;

    const startX = rect.left + 10 + Math.random() * (cardW - 20);
    const startY = rect.top + 10 + Math.random() * (cardH - 20);
    spark.style.left = `${startX}px`;
    spark.style.top = `${startY}px`;

    const sSign = Math.random() < 0.5 ? -1 : 1;
    const sdx1 = Math.round(sSign * Math.random() * 12);
    const sdy1 = Math.round(-15 - Math.random() * 20);
    const sdx2 = Math.round(sSign * (10 + Math.random() * 25));
    const sdy2 = Math.round(-40 - Math.random() * 35);
    const sdx3 = Math.round(sSign * (18 + Math.random() * 40));
    const sdy3 = Math.round(-70 - Math.random() * 50);

    spark.style.setProperty('--sdx1', `${sdx1}px`);
    spark.style.setProperty('--sdy1', `${sdy1}px`);
    spark.style.setProperty('--sdx2', `${sdx2}px`);
    spark.style.setProperty('--sdy2', `${sdy2}px`);
    spark.style.setProperty('--sdx3', `${sdx3}px`);
    spark.style.setProperty('--sdy3', `${sdy3}px`);

    const dur = 0.65 + Math.random() * 0.35;
    spark.style.setProperty('--spark-dur', `${dur}s`);
    spark.style.animationDelay = `${Math.floor(Math.random() * 250)}ms`;

    document.body.append(spark);
    setTimeout(() => spark.remove(), 1250);
  }
}

// ═══ فازِ سوزاندنِ کوت ═══
// حاکم فقط ۴ برگ می‌سوزاند — خالِ حکم دیگر انتخاب نمی‌شود (اولین برگی که لید می‌کند
// خودِ حکم می‌شود). پس نه پنلی، نه suit-picker: فقط کارت‌های دست + یک دکمهٔ شناورِ
// کوچک که با انتخابِ برگِ چهارم ظاهر می‌شود. کارتِ انتخاب‌شده سرِ جایش بالا می‌آید،
// نودهای فن حفظ می‌شوند و انتخاب فقط یک کلاس را نرم toggle می‌کند.

function kotConfirmFab(v, wrap) {
  const btn = el('button', {
    type: 'button', className: 'kot-confirm-fab pending',
    hidden: true,
    style: 'display: none',
    onclick: (e) => { e.stopPropagation(); _kotConfirm(v, wrap); },
  });
  return btn;
}

// فنِ کوت را با state هماهنگ می‌کند: کارت‌ها در دو ردیف بادبزنی (موبایل و دسکتاپ) منظم قرار می‌گیرند.
function _kotSync(v, wrap) {
  const hand = sortHand(v.yourHand || [], v.hokm);
  const sel = passKotSelection.selectedIds;
  const fan = wrap.querySelector('.kot-fan');
  if (!fan) return;
  wrap._fanNodes = wrap._fanNodes || new Map();
  const seen = new Set();

  let rowTop = fan.querySelector(':scope > .kot-row.row-top');
  let rowBot = fan.querySelector(':scope > .kot-row.row-bottom');
  if (!rowTop || !rowBot) {
    fan.querySelectorAll(':scope > .kot-row').forEach((r) => r.remove());
    fan.querySelectorAll(':scope > .card').forEach((c) => c.remove());
    rowTop = el('div', { className: 'kot-row row-top' });
    rowBot = el('div', { className: 'kot-row row-bottom' });
    fan.append(rowTop, rowBot);
  }

  // روی دسکتاپ تمام ۱۶ برگ در یک ردیف بادبزنی باز و شکیل چیده می‌شوند؛ فقط در موبایل دو ردیفه می‌شود
  const isMob = _isMobileHand();
  const splitIdx = isMob ? getHandRowSplitIndex(hand, true) : 0;
  const topCards = splitIdx > 0 ? hand.slice(0, splitIdx) : [];
  const botCards = splitIdx > 0 ? hand.slice(splitIdx) : hand;

  const renderKotCard = (card, idxInRow, rowCards, targetRow, rowOffset) => {
    const globalIdx = rowOffset + idxInRow;
    let c = wrap._fanNodes.get(card.id);
    if (!c) {
      c = cardEl(card, { selectable: true });
      c.classList.add('click');
      c.dataset.cid = card.id;
      c.onclick = (e) => { e.stopPropagation(); _kotClick(v, wrap, card, c); };
      wrap._fanNodes.set(card.id, c);
    }
    if (c.parentNode !== targetRow || targetRow.children[idxInRow] !== c) {
      targetRow.insertBefore(c, targetRow.children[idxInRow] || null);
    }
    delete c.dataset.restingTransform;

    const n = rowCards.length;
    const mid = (n - 1) / 2;
    const distFromMid = isRTL() ? (mid - idxInRow) : (idxInRow - mid);
    const absDist = Math.abs(distFromMid);

    // زاویه بادبزنی و قوس متقارن — در دسکتاپ با محور دورتر (280%) و شیب ملایم‌تر
    const angleStep = isMob ? Math.min(4.2, 24 / Math.max(1, n)) : Math.min(2.4, 34 / Math.max(1, n));
    const rotDeg = distFromMid * angleStep;
    const arcYPx = isMob ? (absDist * absDist) * 1.5 : (absDist * absDist) * 0.32;
    const fanXPx = 0;

    const finalRot = rotDeg.toFixed(2);
    const finalY = arcYPx.toFixed(1);
    const finalX = fanXPx.toFixed(1);

    c.style.setProperty('--fan-rot', `${finalRot}deg`);
    c.style.setProperty('--fan-y', `${finalY}px`);
    c.style.setProperty('--fan-x', `${finalX}px`);
    c.style.setProperty('--rot', `${finalRot}deg`);
    c.style.transformOrigin = isMob ? '50% 130%' : '50% 280%';
    c.style.transform = '';

    c.style.setProperty('--i', idxInRow);
    c.style.setProperty('--n', rowCards.length);
    c.style.setProperty('--global-i', globalIdx);
    c.style.setProperty('--total-n', hand.length);

    // فاصله‌گذاری هوشمند بین دسته‌های خال درون هر ردیف
    const isNewSuit = idxInRow > 0 && rowCards[idxInRow - 1].suit !== card.suit;
    c.classList.toggle('suit-gap', isNewSuit);

    const isSel = sel.has(card.id);
    c.classList.toggle('burn-marked', isSel);
    const badge = c.querySelector('.fire-badge');
    if (isSel && !badge) c.append(el('span', { className: 'fire-badge', textContent: '🔥' }));
    else if (!isSel && badge) badge.remove();
    seen.add(card.id);
  };

  topCards.forEach((card, idx) => renderKotCard(card, idx, topCards, rowTop, 0));
  botCards.forEach((card, idx) => renderKotCard(card, idx, botCards, rowBot, topCards.length));

  while (rowTop.children.length > topCards.length) {
    rowTop.lastElementChild.remove();
  }
  while (rowBot.children.length > botCards.length) {
    rowBot.lastElementChild.remove();
  }

  for (const [id, node] of wrap._fanNodes) {
    if (!seen.has(id)) { node.remove(); wrap._fanNodes.delete(id); }
  }

  fan.classList.toggle('has-pick', sel.size > 0);
  _kotUpdateConfirm(v, wrap);
}

function _kotUpdateConfirm(v, wrap) {
  const n = passKotSelection.selectedIds.size;
  const hand = v.yourHand || [];
  const req = 4;
  const pts = [...passKotSelection.selectedIds]
    .reduce((s, id) => s + getCardPoints((hand.find((c) => c.id === id) || {}).rank), 0);

  const promptEl = wrap.querySelector('.kot-instruction-title');
  if (promptEl) {
    promptEl.innerHTML = t('table.kot_select_prompt', {
      count: faNum(req),
      sel: `<b style="color:var(--gold, #f4c95d)">${faNum(n)}</b>`,
    }, `۴ برگ برای سوزاندن انتخاب کنید (${faNum(n)} از ${faNum(req)})`);
  }

  const btn = wrap.querySelector('.kot-confirm-fab');
  if (!btn) return;
  const submitting = passKotSelection.isSubmitting;

  if (submitting) {
    if (promptEl) { promptEl.hidden = true; promptEl.style.display = 'none'; }
    btn.hidden = false;
    btn.style.display = '';
    btn.disabled = true;
    btn.className = 'kot-confirm-fab pending';
    btn.innerHTML = `<span>🔥 ${t('table.kot_burning', null, 'در حال سوزاندن…')}</span>`;
  } else if (n === req) {
    if (promptEl) { promptEl.hidden = true; promptEl.style.display = 'none'; }
    btn.hidden = false;
    btn.style.display = '';
    btn.disabled = false;
    btn.className = 'kot-confirm-fab ready';
    const ptsText = pts > 0 ? ` · +${faNum(pts)} ${t('table.pts', null, 'امتیاز')}` : '';
    btn.innerHTML = `<span>🔥 ${t('table.kot_burn_btn', { count: faNum(req), pts: ptsText }, `سوزاندن ${faNum(req)} برگ${ptsText}`)}</span>`;
  } else {
    // کمتر از ۴ برگ انتخاب شده: فقط تیتر راهنما نشان داده شود و دکمه غیرفعال اضافی پنهان بماند
    if (promptEl) { promptEl.hidden = false; promptEl.style.display = ''; }
    btn.hidden = true;
    btn.style.display = 'none';
    btn.disabled = true;
    btn.className = 'kot-confirm-fab pending';
    btn.innerHTML = '';
  }
}

function _kotClick(v, wrap, card, node) {
  if (passKotSelection.isSubmitting) return;
  const sel = passKotSelection.selectedIds;
  const selecting = !sel.has(card.id);
  const req = 4;
  if (selecting && sel.size >= req) {
    sounds.reject();
    if (navigator.vibrate) try { navigator.vibrate([30, 20, 30]); } catch { /* noop */ }
    node.classList.remove('reject');
    requestAnimationFrame(() => {
      node.classList.add('reject');
      setTimeout(() => node.classList.remove('reject'), 420);
    });
    return;
  }
  if (selecting) sel.add(card.id); else sel.delete(card.id);
  sounds.play();
  if (navigator.vibrate) try { navigator.vibrate(selecting ? 18 : 13); } catch { /* noop */ }
  _kotSync(v, wrap);
}

function showMinimalHokmModal(v, wrap, discardIds, onChosen) {
  const existing = document.querySelector(".minimal-joker-hokm-overlay");
  if (existing) existing.remove();

  const titleText = t("table.choose_joker_hokm_minimal_title", null, "تعیین خالِ حکم");
  const panel = overlay(titleText);
  panel.classList.add("clear-hand-overlay", "choose-hokm-overlay", "minimal-joker-hokm-overlay");

  const inner = panel.querySelector(".panel");
  inner.append(el("p", {
    className: "muted",
    textContent: t("table.choose_joker_hokm_minimal_sub", null, "شلم با جوکر — لطفاً خالِ حکم این دست را مشخص کنید:"),
  }));

  const discardSet = new Set(discardIds || []);
  const remainingHand = (v.yourHand || []).filter((c) => !discardSet.has(c.id));
  const suitCounts = { spades: 0, hearts: 0, diamonds: 0, clubs: 0 };
  for (const c of remainingHand) {
    if (c && c.suit && suitCounts[c.suit] != null && !isJoker(c)) {
      suitCounts[c.suit]++;
    }
  }

  let maxCount = 0;
  for (const s of Object.keys(suitCounts)) {
    if (suitCounts[s] > maxCount) maxCount = suitCounts[s];
  }

  const suits = ["spades", "hearts", "diamonds", "clubs"];
  const suitRow = el("div", { className: "suit-row modern-suit-row" });
  suits.forEach((s) => {
    const isRed = RED.has(s);
    const count = suitCounts[s] || 0;
    const isBest = (maxCount > 0 && count === maxCount);

    const btn = el("button", {
      className: "modern-suit-btn suit-" + s + (isRed ? " red" : "") + (isBest ? " is-best" : ""),
      dataset: { suit: s },
      onclick: () => {
        sounds.hokm();
        panel.classList.add("choice-sent");
        btn.classList.add("chosen");
        setTimeout(() => {
          panel.remove();
          onChosen(s);
        }, 180);
      },
    });

    if (isBest) {
      btn.append(el("span", { className: "best-tag", textContent: t("table.best_suit_tag", null, "بیشترین") }));
    }

    const svgWrap = el("span", { className: "modern-suit-svg-wrap" });
    if (HOKM_SUIT_SVG[s]) {
      svgWrap.innerHTML = HOKM_SUIT_SVG[s];
    } else {
      svgWrap.textContent = SUIT_GLYPH[s] || "";
    }

    btn.append(
      svgWrap,
      el("span", { className: "modern-suit-name", textContent: suitName(s) }),
      el("span", { className: "modern-suit-count", textContent: t("table.cards_count_unit", { count: faNum(count) }, faNum(count) + " برگ") }),
    );
    suitRow.append(btn);
  });
  inner.append(suitRow);

  const cancelBtn = el("button", {
    className: "btn cancel-btn",
    style: "margin-top: 14px; padding: 6px 18px; font-size: 13px;",
    textContent: t("table.cancel", null, "انصراف"),
    onclick: () => {
      passKotSelection.isSubmitting = false;
      panel.remove();
      _kotSync(v, wrap || document.querySelector(".felt") || document.body);
    },
  });
  inner.append(el("div", { style: "text-align: center;" }, cancelBtn));

  guardChoiceTaps(panel);
  document.body.append(panel);
}

function _kotConfirm(v, wrap) {
  const n = passKotSelection.selectedIds.size;
  const req = 4;
  if (passKotSelection.isSubmitting || n !== req) return;

  if (v.jokerMode && !passKotSelection.hokm) {
    showMinimalHokmModal(v, wrap, [...passKotSelection.selectedIds], (chosenSuit) => {
      passKotSelection.hokm = chosenSuit;
      _kotExecuteBurn(v, wrap, chosenSuit);
    });
    return;
  }
  _kotExecuteBurn(v, wrap, passKotSelection.hokm || null);
}

function _kotExecuteBurn(v, wrap, chosenHokm = null) {
  passKotSelection.isSubmitting = true;
  _kotUpdateConfirm(v, wrap);
  sounds.burn();
  const hand = v.yourHand || [];
  const totalPts = [...passKotSelection.selectedIds]
    .reduce((s, id) => s + getCardPoints((hand.find((c) => c.id === id) || {}).rank), 0);
  wrap.querySelectorAll('.kot-fan .card.burn-marked').forEach((cardNode) => {
    cardNode.classList.add('burning');
    spawnCardBurnParticles(cardNode);
  });
  if (totalPts > 0) spawnFloatingPoints(totalPts, wrap.querySelector('.kot-confirm-fab'));
  setTimeout(() => {
    table.humanSetHokm([...passKotSelection.selectedIds], chosenHokm);
  }, 960);
}

// محاسبه وضعیت مرحله‌ای پخش کارت و انیمیشن مرتب‌سازی یکپارچه در پایان کل پخش
function getDealStage(v, now = Date.now()) {
  if (!v || !v.yourHand || v.yourHand.length === 0) {
    return { isDealing: false, stageKey: 'none', cards: [], newCardIds: new Set(), sortPhase: 'none' };
  }
  const isHokmSecond = (v.gameType === 'hokm') && (v.hokm != null || (v.yourHand && v.yourHand.length > 5));
  const curDealKey = (v.gameType === 'chahar_barg')
    ? `${v.handNo}_${v.dealIndex || 0}`
    : (v.gameType === 'hokm' ? `${v.handNo}_${isHokmSecond ? 1 : 0}` : v.handNo);
  if (!_dealDeal || (_dealDeal.dealKey || _dealDeal.handNo) !== curDealKey || _reducedMotion()) {
    return { isDealing: false, stageKey: 'idle', cards: sortHand(v.yourHand, v.hokm), newCardIds: new Set(), sortPhase: 'none' };
  }

  const elapsed = now - _dealDeal.t0;
  const rc = _dealDeal.roundCounts;
  const raw = v.yourHand;
  const perSeat = rc.length;
  const landedPacks = _dealDeal.landedPacks || 0;
  const initDel = _dealDeal.initialDelay || 0;
  const numSeats = _dealDeal.numSeats || 4;
  const isHokmStage1 = !!_dealDeal.isHokmSecond;
  const baseCount = isHokmStage1 ? 5 : 0;

  // اگر پخش فقط یک دور است (مثلاً ۴ برگ چهاربرگ یا ۵ برگ اولیه حاکم)
  if (perSeat <= 1) {
    const fd = initDel + (numSeats - 1) * _dealDeal.step;
    const landTime = fd + _dealDeal.landOffset;
    if (landedPacks < 1 && elapsed < landTime - 25) {
      return { isDealing: true, stageKey: 'r_pre', cards: [], newCardIds: new Set(), sortPhase: 'none' };
    }
    return { isDealing: true, stageKey: 'r0_single', cards: sortHand(raw, v.hokm), newCardIds: new Set(), sortPhase: 'none' };
  }

  // حین پخش دورها (دورهای ۰، ۱ و ۲): کارت‌ها زنده مرتب می‌شوند و با ریتم آبشاری در دست می‌نشینند
  let newLandedCount = 0;
  let latestBatchStart = baseCount;
  let latestBatchCount = 0;

  for (let r = 0; r < perSeat; r++) {
    const fd = initDel + (r * numSeats + (numSeats - 1)) * _dealDeal.step + r * _dealDeal.roundPause;
    const landTime = fd + _dealDeal.landOffset;
    if (r < landedPacks || elapsed >= landTime - 25) {
      latestBatchStart = baseCount + newLandedCount;
      latestBatchCount = rc[r];
      newLandedCount += rc[r];
    }
  }

  const totalLanded = baseCount + newLandedCount;
  if (totalLanded === 0) {
    return { isDealing: true, stageKey: 'r_pre', cards: [], newCardIds: new Set(), sortPhase: 'none' };
  }

  const landedCards = raw.slice(0, totalLanded);
  const latestBatch = (latestBatchCount > 0)
    ? raw.slice(latestBatchStart, latestBatchStart + latestBatchCount)
    : [];
  const newCardIds = new Set(latestBatch.map((c) => c.id));
  const sortedLanded = sortHand(landedCards, v.hokm);
  // توالی آبشاری ورود برگ‌های تازه بر اساس جایگاه بصری چیدمان میان خال‌ها
  const batchCardIds = sortedLanded.filter((c) => newCardIds.has(c.id)).map((c) => c.id);

  return {
    isDealing: true,
    stageKey: `r_accum_${totalLanded}`,
    cards: sortedLanded,
    newCardIds,
    batchCardIds,
    sortPhase: 'none',
  };
}

// امضای هر چیزی که ظاهرِ نوارِ دست به آن بستگی دارد.
function handStripSig(v) {
  // انتخاب/حکم/isSubmittingِ کوت عمداً اینجا نیست: نوارِ کوت یک‌بار ساخته می‌شود و
  // _kotSync درجا به‌روزش می‌کند (بدونِ بازساختِ کلِ نوار → بدونِ پرش/انیمیشنِ تکراری).
  const stage = getDealStage(v);
  const yourTurn = v.phase === 'PLAYING_TURNS' && isActiveSeat(v, v.you);
  return [
    stage.stageKey,
    stage.sortPhase,
    stage.cards.map((c) => c.id).join(','),
    v.legal ? [...v.legal].sort().join(',') : '',
    yourTurn ? 1 : 0,
    v.hokm || '',
    // ⚠ نه خودِ turnSeat و نه طولِ تریک: نوار فقط می‌خواهد بداند «نوبتِ من است یا نه»
    // و چه کارت‌هایی در دست من یا مجاز برای بازی هستند. تریک و کارت‌های حریفان به نوار دست مربوط نیست.
    v.phase, v.turnSeat === v.you ? 1 : 0, isActiveSeat(v, v.you) ? 1 : 0,
    v.you, v.handNo, v.gameType, v.hakemSeat, v.hakemSeat != null ? (v.names || [])[v.hakemSeat] : '',
    v.observerMode ? 1 : 0, v.canClaim ? 1 : 0, v.jokerMode ? 1 : 0,
    // هندسهٔ موبایل inline روی کارت‌ها می‌نشیند؛ با عبور از مرزِ ۵۶۰px باید بازسازی شود
    // وگرنه transform/--rotِ موبایل روی دسکتاپ می‌ماند و دو بادبزن روی هم می‌افتند.
    _isMobileHand() ? 'm' : 'd',
  ].join('|');
}
const _isMobileHand = () => window.innerWidth <= 560;

// تقسیم کارت‌های دست به دو ردیف هوشمندانه با حفظ ۱۰۰٪ یکپارچگی دسته‌های خال (فقط برای موبایل)
function getHandRowSplitIndex(hand, isMobile = null) {
  const isMobileView = isMobile !== null ? isMobile : _isMobileHand();
  // دسکتاپ: همیشه تک‌ردیفه است تا تمام کارت‌ها در یک ردیف بادبزنی چشم‌نواز و بدون هم‌پوشانی نمایش داده شوند
  if (!isMobileView) return 0;

  const n = hand.length;
  if (n < 7) return 0; // کمتر از ۷ برگ در یک ردیف می‌نشیند

  const mid = Math.round(n / 2);
  let bestIdx = -1;
  let bestDist = Infinity;

  // حداقل تعداد برگ در هر ردیف تا ردیفی خالی یا کمتر از ۲ برگ نشود
  const minCardsPerRow = 2;

  for (let i = 1; i < n; i++) {
    if (hand[i].suit !== hand[i - 1].suit) {
      if (i >= minCardsPerRow && (n - i) >= minCardsPerRow) {
        const dist = Math.abs(i - mid);
        if (dist < bestDist) {
          bestDist = dist;
          bestIdx = i;
        }
      }
    }
  }

  // اگر مرز تعویض خال پیدا شد، دقیقاً روی همان مرز می‌شکنیم تا هیچ خالی هرگز نصف نشود
  if (bestIdx !== -1) {
    return bestIdx;
  }

  // فال‌بک نادر فقط زمانی که دست تک‌خال باشد یا مرز معتبری وجود نداشته باشد
  return mid;
}

function updateChaharBargMatchHints(card, v) {
  if (v?.gameType !== 'chahar_barg') return;
  const boardEl = document.querySelector('.chaharbarg-board');
  if (!boardEl) return;
  boardEl.querySelectorAll('.chaharbarg-board-card.match-hint').forEach((el) => el.classList.remove('match-hint'));
  if (!card) return;
  const matchedIds = new Set(getCardMatchHints(card, v.board || []));
  if (matchedIds.size > 0) {
    sounds.tapHint?.();
    boardEl.querySelectorAll('.chaharbarg-board-card').forEach((node) => {
      const id = node.getAttribute('data-card-id');
      if (id && matchedIds.has(id)) {
        node.classList.add('match-hint');
      }
    });
  }
}

function handStrip(v, existingWrap = null) {
  const isKotPhase = !v.observerMode && v.phase === 'PASS_KOT' && v.hakemSeat === v.you;
  const isHandFocused = (!v.observerMode && v.phase === 'BIDDING' && v.turnSeat === v.you) ||
                        (!v.observerMode && v.gameType === 'hokm' && (v.phase === 'CHOOSE_HOKM' || v.phase === 'CHOOSING_HOKM') && (v.turnSeat === v.you || v.hakemSeat === v.you)) ||
                        isKotPhase;
  const targetClass = 'hand-strip' + (isHandFocused ? ' above-overlay' : '') + (isKotPhase ? ' kot-mode' : '');
  const wrap = existingWrap || el('div', { className: targetClass });
  if (wrap.className !== targetClass) wrap.className = targetClass;

  // در حالتِ سرعتی «نوبت» یعنی: یا آغازگرِ دوری، یا دور باز است و تو هنوز در آن
  // کارت نینداخته‌ای — isActiveSeat هر دو را پوشش می‌دهد.
  const yourTurn = v.phase === 'PLAYING_TURNS' && isActiveSeat(v, v.you);
  // اگر نوبتِ بازیکن نیست، انتخابِ لمسیِ قبلی را ابطال کن
  if (!yourTurn && _mobileSelId) {
    _mobileSelId = null;
    _mobileSelTs = 0;
  }
  // اگر نوبتِ توست ولی legal خالی است (لبه/باگ)، همه را clickable کن تا فریز نشوی (سرور اعتبارسنجی می‌کند)
  const legalEmpty = yourTurn && (!v.legal || v.legal.size === 0);
  const stage = getDealStage(v);
  const hand = stage.cards;
  const newCardIds = stage.newCardIds;
  wrap.classList.toggle('hand-gathering', stage.sortPhase === 'gather');
  wrap.classList.toggle('hand-spreading', stage.sortPhase === 'spread');
  if (v.handNo !== _dealHandNo) {
    _dealHandNo = v.handNo;
    _dealtCards.clear();
    _dealInfo.clear();
    predecodeCourtCards(hand);
  }

  if (isKotPhase) {
    if (passKotSelection.handNo !== v.handNo) {
      passKotSelection = {
        selectedIds: new Set(),
        hokm: null,
        handNo: v.handNo,
        isSubmitting: false,
      };
    }
    const validIds = new Set(hand.map((c) => c.id));
    for (const id of passKotSelection.selectedIds) {
      if (!validIds.has(id)) passKotSelection.selectedIds.delete(id);
    }
    let header = wrap.querySelector(':scope > .kot-header-bar');
    let fan = wrap.querySelector(':scope > .kot-fan');
    if (!header || !fan) {
      wrap.replaceChildren();
      wrap._fanNodes = new Map();
      header = el('div', { className: 'kot-header-bar' });
      const promptEl = el('div', { className: 'kot-instruction-title' });
      const fab = kotConfirmFab(v, wrap);
      header.append(promptEl, fab);
      fan = el('div', { className: 'kot-fan' });
      wrap.append(header, fan);
    }
    _kotSync(v, wrap);
    return wrap;
  }

  // اگر قبلاً در حالتِ kot بود، ساختار آن پاک شود
  if (wrap.querySelector('.kot-fan')) {
    wrap.replaceChildren();
    delete wrap._fanNodes;
  }

  // استخر نودهای کارت موجود برای جلوگیری از تخریب و بازساخت مجدد DOM
  const existingMap = new Map();
  const prevPositions = new Map();
  const currentHandKey = hand.map((c) => c.id).join(',');
  const handCardsChanged = !wrap._lastHandKey || wrap._lastHandKey !== currentHandKey;
  wrap._lastHandKey = currentHandKey;

  if (existingWrap) {
    for (const child of Array.from(wrap.querySelectorAll('.card[data-card-id]'))) {
      const cId = String(child.dataset.cardId);
      existingMap.set(cId, child);
      if (!_dealDeal && handCardsChanged && !_reducedMotion()) {
        prevPositions.set(cId, child.getBoundingClientRect());
      }
    }
    const handIds = new Set(hand.map((c) => String(c.id)));
    // حذف کارت‌هایی که بازی شده‌اند یا دیگر در دست نیستند
    for (const [id, node] of existingMap.entries()) {
      if (!handIds.has(id)) {
        node.remove();
        existingMap.delete(id);
      }
    }
    wrap.querySelectorAll(':scope > .your-turn, :scope > .hand-focus-hint, :scope > .claim-btn').forEach((n) => n.remove());
  }

  // دو ردیف فیزیکی مجزا برای ردیف‌های کارت
  let rowTop = wrap.querySelector(':scope > .hand-row.row-top');
  let rowBot = wrap.querySelector(':scope > .hand-row.row-bottom');
  if (!rowTop || !rowBot) {
    wrap.querySelectorAll(':scope > .hand-row').forEach((r) => r.remove());
    rowTop = el('div', { className: 'hand-row row-top' });
    rowBot = el('div', { className: 'hand-row row-bottom' });
    const firstNonRow = wrap.firstElementChild;
    if (firstNonRow) {
      wrap.insertBefore(rowTop, firstNonRow);
      wrap.insertBefore(rowBot, firstNonRow);
    } else {
      wrap.append(rowTop, rowBot);
    }
  }

  // چیدمان پایدار ردیف‌ها: از جابجایی کارت‌های مستقرشده بین ردیف بالا و پایین جلوگیری می‌کنیم
  const isMobileView = _isMobileHand();
  let topCards = [];
  let botCards = hand;
  if (isMobileView) {
    const finalHand = (v.yourHand && v.yourHand.length >= 7) ? sortHand(v.yourHand, v.hokm) : hand;
    const finalSplitIdx = getHandRowSplitIndex(finalHand, true);
    if (finalSplitIdx > 0 && finalHand.length >= 7) {
      const topIdSet = new Set(finalHand.slice(0, finalSplitIdx).map((c) => String(c.id)));
      topCards = hand.filter((c) => topIdSet.has(String(c.id)));
      botCards = hand.filter((c) => !topIdSet.has(String(c.id)));
    } else {
      const splitIdx = getHandRowSplitIndex(hand, true);
      topCards = splitIdx > 0 ? hand.slice(0, splitIdx) : [];
      botCards = splitIdx > 0 ? hand.slice(splitIdx) : hand;
    }
  }

  const renderCardInRow = (card, idxInRow, rowCards, targetRow, rowOffset) => {
    const globalIdx = rowOffset + idxInRow;
    const cardIdStr = String(card.id);
    const legal = (v.gameType === 'chahar_barg' || v.gameType === 'bluff')
      ? true
      : (v.legal ? (v.legal.has(card.id) || v.legal.has(cardIdStr)) : false);
    const isPlayable = (v.gameType === 'bluff')
      ? (!v.observerMode && v.roomState === 'IN_HAND')
      : (yourTurn && (legal || legalEmpty));

    let c = existingMap.get(cardIdStr);

    const onBluffCardClick = () => {
      if (c.dataset.swiped === '1') { delete c.dataset.swiped; return; }
      const cId = card.id;
      const existIdx = _bluffSelectedCards.findIndex((sc) => (sc.id || sc) === cId);
      if (existIdx >= 0) {
        _bluffSelectedCards.splice(existIdx, 1);
        c.classList.remove('sel');
      } else {
        if (_bluffSelectedCards.length >= 4) {
          toast(t('bluff.max_cards_toast', null, 'حداکثر ۴ کارت می‌توانید انتخاب کنید'));
          return;
        }
        _bluffSelectedCards.push(card);
        c.classList.add('sel');
        if (navigator.vibrate) try { navigator.vibrate(10); } catch {}
      }
      const bctrl = document.querySelector('.bluff-controls-host');
      if (bctrl) {
        renderBluffControls(v, bctrl, { el, faNum, toast }, _bluffSelectedCards, (act) => {
          if (act.type === 'BLUFF_CLAIM') {
            table.bluffClaim(act.cardIds, act.claimedRank);
            _bluffSelectedCards = [];
          } else if (act.type === 'BLUFF_CHALLENGE') {
            table.bluffChallenge();
          } else if (act.type === 'BLUFF_CONFIRM_WINNER') {
            table.bluffConfirmWinner();
          }
        });
      }
    };

    // لمسِ کارتِ غیرمجاز: لرزش + ویبره، و اگر نوبتِ خودت است کارت‌های مجاز لحظه‌ای
    // روشن می‌شوند و خالِ لازم گفته می‌شود (به‌جای اینکه بازیکن حدس بزند چرا رد شد).
    const rejectTap = () => {
      const relevant = (yourTurn && !legal) || (!yourTurn && v.phase === 'PLAYING_TURNS');
      if (!relevant) return;
      sounds.reject();
      if (navigator.vibrate) try { navigator.vibrate([35, 25, 35]); } catch {}
      c.classList.remove('reject');
      requestAnimationFrame(() => {
        c.classList.add('reject');
        setTimeout(() => c.classList.remove('reject'), 460);
      });
      if (yourTurn) {
        wrap.classList.add('hint-legal');
        clearTimeout(wrap._hintT);
        wrap._hintT = setTimeout(() => wrap.classList.remove('hint-legal'), 1100);
        if (v.hokm == null && (!v.trick || v.trick.length === 0) && (isJoker(card) || card?.suit === 'joker')) {
          toast(t('table.joker_first_lead_forbidden', null, 'برگ اول حاکم نمی‌تواند جوکر باشد؛ باید با یک خال بازی کنید تا حکم تعیین شود'));
          return;
        }
        const lead = v.leadSuit === 'joker' ? v.hokm : v.leadSuit;
        if (SUIT_GLYPH[lead]) toast(t('table.lead_required', { suit: SUIT_GLYPH[lead] }, `باید با خال ${SUIT_GLYPH[lead]} بازی کنی`));
      }
    };

    const attachCardClick = (node) => {
      if (!isPlayable) {
        node.onclick = rejectTap;
      } else if (v.gameType === 'bluff') {
        node.onclick = onBluffCardClick;
      } else {
        node.onclick = (e) => {
          if (node.dataset.swiped === '1') { delete node.dataset.swiped; return; }
          const isRealMouse = e && e.pointerType === 'mouse';
          if (_isTouchDevice() && !isRealMouse) {
            if (getTouchPlayMode() === 'single') {
              executeCardPlay(card, node, v);
              return;
            }
            if (_mobileSelId === card.id) {
              if (Date.now() - _mobileSelTs < 320) return;
              executeCardPlay(card, node, v);
            } else {
              _mobileSelId = card.id;
              _mobileSelTs = Date.now();
              updateChaharBargMatchHints(card, v);
              wrap.querySelectorAll('.card.sel').forEach((el) => {
                el.classList.remove('sel');
                el.style.transform = '';
              });
              wrap.querySelectorAll('.hand-row.row-top.has-sel').forEach((n) => n.classList.remove('has-sel'));
              node.classList.add('sel');
              node.closest?.('.hand-row.row-top')?.classList.add('has-sel');
              node.style.transform = '';
              if (navigator.vibrate) try { navigator.vibrate(10); } catch {}
            }
            return;
          }
          executeCardPlay(card, node, v);
        };
      }
    };

    if (!c) {
      // فقط اگر کارت قبلاً در DOM نبوده، المنت جدید ایجاد کن
      c = cardEl(card, { clickable: isPlayable });
      attachCardClick(c);
    } else {
      // کارت موجود: فقط کلاس‌ها و رویداد را درجا به‌روز کن
      c.classList.toggle('click', isPlayable);
      if (c.dataset.optimisticPlayed === '1') {
        c.style.opacity = '0';
        c.style.pointerEvents = 'none';
      }
      let hitBridge = c.querySelector('.card-hit-bridge');
      if (isPlayable && !hitBridge) {
        c.prepend(el('span', { className: 'card-hit-bridge' }));
      } else if (!isPlayable && hitBridge) {
        hitBridge.remove();
      }
      attachCardClick(c);
    }

    const isHokmCard = !!(v.hokm && (card.suit === v.hokm || (v.jokerMode && (card.rank === 'JOKER_RED' || card.rank === 'JOKER_BLACK'))));
    c.classList.toggle('is-hokm', isHokmCard);
    c.classList.toggle('is-hokm-card', isHokmCard);
    const existingGem = c.querySelector('.card-hokm-gem');
    if (isHokmCard && !existingGem) {
      c.append(el('span', { className: 'card-hokm-gem', 'aria-hidden': 'true', textContent: '✦' }));
    } else if (!isHokmCard && existingGem) {
      existingGem.remove();
    }

    if (v.gameType === 'bluff') {
      const isSelected = _bluffSelectedCards.some((sc) => (sc.id || sc) === card.id);
      c.classList.toggle('sel', isSelected);
    }

    if (v.gameType === 'chahar_barg' && isPlayable && !_isTouchDevice()) {
      c.onmouseenter = () => updateChaharBargMatchHints(card, v);
      c.onmouseleave = () => updateChaharBargMatchHints(null, v);
    }

    // تضمین قطعی تطابق ترتیب فیزیکی نودهای DOM با آرایه مرتب‌شده کارت‌ها (جلوگیری از رفتن کارت‌ها پشت یکدیگر)
    if (targetRow.children[idxInRow] !== c) {
      targetRow.insertBefore(c, targetRow.children[idxInRow] || null);
    }

    setupCardTouchInteractions(c, card);

    // متغیرهای هندسه بادبزنی ردیف در موبایل (شعاعی، قوس چتری عمیق و نامرتبی طبیعی)
    const n = rowCards.length;
    const mid = (n - 1) / 2;
    const distFromMid = isRTL() ? (mid - idxInRow) : (idxInRow - mid); // RTL: کارت‌های راست مثبت؛ LTR: کارت‌های راست مثبت
    const absDist = Math.abs(distFromMid);

    // ۱. زاویه بادبزنی (ملایم‌تر در موبایل برای جلوگیری از خروج کارت‌های کناری)
    const angleStep = _isMobileHand() ? Math.min(4.2, 24 / Math.max(1, n)) : Math.min(6, 30 / Math.max(1, n));
    const rotDeg = distFromMid * angleStep;

    // ۲. قوس سهموی عمیق و چتری (کارت‌های وسط بالا، کارت‌های کناری با شیب زیبای دست به پایین)
    const arcYPx = (absDist * absDist) * 2.0;

    // ۳. گسترش افقی شعاعی به بیرون (باز شدن بادبزن به سمت طرفین)
    const fanXPx = 0;

    // ۴. تثبیت کامل هندسه کارت‌ها — قوس متقارن بادبزن بدون کوچک‌ترین لرزش، تکان یا نامرتبی تصادفی
    const jitterRot = 0;
    const jitterY = 0;
    const jitterX = 0;

    const finalRot = rotDeg.toFixed(2);
    const finalY = arcYPx.toFixed(1);
    const finalX = fanXPx.toFixed(1);

    c.style.setProperty('--fan-rot', `${finalRot}deg`);
    c.style.setProperty('--fan-y', `${finalY}px`);
    c.style.setProperty('--fan-x', `${finalX}px`);

    // --rot فقط موبایل: دسکتاپ یک ردیف است و CSS زاویه را از --global-i/--total-n می‌سازد؛
    // مقدارِ inline (محاسبه‌شده per-row) آن را دو بادبزنِ روی هم می‌کرد.
    if (_isMobileHand()) c.style.setProperty('--rot', `${finalRot}deg`);
    else c.style.removeProperty('--rot');
    c.style.setProperty('--arc-y', `${arcYPx.toFixed(1)}px`);
    c.style.setProperty('--micro-rot', '0deg');
    c.style.setProperty('--micro-y', '0px');
    c.style.setProperty('--micro-x', '0px');
    c.style.setProperty('--i', idxInRow);
    c.style.setProperty('--n', rowCards.length);
    c.style.setProperty('--global-i', globalIdx);
    c.style.setProperty('--total-n', hand.length);

    // فاصله‌گذاری هوشمند بین دسته‌های خال‌های مختلف درون ردیف (دست از همان ابتدا به صورت پیوسته مرتب است)
    const isNewSuit = idxInRow > 0 && rowCards[idxInRow - 1].suit !== card.suit;
    c.classList.toggle('suit-gap', isNewSuit);

    const isSel = (v.gameType === 'bluff')
      ? _bluffSelectedCards.some((sc) => (sc.id || sc) === card.id)
      : (isPlayable && _mobileSelId === card.id);
    c.classList.toggle('sel', isSel);

    // اعمال transform-origin برای موبایل؛ مقدار transform مستقیماً از طریق متغیرهای CSS
    // (--fan-x, --fan-y, --fan-rot) و کلاس .sel با شتاب‌دهی سخت‌افزاری GPU اداره می‌شود
    if (_isMobileHand()) {
      c.style.transformOrigin = '50% 130%';
      if (!c.dataset.swiping) {
        c.style.transform = '';
      }
    } else {
      c.style.transform = '';
      c.style.transformOrigin = '';
    }

    // انیمیشنِ فرود نرم آبشاری: با ریتم ۴۸ms برای هر برگ در بسته ورودی (سریع، متمایز و پرانرژی)
    if (!_dealtCards.has(card.id)) {
      _dealtCards.add(card.id);
      if (!_reducedMotion()) {
        const batchList = stage.batchCardIds || [];
        const bIdx = Math.max(0, batchList.indexOf(card.id));
        c.classList.add('deal-in');
        c.style.animationDelay = (bIdx * 34) + 'ms';
        c.addEventListener('animationend', () => {
          c.classList.remove('deal-in');
          c.style.animationDelay = '';
        }, { once: true });
      }
    } else if (!c.style.animationDelay) {
      c.classList.remove('deal-in');
    }
  };

  topCards.forEach((card, i) => renderCardInRow(card, i, topCards, rowTop, 0));
  botCards.forEach((card, i) => renderCardInRow(card, i, botCards, rowBot, topCards.length));
  while (rowTop.children.length > topCards.length) rowTop.lastElementChild.remove();
  while (rowBot.children.length > botCards.length) rowBot.lastElementChild.remove();
  rowTop.classList.toggle('empty', topCards.length === 0);
  rowBot.classList.toggle('empty', botCards.length === 0);
  rowTop.classList.toggle('has-sel', topCards.some((c) => _mobileSelId === c.id));

  // FLIP: فقط برای جابجایی کارت‌ها حین بازی (مانند بستن جای خالی کارت بازی‌شده) و نه حین پخش کارت
  if (prevPositions.size > 0 && !_dealDeal && !_reducedMotion()) {
    const cardsToAnimate = [];
    wrap.querySelectorAll('.card[data-card-id]').forEach((node) => {
      const id = node.dataset.cardId;
      const prevRect = prevPositions.get(id);
      if (!prevRect) return;
      const newRect = node.getBoundingClientRect();
      const dx = prevRect.left - newRect.left;
      const dy = prevRect.top - newRect.top;
      if (Math.abs(dx) > 2 || Math.abs(dy) > 2) {
        cardsToAnimate.push({ node, dx, dy });
      }
    });

    if (cardsToAnimate.length > 0) {
      if (stage.stageKey.includes('sorted')) {
        sounds.reveal?.(); // پخش افکت صوتی سر خوردن کارت هنگام مرتب‌سازی
      }
      const isMob = _isMobileHand();
      cardsToAnimate.forEach(({ node, dx, dy }) => {
        const baseTransform = isMob
          ? 'translate(var(--fan-x, 0px), var(--fan-y, 0px)) rotate(var(--fan-rot, 0deg))'
          : 'translateY(0) rotate(var(--rot)) scale(var(--hand-scale))';
        node.style.transform = `translate(${dx.toFixed(1)}px, ${dy.toFixed(1)}px) ${baseTransform}`;
        node.style.transition = 'none';
      });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          cardsToAnimate.forEach(({ node }) => {
            node.style.transition = 'transform 0.36s cubic-bezier(0.2, 0.9, 0.3, 1)';
            node.style.transform = '';
            const cleanup = () => {
              node.style.transition = '';
              node.removeEventListener('transitionend', cleanup);
            };
            node.addEventListener('transitionend', cleanup);
            setTimeout(cleanup, 450);
          });
        });
      });
    }
  }

  if (v.phase === 'PASS_KOT' && v.hakemSeat !== v.you && !v.observerMode) {
    const hakemName = v.names?.[v.hakemSeat] || t('table.hakem', null, 'حاکم');
    wrap.append(el('div', { className: 'your-turn', textContent: t('table.hakem_choosing_kot', { name: hakemName, count: faNum(4) }, `${hakemName} در حال انتخابِ ${faNum(4)} برگ برای سوزاندن… (حکم با اولین برگِ او)`) }));
  } else if (!stage.isDealing && isHandFocused && v.phase === 'BIDDING') {
    wrap.append(el('div', { className: 'hand-focus-hint', textContent: t('table.hand_hint_bidding', null, 'کارت‌های شما برای اعلام تعهد') }));
  } else if (!stage.isDealing && isHandFocused && (v.phase === 'CHOOSE_HOKM' || v.phase === 'CHOOSING_HOKM')) {
    wrap.append(el('div', { className: 'hand-focus-hint', textContent: t('table.hand_hint_choose_hokm', null, 'کارت‌های شما برای انتخاب حکم') }));
  } else if (!stage.isDealing && v.gameType === 'hokm' && (v.phase === 'CHOOSE_HOKM' || v.phase === 'CHOOSING_HOKM') && v.hakemSeat !== v.you && !v.observerMode) {
    const hakemName = v.names?.[v.hakemSeat] || t('table.hakem', null, 'حاکم');
    wrap.append(el('div', { className: 'hand-focus-hint', textContent: t('table.hand_hint_waiting_hokm', { name: hakemName }, `${hakemName} در حال انتخاب خال حکم است…`) }));
  } else if (yourTurn) {
    if (v.gameType === 'bluff') {
      // در بازی بلوف اکشن‌بار اختصاصی بالای دست رندر می‌شود؛ بنر متنی مزاحم اضافه نشود
    } else if (v.canClaim) {
      const claimBtn = el('button', {
        type: 'button',
        className: 'claim-btn glow-pulse',
        title: t('table.claim_button_title', null, 'برنده شدن قطعی تمام دورهای باقیمانده بدون نیاز به انداختن تک‌تک کارت‌ها'),
        onclick: (e) => {
          e.stopPropagation();
          sounds?.trump?.();
          table.claim();
        },
      },
        el('span', { className: 'claim-icon', textContent: '🏆' }),
        el('span', { className: 'claim-text', textContent: t('table.claim_button', null, 'اعلام کارت‌های سر (پایان دست)') }),
      );
      wrap.append(claimBtn);
    }
  }

  return wrap;
}

// ─── اورلی‌ها ──────────────────────────────────────────────────────────────────
// امضای اورلیِ فعال. اگر عوض نشده باشد، نودِ موجود دست‌نخورده می‌ماند (اسکرول و
// فوکوس حفظ می‌شود). عمداً سخاوتمند است: هر فیلدی که هر کدام از اورلی‌ها می‌خوانند
// اینجاست — کم‌گذاشتن یعنی UI بیات، زیاد گذاشتن فقط یک بازساختِ اضافه.
function overlaySig(v) {
  const b = v.bidding || {};
  const isDealingNow = (_dealDeal != null || (typeof _dealFxUntil === 'number' && Date.now() < _dealFxUntil));
  const isDealingBlock = isDealingNow;
  return [
    _pendingJokerPlay ? `joker_lead:${_pendingJokerPlay.cardId}` : '',
    // کدام اورلی
    v.matchCancelled ? 1 : 0, v.cancelReason || '',
    v.matchOver ? 1 : 0, v.roomState, v.observerMode ? 1 : 0,
    isDealingBlock ? 1 : 0,
    (Date.now() < _resultOverlayHoldUntil) ? 1 : 0,
    v.gameType, v.phase, v.turnSeat, v.hakemSeat, v.you, v.jokerMode ? 1 : 0,
    // محتوای اورلی‌ها
    v.result ? JSON.stringify(v.result) : '',
    v.handNo, (v.matchScore || []).join(','),
    (v.names || []).join(' '),
    (v.bots || []).map((x) => (x ? 1 : 0)).join(''),
    (v.ready || []).map((x) => (x ? 1 : 0)).join(''),
    v.roomId || '', v.playerMode || '', v.botFillAt || '',
    b.floor, b.ceil, b.highestBid, b.highestSeat, b.bid_type, b.bid_value,
    v.bluffInterrogation ? JSON.stringify(v.bluffInterrogation) : '',
    v.winnerSeat ?? '', (v.cardCounts || []).join(','),
    (v.eloRatings || []).join(','), (v.gamesPlayed || []).join(','),
  ].join('|');
}

function overlay(title, ...children) {
  return el('div', { className: 'overlay' }, el('div', { className: 'panel' }, el('h2', { textContent: title }), ...children));
}

// شیت‌های تک‌لمسی (تعهد / انتخابِ حکم) درست لحظهٔ رسیدنِ نوبت زیرِ انگشت ظاهر می‌شوند:
// ۱) لمسی که ۳۵۰ms اولِ ظاهرشدن برسد برای چیزِ دیگری بوده → نادیده.
// ۲) بعد از انتخاب، دکمه‌ها فوراً قفل و گزینه علامت می‌خورد (بازخوردِ آنی بدونِ انتظارِ
//    سرور، و بدونِ ارسالِ دوباره که NOT_YOUR_TURN می‌داد). اگر سرور رد کرد و شیت عوض
//    نشد، ۲.۵ ثانیه بعد باز می‌شود.
function guardChoiceTaps(ov) {
  const bornAt = performance.now();
  ov.addEventListener('click', (e) => {
    const btn = e.target.closest?.('.bid-btn, .suit-btn');
    if (!btn) return;
    if (performance.now() - bornAt < 350 || ov.classList.contains('choice-sent')) {
      e.stopPropagation(); e.preventDefault();
      return;
    }
    if (btn.classList.contains('disabled') || btn.hasAttribute('disabled')) return;
    ov.classList.add('choice-sent');
    btn.classList.add('chosen');
    setTimeout(() => { ov.classList.remove('choice-sent'); btn.classList.remove('chosen'); }, 2500);
  }, true);
}

function biddingOverlay(v) {
  const b = v.bidding || {};
  const floor = b.floor || (v.jokerMode ? 120 : 100);
  const ceil = b.ceil || (v.jokerMode ? 200 : 165);
  const currentHigh = b.highestBid;
  const bidType = b.bid_type || (currentHigh === 'shelem' ? 'shelem' : currentHigh === 'kenz' ? 'kenz' : (typeof currentHigh === 'number' && currentHigh > 0 ? 'numeric' : null));
  const canPassNow = b.canPass !== false;
  const isForcedBid = !canPassNow;

  // وضعیت باز بودن تعهدهای ویژه
  // شلم فقط وقتی باز می‌شود که بالاترین تعهد دقیقاً سقف عددی (۲۰۰ با جوکر، ۱۶۵ عادی) باشد
  const canBidShelem = (currentHigh === ceil || (typeof currentHigh === 'number' && currentHigh >= ceil)) && bidType !== 'shelem' && bidType !== 'kenz';
  // کنز فقط وقتی باز می‌شود که یک بازیکن شلم خوانده باشد
  const canBidKenz = (currentHigh === 'shelem' || bidType === 'shelem');
  // وقتی کنز خوانده شد، سقف قطعی است و سایرین فقط می‌توانند پاس دهند
  const isKenzActive = (currentHigh === 'kenz' || bidType === 'kenz');

  // ۱. ردیف تعهدهای عددی
  const row = el('div', { className: 'bid-row' });
  if (!isKenzActive && !canBidKenz && !(typeof currentHigh === 'number' && currentHigh >= ceil)) {
    for (let amt = floor; amt <= ceil; amt += 5) {
      row.append(el('button', {
        className: 'bid-btn',
        textContent: faNum(amt),
        onclick: () => { sounds.bid(); table.humanBid(amt); },
      }));
    }
  }

  // ۲. ردیف تعهدهای تشدیدی (شلم و کنز)
  const specialRow = el('div', { className: 'bid-row special-bids-row' });

  // دکمه شلم: قفل تا رسیدن به ۲۰۰ (یا ۱۶۵)، فعال در ۲۰۰، غیرفعال پس از شلم/کنز
  const shelemBtn = el('button', {
    type: 'button',
    className: 'bid-btn shelem' + (canBidShelem ? ' unlocked' : ' disabled locked'),
    textContent: canBidShelem ? t('bidding.shelem_btn_unlocked', { max: faNum(ceil) }, `🔥 ${t('bidding.shelem', null, 'شلم')} (${faNum(ceil)})`) : t('bidding.shelem_btn_locked', null, `🔒 ${t('bidding.shelem', null, 'شلم')}`),
    title: canBidShelem ? t('bidding.shelem_tip_unlocked', null, 'اعلام قرارداد شلم (+۲× امتیاز)') : t('bidding.shelem_tip_locked', { max: faNum(ceil) }, `قفل — نیازمند رسیدن به تعهد ${faNum(ceil)}`),
    onclick: canBidShelem ? () => { sounds.bid(); table.humanBid('shelem'); } : (e) => {
      e.currentTarget.classList.add('shake');
      setTimeout(() => e.currentTarget.classList.remove('shake'), 500);
      uiToast(t('bidding.shelem_toast_locked', { max: faNum(ceil) }, `تعهد شلم فقط پس از ثبت سقف عددی (${faNum(ceil)}) باز می‌شود.`));
    },
  });
  if (!canBidShelem && (isKenzActive || canBidKenz)) {
    shelemBtn.setAttribute('disabled', 'true');
  }
  specialRow.append(shelemBtn);

  // دکمه کنز: قفل تا اعلام شلم، فعال پس از شلم، غیرفعال پس از کنز
  const kenzBtn = el('button', {
    type: 'button',
    className: 'bid-btn kenz' + (canBidKenz ? ' unlocked' : ' disabled locked'),
    textContent: canBidKenz ? t('bidding.kenz_btn_unlocked', null, '⚡ کنز (مرگ ناگهانی)') : t('bidding.kenz_btn_locked', null, '🔒 کنز'),
    title: canBidKenz ? t('bidding.kenz_tip_unlocked', null, 'اعلام قرارداد کنز (All-In / برد یا باخت آنی کل مسابقه)') : t('bidding.kenz_tip_locked', null, 'قفل — نیازمند اعلام تعهد شلم توسط یک بازیکن'),
    onclick: canBidKenz ? () => { sounds.bid(); table.humanBid('kenz'); } : (e) => {
      e.currentTarget.classList.add('shake');
      setTimeout(() => e.currentTarget.classList.remove('shake'), 500);
      uiToast(t('bidding.kenz_toast_locked', null, 'تعهد کنز فقط پس از اعلام تعهد شلم باز می‌شود.'));
    },
  });
  if (!canBidKenz) {
    kenzBtn.setAttribute('disabled', 'true');
  }
  specialRow.append(kenzBtn);

  let pass;
  if (canPassNow) {
    pass = el('button', {
      className: 'bid-btn pass',
      textContent: t('bidding.pass', null, 'پاس') + ' ✋',
      onclick: () => { sounds.pass(); table.humanBid(null); },
    });
  } else {
    pass = el('button', {
      type: 'button',
      className: 'bid-btn pass disabled',
      textContent: t('bidding.pass_disabled', null, 'پاس (غیرمجاز)'),
      title: t('bidding.pass_forbidden_tip', null, '۳ بازیکن قبلی پاس داده‌اند و شما ملزم به اعلام تعهد هستید'),
      onclick: (e) => {
        const btn = e.currentTarget;
        btn.classList.remove('shake');
        requestAnimationFrame(() => {
          btn.classList.add('shake');
        });
        uiToast(t('bidding.pass_forbidden_toast', null, '۳ نفر اول پاس داده‌اند؛ شما ملزم به اعلام تعهد هستید.'));
      },
    });
  }

  let info;
  const highSeatName = v.names?.[b.highestSeat] || '';
  if (b.highestSeat == null) {
    info = isForcedBid
      ? t('bidding.forced_bid_floor', { min: faNum(floor) }, `۳ بازیکن قبلی پاس داده‌اند؛ شما ملزم به اعلام تعهد هستید (حداقل ${faNum(floor)}).`)
      : t('bidding.no_bids_yet', { min: faNum(floor) }, `هنوز کسی تعهد نداده است. حداقل ${faNum(floor)}.`);
  } else if (isKenzActive) {
    info = t('bidding.highest_kenz', { name: highSeatName }, `⚡ بالاترین تعهد: کنز (${highSeatName}) — قرارداد All-In؛ تمام بازیکنان دیگر فقط می‌توانند پاس دهند.`);
  } else if (canBidKenz) {
    info = t('bidding.highest_shelem_kenz_unlocked', { name: highSeatName }, `🔥 بالاترین تعهد: شلم (${highSeatName}) — تعهد کنز (مرگ ناگهانی) برای شما باز شد!`);
  } else if (canBidShelem) {
    info = t('bidding.highest_max_shelem_unlocked', { max: faNum(ceil), name: highSeatName }, `بالاترین تعهد: ${faNum(ceil)} (${highSeatName}) — سقف عددی اعلام شد؛ تعهد شلم باز شد!`);
  } else {
    info = t('bidding.highest_bid_val', { bid: faNum(b.highestBid), name: highSeatName }, `بالاترین تعهد: ${faNum(b.highestBid)} (${highSeatName})`);
  }

  const titleText = isForcedBid ? t('bidding.forced_turn_title', null, '📜 نوبت شماست (تعهد اجباری)') : t('bidding.turn_title', null, 'نوبت تعهد شماست');
  const infoEl = el('p', {
    className: isForcedBid ? 'cr-forced-bid-alert' : (isKenzActive ? 'kenz-alert-text' : (canBidShelem || canBidKenz ? 'unlock-alert-text' : 'muted')),
    textContent: info,
  });

  const o = overlay(titleText, infoEl, row, specialRow, el('div', { className: 'bid-actions' }, pass));
  o.classList.add('clear-hand-overlay', 'bidding-overlay');
  if (isForcedBid) o.classList.add('forced-bid-overlay');
  return o;
}

// انتخاب حکم در بازی حکم (فقط خال، بدون discard) — حاکم با ۵ کارت.
// اتاقِ انتظار: تا وقتی همه «اعلام آمادگی» نزده‌اند بازی شروع نمی‌شود.
function waitingOverlay(v) {
  const isCoop = v.playerMode === 'COOP_2V2';
  const youTeam = (v.you != null) ? (v.you % 2) : 0;
  const names = v.names || [null, null, null, null];
  const bots = v.bots || [false, false, false, false];
  const readyList = v.ready || [false, false, false, false];

  const SEAT_POS_LABELS = [
    t('waiting.seat_1', null, 'صندلی ۱'),
    t('waiting.seat_2', null, 'صندلی ۲'),
    t('waiting.seat_3', null, 'صندلی ۳'),
    t('waiting.seat_4', null, 'صندلی ۴'),
  ];

  function renderSeatCard(seat) {
    const name = names[seat];
    const isBot = !!bots[seat];
    const ready = !!readyList[seat] || isBot;
    const isYou = seat === v.you;
    const isTeammate = v.you != null && !isYou && (seat % 2 === youTeam);
    const isOpponent = v.you != null && (seat % 2 !== youTeam);

    const seatCard = el('div', {
      className: 'wait-seat' + (name ? '' : ' empty') + (ready ? ' ready' : '') + (isYou ? ' is-you' : ''),
    });

    // سطر بالای کارت صندلی
    const topRow = el('div', { className: 'ws-top' },
      el('span', { className: 'ws-pos', textContent: SEAT_POS_LABELS[seat] }),
    );

    if (isYou) {
      topRow.append(el('span', { className: 'ws-badge you', textContent: t('waiting.you', null, 'شما') }));
    } else if (isTeammate) {
      topRow.append(el('span', { className: 'ws-badge teammate', textContent: '🤝 ' + t('waiting.teammate', null, 'یار شما') }));
    } else if (isOpponent) {
      topRow.append(el('span', { className: 'ws-badge opponent', textContent: '⚔️ ' + t('waiting.opponent', null, 'حریف') }));
    }

    // سطر میانی
    const midRow = el('div', { className: 'ws-mid' });
    if (name) {
      midRow.append(
        el('span', { className: 'ws-name', textContent: name + (isBot ? ' 🤖' : '') }),
        el('span', { className: 'ws-status', textContent: ready ? t('waiting.status_ready', null, '✓ آماده') : t('waiting.status_not_ready', null, 'آماده نیست') }),
      );
    } else {
      midRow.append(el('span', { className: 'ws-empty-text', textContent: t('waiting.empty_seat', null, 'صندلی خالی') }));
      // امکان تغییر جایگاه به این صندلی خالی
      const canSwitch = v.you != null && !isYou && (!isCoop || (seat === 0 || seat === 2));
      if (canSwitch) {
        midRow.append(el('button', {
          className: 'ghost-sm ws-switch-btn',
          textContent: t('waiting.sit_btn', null, '💺 نشستن'),
          title: t('waiting.sit_tip', null, 'تغییر جایگاه به این صندلی'),
          onclick: () => table.switchSeat?.(seat),
        }));
      }
    }

    seatCard.append(topRow, midRow);
    return seatCard;
  }

  // تیم ۱: صندلی‌های ۰ و ۲
  const isTeam1Mine = youTeam === 0;
  const team1Card = el('div', { className: 'wait-team-card team-1' + (isTeam1Mine ? ' my-team' : '') },
    el('div', { className: 'wait-team-header' },
      el('span', { className: 'team-title', textContent: t('waiting.team_1', null, 'تیم ۱') + (isTeam1Mine ? ' ' + t('waiting.team_mine_tag', null, '🤝 (تیم شما)') : ' ' + t('waiting.team_opp_tag', null, '⚔️ (تیم حریف)')) }),
      el('span', { className: 'team-sub', textContent: isCoop ? (isTeam1Mine ? t('waiting.you_and_teammate', null, 'شما و یارتان') : t('waiting.two_bots', null, '۲ ربات')) : (isTeam1Mine ? t('waiting.you_and_teammate', null, 'شما و یارتان') : t('waiting.opponents', null, 'حریفان')) }),
    ),
    el('div', { className: 'wait-team-seats' }, renderSeatCard(0), renderSeatCard(2)),
  );

  // تیم ۲: صندلی‌های ۱ و ۳
  const isTeam2Mine = youTeam === 1;
  const team2Card = el('div', { className: 'wait-team-card team-2' + (isTeam2Mine ? ' my-team' : '') },
    el('div', { className: 'wait-team-header' },
      el('span', { className: 'team-title', textContent: t('waiting.team_2', null, 'تیم ۲') + (isTeam2Mine ? ' ' + t('waiting.team_mine_tag', null, '🤝 (تیم شما)') : ' ' + t('waiting.team_opp_tag', null, '⚔️ (تیم حریف)')) }),
      el('span', { className: 'team-sub', textContent: isCoop ? (isTeam2Mine ? t('waiting.you_and_teammate', null, 'شما و یارتان') : t('waiting.two_bots', null, '۲ ربات')) : (isTeam2Mine ? t('waiting.you_and_teammate', null, 'شما و یارتان') : t('waiting.opponents', null, 'حریفان')) }),
    ),
    el('div', { className: 'wait-team-seats' }, renderSeatCard(1), renderSeatCard(3)),
  );

  const teamsContainer = el('div', { className: 'wait-teams' }, team1Card, team2Card);

  const youReady = v.you != null && !!readyList[v.you];
  const readyBtn = el('button', {
    className: youReady ? 'ghost' : 'primary',
    textContent: youReady ? t('waiting.cancel_ready', null, 'لغو آمادگی') : t('waiting.ready_btn', null, '✓ آماده‌ام'),
    onclick: () => table.setReady?.(!youReady),
  });

  const fillBotsBtn = el('button', {
    className: 'ghost-sm wait-bot-start-btn',
    textContent: t('waiting.start_with_bots', null, '🤖 شروع با ربات'),
    title: t('waiting.start_with_bots_tip', null, 'پر کردن صندلی‌های خالی با ربات و شروع بازی'),
    onclick: () => {
      table.fillBotsAndStart?.();
    },
  });

  const code = el('div', { className: 'wait-code' },
    el('span', { className: 'muted small', textContent: t('waiting.invite_code_label', null, 'کدِ دعوت: ') }),
    el('strong', { textContent: v.roomId || '—' }),
    el('button', {
      className: 'ghost-sm',
      textContent: t('waiting.copy_btn', null, '📋 کپی'),
      onclick: () => {
        navigator.clipboard?.writeText(v.roomId || '').then(() => toast(t('waiting.code_copied', null, 'کد کپی شد'), 'ok'));
      },
    }),
  );

  const leaveBtn = el('button', { className: 'ghost-sm', textContent: t('waiting.leave_btn', null, 'خروج'), onclick: () => leaveGame() });

  const subtitle = isCoop
    ? t('waiting.subtitle_coop', null, 'بازی دونفره با ربات: شما و یارتان در تیم ۱ مقابل ۲ ربات قرار می‌گیرید. پس از آمادگی هر دو نفر بازی شروع می‌شود.')
    : t('waiting.subtitle_pvp', null, 'جایگاه‌ها و هم‌تیمی‌ها مشخص شده‌اند. می‌توانید با کلیک روی «نشستن اینجا» جایگاه خود را تغییر دهید.');

  // «بازی سریع»: تا botFillAt منتظرِ بازیکنِ واقعی می‌مانیم، بعد ربات می‌نشیند.
  // بدونِ این شمارنده، بازیکن روی صفحهٔ انتظار می‌ماند بی‌آنکه بداند چرا.
  // ثانیه‌شمار را همان اینتروالِ ۲۰۰ms در startTimer به‌روز می‌کند.
  let fillRow = null;
  if (v.botFillAt && names.some((n, i) => !n && !bots[i])) {
    const left = Math.max(0, Math.ceil((v.botFillAt - Date.now()) / 1000));
    fillRow = el('div', { className: 'wait-fill' },
      el('span', { className: 'wait-fill-txt', textContent: t('waiting.searching_real_player', null, 'در جست‌وجوی بازیکنِ واقعی…') }),
      el('b', { className: 'wait-fill-secs', textContent: faNum(left) }),
      el('span', { className: 'muted small', textContent: t('waiting.secs_until_bot', null, 'ثانیه تا نشستنِ ربات') }),
    );
    // ⚠ dataset را نمی‌شود از داخلِ el() ست کرد (اکسسورِ فقط‌خواندنی → Object.assign خطا می‌دهد)
    fillRow.dataset.deadline = String(v.botFillAt);
  }

  const gameTitle = GAME_FA[v.gameType] || '';
  return overlay(t('waiting.room_title', { game: gameTitle }, `اتاقِ انتظار — ${gameTitle}`),
    el('p', { className: 'muted small', textContent: subtitle }),
    teamsContainer,
    fillRow,
    code,
    el('div', { className: 'wait-actions' }, readyBtn, fillBotsBtn, leaveBtn),
  );
}

function chooseHokmOverlay(v) {
  const panel = overlay(t('table.choose_hokm_title', null, 'حاکم: خالِ حکم را انتخاب کن'));
  panel.classList.add('clear-hand-overlay', 'choose-hokm-overlay');
  const inner = panel.querySelector('.panel');
  inner.append(el('p', { className: 'muted', textContent: t('table.choose_hokm_sub', null, 'با نگاه به ۵ کارتِ خود، خالِ حکم را تعیین کن. سپس ۱۳ کارت کامل می‌شود.') }));
  inner.append(el('div', { className: 'hokm-five-note', textContent: t('table.hokm_five_cards_note', null, 'تعیین حکم بر اساس ۵ کارت اولیه') }));

  // شمارش تعداد برگ‌های هر خال در ۵ کارت دست حاکم جهت پیشنهاد بهینه و آگاهی بصری
  const suitCounts = { spades: 0, hearts: 0, diamonds: 0, clubs: 0 };
  const hand = Array.isArray(v.yourHand) ? v.yourHand : [];
  for (const c of hand) {
    if (c && c.suit && suitCounts[c.suit] != null) {
      suitCounts[c.suit]++;
    }
  }
  let maxCount = 0;
  for (const s of Object.keys(suitCounts)) {
    if (suitCounts[s] > maxCount) maxCount = suitCounts[s];
  }

  const suits = ['spades', 'hearts', 'diamonds', 'clubs'];
  const suitRow = el('div', { className: 'suit-row modern-suit-row' });
  suits.forEach((s) => {
    const isRed = RED.has(s);
    const count = suitCounts[s] || 0;
    const isBest = (maxCount > 0 && count === maxCount);

    const btn = el('button', {
      className: `modern-suit-btn suit-${s}` + (isRed ? ' red' : '') + (isBest ? ' is-best' : ''),
      dataset: { suit: s },
      onclick: () => {
        sounds.hokm();
        panel.classList.add('choice-sent');
        btn.classList.add('chosen');
        table.chooseHokm(s);
      },
    });

    if (isBest) {
      btn.append(el('span', { className: 'best-tag', textContent: t('table.best_suit_tag', null, 'بیشترین') }));
    }

    const svgWrap = el('span', { className: 'modern-suit-svg-wrap' });
    if (HOKM_SUIT_SVG[s]) {
      svgWrap.innerHTML = HOKM_SUIT_SVG[s];
    } else {
      svgWrap.textContent = SUIT_GLYPH[s] || '';
    }

    btn.append(
      svgWrap,
      el('span', { className: 'modern-suit-name', textContent: suitName(s) }),
      el('span', { className: 'modern-suit-count', textContent: t('table.cards_count_unit', { count: faNum(count) }, `${faNum(count)} برگ`) }),
    );
    suitRow.append(btn);
  });
  inner.append(suitRow);
  return panel;
}

function chooseJokerHokmOverlay(v, pending) {
  const isRed = pending?.card?.rank === 'JOKER_RED' || isJokerRed(pending?.card);
  const cardName = isRed ? t('table.joker_red', null, 'جوکر قرمز') : t('table.joker_blue', null, 'جوکر آبی');
  const panel = overlay(t('table.choose_joker_hokm_title', { cardName }, 'حاکم: تعیین خالِ حکم با ' + cardName));
  panel.classList.add('clear-hand-overlay', 'choose-hokm-overlay', 'choose-joker-hokm-overlay');
  panel.onclick = (e) => {
    if (e.target === panel) {
      _pendingJokerPlay = null;
      render(v);
    }
  };
  const inner = panel.querySelector('.panel');
  inner.append(el('p', { className: 'muted', textContent: t('table.choose_joker_hokm_sub', null, 'شما بازی را با جوکر آغاز می‌کنید. لطفاً خالِ حکم را انتخاب کنید:') }));
  const suits = ['spades', 'hearts', 'diamonds', 'clubs'];
  const suitRow = el('div', { className: 'suit-row big' });
  suits.forEach((s) => {
    suitRow.append(el('button', {
      className: 'suit-btn' + (RED.has(s) ? ' red' : '') + ` suit-${s}`,
      dataset: { suit: s },
      textContent: SUIT_GLYPH[s] + ' ' + suitName(s),
      onclick: () => {
        sounds.hokm();
        const cardId = pending.cardId;
        _pendingJokerPlay = null;
        sounds.play();
        resetTitleNotification();
        table.humanPlay(cardId, s);
      },
    }));
  });
  inner.append(suitRow);
  const cancelBtn = el('button', {
    className: 'btn cancel-btn',
    textContent: 'انصراف',
    onclick: () => {
      _pendingJokerPlay = null;
      render(v);
    },
  });
  inner.append(el('div', { style: 'margin-top: 14px; text-align: center;' }, cancelBtn));
  return panel;
}

function bluffInterrogationOverlay(v) {
  const ovEl = el('div', { className: 'overlay bluff-interrogation-overlay active' });
  renderBluffInterrogationModal(v, ovEl, { el, faNum }, (act) => {
    if (act.type === 'BLUFF_CONFESS') table.bluffConfess();
    else if (act.type === 'BLUFF_STAND_GROUND') table.bluffStandGround();
    else if (act.type === 'BLUFF_RESOLVE') table.bluffResolve(act.action);
  });
  return ovEl;
}

// // ─── کارت تطبیقی و فوق‌مدرن پایان دست (کامپکت و مناسب موبایل و دسکتاپ) ─────
function renderHandResultCard(v, r, youTeam) {
  const isObserver = !!(v.observerMode || v.you == null);
  const safeYou = isObserver ? 0 : v.you;
  const safeYouTeam = isObserver ? 0 : (youTeam != null ? youTeam : (safeYou % 2));
  const oppTeam = 1 - safeYouTeam;

  const isShelem = v.gameType !== 'hokm';
  const youAreContractor = isShelem && r.contractorTeam === safeYouTeam;
  const oppIsContractor = isShelem && r.contractorTeam === oppTeam;

  let youWon = false;
  let verdictTitle = '';
  let verdictType = 'lose';

  const cTeamName = t('hand_result.team_n', { n: r.contractorTeam + 1 }, `تیم ${r.contractorTeam + 1}`);
  const dTeamName = t('hand_result.team_n', { n: 2 - r.contractorTeam }, `تیم ${2 - r.contractorTeam}`);

  if (isShelem) {
    const hasJokerMode = Boolean(v.jokerMode || r.jokerMode);
    const maxScore = hasJokerMode ? 200 : 165;
    const kotThresh = hasJokerMode ? 100 : 85;
    const isOppShelem = Boolean(r.opponentShelem || (r.teamPoints && r.teamPoints[1 - r.contractorTeam] >= maxScore));

    const isSpecialKenz = r.contractType === 'kenz' || r.bidType === 'kenz' || r.bid === 'kenz';
    const isSpecialShelem = r.contractType === 'shelem' || r.bidType === 'shelem' || r.bid === 'shelem';

    if (isSpecialKenz) {
      if (isObserver) {
        if (r.kenzContractWon || r.success) {
          verdictTitle = t('hand_result.obs_kenz_won', { cTeam: cTeamName }, `⚡ کنز موفق! ${cTeamName} کل دست را برد و فوراً فاتح مسابقه شد! 🏆`);
          verdictType = 'shelem';
        } else {
          verdictTitle = t('hand_result.obs_kenz_lost', { dTeam: dTeamName }, `💥 شکست تعهد کنز! ${dTeamName} تریک گرفت و فوراً برنده مسابقه شد! 🏆`);
          verdictType = 'lose';
        }
      } else if (youAreContractor) {
        if (r.kenzContractWon || r.success) {
          youWon = true;
          verdictTitle = t('hand_result.you_kenz_won', null, `⚡ پیروزی بزرگ کنز! تمام دست را بردید و فوراً قهرمان مسابقه شدید! 🏆`);
          verdictType = 'shelem';
        } else {
          youWon = false;
          verdictTitle = t('hand_result.you_kenz_lost', null, `💥 شکست تعهد کنز! حریف تریک گرفت و کل مسابقه واگذار شد ❌`);
          verdictType = 'lose';
        }
      } else {
        if (r.kenzContractWon || r.success) {
          youWon = false;
          verdictTitle = t('hand_result.opp_kenz_won', null, `💥 کنز حریف موفق شد! حریف تمام دست و مسابقه را فتح کرد ❌`);
          verdictType = 'lose';
        } else {
          youWon = true;
          verdictTitle = t('hand_result.opp_kenz_burned', null, `🛡️ کنز حریف را سوزاندید! پیروزی آنی و فتح تمام مسابقه! 🏆`);
          verdictType = 'win';
        }
      }
    } else if (isSpecialShelem) {
      if (isObserver) {
        if (r.shelemContractWon || r.success) {
          verdictTitle = t('hand_result.obs_shelem_won', { cTeam: cTeamName, score: faNum(2 * maxScore) }, `🎉 شلم تعهد شده محقق شد! ${cTeamName} تمام دست را برد (+${faNum(2 * maxScore)} امتیاز)`);
          verdictType = 'shelem';
        } else {
          verdictTitle = t('hand_result.obs_shelem_lost', { cTeam: cTeamName, score: faNum(2 * maxScore) }, `❌ تعهد شلم شکست خورد! (${faNum(2 * maxScore)}- امتیاز منفی برای ${cTeamName})`);
          verdictType = 'lose';
        }
      } else if (youAreContractor) {
        if (r.shelemContractWon || r.success) {
          youWon = true;
          verdictTitle = t('hand_result.you_shelem_won', { score: faNum(2 * maxScore) }, `🎉 تعهد شلم را بردید! تمام دست فتح شد (+${faNum(2 * maxScore)} امتیاز دوبل)`);
          verdictType = 'shelem';
        } else {
          youWon = false;
          verdictTitle = t('hand_result.you_shelem_lost', { score: faNum(2 * maxScore) }, `❌ تعهد شلم سوخت! حریف تریک گرفت (${faNum(2 * maxScore)}- امتیاز منفی دوبل)`);
          verdictType = 'lose';
        }
      } else {
        if (r.shelemContractWon || r.success) {
          youWon = false;
          verdictTitle = t('hand_result.opp_shelem_won', { score: faNum(2 * maxScore) }, `💥 شلم شدید! حریف تعهد شلم خود را محقق کرد (+${faNum(2 * maxScore)} امتیاز)`);
          verdictType = 'lose';
        } else {
          youWon = true;
          verdictTitle = t('hand_result.opp_shelem_burned', { score: faNum(2 * maxScore) }, `🛡️ تعهد شلم حریف را سوزاندید! (${faNum(2 * maxScore)}- امتیاز منفی برای حریف)`);
          verdictType = 'win';
        }
      }
    } else if (isObserver) {
      if (r.shelem) {
        verdictTitle = t('hand_result.obs_normal_shelem', { cTeam: cTeamName, max: faNum(maxScore) }, `🎉 شلم! ${cTeamName} تمام ${faNum(maxScore)} امتیاز را کسب کرد`);
        verdictType = 'shelem';
      } else if (isOppShelem) {
        verdictTitle = t('hand_result.obs_opp_shelem', { dTeam: dTeamName, max: faNum(maxScore) }, `💥 شلم! ${dTeamName} تمام ${faNum(maxScore)} امتیاز را کسب کرد`);
        verdictType = 'shelem';
      } else if (r.kot) {
        verdictTitle = t('hand_result.obs_kot', { cTeam: cTeamName, thresh: faNum(kotThresh) }, `💥 کوت! ${cTeamName} کمتر از ${faNum(kotThresh)} امتیاز گرفت`);
        verdictType = 'kot';
      } else if (r.success) {
        verdictTitle = t('hand_result.obs_contract_won', { cTeam: cTeamName, bid: faNum(r.bid) }, `✅ تعهد ${cTeamName} با موفقیت محقق شد (${faNum(r.bid)} امتیاز)`);
        verdictType = 'win';
      } else {
        verdictTitle = t('hand_result.obs_contract_lost', { cTeam: cTeamName, bid: faNum(r.bid) }, `❌ تعهد ${cTeamName} سوخت (${faNum(r.bid)}- امتیاز)`);
        verdictType = 'lose';
      }
    } else if (youAreContractor) {
      // شما یا هم‌تیمی‌تان تعهد را برداشته بودید
      if (r.shelem) {
        youWon = true;
        verdictTitle = t('hand_result.you_contract_shelem', { max: faNum(maxScore) }, `🎉 شلم کردید! تمام ${faNum(maxScore)} امتیاز (امتیاز دوبل)`);
        verdictType = 'shelem';
      } else if (isOppShelem) {
        youWon = false;
        verdictTitle = t('hand_result.you_contract_opp_shelem', { max: faNum(maxScore), penalty: faNum(2 * r.bid) }, `💥 شلم شدید! حریف تمام ${faNum(maxScore)} امتیاز را گرفت (${faNum(2 * r.bid)}- جریمه دوبل)`);
        verdictType = 'lose';
      } else if (r.kot) {
        youWon = false;
        verdictTitle = t('hand_result.you_contract_kot', { thresh: faNum(kotThresh), penalty: faNum(2 * r.bid) }, `💥 کوت شدید! کمتر از ${faNum(kotThresh)} امتیاز (${faNum(2 * r.bid)}- امتیاز منفی دوبل)`);
        verdictType = 'kot';
      } else if (r.success) {
        youWon = true;
        verdictTitle = t('hand_result.you_contract_success', { bid: faNum(r.bid) }, `✅ تعهد تیم شما با موفقیت محقق شد (${faNum(r.bid)} امتیاز)`);
        verdictType = 'win';
      } else {
        youWon = false;
        verdictTitle = t('hand_result.you_contract_failed', { bid: faNum(r.bid) }, `❌ تعهد تیم شما سوخت (${faNum(r.bid)}- امتیاز منفی)`);
        verdictType = 'lose';
      }
    } else {
      // حریف تعهد را برداشته بود (شما مدافع بودید)
      if (r.shelem) {
        youWon = false;
        verdictTitle = t('hand_result.def_opp_shelem', { max: faNum(maxScore) }, `💥 شلم شدید! تمام ${faNum(maxScore)} امتیاز برای حریف`);
        verdictType = 'lose';
      } else if (isOppShelem) {
        youWon = true;
        verdictTitle = t('hand_result.def_you_shelem', { max: faNum(maxScore), penalty: faNum(2 * r.bid) }, `🎉 شلم کردید! تمام ${faNum(maxScore)} امتیاز را گرفتید (${faNum(2 * r.bid)}- جریمه دوبل حریف)`);
        verdictType = 'shelem';
      } else if (r.kot) {
        youWon = true;
        verdictTitle = t('hand_result.def_opp_kot', { penalty: faNum(2 * r.bid) }, `🎉 حریف کوت شد! جریمه منفی دوبل (${faNum(2 * r.bid)}- برای حریف)`);
        verdictType = 'win';
      } else if (r.success) {
        youWon = false;
        verdictTitle = t('hand_result.def_opp_contract_success', { bid: faNum(r.bid) }, `تعهد حریف محقق شد (${faNum(r.bid)} امتیاز)`);
        verdictType = 'neutral';
      } else {
        youWon = true;
        verdictTitle = t('hand_result.def_opp_contract_burned', { bid: faNum(r.bid) }, `🛡️ تعهد حریف سوخت! (${faNum(r.bid)}- امتیاز جریمه حریف)`);
        verdictType = 'win';
      }
    }
  } else {
    // بازی حکم
    youWon = r.winnerTeam === safeYouTeam;
    const isHakemKot = Boolean(r.hakemKot);
    if (isObserver) {
      const winnerName = t('hand_result.team_n', { n: r.winnerTeam + 1 }, `تیم ${r.winnerTeam + 1}`);
      if (isHakemKot) {
        verdictTitle = t('hand_result.hokm_obs_hakem_kot', { winner: winnerName }, `🔥 حاکم‌کوت! ${winnerName} ۷ بر ۰ برد (۳ دست)`);
        verdictType = 'shelem';
      } else if (r.kot) {
        verdictTitle = t('hand_result.hokm_obs_kot', { winner: winnerName }, `💥 کوت! ${winnerName} ۷ بر ۰ برد (۲ دست)`);
        verdictType = 'kot';
      } else {
        verdictTitle = t('hand_result.hokm_obs_win', { winner: winnerName }, `✅ ${winnerName} این دست را برد`);
        verdictType = 'win';
      }
    } else if (youWon) {
      if (isHakemKot) {
        verdictTitle = t('hand_result.hokm_you_hakem_kot', null, '🔥 حاکم‌کوت کردید! (۷ بر ۰ علیه حاکم — ۳ دست برد)');
        verdictType = 'shelem';
      } else if (r.kot) {
        verdictTitle = t('hand_result.hokm_you_kot', null, '🎉 حریف را کوت کردید! (۷ بر ۰ — ۲ دست برد)');
        verdictType = 'shelem';
      } else {
        verdictTitle = t('hand_result.hokm_you_win', null, '✅ این دست را با موفقیت بردید');
        verdictType = 'win';
      }
    } else {
      if (isHakemKot) {
        verdictTitle = t('hand_result.hokm_you_got_hakem_kot', null, '👑💥 حاکم‌کوت شدید! (باخت ۷ بر ۰ تیم حاکم — ۳ دست برای حریف)');
        verdictType = 'kot';
      } else if (r.kot) {
        verdictTitle = t('hand_result.hokm_you_got_kot', null, '💥 کوت شدید! (۰ بر ۷ — ۲ دست برای حریف)');
        verdictType = 'kot';
      } else {
        verdictTitle = t('hand_result.hokm_you_lost', null, '❌ این دست را واگذار کردید');
        verdictType = 'lose';
      }
    }
  }

  const cardWrap = el('div', { className: `res-card-wrap ${verdictType}` });

  // سربرگ پیام وضعیت
  let subText = null;
  if (isShelem && r.bid) {
    const bidLabel = (r.bid === 'kenz' || r.bidType === 'kenz') ? t('hand_result.kenz_label', null, 'کنز ⚡ (مرگ آنی)') :
                     (r.bid === 'shelem' || r.bidType === 'shelem') ? t('hand_result.shelem_label', null, 'شلم 👑 (کل دست)') :
                     faNum(r.bid);
    const teamLabel = isObserver
      ? (t('hand_result.team_n', { n: r.contractorTeam + 1 }, `تیم ${r.contractorTeam + 1}`) + ' 👑')
      : (youAreContractor ? (t('hand_result.your_team', null, 'تیم شما') + ' 🤝') : (t('hand_result.opp_team', null, 'تیم حریف') + ' ⚔️'));
    subText = t('hand_result.hand_bid', { bid: bidLabel, team: teamLabel }, `تعهد دست: ${bidLabel} (${teamLabel})`);
  }
  const isClaimWin = Boolean(r.claim || r.claimed);
  const banner = el('div', { className: `res-card-banner ${verdictType}` },
    el('div', { className: 'res-banner-title', textContent: verdictTitle }),
    subText ? el('div', { className: 'res-banner-sub', textContent: subText }) : null,
    isClaimWin ? el('div', { className: 'res-banner-claim-badge', textContent: t('hand_result.claimed_badge', null, '🏆 با اعلام قطعی کارت‌های سر (Claim)') }) : null,
  );
  cardWrap.append(banner);

  // بخش تطبیقی دو تیم با اعداد درشت و تفکیک رنگی بالا
  const teamsGrid = el('div', { className: 'res-teams-grid' });

  // ۱. کارت تیم شما / تیم ۱
  const hokmValue = r.value || (r.hakemKot ? 3 : (r.kot ? 2 : 1));
  const youPts = isShelem ? ((r.teamPoints && r.teamPoints[safeYouTeam]) ?? 0) : ((r.tricksWon && r.tricksWon[safeYouTeam]) ?? 0);
  const youDelta = isShelem ? ((r.delta && r.delta[safeYouTeam]) ?? 0) : (r.winnerTeam === safeYouTeam ? hokmValue : 0);
  const youTotal = (v.matchScore && v.matchScore[safeYouTeam]) ?? 0;
  const youTricks = (r.tricksWon && r.tricksWon[safeYouTeam]) ?? 0;
  const youName = isObserver ? t('hand_result.team_n', { n: safeYouTeam + 1 }, `تیم ${safeYouTeam + 1}`) : t('hand_result.your_team', null, 'تیم شما');
  const youIcon = isObserver ? '👥' : '🤝';

  const youCol = el('div', { className: 'res-team-card you' },
    el('div', { className: 'res-tc-head' },
      el('div', { className: 'res-tc-name-wrap' },
        el('span', { className: 'res-tc-icon', textContent: youIcon }),
        el('strong', { className: 'res-tc-name', textContent: youName }),
      ),
      (isShelem && r.contractorTeam === safeYouTeam) ? el('span', { className: 'res-tc-chip', textContent: t('hand_result.contractor_chip', null, '👑 متعهد') }) : null,
    ),
    isShelem ? el('div', { className: 'res-tc-delta ' + (youDelta >= 0 ? 'pos' : 'neg') },
      el('span', { className: 'res-tc-delta-lbl', textContent: t('hand_result.match_delta', null, 'تغییر مسابقه') }),
      el('strong', { className: 'res-tc-delta-val', textContent: signed(youDelta) }),
    ) : (youDelta > 0 ? el('div', { className: 'res-tc-delta pos' },
      el('span', { className: 'res-tc-delta-lbl', textContent: t('hand_result.hands_delta', null, 'دست‌های برده') }),
      el('strong', { className: 'res-tc-delta-val', textContent: `+${faNum(youDelta)} دست` + (r.hakemKot ? ' 🔥' : (r.kot ? ' 💥' : '')) }),
    ) : null),
    el('div', { className: 'res-tc-stats' },
      el('div', { className: 'res-tc-row' },
        el('span', { textContent: isShelem ? t('hand_result.this_hand_score', null, 'امتیاز این دست:') : t('hand_result.tricks', null, 'تریک‌ها:') }),
        el('strong', { className: 'res-num-lg', textContent: isShelem ? faNum(youPts) : t('hand_result.tricks_of_7', { won: faNum(youTricks) }, `${faNum(youTricks)} از ۷`) }),
      ),
      isShelem ? el('div', { className: 'res-tc-row' },
        el('span', { textContent: t('hand_result.hands_won', null, 'دست‌های برده:') }),
        el('strong', { className: 'res-num-lg', textContent: faNum(youTricks) }),
      ) : null,
      el('div', { className: 'res-tc-row total' },
        el('span', { textContent: isShelem ? t('hand_result.total_score', null, 'امتیاز کل:') : t('hand_result.hands_won', null, 'دست‌های برده:') }),
        el('strong', { className: 'res-tc-total-val', textContent: isShelem ? faNum(youTotal) : `${faNum(youTotal)}/۷` }),
      ),
    ),
  );

  // ۲. کارت تیم حریف / تیم ۲
  const oppPts = isShelem ? ((r.teamPoints && r.teamPoints[oppTeam]) ?? 0) : ((r.tricksWon && r.tricksWon[oppTeam]) ?? 0);
  const oppDelta = isShelem ? ((r.delta && r.delta[oppTeam]) ?? 0) : (r.winnerTeam === oppTeam ? hokmValue : 0);
  const oppTotal = (v.matchScore && v.matchScore[oppTeam]) ?? 0;
  const oppTricks = (r.tricksWon && r.tricksWon[oppTeam]) ?? 0;
  const oppName = isObserver ? t('hand_result.team_n', { n: oppTeam + 1 }, `تیم ${oppTeam + 1}`) : t('hand_result.opp_team', null, 'تیم حریف');
  const oppIcon = isObserver ? '👥' : '⚔️';

  const oppCol = el('div', { className: 'res-team-card opp' },
    el('div', { className: 'res-tc-head' },
      el('div', { className: 'res-tc-name-wrap' },
        el('span', { className: 'res-tc-icon', textContent: oppIcon }),
        el('strong', { className: 'res-tc-name', textContent: oppName }),
      ),
      (isShelem && r.contractorTeam === oppTeam) ? el('span', { className: 'res-tc-chip', textContent: t('hand_result.contractor_chip', null, '👑 متعهد') }) : null,
    ),
    isShelem ? el('div', { className: 'res-tc-delta ' + (oppDelta >= 0 ? 'pos' : 'neg') },
      el('span', { className: 'res-tc-delta-lbl', textContent: t('hand_result.match_delta', null, 'تغییر مسابقه') }),
      el('strong', { className: 'res-tc-delta-val', textContent: signed(oppDelta) }),
    ) : (oppDelta > 0 ? el('div', { className: 'res-tc-delta pos' },
      el('span', { className: 'res-tc-delta-lbl', textContent: t('hand_result.hands_delta', null, 'دست‌های برده') }),
      el('strong', { className: 'res-tc-delta-val', textContent: `+${faNum(oppDelta)} دست` + (r.hakemKot ? ' 🔥' : (r.kot ? ' 💥' : '')) }),
    ) : null),
    el('div', { className: 'res-tc-stats' },
      el('div', { className: 'res-tc-row' },
        el('span', { textContent: isShelem ? t('hand_result.this_hand_score', null, 'امتیاز این دست:') : t('hand_result.tricks', null, 'تریک‌ها:') }),
        el('strong', { className: 'res-num-lg', textContent: isShelem ? faNum(oppPts) : t('hand_result.tricks_of_7', { won: faNum(oppTricks) }, `${faNum(oppTricks)} از ۷`) }),
      ),
      isShelem ? el('div', { className: 'res-tc-row' },
        el('span', { textContent: t('hand_result.hands_won', null, 'دست‌های برده:') }),
        el('strong', { className: 'res-num-lg', textContent: faNum(oppTricks) }),
      ) : null,
      el('div', { className: 'res-tc-row total' },
        el('span', { textContent: isShelem ? t('hand_result.total_score', null, 'امتیاز کل:') : t('hand_result.hands_won', null, 'دست‌های برده:') }),
        el('strong', { className: 'res-tc-total-val', textContent: isShelem ? faNum(oppTotal) : `${faNum(oppTotal)}/۷` }),
      ),
    ),
  );

  teamsGrid.append(youCol, oppCol);
  cardWrap.append(teamsGrid);
  return cardWrap;
}

// نتیجه‌ی یک دستِ حکم (برد با ۷ تریک، کوت = ۲ دست).
function hokmResultOverlay(v, r, youTeam) {
  const card = renderHandResultCard(v, r, youTeam);
  const o = overlay(t('hand_result.hand_end_title', null, 'پایان دست'), card,
    v.observerMode
      ? el('p', { className: 'muted small res-countdown-note', textContent: t('hand_result.next_hand_auto', null, 'دست بعد به‌صورت خودکار شروع می‌شود…') })
      : nextHandEl()
  );
  o.classList.add('result-overlay-wrap');
  return o;
}

// نتیجه دست چهاربرگ (پاسور / ۱۱)
function chaharBargResultOverlay(v, r, youTeam) {
  const oppTeam = 1 - youTeam;
  const isObserver = !v || v.observerMode || v.you == null;
  const youPts = r?.scores?.[youTeam] ?? 0;
  const oppPts = r?.scores?.[oppTeam] ?? 0;
  const youWon = youPts >= oppPts;

  const title = isObserver
    ? t('hand_result.cb_obs_title', { s1: faNum(r?.scores?.[0] ?? 0), s2: faNum(r?.scores?.[1] ?? 0) }, `پایان دست — تیم ۱: ${faNum(r?.scores?.[0] ?? 0)} / تیم ۲: ${faNum(r?.scores?.[1] ?? 0)}`)
    : (youWon ? t('hand_result.cb_you_won', null, '🎉 این دست را بردید!') : t('hand_result.cb_you_lost', null, 'این دست را واگذار کردید'));

  const cardWrap = el('div', { className: `res-card-wrap ${youWon ? 'win' : 'lose'}` });

  const youDet = r?.details?.[youTeam] || {};
  const oppDet = r?.details?.[oppTeam] || {};

  const makeTeamCol = (name, det, pts, isMine) => {
    const bonusStr = det.clubs >= 7 ? t('hand_result.cb_clubs_bonus', null, '⭐ (۷ امتیاز هفت‌خاج)') : '';
    return el('div', { className: `cb-res-col ${isMine ? 'mine' : 'opp'}`, style: 'flex:1;padding:14px;border-radius:14px;background:rgba(255,255,255,0.05);text-align:right;' },
      el('h4', { style: 'color:var(--gold);font-size:1.05rem;margin-bottom:6px;', textContent: name }),
      el('div', { style: 'font-size:1.3rem;font-weight:900;margin-bottom:10px;color:#f8fafc;' }, t('hand_result.cb_pts', { pts: faNum(pts) }, `${faNum(pts)} امتیاز`)),
      el('div', { style: 'display:flex;flex-direction:column;gap:5px;font-size:0.86rem;color:#cbd5e1;' },
        el('span', {}, t('hand_result.cb_clubs', { count: faNum(det.clubs || 0), bonus: bonusStr }, `♣ گشنیزها: ${faNum(det.clubs || 0)} برگ ${bonusStr}`)),
        el('span', {}, t('hand_result.cb_ten_diamonds', { val: det.tenDiamonds ? t('hand_result.cb_yes_3pts', null, '✅ (۳ امتیاز)') : '❌' }, `♦ ۱۰ خشت: ${det.tenDiamonds ? '✅ (۳ امتیاز)' : '❌'}`)),
        el('span', {}, t('hand_result.cb_two_clubs', { val: det.twoClubs ? t('hand_result.cb_yes_2pts', null, '✅ (۲ امتیاز)') : '❌' }, `♣ ۲ گشنیز: ${det.twoClubs ? '✅ (۲ امتیاز)' : '❌'}`)),
        el('span', {}, t('hand_result.cb_jacks', { count: faNum(det.jacks || 0) }, `🗡️ سربازها: ${faNum(det.jacks || 0)} برگ`)),
        el('span', {}, t('hand_result.cb_aces', { count: faNum(det.aces || 0) }, `🅰️ آس‌ها: ${faNum(det.aces || 0)} برگ`)),
        el('span', {}, t('hand_result.cb_surs', { count: faNum((r?.surs?.[isMine ? youTeam : oppTeam] || 0)) }, `⭐ سورها: ${faNum((r?.surs?.[isMine ? youTeam : oppTeam] || 0))} سور`)),
      )
    );
  };

  const t1Name = isObserver
    ? t('hand_result.team_n', { n: 1 }, 'تیم ۱')
    : (v.playerCount === 2 ? t('hand_result.you', null, 'شما') : t('hand_result.your_team', null, 'تیم شما'));
  const t2Name = isObserver
    ? t('hand_result.team_n', { n: 2 }, 'تیم ۲')
    : (v.playerCount === 2 ? t('hand_result.opp', null, 'حریف') : t('hand_result.opp_team', null, 'تیم حریف'));

  const grid = el('div', { className: 'cb-res-grid', style: 'display:flex;gap:12px;margin:12px 0;' },
    makeTeamCol(t1Name, youDet, youPts, !isObserver),
    makeTeamCol(t2Name, oppDet, oppPts, false),
  );

  const totalScoreNote = el('div', { className: 'cb-res-total', style: 'text-align:center;font-size:0.92rem;font-weight:bold;margin:12px 0;padding:8px;border-radius:10px;background:rgba(244,201,93,0.1);color:var(--gold);' },
    t('hand_result.cb_total_match', {
      t1: t1Name,
      s1: faNum(v.matchScore?.[youTeam] ?? 0),
      t2: t2Name,
      s2: faNum(v.matchScore?.[oppTeam] ?? 0),
      target: faNum(v.matchTarget || 62)
    }, `امتیاز کل مسابقه: ${t1Name} ${faNum(v.matchScore?.[youTeam] ?? 0)} — ${t2Name} ${faNum(v.matchScore?.[oppTeam] ?? 0)} (هدف: ${faNum(v.matchTarget || 62)})`)
  );

  cardWrap.append(grid, totalScoreNote);

  const o = overlay(title, cardWrap,
    v.observerMode
      ? el('p', { className: 'muted small res-countdown-note', textContent: t('hand_result.next_hand_auto', null, 'دست بعد به‌صورت خودکار شروع می‌شود…') })
      : nextHandEl()
  );
  o.classList.add('result-overlay-wrap');
  return o;
}

// کنترلِ «دستِ بعد»: در حالتِ محلی دکمه، در حالتِ شبکه پیام (سرور خودش بعد از چند ثانیه شروع می‌کند)
function nextHandEl() {
  const isNetwork = networkTable && table === networkTable;
  if (!isNetwork && table && typeof table.startHand === 'function') {
    return el('button', { className: 'primary res-next-btn', textContent: t('hand_result.next_hand_btn', null, 'دستِ بعد ▸'), onclick: () => table.startHand() });
  }
  return el('p', { className: 'muted small res-countdown-note', textContent: t('hand_result.next_hand_auto', null, 'دست بعد به‌صورت خودکار شروع می‌شود…') });
}

// نتیجه‌ی یک دستِ بی‌دل (۴ نفره انفرادی، امتیاز منفی و شق‌القمر).
function bidelResultOverlay(v, r) {
  const cardWrap = el('div', { className: 'res-card-wrap bidel-res-wrap' });
  const isMoon = r?.shotTheMoonSeat != null;
  const shooterName = isMoon ? (v.names?.[r.shotTheMoonSeat] || t('hand_result.player_n', { n: r.shotTheMoonSeat + 1 }, `بازیکن ${r.shotTheMoonSeat + 1}`)) : '';

  let banner;
  if (isMoon) {
    banner = el('div', { className: 'res-card-banner moon-shot-banner' },
      el('div', { className: 'res-banner-title', textContent: t('hand_result.bidel_moon_title', null, '🌕 شق‌القمر! (ماه زدن)') }),
      el('div', { className: 'res-banner-sub', textContent: t('hand_result.bidel_moon_sub', { name: shooterName }, `شاهکار بی‌نظیر! ${shooterName} تمام کارت‌های امتیازدار را شکار کرد! (۰ امتیاز منفی برای او، ۲۶+ برای ۳ رقیب)`) }),
    );
  } else {
    banner = el('div', { className: 'res-card-banner bidel-hand-banner' },
      el('div', { className: 'res-banner-title', textContent: t('hand_result.bidel_hand_title', null, 'پایان دست بی‌دل 💔') }),
      el('div', { className: 'res-banner-sub', textContent: t('hand_result.bidel_hand_sub', null, 'خال دل: ۱- امتیاز • بی‌بی پیک: ۱۳- امتیاز') + (v.jackDiamondsBonus ? t('hand_result.bidel_hand_sub_jack', null, ' • سرباز خشت: ۱۰+ امتیاز جبرانی') : '') }),
    );
  }
  cardWrap.append(banner);

  const grid = el('div', { className: 'bidel-res-grid' });
  const target = v.targetScore || 100;

  for (let s = 0; s < 4; s++) {
    const isYou = (!v.observerMode && v.you === s);
    const pName = v.names?.[s] || t('hand_result.player_n', { n: s + 1 }, `بازیکن ${s + 1}`);
    const pHand = r?.handScore?.[s] ?? 0;
    const pTotal = v.matchScore?.[s] ?? 0;
    const hCount = r?.heartsTaken?.[s] ?? 0;
    const hasQ = r?.queenSpadesSeat === s;
    const hasJ = r?.jackDiamondsSeat === s;

    const dangerPct = Math.min(100, Math.round((pTotal / target) * 100));
    const dangerClass = dangerPct >= 85 ? 'fatal' : (dangerPct >= 65 ? 'danger' : (dangerPct >= 40 ? 'warn' : 'safe'));

    const badges = el('div', { className: 'bidel-res-player-badges' });
    if (hasQ) badges.append(el('span', { className: 'bdl-res-bdg queen', textContent: t('hand_result.bidel_badge_queen', null, '♠Q (۱۳+)'), title: t('hand_result.bidel_badge_queen_title', null, 'بی‌بی پیک') }));
    if (hCount > 0) badges.append(el('span', { className: 'bdl-res-bdg hearts', textContent: t('hand_result.bidel_badge_hearts', { count: faNum(hCount) }, `♥ ${faNum(hCount)}`), title: t('hand_result.bidel_badge_hearts_title', { count: faNum(hCount) }, `${faNum(hCount)} کارت دل`) }));
    if (hasJ) badges.append(el('span', { className: 'bdl-res-bdg jack', textContent: t('hand_result.bidel_badge_jack', null, '♦J (۱۰-)'), title: t('hand_result.bidel_badge_jack_title', null, 'سرباز خشت جایزه') }));
    if (!hasQ && hCount === 0 && !hasJ) badges.append(el('span', { className: 'bdl-res-bdg clean', textContent: t('hand_result.bidel_badge_clean', null, '✨ پاک (۰)'), title: t('hand_result.bidel_badge_clean_title', null, 'بدون جریمه') }));

    const card = el('div', { className: `bidel-res-card ${dangerClass}` + (isYou ? ' is-you' : '') },
      el('div', { className: 'bidel-res-card-head' },
        el('div', { className: 'bidel-res-pname' },
          el('span', { className: 'bidel-res-seat', textContent: faNum(s + 1) }),
          el('strong', { textContent: pName }),
          isYou ? el('span', { className: 'bidel-res-you-tag', textContent: t('hand_result.you', null, 'شما') }) : null,
        ),
        el('div', { className: 'bidel-res-hand-pts ' + (pHand > 0 ? 'bad' : (pHand < 0 ? 'good' : 'neutral')) },
          (pHand > 0 ? `+${faNum(pHand)}` : (pHand < 0 ? `${faNum(pHand)}` : '۰')),
        ),
      ),
      badges,
      el('div', { className: 'bidel-res-meter-wrap' },
        el('div', { className: 'bidel-res-meter-bar', style: `width: ${dangerPct}%` }),
      ),
      el('div', { className: 'bidel-res-card-foot' },
        el('span', { className: 'bidel-res-total-lbl', textContent: t('hand_result.bidel_total_penalty', null, 'مجموع منفی:') }),
        el('strong', { className: 'bidel-res-total-val', textContent: `${faNum(pTotal)} / ${faNum(target)}` }),
      ),
    );
    grid.append(card);
  }

  cardWrap.append(grid);

  if (v.observerMode) {
    setTimeout(() => { if (table && typeof table.startHand === 'function') table.startHand(); }, 3000);
  }
  const o = overlay(t('hand_result.hand_end_title', null, 'پایان دست'), cardWrap,
    v.observerMode
      ? el('p', { className: 'muted small res-countdown-note', textContent: t('hand_result.next_hand_auto', null, 'دست بعد به‌صورت خودکار شروع می‌شود…') })
      : nextHandEl()
  );
  o.classList.add('result-overlay-wrap');
  return o;
}

function bidelMatchOverOverlay(v) {
  const isObserver = !!(v.observerMode || v.you == null);
  const scores = v.matchScore || [0, 0, 0, 0];
  const target = v.targetScore || 100;
  // مرتب‌سازی رتبه‌ها: کمترین امتیاز منفی = رتبه ۱
  const ranking = v.ranking || [0, 1, 2, 3].slice().sort((a, b) => (scores[a] ?? 0) - (scores[b] ?? 0));
  const winnerSeat = ranking[0];
  const winnerName = v.names?.[winnerSeat] || t('hand_result.player_n', { n: winnerSeat + 1 }, `بازیکن ${winnerSeat + 1}`);
  const myRank = isObserver ? -1 : (ranking.indexOf(v.you) + 1);

  const coinsAwarded = v.coinsAwarded || [0, 0, 0, 0];
  const myCoins = !isObserver ? (coinsAwarded[v.you] || 0) : 0;

  let title, sub;
  if (isObserver) {
    title = t('hand_result.bidel_player_won', { player: winnerName }, `🏆 ${winnerName} پیروز شد!`);
    sub = t('hand_result.bidel_target_reached', { target: faNum(target) }, `پایان مسابقه با رسیدن یکی از بازیکنان به سقف ${faNum(target)} منفی`);
  } else if (myRank === 1) {
    title = t('hand_result.match_won', null, '🏆 پیروز شدید!');
    sub = myCoins > 0 ? t('hand_result.bidel_win_coins', { coins: faNum(myCoins) }, `تبریک! کمترین امتیاز منفی با پاداش +${faNum(myCoins)} سکه 🪙`) : t('hand_result.bidel_win_desc', null, 'تبریک! با کمترین نمره منفی قهرمان شدید!');
  } else if (myRank === 2) {
    title = t('hand_result.bidel_second_title', null, '🥈 رتبه دوم!');
    sub = myCoins > 0 ? t('hand_result.bidel_second_coins', { coins: faNum(myCoins) }, `عملکرد عالی! جایزه مقام دوم: +${faNum(myCoins)} سکه 🪙`) : t('hand_result.bidel_second_desc', null, 'عملکرد عالی در کنترل امتیازات منفی!');
  } else {
    title = t('hand_result.match_lost', null, 'باختید');
    sub = t('hand_result.bidel_loss_desc', { rank: faNum(myRank), target: faNum(target) }, `رتبه ${faNum(myRank)} مسابقه — امتیازات منفی به سقف ${faNum(target)} رسید`);
  }

  const ranksList = el('div', { className: 'bidel-ranks-list' });
  const MEDALS = ['🥇', '🥈', '🥉', '💀'];

  ranking.forEach((seat, idx) => {
    const isYou = (!isObserver && v.you === seat);
    const pName = v.names?.[seat] || t('hand_result.player_n', { n: seat + 1 }, `بازیکن ${seat + 1}`);
    const pScore = scores[seat] ?? 0;
    const pCoins = coinsAwarded[seat] || 0;

    const row = el('div', { className: `bidel-rank-row rank-${idx + 1}` + (isYou ? ' is-you' : '') },
      el('div', { className: 'bidel-rank-medal', textContent: MEDALS[idx] || `${faNum(idx + 1)}` }),
      el('div', { className: 'bidel-rank-name-wrap' },
        el('strong', { className: 'bidel-rank-name', textContent: pName }),
        isYou ? el('span', { className: 'bidel-res-you-tag', textContent: t('hand_result.you', null, 'شما') }) : null,
      ),
      el('div', { className: 'bidel-rank-score-wrap' },
        el('span', { className: 'bidel-rank-score-lbl', textContent: t('hand_result.bidel_penalty_lbl', null, 'منفی:') }),
        el('strong', { className: 'bidel-rank-score', textContent: faNum(pScore) }),
      ),
      pCoins > 0 ? el('span', { className: 'bidel-rank-coin-tag', textContent: `+${faNum(pCoins)} 🪙` }) : null,
    );
    ranksList.append(row);
  });

  return overlay(title,
    el('p', { className: 'verdict bidel-verdict', textContent: sub }),
    ranksList,
    el('div', { className: 'match-over-actions' },
      el('button', { className: 'primary', textContent: t('hand_result.play_again', null, '🔁 بازی دوباره'), onclick: playAgain }),
      el('button', { className: 'ghost-sm', textContent: t('hand_result.leave_room', null, 'خروج از اتاق'), onclick: () => leaveGame() }))
  );
}

function bluffMatchOverOverlay(v) {
  const isObserver = !!(v.observerMode || v.you == null);
  const winnerSeat = v.winnerSeat ?? 0;
  const winnerName = v.names?.[winnerSeat] || v.winnerName || t('hand_result.player_n', { n: winnerSeat + 1 }, `بازیکن ${winnerSeat + 1}`);
  const isYou = !isObserver && v.you === winnerSeat;
  const cardCounts = v.cardCounts || v.handCounts || [0, 0, 0, 0];

  let title = isObserver
    ? t('hand_result.bluff_player_won', { player: winnerName }, `🏆 ${winnerName} پیروز شد!`)
    : (isYou ? t('hand_result.match_won', null, '🏆 پیروز شدید!') : t('hand_result.match_lost', null, 'باختید'));
  let sub = isYou
    ? t('hand_result.bluff_you_won_desc', null, 'تبریک! تمام کارت‌های دست خود را زودتر از همه خالی کردید.')
    : t('hand_result.bluff_opp_won_desc', { player: winnerName }, `🏆 ${winnerName} زودتر از همه تمام کارت‌هایش را خالی کرد.`);

  const ranksList = el('div', { className: 'bidel-ranks-list' });
  // مرتب‌سازی رتبه‌ها: صندلی برنده (۰ کارت) در صدر
  const seats = [0, 1, 2, 3].slice().sort((a, b) => (cardCounts[a] ?? 0) - (cardCounts[b] ?? 0));
  const MEDALS = ['👑', '🥈', '🥉', '💀'];

  seats.forEach((s, idx) => {
    const isMe = !isObserver && v.you === s;
    const pName = v.names?.[s] || t('hand_result.player_n', { n: s + 1 }, `بازیکن ${s + 1}`);
    const cnt = cardCounts[s] ?? 0;

    const row = el('div', { className: `bidel-rank-row rank-${idx + 1}` + (isMe ? ' is-you' : '') },
      el('div', { className: 'bidel-rank-medal', textContent: MEDALS[idx] || `${faNum(idx + 1)}` }),
      el('div', { className: 'bidel-rank-name-wrap' },
        el('strong', { className: 'bidel-rank-name', textContent: pName }),
        isMe ? el('span', { className: 'bidel-res-you-tag', textContent: t('hand_result.you', null, 'شما') }) : null,
      ),
      el('div', { className: 'bidel-rank-score-wrap' },
        el('span', { className: 'bidel-rank-score-lbl', textContent: t('hand_result.bluff_remaining_lbl', null, 'باقیمانده:') }),
        el('strong', { className: 'bidel-rank-score', textContent: t('hand_result.bluff_cards_count', { count: faNum(cnt) }, `${faNum(cnt)} کارت`) }),
      ),
    );
    ranksList.append(row);
  });

  return overlay(title,
    el('p', { className: 'verdict bidel-verdict', textContent: sub }),
    ranksList,
    el('div', { className: 'match-over-actions' },
      el('button', { className: 'primary', textContent: t('hand_result.play_again', null, '🔁 بازی دوباره'), onclick: playAgain }),
      el('button', { className: 'ghost-sm', textContent: t('hand_result.leave_room', null, 'خروج از اتاق'), onclick: () => leaveGame() }))
  );
}

function resultOverlay(v) {
  const r = v.result;
  const youTeam = (v.you != null) ? (v.you % 2) : 0;
  if (v.gameType === 'hokm') return hokmResultOverlay(v, r, youTeam);
  if (v.gameType === 'chahar_barg') return chaharBargResultOverlay(v, r, youTeam);
  if (v.gameType === 'bidel') return bidelResultOverlay(v, r);
  const card = renderHandResultCard(v, r, youTeam);
  if (v.observerMode) {
    setTimeout(() => { if (table && typeof table.startHand === 'function') table.startHand(); }, 3000);
  }
  const o = overlay(t('hand_result.hand_end_title', null, 'پایان دست'), card,
    v.observerMode
      ? el('p', { className: 'muted small res-countdown-note', textContent: t('hand_result.next_hand_auto', null, 'دست بعد به‌صورت خودکار شروع می‌شود…') })
      : nextHandEl()
  );
  o.classList.add('result-overlay-wrap');
  return o;
}

function matchOverOverlay(v) {
  if (v.gameType === 'bidel') return bidelMatchOverOverlay(v);
  if (v.gameType === 'bluff') return bluffMatchOverOverlay(v);
  const isObserver = !!(v.observerMode || v.you == null);
  const youTeam = (v.you != null ? v.you : 0) % 2;
  const oppTeam = 1 - youTeam;
  const unit = v.gameType === 'hokm' ? t('hand_result.unit_hands', null, 'دست') : t('hand_result.unit_points', null, 'امتیاز');
  const isShelem = v.gameType === 'shelem';
  const maxTarget = v.jokerMode ? 1600 : 1200;
  const maxWin = v.jokerMode ? 40 : 32;
  const target = v.matchTarget || maxTarget;
  let winReward = Math.max(1, Math.round(maxWin * (target / maxTarget)));
  if (v.gameType === 'chahar_barg') winReward = 20;
  else if (v.gameType === 'hokm') winReward = 10;
  const isKenz = Boolean(v.kenzMatchOver || (v.result && (v.result.contractType === 'kenz' || v.result.instantMatchOver)));
  const winnerTeam = (v.winnerTeam != null) ? v.winnerTeam : (v.matchScore[0] >= v.matchScore[1] ? 0 : 1);

  if (isObserver) {
    const kenzNote = isKenz ? t('hand_result.kenz_note_obs', null, '⚡ با پیروزی در تعهد کنز (مرگ آنی)!') : '';
    const obsTitle = t('hand_result.match_obs_won', { team: t('hand_result.team_n', { n: winnerTeam + 1 }, `تیم ${winnerTeam + 1}`) }, `🏆 تیم ${winnerTeam + 1} پیروز شد!`);
    const obsVerdict = t('hand_result.match_final_score', { unit, t1: t('hand_result.team_n', { n: 1 }, 'تیم ۱'), s1: faNum(v.matchScore[0]), t2: t('hand_result.team_n', { n: 2 }, 'تیم ۲'), s2: faNum(v.matchScore[1]) }, `${unit} نهایی — تیم ۱: ${faNum(v.matchScore[0])} / تیم ۲: ${faNum(v.matchScore[1])}`);
    return overlay(obsTitle,
      el('p', { className: 'verdict', textContent: obsVerdict }),
      kenzNote ? el('p', { className: 'muted small kenz-alert-text', textContent: kenzNote }) : null,
      el('button', { className: 'primary', textContent: t('hand_result.leave_room', null, 'خروج از اتاق'), onclick: () => leaveGame() }));
  }
  const won = (v.winnerTeam != null) ? (v.winnerTeam === youTeam) : (v.matchScore[youTeam] >= v.matchScore[oppTeam]);
  const kenzNote = isKenz ? (won ? t('hand_result.kenz_note_win', null, '⚡ با پیروزی مقتدرانه در تعهد کنز (مرگ آنی)!') : t('hand_result.kenz_note_loss', null, '⚡ با باخت در تعهد کنز (مرگ آنی) — حریف پیروز شد')) : '';
  const rewardEl = won ? el('p', { className: 'match-reward-msg', textContent: t('hand_result.reward_msg', { pts: faNum(winReward) }, `🎉 پاداش پیروزی: +${faNum(winReward)} امتیاز رتبه‌بندی`) }) : null;
  const youVerdict = t('hand_result.match_final_score_you', { unit, s1: faNum(v.matchScore[youTeam]), s2: faNum(v.matchScore[oppTeam]) }, `${unit} نهایی — تیم شما ${faNum(v.matchScore[youTeam])} / حریف ${faNum(v.matchScore[oppTeam])}`);
  return overlay(won ? t('hand_result.match_won', null, '🏆 بردید!') : t('hand_result.match_lost', null, 'باختید'),
    el('p', { className: 'verdict', textContent: youVerdict }),
    kenzNote ? el('p', { className: 'kenz-alert-text', textContent: kenzNote }) : null,
    rewardEl,
    el('div', { className: 'match-over-actions' },
      el('button', { className: 'primary', textContent: t('hand_result.play_again', null, '🔁 بازی دوباره'), onclick: playAgain }),
      el('button', { className: 'ghost-sm', textContent: t('hand_result.leave_room', null, 'خروج از اتاق'), onclick: () => leaveGame() }))
  );
}

// «بازی دوباره» در همان اتاق و با حفظ صندلی کاربر — بدون رفتن به لابی
function playAgain() {
  if (table && typeof table.playAgain === 'function') {
    table.playAgain();
  } else if (table && table !== networkTable && typeof table.startMatch === 'function') {
    table.startMatch();
  } else if (networkTable && table === networkTable) {
    networkTable.playAgain();
  } else {
    const args = _lastQuickStart;
    leaveGame({ force: true });
    if (args) startGame(args);
  }
}

function matchCancelledOverlay(v) {
  const byError = v.cancelReason === 'ENGINE_ERROR';
  const title = byError ? t('hand_result.match_stopped_title', null, '⚠️ بازی متوقف شد') : t('hand_result.match_cancelled_title', null, '🏳️ بازی لغو شد');
  const text = byError
    ? t('hand_result.match_stopped_tech_err', null, 'به دلیل یک خطای فنی، این دست متوقف شد. امتیازی کم یا زیاد نشد و چیزی در سوابق ثبت نگردید. می‌توانید بازی تازه‌ای شروع کنید.')
    : t('hand_result.match_cancelled_consensus', null, 'با موافقت ۳ بازیکن و روشن شدن چراغ سوم آبی، این بازی بدون کسر یا افزایش امتیاز و بدون ثبت در سوابق لغو گردید.');
  const kids = [];
  if (!byError) {
    kids.push(el('div', { className: 'cancel-lights-row large' },
      el('span', { className: 'cancel-light-bullet active' }),
      el('span', { className: 'cancel-light-bullet active' }),
      el('span', { className: 'cancel-light-bullet active' }),
    ));
  }
  kids.push(el('p', { className: 'verdict', style: 'color: #93c5fd; max-width: 340px; margin: 12px auto; line-height: 1.6; font-size: 13.5px;', textContent: text }));
  kids.push(el('div', { className: 'match-over-actions' },
    el('button', { className: 'primary', textContent: t('hand_result.play_again', null, '🔁 بازی دوباره'), onclick: playAgain }),
    el('button', { className: 'ghost-sm', textContent: t('hand_result.leave_room', null, 'خروج از اتاق'), onclick: () => leaveGame() })));
  return overlay(title, ...kids);
}

const signed = (n) => (n > 0 ? '+' : '') + faNum(n);

// ─── سیستم چت و پیام‌های آماده در ui/chatVoice.js ماژولار شده است ───

// ─── منوی سریعِ آواتار/نام: کلیک=منو (مشاهده پروفایل / پیام خصوصی)، دابل‌کلیک=مستقیم پیام خصوصی ──
const avatarMenu = {
  el: null,
  hide() {
    this.el?.remove(); this.el = null;
    document.removeEventListener('click', this._outside);
  },
  toggle(anchor, opts) {
    this.hide();
    const items = [
      el('button', { className: 'avatar-menu-item', textContent: '👤 مشاهده پروفایل', onclick: () => { this.hide(); profileCardUI.showById(opts); } }),
    ];
    if (opts.userId != null) {
      items.push(el('button', { className: 'avatar-menu-item', textContent: '💬 پیام خصوصی', onclick: () => { this.hide(); openDm(opts.userId, opts.username, opts.avatarUrl); } }));
      if (opts.userId !== myUserId) {
        items.push(el('button', { className: 'avatar-menu-item report-item', style: 'color:#f87171;', textContent: '🚩 گزارش تخلف', onclick: () => { this.hide(); openReportUserModal(opts.userId, opts.username); } }));
      }
    }
    this.el = el('div', { className: 'avatar-menu' }, ...items);
    document.body.append(this.el);
    const rect = anchor.getBoundingClientRect();
    const left = Math.min(Math.max(8, rect.left), window.innerWidth - 172);
    this.el.style.cssText = `position:fixed;top:${rect.bottom + 6}px;left:${left}px`;
    setTimeout(() => document.addEventListener('click', this._outside = () => this.hide(), { once: true }), 0);
  },
};
// یک بار کلیک: منوی سریع. دابل‌کلیک: مستقیم پیام خصوصی (بدون منو).
function bindProfileMenu(elm, opts) {
  if (!elm) return;
  elm.style.cursor = 'pointer';
  elm.onclick = (e) => { e.stopPropagation(); avatarMenu.toggle(elm, opts); };
  elm.ondblclick = (e) => {
    e.stopPropagation();
    avatarMenu.hide();
    if (opts.userId != null) openDm(opts.userId, opts.username, opts.avatarUrl);
  };
}

// ─── مودال گزارش تخلف کاربر (الزام رسمی انتشار کافه‌بازار) ─────────────────
function openReportUserModal(targetUserId = null, targetName = '') {
  if (!authToken) {
    toast(t('report.need_login'), 'warn');
    return;
  }
  const existing = document.querySelector('.report-modal-overlay');
  if (existing) existing.remove();

  const overlay = el('div', { className: 'report-modal-overlay' });
  const modal = el('div', { className: 'report-modal' });

  const titleText = targetName ? t('report.target_modal_title', { name: targetName }) : t('report.modal_title');
  const title = el('div', { className: 'report-modal-header' },
    el('h3', { textContent: titleText }),
    el('button', { className: 'report-close-btn', textContent: '✕', onclick: () => overlay.remove() })
  );

  const desc = el('p', {
    className: 'muted small report-desc',
    textContent: t('report.desc')
  });

  let userTargetInput = null;
  if (!targetUserId) {
    userTargetInput = el('input', {
      type: 'text',
      className: 'report-target-input',
      style: 'width:100%;margin-bottom:12px;padding:9px 12px;border-radius:10px;border:1px solid rgba(255,255,255,0.15);background:#111420;color:#f8fafc;font-size:13px;font-family:inherit;box-sizing:border-box;outline:none;',
      placeholder: t('report.target_placeholder')
    });
  }

  const reasonKeys = [
    'reason_profile',
    'reason_harassment',
    'reason_cheat',
    'reason_abandon',
    'reason_spam',
    'reason_other'
  ];
  const reasons = reasonKeys.map(k => t(`report.${k}`));

  let selectedReason = reasons[0];
  const list = el('div', { className: 'report-reasons-list' });
  reasons.forEach((r, idx) => {
    const item = el('label', { className: 'report-reason-item' + (idx === 0 ? ' selected' : '') });
    const radio = el('input', {
      type: 'radio',
      name: 'report_reason',
      value: r,
      checked: idx === 0,
      onchange: () => {
        selectedReason = r;
        list.querySelectorAll('.report-reason-item').forEach(el => el.classList.remove('selected'));
        item.classList.add('selected');
      }
    });
    item.append(radio, el('span', { textContent: r }));
    list.append(item);
  });

  const commentInput = el('textarea', {
    className: 'report-comment-input',
    placeholder: t('report.comment_placeholder'),
    rows: 2,
    maxLength: 250
  });

  const submitBtn = el('button', {
    className: 'btn-sm btn-accent report-submit-btn',
    textContent: t('report.submit'),
    onclick: async () => {
      const targetUserStr = userTargetInput ? userTargetInput.value.trim() : '';
      if (!targetUserId && !targetUserStr) {
        toast(t('report.need_username'), 'warn');
        userTargetInput?.focus();
        return;
      }
      submitBtn.disabled = true;
      submitBtn.textContent = t('report.submitting');
      try {
        const fullReason = commentInput.value.trim()
          ? `${selectedReason} | ${commentInput.value.trim()}`
          : selectedReason;
        const payload = {
          targetUserId: targetUserId || null,
          targetUsername: targetUserStr || targetName || null,
          reason: fullReason,
          roomId: lastView?.roomId || null
        };
        const endpoint = targetUserId ? `/api/profile/${targetUserId}/report` : '/api/profile/report';
        const res = await apiFetch('POST', endpoint, payload);
        if (res?.ok) {
          toast(t('report.success'), 'ok');
          overlay.remove();
        } else {
          toast(res?.message || res?.error || t('report.failed'), 'err');
          submitBtn.disabled = false;
          submitBtn.textContent = t('report.submit');
        }
      } catch (e) {
        toast(t('report.server_error'), 'err');
        submitBtn.disabled = false;
        submitBtn.textContent = t('report.submit');
      }
    }
  });

  const cancelBtn = el('button', {
    className: 'btn-sm btn-ghost report-cancel-btn',
    textContent: t('common.cancel'),
    onclick: () => overlay.remove()
  });

  const actions = el('div', { className: 'report-modal-actions' }, submitBtn, cancelBtn);

  if (userTargetInput) {
    modal.append(title, desc, userTargetInput, list, commentInput, actions);
  } else {
    modal.append(title, desc, list, commentInput, actions);
  }
  overlay.append(modal);
  overlay.onclick = (e) => { if (e.target === overlay) overlay.remove(); };
  document.body.append(overlay);
}
window.openReportUserModal = openReportUserModal;

// ─── پروفایل سریع (کلیک روی آواتار / دوستان / لابی) ────────────────────────
const profileCardUI = {
  el: null,

  // نمایش از داخل بازی (seat دارد)
  show(v, seat, anchor) {
    const username = v.names?.[seat] || '?';
    const userId   = (v.userIds    || [])[seat];
    const avatarUrl = (v.avatarUrls || [])[seat];
    const inRoom   = !!(v.roomId || (table && table !== networkTable));
    this._show({ username, userId, avatarUrl, inRoom, anchor });
  },

  // نمایش از لابی / دوستان (فقط userId یا username)
  showById(opts = {}) { this._show(opts); },

  async _show({ username, userId, avatarUrl, inRoom = false, anchor = null }) {
    this.hide();
    const card = el('div', { className: 'profile-card' });

    // هدر افقی: آواتار + اطلاعات
    const infoCol = el('div', { className: 'pc-info' });
    infoCol.append(
      el('div', { className: 'pc-name', textContent: username || '?' }),
    );
    const gradeWrap = el('div', { className: 'pc-grade' });
    const statsEl   = el('div', { className: 'pc-stats', textContent: t('common.loading', null, 'در حال بارگذاری…') });
    infoCol.append(gradeWrap, statsEl);

    const header = el('div', { className: 'pc-header' });
    header.append(
      avatarEl(username || '?', avatarUrl, 72),
      infoCol,
    );
    card.append(
      el('button', { className: 'pc-close', textContent: '✕', onclick: () => this.hide() }),
      header,
    );

    // پس‌زمینهٔ تیره + کارت وسطِ صفحه (نه چسبیده به anchor)
    const backdrop = el('div', { className: 'pc-backdrop', onclick: () => this.hide() });
    document.body.append(backdrop, card);
    this._backdrop = backdrop;
    this.el = card;
    card.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:10000';

    try {
      const path = userId
        ? `/api/profile/${userId}`
        : `/api/profile/by-name/${encodeURIComponent(username || '')}`;
      const data = await apiFetch('GET', path);
      if (!this.el) return;

      if (data.display_name) {
        const nameEl = card.querySelector('.pc-name');
        if (nameEl) nameEl.textContent = data.display_name;
      }
      const bioOrMeta = [];
      if (data.gender === 'male') bioOrMeta.push(t('profile_modal.mr', null, 'آقا 👨'));
      else if (data.gender === 'female') bioOrMeta.push(t('profile_modal.ms', null, 'خانم 👩'));
      if (data.age) bioOrMeta.push(t('profile_modal.years_old', { n: faNum(data.age) }, `${faNum(data.age)} ساله`));
      if (bioOrMeta.length) {
        const metaEl = el('div', { className: 'pc-user-meta', textContent: bioOrMeta.join(' · ') });
        card.querySelector('.pc-name')?.after(metaEl);
      }

      if (data.stats?.games) {
        // فاز ۲: پروفایل کامل (هدر + تب عمومی + تب هر بازی) جای هدر و آمار ترکیبی قدیمی
        card.classList.add('pc-wide');
        card.replaceChildren(card.querySelector('.pc-close'), profileView(data, { self: data.id === myUserId }));
      } else {
      const elo    = data.elo_rating ?? 1200;
      const games  = data.games_played ?? 0;
      const wins   = data.games_won ?? 0;
      const losses = games - wins;
      const g      = eloGrade(elo, games);

      gradeWrap.append(
        gradeTag(elo, games),
        el('span', { className: 'pc-grade-label', style: `color:${g.color}`, textContent: g.label }),
        el('span', { className: 'pc-elo-num', textContent: ` · ${faNum(Math.round(elo))} ${t('profile_modal.rating_label', null, 'تراز')}` }),
      );
      statsEl.innerHTML = '';
      const winRate = games > 0 ? Math.round(wins / games * 100) : 0;
      statsEl.append(
        el('span', { textContent: t('profile_modal.stat_games_count', { n: faNum(games) }, `${faNum(games)} بازی`) }),
        el('span', { className: 'pc-sep', textContent: '·' }),
        el('span', { style: 'color:#36d399', textContent: t('profile_modal.stat_games_count', { n: faNum(wins) }, `${faNum(wins)} بازی`) }),
        el('span', { className: 'pc-sep', textContent: '·' }),
        el('span', { style: 'color:#fca5a5', textContent: t('profile_modal.stat_losses', null, 'باخت') + ': ' + faNum(losses) }),
        el('span', { className: 'pc-sep', textContent: '·' }),
        el('span', { style: 'color:#facc15; font-weight:700', textContent: `${faNum(winRate)}٪` }),
      );
      // رتبه + ترکِ اتاق — همیشه نمایش داده می‌شوند
      const extra = el('div', { className: 'pc-stats pc-stats2' },
        el('span', { className: 'pc-rank' }, t('profile_modal.stat_rank', { rank: data.rank != null ? faNum(data.rank) : '—' }, `🏆 رتبه: ${data.rank != null ? faNum(data.rank) : '—'}`)),
        el('span', { className: 'pc-sep', textContent: '·' }),
        el('span', { style: 'color:#fca5a5', title: t('profile_modal.stat_abandoned_tip', null, 'ترکِ بازی وسطِ مسابقه') }, t('profile_modal.stat_abandoned_count', { n: faNum(data.games_abandoned ?? 0) }, `🚪 ترک: ${faNum(data.games_abandoned ?? 0)}`)),
      );
      statsEl.after(extra);
      if (data.bio) card.append(el('div', { className: 'pc-bio', textContent: data.bio }));
      }

      if (data.id && data.id !== myUserId) {
        let currentStatus = friendsSet.has(data.id) ? 'FRIENDS' : 'NONE';
        try {
          const statusRes = await apiFetch('GET', `/api/friends/status/${data.id}`);
          if (statusRes?.status) currentStatus = statusRes.status;
        } catch {}

        const friendBtn = el('button', { className: 'pc-action-btn' });

        function updateFriendBtn() {
          friendBtn.className = 'pc-action-btn';
          friendBtn.disabled = false;
          if (currentStatus === 'FRIENDS') {
            friendBtn.classList.add('is-friend');
            friendBtn.textContent = t('profile_modal.btn_is_friend', null, '✓ دوست');
          } else if (currentStatus === 'PENDING_SENT') {
            friendBtn.classList.add('pending');
            friendBtn.textContent = t('profile_modal.btn_pending_sent', null, '⏳ ارسال شد');
            friendBtn.disabled = true;
          } else if (currentStatus === 'PENDING_RECEIVED') {
            friendBtn.classList.add('accept-highlight');
            friendBtn.textContent = t('profile_modal.btn_accept_friend', null, '🤝 تایید');
          } else {
            friendBtn.textContent = t('profile_modal.btn_add_friend', null, '➕ دوستی');
          }
        }

        updateFriendBtn();

        friendBtn.onclick = async () => {
          if (myProfile?.is_guest) {
            showUpgradeGuestModal('friends');
            return;
          }
          if (currentStatus === 'FRIENDS') {
            if (!confirm(t('profile_modal.remove_friend_confirm', { username }, `آیا از حذف «${username}» از لیست دوستان مطمئن هستید؟`))) return;
            await apiFetch('DELETE', `/api/friends/${data.id}`);
            friendsSet.delete(data.id);
            currentStatus = 'NONE';
            updateFriendBtn();
            toast(t('profile_modal.friend_removed', { username }, `${username} از لیست دوستان حذف شد`));
          } else if (currentStatus === 'PENDING_RECEIVED') {
            await apiFetch('POST', `/api/friends/accept/${data.id}`);
            if (networkTable) networkTable.acceptFriendRequest(data.id);
            friendsSet.add(data.id);
            currentStatus = 'FRIENDS';
            updateFriendBtn();
            toast(t('profile_modal.friend_became', { username }, `شما و ${username} با هم دوست شدید! 🎉`));
          } else if (currentStatus === 'NONE') {
            await apiFetch('POST', `/api/friends/request/${data.id}`);
            if (networkTable) networkTable.sendFriendRequest(data.id);
            currentStatus = 'PENDING_SENT';
            updateFriendBtn();
            toast(t('profile_modal.friend_req_sent', { username }, `درخواست دوستی برای ${username} ارسال شد`));
          }
        };

        const dmBtn = el('button', {
          className: 'pc-action-btn dm-open-btn', textContent: t('profile_modal.btn_dm', null, '💬 پیام'),
          onclick: () => {
            if (myProfile?.is_guest) {
              showUpgradeGuestModal('dm');
              return;
            }
            openDm(data.id, username);
          },
        });

        const reportBtn = el('button', {
          className: 'pc-action-btn pc-report-btn',
          textContent: t('profile_modal.btn_report', null, '🚩 گزارش تخلف'),
          title: t('profile_modal.btn_report_tip', null, 'گزارش تخلف این کاربر به مدیریت'),
          onclick: () => openReportUserModal(data.id, data.display_name || data.username || username),
        });

        const actionsRow = el('div', { className: 'pc-actions' });
        actionsRow.append(friendBtn, dmBtn, reportBtn);

        const amIInRoom = !!(lastView?.roomId || (table && table === networkTable && !$('#table')?.classList.contains('hidden')));
        const isTargetInRoom = (lastView?.userIds || []).includes(data.id);
        if (amIInRoom && !isTargetInRoom) {
          actionsRow.append(el('button', {
            className: 'pc-action-btn primary-sm', textContent: t('profile_modal.btn_invite', null, '📨 دعوت'),
            onclick: () => {
              if (myProfile?.is_guest) {
                showUpgradeGuestModal('invite');
                this.hide();
                return;
              }
              if (table?.invite) { table.invite(data.id); }
              else toast(t('profile_modal.invite_only_in_room', null, 'برای دعوت باید داخل یک اتاق باشید'), 'error');
              this.hide();
            },
          }));
        }

        card.append(actionsRow);
      }
    } catch {
      if (this.el) statsEl.textContent = t('profile_modal.data_unavailable', null, 'اطلاعات در دسترس نیست');
    }
  },

  hide() {
    this.el?.remove(); this.el = null;
    this._backdrop?.remove(); this._backdrop = null;
  },
};

// ─── پیامِ خصوصی (dmPanel و dmUnread) در ui/socialPanels.js ماژولار شده است ───

// ─── پاپ‌آپ ری‌اکشن‌های سریع روی میز ─────────────────────────────────────
const reactionsPopupUI = {
  el: null,
  list: ['👏', '🔥', '👑', '🤦‍♂️', '🃏', '❤️', '☕', '🧊'],
  taunts: [
    'دست مریزاد! 👏',
    'عجب حرکتی! 🔥',
    'چیکار کردی یار؟! 🤦‍♂️',
    'بزن بریم! 🚀',
    'یه چایی بریز ☕',
    'آرامش! 🧊',
  ],

  // پک‌های صوتیِ خریداری‌شده، نرمال‌شده: [{ key, title, phrases: [{ text, audio_url }] }]
  voicePacks() {
    const packs = Array.isArray(myProfile?.owned_voice_packs) ? myProfile.owned_voice_packs : [];
    const normalized = packs.map((pack) => ({
      key: pack.key, title: pack.title || pack.key,
      phrases: (Array.isArray(pack.phrases) ? pack.phrases : []).map((ph) =>
        (typeof ph === 'string' ? { text: ph.trim(), audio_url: '' }
          : (ph && ph.text ? { text: String(ph.text).trim(), audio_url: ph.audio_url || '' } : null)))
        .filter((ph) => ph && ph.text),
    })).filter((pk) => pk.phrases.length);
    // پیش‌بارگذاری تمام صوت‌های پک‌های کاربر در پس‌زمینه برای پخش آنی (Zero-Latency)
    try {
      for (const pk of normalized) {
        for (const ph of pk.phrases) {
          if (ph.audio_url) sounds.preloadVoice?.(ph.audio_url);
        }
      }
    } catch {}
    return normalized;
  },

  toggle(anchor) {
    if (this.el) { this.hide(); return; }
    this.el = el('div', { className: 'reactions-popup' });

    // ⭐ نشان‌شده‌ها — همان‌هایی که در پنلِ سریعِ موبایل نشان شده‌اند (همگام از طریقِ پروفایل)
    const favs = quickFavItems();
    if (favs.length) {
      const favSec = el('div', { className: 'taunt-quick-sec' });
      favSec.append(el('div', { style: 'font-size:11px;color:var(--gold);margin:2px 0 4px;font-weight:700;', textContent: '⭐ نشان‌شده‌ها' }));
      for (const it of favs) {
        favSec.append(el('button', {
          className: 'taunt-quick-btn' + (it.kind === 'voice' ? ' voice-owned' : ''),
          textContent: it.kind === 'voice' ? `🎙️ ${it.label}` : it.label,
          onclick: (e) => { e.stopPropagation(); it.send(); this.hide(); },
        }));
      }
      this.el.append(favSec);
    }

    // ردیف ایموجی‌ها
    const row = el('div', { className: 'reactions-row' });
    for (const emoji of this.list) {
      row.append(el('button', {
        className: 'reaction-btn',
        textContent: emoji,
        onclick: (e) => {
          e.stopPropagation();
          this.trigger(emoji);
          this.hide();
        },
      }));
    }
    this.el.append(row);

    // ردیف کل‌کل و تکیه‌کلام‌های سریع
    const tauntSec = el('div', { className: 'taunt-quick-sec' });
    const quickTaunts = this.taunts;

    // تکیه‌کلام‌های پک‌های صوتی خریداری‌شده توسط بازیکن
    const ownedVoicePhrases = [];
    if (Array.isArray(myProfile?.owned_voice_packs)) {
      for (const pack of myProfile.owned_voice_packs) {
        if (Array.isArray(pack.phrases)) {
          for (const ph of pack.phrases) {
            if (typeof ph === 'string' && ph.trim()) {
              ownedVoicePhrases.push({ text: ph.trim(), audio_url: '' });
            } else if (ph && typeof ph === 'object' && ph.text) {
              ownedVoicePhrases.push({ text: ph.text.trim(), audio_url: ph.audio_url || '' });
            }
          }
        }
      }
    }

    if (ownedVoicePhrases.length > 0) {
      tauntSec.append(el('div', {
        style: 'font-size:11px;color:var(--gold);margin:4px 0 2px;font-weight:700;display:flex;align-items:center;gap:4px;',
        textContent: '🎙️ تکیه‌کلام‌های صوتی شما:'
      }));
      for (const vp of ownedVoicePhrases) {
        tauntSec.append(el('button', {
          className: 'taunt-quick-btn voice-owned',
          style: 'border-color:rgba(244,201,93,0.4);color:var(--gold);background:rgba(244,201,93,0.08);',
          textContent: `🎙️ ${vp.text}`,
          onclick: (e) => {
            e.stopPropagation();
            this.triggerTaunt(vp);
            this.hide();
          },
        }));
      }
      tauntSec.append(el('div', {
        style: 'font-size:11px;color:var(--muted);margin:6px 0 2px;font-weight:600;',
        textContent: 'تکیه‌کلام‌های عمومی:'
      }));
    }

    for (const phrase of quickTaunts) {
      tauntSec.append(el('button', {
        className: 'taunt-quick-btn',
        textContent: phrase,
        onclick: (e) => {
          e.stopPropagation();
          this.triggerTaunt(phrase);
          this.hide();
        },
      }));
    }
    this.el.append(tauntSec);

    document.body.append(this.el);
    const rect = anchor.getBoundingClientRect();
    this.el.style.cssText = `position:fixed;bottom:${window.innerHeight - rect.top + 8}px;right:${window.innerWidth - rect.right}px;`;
    setTimeout(() => document.addEventListener('click', this._outside = () => this.hide(), { once: true }), 0);
  },

  hide() {
    this.el?.remove(); this.el = null;
    if (this._outside) document.removeEventListener('click', this._outside);
  },

  trigger(emoji) {
    // بازخورد آنی بصری برای خود کاربر (Optimistic UI)
    try {
      sounds.reaction();
      _recentSelfReactions.push({ emoji, ts: Date.now() });
      const mySeat = (typeof lastView !== 'undefined' && lastView?.you != null) ? lastView.you : 0;
      spawnFloatingEmoji(null, mySeat, emoji, mySeat);
    } catch (err) {
      console.error('Reaction trigger error:', err);
    }
    try {
      table?.sendReaction?.(emoji);
    } catch (err) {
      console.error('table.sendReaction error:', err);
    }
  },

  triggerTaunt(phrase) {
    const text = typeof phrase === 'string' ? phrase : (phrase.text || 'صوت');
    const audioUrl = typeof phrase === 'object' && phrase ? phrase.audio_url : null;
    try {
      _recentSelfTaunts.push({ text, ts: Date.now() });
      if (audioUrl && !isMuted()) {
        sounds.voiceTaunt?.(audioUrl, 0.85);
      } else {
        sounds.reaction?.();
      }
      const mySeat = (typeof lastView !== 'undefined' && lastView?.you != null) ? lastView.you : 0;
      spawnFloatingTaunt(null, mySeat, text, mySeat);
    } catch (err) {
      console.error('Taunt trigger error:', err);
    }
    try {
      table?.sendVoiceTaunt?.(text, text, audioUrl);
    } catch (err) {
      console.error('table.sendVoiceTaunt error:', err);
    }
  },
};

function updateLobbyCoinBadge() {
  const coinSpan = document.querySelector('.lb3-coin-badge span:last-child');
  if (coinSpan && myProfile?.coins != null) {
    coinSpan.textContent = `${fmtNum(myProfile.coins)} ${t('lobby.coins', null, 'سکه')}`;
  }
}

// ─── پنجره فروشگاه در ui/shopModal.js ماژولار شده است ───
initShopModal({
  el,
  faNum: fmtNum,
  fmtNum,
  t,
  getLang,
  apiFetch,
  toast,
  getProfile: () => myProfile,
  getAuthToken: () => authToken,
  avatarEl,
  cardEl,
  API,
  get KNOWN_CARD_BACKS() { return typeof KNOWN_CARD_BACKS !== 'undefined' ? KNOWN_CARD_BACKS : {}; },
  onUpdated: () => {
    updateLobbyCoinBadge();
    if (typeof render === 'function' && typeof lastView !== 'undefined' && lastView) {
      render(lastView);
    }
  },
});

// ─── پنل‌های اجتماعی (پروفایل، دوستان، حاضرین) در ui/socialPanels.js ماژولار شده است ───
initSocialPanels({
  el,
  faNum,
  t,
  getLang,
  setLang,
  apiFetch,
  toast,
  API,
  getMyProfile: () => myProfile,
  getMyUserId: () => myUserId,
  getAuthToken: () => authToken,
  setAuthToken: (t) => { authToken = t; localStorage.setItem('shelem_token', t); },
  getFriendsSet: () => friendsSet,
  avatarEl,
  bindProfileMenu,
  getNetworkTable: () => networkTable,
  getTable: () => table,
  getLastView: () => lastView,
  profileCardUI,
  buildCardBackSelector,
  loadMyProfile,
  initNetwork,
  isActiveSeat,
  onGuestRestriction: (reason) => showUpgradeGuestModal(reason),
  // ⚠ getter/setter نه: Object.assign مقدارِ getter را یک‌بار می‌خواند و ستر را دور می‌اندازد (پنلِ حاضرین هرگز باز نمی‌شد)
  getOccupantsOpen: () => occupantsOpen,
  setOccupantsOpen: (v) => { occupantsOpen = v; },
  onProfileUpdated: () => {
    updateLobbyCoinBadge();
    _lastLobbyRooms = null;
    if (!$('#lobby').classList.contains('hidden')) renderLobby();
    if (typeof render === "function" && typeof lastView !== "undefined" && lastView) {
      render(lastView);
    }
  },
});
// ─── احراز هویت و ثبت‌نام در ui/authModal.js ماژولار شده است ───
initAuthModal({
  el,
  faNum,
  t,
  getLang,
  setLang,
  API,
  apiFetch,
  toast,
  brandMark,
  isTouchDevice: _isTouchDevice,
  loadMyProfile,
  getMyProfile: () => myProfile,
  getNetworkTable: () => networkTable,
  initNetwork,
  renderLobby,
  setAuthToken: (t) => { authToken = t; },
  openPracticeModal: () => showPracticeGameModal(),
  startOfflineGame: () => showPracticeGameModal(),
});
// ─── سیستم چت و پیام صوتی در ui/chatVoice.js ماژولار شده است ───
initChatVoice({
  el,
  faNum,
  t,
  getLang,
  toast,
  getTable: () => table,
  getLastView: () => lastView,
  getDmUnread: () => dmUnread,
  getFriendsPanel: () => friendsPanel,
  getOccupantsUI: () => occupantsUI,
  avatarEl,
  getMyProfile: () => myProfile,
  getMyAvatarUrl: () => myProfile?.avatar_url || null,
  getOccupantsOpen: () => occupantsOpen,
  setOccupantsOpen: (v) => { occupantsOpen = v; },
  getReactionsPopupUI: () => reactionsPopupUI,
  onGuestRestriction: (reason) => showUpgradeGuestModal(reason),
  apiFetch,
  clearBubbleWithAnimation,
  overlay,
});



// ─── موتور ضبط و پخش صدا در ui/chatVoice.js ماژولار شده است ───

// ─── تایمر پیوسته ────────────────────────────────────────────────────────────
let _lastTickSec = -1;
// این اینتروال ۵ بار در ثانیه اجرا می‌شود. قبلاً هر تیک تا چهار `querySelectorAll`
// سراسری می‌زد، حتی وقتی هیچ بانکِ زمانی/شمارنده‌ای روی صفحه نبود یا تب مخفی بود.
// حالا: در تبِ مخفی هیچ کاری نمی‌کند، و نودها تا رندرِ بعدی کش می‌شوند
// (`_tickCacheAt` را `render()` صفر می‌کند).
let _tickCache = null;
let _tickCacheAt = -1;
let _renderSeq = 0;
function _tickNodes() {
  if (_tickCache && _tickCacheAt === _renderSeq) return _tickCache;
  _tickCacheAt = _renderSeq;
  _tickCache = {
    banks: document.querySelectorAll('.bank-badge[data-deadline]'),
    fill: document.querySelector('.wait-fill[data-deadline]'),
    timers: document.querySelectorAll('.avatar-turn-timer'),
    rings: document.querySelectorAll('.radial-timer-ring'),
  };
  return _tickCache;
}

function startTimer() {
  clearInterval(timerInterval);
  timerInterval = setInterval(() => {
    // تبِ مخفی: هیچ‌چیزی دیده نمی‌شود، پس نه DOM بخوان نه بنویس.
    if (typeof document !== 'undefined' && document.hidden) return;
    const N = _tickNodes();
    // ثانیه‌شمارِ بانکِ زمانِ صندلی‌های قطع‌شده — مستقل از نوبتِ فعال
    for (const badge of N.banks) {
      const secs = badge.querySelector('.bank-secs');
      if (!secs) continue;
      const left = Math.max(0, Math.round((Number(badge.dataset.deadline) - Date.now()) / 1000));
      const t = faNum(left);
      if (secs.textContent !== t) secs.textContent = t;
      badge.classList.toggle('bank-low', left <= 20);
    }
    // شمارشِ معکوسِ پنجرهٔ «انتظار برای بازیکنِ واقعی» در اتاقِ انتظار
    const fill = N.fill;
    if (fill && fill.isConnected) {
      const secs = fill.querySelector('.wait-fill-secs');
      const left = Math.max(0, Math.ceil((Number(fill.dataset.deadline) - Date.now()) / 1000));
      const t = faNum(left);
      if (secs && secs.textContent !== t) secs.textContent = t;
    }
    if (!lastView?.turnStartTs || !lastView?.turnMs) return;
    const elapsed = Math.max(0, Date.now() - lastView.turnStartTs);
    const pct = Math.max(0, Math.min(100, ((lastView.turnMs - elapsed) / lastView.turnMs) * 100));
    const maxSecs = Math.max(1, Math.ceil(lastView.turnMs / 1000));
    const secsLeft = Math.max(0, Math.min(maxSecs, Math.ceil((lastView.turnMs - elapsed) / 1000)));

    // به‌روزرسانی عدد تایمر درون آواتار فعال
    // ⚠ این تیک ۵ بار در ثانیه اجرا می‌شود ولی عدد ثانیه فقط یک بار عوض می‌شود:
    // چهار نوشتنِ از پنج، تنها invalidateِ بی‌اثر بود (و این نود داخلِ لایهٔ ۳بعدیِ نمد است).
    const tTxt = faNum(secsLeft);
    N.timers.forEach(el => {
      if (el.textContent !== tTxt) el.textContent = tTxt;
      el.classList.toggle('danger', pct < 30);
    });

    // به‌روزرسانی رینگ‌های دور آواتار فعال (دایره‌ای یا مستطیلِ گوشه‌گرد)
    N.rings.forEach(ring => {
      const totalLen = Number(ring.getAttribute('stroke-dasharray')) || (2 * Math.PI * Number(ring.getAttribute('r') || 23));
      const off = (totalLen * (1 - pct / 100)).toFixed(1);
      if (ring.style.strokeDashoffset !== off) ring.style.strokeDashoffset = off;
      ring.classList.toggle('danger', pct < 30);
    });

    // صدای تیک‌تاک در ۵ ثانیه آخر برای بازیکن فعال
    const isMyActiveTurn = lastView?.speedMode
      ? (Array.isArray(lastView?.openSeats) && lastView.openSeats.includes(lastView.you))
      : (lastView?.turnSeat != null && lastView.turnSeat === lastView.you);
    if (secsLeft <= 5 && secsLeft > 0 && secsLeft !== _lastTickSec
        && !lastView?.observerMode && isMyActiveTurn) {
      _lastTickSec = secsLeft;
      sounds.tick(secsLeft % 2 === 0);
    }
  }, 200);
}

// ─── کنترل‌ها ─────────────────────────────────────────────────────────────────
function toggleMute() {
  muted = _toggleMuteAudio();
  if (lastView) render(lastView);
  return muted;
}

let _lastQuickStart = null;
let _tableConnectTimeout = null;
function startGame({ observer = false, roomId = null, gameType = selectedGame, create = null, noBot = false, botDifficulty = 'PRO', speedMode = false, offline = false } = {}) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false && !roomId && !create) {
    offline = true;
  }
  _lastQuickStart = (!observer && !roomId && !create && !offline) ? { gameType, noBot, botDifficulty, speedMode } : null;
  // بستن و پاکسازی هرگونه مدال یا شیت بازمانده از لابی
  document.querySelectorAll('.bot-modal-overlay:not(.closing), .lb-modal-overlay:not(.closing), .room-settings-overlay:not(.closing), .score-breakdown-overlay:not(.closing), .table-theme-overlay:not(.closing)').forEach((m) => m.remove());

  clearTimeout(_tableConnectTimeout);
  if (!offline) {
    _tableConnectTimeout = setTimeout(() => {
      if ($('#table .table-loading-screen')) {
        if (!roomId && !create) {
          toast(t('table.fallback_to_bot', null, 'عدم اتصال به سرور — شروع بازی با ربات…'), 'info');
          const diff = create?.botDifficulty || botDifficulty || 'PRO';
          import('./game/localTable.js?v=20261028_428').then(({ LocalTable }) => {
            table = new LocalTable({
              gameType,
              onUpdate: render,
              onToast: toast,
              onBidMade: (payload) => handleBidMade(payload),
              onHokmPhase: ({ hakemSeat, winningBid }) => {
                if (hakemSeat != null) {
                  contractorCelebratingSeat = hakemSeat;
                  sounds?.royalSeal?.();
                  scheduleRender();
                }
              },
              observerMode: observer,
              botDifficulty: diff,
              jokerMode: !!(create?.jokerMode),
              andakhtan: create?.andakhtan !== false,
              matchTarget: create?.matchTarget
            });
            table.startMatch();
            startTimer();
          }).catch((e) => {
            console.error('[localTable]', e);
            leaveGame({ force: true });
          });
        } else {
          toast(t('table.connect_timeout', null, 'زمان اتصال به اتاق به پایان رسید. لطفاً وضعیت اینترنت را بررسی کنید.'), 'error');
          leaveGame({ force: true });
        }
      }
    }, 4_000);
  }

  $('#lobby').classList.add('hidden');
  $('#table').classList.remove('hidden');
  _syncBackState();   // آدرس به /table می‌رود → بکِ مرورگر معنا پیدا می‌کند
  $('#table').replaceChildren(
    el('div', { className: 'table-loading-screen' },
      el('div', { className: 'auth-spinner' }),
      el('span', { style: 'color: #94a3b8; font-size: 0.95rem; margin-top: 12px;', textContent: offline ? t('table.loading_offline', null, 'در حال آماده‌سازی بازی آفلاین...') : t('table.connecting_to_room', null, 'در حال اتصال به اتاق بازی...') }),
      el('button', {
        className: 'ghost-sm',
        style: 'margin-top: 18px; color: #cbd5e1; border: 1px solid rgba(203, 213, 225, 0.25); border-radius: 8px; padding: 6px 14px; cursor: pointer; font-size: 0.85rem; background: rgba(255, 255, 255, 0.05);',
        textContent: t('table.cancel_to_lobby', null, 'انصراف و بازگشت'),
        onclick: () => leaveGame({ force: true }),
      })
    )
  );
  composerUI.built = false;
  chatRailUI.built = false;
  chatRailUI._lastLen = -1;
  occupantsOpen = false;
  occupantsUI.root = null; occupantsUI.lastV = null;
  _cachedCenterEl = null;
  _cachedFelt = null;
  _lastWinPos = null;
  _dealFxHandNo = -1;
  _dealFxDealIndex = -1;
  _dealFxHokmStage = 0;
  _resultOverlayHoldUntil = 0;
  _lastResultSeenHand = -1;
  _lastAnnouncedHokmHand = -1;
  _lastAnnouncedHokmSuit = null;
  _dealSndHandNo = -1;
  sounds.stopDeal?.();
  clearTimeout(_cheerTimer); clearTimeout(_matchEndTimer);
  _lastTickSec = -1;
  _lastContractorStatus = null;
  prevSnd = { trickLen: 0, lastWin: null, revealShown: 0, phase: null, chatLen: 0, turnSeat: null, roomState: null };
  _isFirstSoundSnapshot = true;
  _dealSndHokmSecondDealt = false;
  _dealFxUntil = 0;
  if (_dealDeal?.timers) {
    _dealDeal.timers.forEach((t) => clearTimeout(t));
  }
  _dealDeal = null;
  _thrownCards.clear();
  _cardThrowTimers.clear();
  _userThrowVec.clear();
  // ریست سیستم حباب
  ephemerals.forEach((b) => clearTimeout(b.timerId));
  ephemerals.clear();
  prevChatLen = 0;
  profileCardUI.hide();
  presetsPopup.hide();

  try { _loadAudioSprite(); } catch { /* noop */ }   // اسپرایت را همین‌جا گرم کن، نه در لاگین
  acquireWakeLock();   // صفحه در طولِ نوبتِ ۲۰ ثانیه‌ای خاموش نشود
  if (!offline && !networkTable && authToken) {
    initNetwork();
  }

  if (!offline && networkTable) {
    networkTable.ensureConnected(true);
    table = networkTable;
    if (observer) networkTable.observe(roomId);
    else if (create) networkTable.createRoom(create);
    else if (roomId) networkTable.joinRoom(roomId);
    else networkTable.join(gameType, noBot, botDifficulty, speedMode, _deck4());
    startTimer();
    if (observer) toast('حالت تماشا — بازی بدون دخالت شما پیش می‌رود');
  } else {
    const diff = create?.botDifficulty || botDifficulty || 'PRO';
    import('./game/localTable.js?v=20261028_428').then(({ LocalTable }) => {
      table = new LocalTable({
        gameType,
        onUpdate: render,
        onToast: toast,
        onBidMade: (payload) => handleBidMade(payload),
        onHokmPhase: ({ hakemSeat, winningBid }) => {
          if (hakemSeat != null) {
            contractorCelebratingSeat = hakemSeat;
            sounds?.royalSeal?.();
            scheduleRender();
          }
        },
        observerMode: observer,
        botDifficulty: diff,
        jokerMode: !!(create?.jokerMode),
        andakhtan: create?.andakhtan !== false,
        matchTarget: create?.matchTarget
      });
      table.startMatch();
      startTimer();
    }).catch((e) => {
      console.error('[localTable]', e);
      toast('بارگذاریِ بازیِ تمرینی ناموفق بود', 'error');
      leaveGame({ force: true });
    });
  }
}

// آیا این خروج، ترکِ عمدیِ وسطِ مسابقهٔ چندنفره است؟ (→ جریمهٔ ۴۰− و قفل تا پایان)
function _isMidMatchLeave() {
  const v = lastView;
  if (!v || table !== networkTable || v.observerMode) return false;
  if (v.matchOver || v.matchCancelled) return false;
  if (v.roomState !== 'IN_HAND' && v.phase !== 'SCORE_CALC') return false;
  return (v.names || []).some((n, i) =>
    n && i !== v.you && !(v.bots || [])[i] && !(v.abandonedSeats || []).includes(i));
}

// مدالِ تأییدِ خروج (به‌جای confirm() که در اپِ دسکتاپ پنجرهٔ خامِ ویندوز باز می‌کرد).
// penalty=true → فهرستِ جریمه‌ها. `appClose` فقط متنِ دکمه را عوض می‌کند. → Promise<boolean>
function showLeaveConfirmModal({ penalty, appClose } = {}) {
  document.getElementById('leave-modal-overlay')?.remove();
  return new Promise((resolve) => {
    let done = false;
    const finish = (ok) => { if (done) return; done = true; closeOverlayWithFade(overlay); resolve(ok); };
    const overlay = el('div', {
      id: 'leave-modal-overlay', className: 'bot-modal-overlay',
      onclick: (e) => { if (e.target === overlay) finish(false); },
    });
    const stay = el('button', { className: 'primary enter-code-btn', textContent: 'ادامهٔ بازی', onclick: () => finish(false) });
    const body = penalty
      ? [
        el('p', { className: 'bot-modal-sub', textContent: 'اگر الان خارج شوید:' }),
        el('ul', { className: 'leave-penalties' },
          el('li', { textContent: '۴۰− امتیاز جریمهٔ ترک بازی ثبت می‌شود' }),
          el('li', { textContent: 'یک ترک به سابقهٔ شما اضافه می‌شود' }),
          el('li', { textContent: 'تا پایانِ این مسابقه نمی‌توانید بازیِ جدیدی شروع کنید' }),
          el('li', { textContent: 'ربات حرفه‌ای جای شما را می‌گیرد' })),
        el('p', { className: 'leave-note', textContent: 'اگر فقط نتتان پریده، نگران نباشید — تا ۱۶۰ ثانیه فرصتِ برگشت دارید.' }),
      ]
      : [el('p', { className: 'bot-modal-sub', textContent: 'بازیِ در جریان بسته می‌شود. مطمئنید؟' })];
    overlay.append(el('div', { className: 'bot-modal' + (penalty ? ' leave-modal-danger' : '') },
      el('div', { className: 'bot-modal-head' },
        el('div', { className: 'bot-modal-title' },
          el('span', { textContent: penalty ? '⚠️' : '🚪' }),
          el('h3', { textContent: penalty ? 'خروج از مسابقهٔ در جریان' : 'خروج از بازی' })),
        el('button', { className: 'occ-close', textContent: '✕', onclick: () => finish(false) })),
      ...body,
      el('div', { className: 'enter-code-actions' }, stay,
        el('button', {
          className: 'ghost-sm enter-code-cancel' + (penalty ? ' leave-btn-danger' : ''),
          textContent: appClose ? 'بستنِ برنامه' : (penalty ? 'خروج با جریمه' : 'خروج'),
          onclick: () => finish(true),
        }))));
    overlay.addEventListener('keydown', (e) => { if (e.key === 'Escape') { e.stopPropagation(); finish(false); } });
    document.body.append(overlay);
    setTimeout(() => stay.focus(), 50);
  });
}

// سقف ساخت اتاق روزانه (فاز ۳، فقط کاربر بدون اشتراک وقتی پلن‌ها فعال‌اند):
// ساخت یک اتاق اضافه با سکه، خرید اشتراک، یا ورود به اتاق دیگران (همیشه آزاد)
function showRoomCapModal(msg = {}) {
  document.getElementById('roomcap-modal-overlay')?.remove();
  const price = Number(msg.price ?? 50);
  const overlay = el('div', {
    id: 'roomcap-modal-overlay', className: 'bot-modal-overlay',
    onclick: (e) => { if (e.target === overlay) closeOverlayWithFade(overlay); },
  });
  const close = () => closeOverlayWithFade(overlay);
  const buyBtn = el('button', {
    className: 'primary enter-code-btn',
    textContent: `ساخت یک اتاق اضافه با ${faNum(price)} سکه`,
    onclick: async () => {
      buyBtn.disabled = true;
      const r = await apiFetch('POST', '/api/shop/room-credit').catch(() => null);
      if (r?.ok) {
        if (myProfile) myProfile.coins = r.newBalance;
        updateLobbyCoinBadge?.();
        toast('یک اتاق اضافه فعال شد — دوباره «ساخت اتاق» را بزنید', 'ok');
        close();
      } else {
        toast(r?.error === 'INSUFFICIENT_COINS' ? 'سکهٔ کافی ندارید' : 'خطا در خرید اتاق اضافه', 'error');
        buyBtn.disabled = false;
      }
    },
  });
  overlay.append(el('div', { className: 'bot-modal' },
    el('div', { className: 'bot-modal-head' },
      el('div', { className: 'bot-modal-title' }, el('span', { textContent: '🏠' }), el('h3', { textContent: 'سقف ساخت اتاق امروز' })),
      el('button', { className: 'occ-close', textContent: '✕', onclick: close })),
    el('p', { className: 'bot-modal-sub', textContent: `امروز ${faNum(msg.limit ?? 3)} اتاق ساخته‌اید. ورود به اتاق دیگران و بازی سریع همچنان نامحدود است.` }),
    el('div', { className: 'enter-code-actions', style: 'flex-direction:column;gap:8px' },
      buyBtn,
      el('button', { className: 'ghost-sm', textContent: '👑 اشتراک VIP — ساخت اتاق نامحدود', onclick: () => { close(); shopModal.show('vip'); } }),
      el('button', { className: 'ghost-sm enter-code-cancel', textContent: 'ورود به اتاق دیگران', onclick: close }),
    )));
  document.body.append(overlay);
}

// بازگشت از درگاه پرداخت: /?pay=ok|fail (سرور بعد از verify ری‌دایرکت می‌کند)
function handlePaymentReturn() {
  const q = new URLSearchParams(location.search);
  const pay = q.get('pay');
  if (!pay) return;
  history.replaceState(null, '', location.pathname + location.hash);
  if (pay === 'ok') {
    toast(`پرداخت با موفقیت انجام شد ✨${q.get('ref') ? ` — کد پیگیری ${faNum(q.get('ref'))}` : ''}`, 'ok');
    loadMyProfile().then(() => { updateLobbyCoinBadge?.(); if (!$('#lobby')?.classList.contains('hidden')) renderLobby(_lastLobbyRooms); }).catch(() => {});
  } else {
    const e = q.get('e') || '';
    toast(e === 'PAYMENT_CANCELLED' ? 'پرداخت لغو شد' : 'پرداخت ناموفق بود — اگر مبلغ کسر شده، تا ۷۲ ساعت برمی‌گردد', 'error');
  }
}
setTimeout(handlePaymentReturn, 1500);

// اپِ دسکتاپ هنگامِ زدنِ ✕ این را صدا می‌زند (main.js) → true یعنی ببند
window.__confirmAppClose = () => {
  const penalty = _isMidMatchLeave();
  return (penalty || window.__isGameActive()) ? showLeaveConfirmModal({ penalty, appClose: true }) : true;
};

function leaveGame(opts = {}) {
  clearTimeout(_tableConnectTimeout);
  if (!opts.force && _isMidMatchLeave()) {
    showLeaveConfirmModal({ penalty: true }).then((ok) => { if (ok) leaveGame({ ...opts, force: true }); });
    return;
  }
  releaseWakeLock();
  clearInterval(timerInterval); timerInterval = null;
  if (table && table !== networkTable) table.reset();
  if (networkTable) networkTable.leave();
  table = null;
  // ⚠ lastView را هم خالی کن: چند تایمرِ دیرِسیده (پایانِ انیمیشنِ پخش، جشنِ حاکم، حبابِ
  // تعهدِ دیر رسیده) scheduleRender → `if (lastView) render(lastView)` صدا می‌زنند و میز/ستونِ گفتگوی
  // اتاقِ قبلی را روی لابی برمی‌گرداندند.
  lastView = null;
  occupantsOpen = false;
  _cachedCenterEl = null;
  _cachedFelt = null;
  _lastWinPos = null;
  _dealFxHandNo = -1;
  _dealFxDealIndex = -1;
  _dealFxHokmStage = 0;
  _resultOverlayHoldUntil = 0;
  _lastResultSeenHand = -1;
  _lastAnnouncedHokmHand = -1;
  _lastAnnouncedHokmSuit = null;
  _dealSndHandNo = -1;
  sounds.stopDeal?.();
  clearTimeout(_cheerTimer); clearTimeout(_matchEndTimer);
  _lastTickSec = -1;
  prevSnd = { trickLen: 0, lastWin: null, revealShown: 0, phase: null, chatLen: 0, turnSeat: null, roomState: null };
  _isFirstSoundSnapshot = true;
  _dealSndHokmSecondDealt = false;
  _dealFxUntil = 0;
  if (_dealDeal?.timers) {
    _dealDeal.timers.forEach((t) => clearTimeout(t));
  }
  _dealDeal = null;
  _thrownCards.clear();
  _cardThrowTimers.clear();
  _userThrowVec.clear();
  ephemerals.forEach((b) => clearTimeout(b.timerId));
  ephemerals.clear();
  prevChatLen = 0;
  profileCardUI.hide();
  presetsPopup.hide();
  composerUI.root?.classList.add('hidden');
  chatRailUI.hide();
  $('#table').classList.add('hidden');
  const occ = $('#occupants');
  if (occ) { occ.classList.add('hidden'); occ.replaceChildren(); occ.classList.remove('open'); }
  $('#lobby').classList.remove('hidden');
  if (!authToken) {
    renderLogin();
  } else {
    renderLobby();
  }
  _syncBackState();   // ورودیِ /table را از تاریخچه بردار
}

// ─── میانبرهای صفحه‌کلید ─────────────────────────────────────────────────────
// e.code (نه e.key) تا با صفحه‌کلیدِ فارسی هم کار کند. همه‌چیز با click روی همان دکمه/کارتِ
// واقعی انجام می‌شود، پس قفل‌ها و گاردهای موجود (guardChoiceTaps، dataset.playing، ردِ
// کارتِ غیرمجاز) عیناً اعمال می‌شوند.
const _KB_HELP = [
  ['→ ←', 'انتخابِ کارتِ مجاز'], ['Enter / Space', 'انداختنِ کارتِ انتخاب‌شده'],
  ['1 … 9 ، 0', 'انتخابِ کارتِ nام از راست'], ['P', 'پاس در تعهد'],
  ['1 … 4', 'انتخابِ خالِ حکم (در پنجرهٔ حکم)'], ['T', 'نوشتنِ پیام'],
  ['M', 'صدا روشن / خاموش'], ['Esc', 'بستنِ پنجره یا لغوِ انتخاب'], ['?', 'همین راهنما'],
];

function _kbHandCards() {
  // ترتیبِ دیداری از راست به چپ (بادبزن RTL است؛ به ترتیبِ DOM تکیه نمی‌کنیم)
  return [...document.querySelectorAll('#table .hand-strip > .card')]
    .map((n) => [n, n.getBoundingClientRect().left])
    .sort((a, b) => b[1] - a[1])
    .map(([n]) => n);
}

function _kbSelect(card) {
  document.querySelectorAll('.hand-strip .card.sel').forEach((n) => n.classList.remove('sel'));
  _mobileSelId = card ? card.dataset.cardId : null;
  _mobileSelTs = _mobileSelId ? Date.now() : 0;
  card?.classList.add('sel');
}

function _kbHelp() {
  const panel = overlay('میانبرهای صفحه‌کلید',
    el('div', { className: 'kb-help' },
      ..._KB_HELP.map(([k, t]) => el('div', { className: 'kb-row' }, el('kbd', { textContent: k }), el('span', { textContent: t })))),
    el('button', { className: 'primary', textContent: 'باشه', onclick: () => panel.remove() }));
  panel.classList.add('kb-help-overlay');
  panel.onclick = (e) => { if (e.target === panel) panel.remove(); };
  document.body.append(panel);
}

document.addEventListener('keydown', (e) => {
  if (e.ctrlKey || e.altKey || e.metaKey || e.repeat) return;
  const t = e.target;
  if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) {
    if (e.key === 'Escape') t.blur();
    return;
  }
  const help = document.querySelector('.kb-help-overlay');
  if (e.key === 'Escape') {
    if (_pendingJokerPlay) {
      _pendingJokerPlay = null;
      render();
      return;
    }
    if (help) help.remove();
    else if (_ownedPopup() || _topFloatingLayer() || _openSidePanel()) { _backCloseOne(); _syncBackState(); }
    else if (_mobileSelId != null) _kbSelect(null);
    return;
  }
  if (e.key === '?' || (e.code === 'Slash' && e.shiftKey)) { e.preventDefault(); if (!help) _kbHelp(); return; }
  if (help || !_tableOpen() || !table || !lastView) return;

  const k = e.code;
  const digit = /^(?:Digit|Numpad)(\d)$/.exec(k);
  const ov = document.querySelector('#table > .overlay');
  if (ov?.matches('.choose-hokm-overlay')) {
    if (digit) { ov.querySelectorAll('.suit-btn')[Number(digit[1]) - 1]?.click(); e.preventDefault(); }
    return;
  }
  if (ov?.matches('.bidding-overlay')) {
    if (k === 'KeyP') { ov.querySelector('.bid-btn.pass')?.click(); e.preventDefault(); }
    return;
  }
  if (k === 'KeyM') { toggleMute(); return; }
  if (k === 'KeyT') {
    const inp = chatRailUI.input?.offsetParent ? chatRailUI.input : composerUI.input;
    if (inp && !inp.disabled) { inp.focus(); e.preventDefault(); }
    return;
  }

  const all = _kbHandCards();
  if (!all.length) return;
  const playable = all.filter((n) => n.classList.contains('click'));
  if (digit) {
    const c = all[(Number(digit[1]) || 10) - 1];
    if (c) { if (c.classList.contains('click')) _kbSelect(c); else c.click(); }
    e.preventDefault();
    return;
  }
  if ((k === 'ArrowLeft' || k === 'ArrowRight') && playable.length) {
    const cur = playable.findIndex((n) => n.classList.contains('sel'));
    const step = k === 'ArrowLeft' ? 1 : -1;
    const next = cur < 0 ? (step > 0 ? 0 : playable.length - 1) : (cur + step + playable.length) % playable.length;
    _kbSelect(playable[next]);
    e.preventDefault();
    return;
  }
  if (k === 'Enter' || k === 'Space' || k === 'NumpadEnter') {
    const sel = playable.find((n) => n.classList.contains('sel'));
    if (sel) { e.preventDefault(); sel.click(); }
  }
});

// ─── شروع برنامه ──────────────────────────────────────────────────────────────
window.__render = render;
if (typeof window !== 'undefined') {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(() => predecodeCourtCards());
  } else {
    setTimeout(() => predecodeCourtCards(), 2000);
  }
}
// /table فقط یک وضعیتِ زمانِ اجراست، نه نقطهٔ ورود: اگر کسی مستقیم بازش کند یا
// وسطِ بازی رفرش بزند، به ریشه برمی‌گردد و ادامهٔ کار با بازیابیِ نشستِ سرور است
// (RoomManager.userRoom خودش کاربر را به اتاقش برمی‌گرداند).
try {
  if (location.pathname !== '/') history.replaceState({ cbLevel: 0 }, '', '/');
} catch { /* noop */ }
(async () => {
  const swWait = (typeof window !== 'undefined' && window.__swReady)
    ? Promise.race([window.__swReady, new Promise((res) => setTimeout(res, 450))])
    : Promise.resolve();

  if (authToken) {
    const [me] = await Promise.all([
      loadMyProfile(),
      swWait
    ]);
    if (!me) {
      renderLogin();
      window.dismissSplash?.();
    } else if (!me.is_guest && (!me.profile_completed || !me.display_name)) {
      renderProfileOnboarding(me);
      window.dismissSplash?.();
    } else {
      initNetwork();
      renderLobby();
      dmUnread.refresh();
      window.dismissSplash?.();
    }
  } else {
    await swWait;
    renderLogin();
    window.dismissSplash?.();
  }
})();

// بازنشانی نمای فعال در هنگام تغییر زبان کاربر
onLangChange(() => {
  try {
    const tableEl = $('#table');
    const lobbyEl = $('#lobby');
    if (tableEl && !tableEl.classList.contains('hidden') && lastView) {
      render(lastView);
    } else if (lobbyEl && !lobbyEl.classList.contains('hidden')) {
      renderLobby(_lastLobbyRooms);
    }
  } catch (err) {
    console.error('[i18n] onLangChange re-render failed:', err);
  }
});

